var crypto;
!(function i(n, s, o) {
  function a(e, t) {
    if (!s[e]) {
      if (!n[e]) {
        var r = 'function' == typeof reqqq && reqqq;
        if (!t && r) return r(e, !0);
        if (f) return f(e, !0);
        throw (((r = new Error("Cannot find module '" + e + "'")).code =
          'MODULE_NOT_FOUND'),
        r);
      }
      (r = s[e] = { exports: {} }),
        n[e][0].call(
          r.exports,
          function(t) {
            return a(n[e][1][t] || t);
          },
          r,
          r.exports,
          i,
          n,
          s,
          o
        );
    }
    return s[e].exports;
  }
  for (var f = 'function' == typeof reqqq && reqqq, t = 0; t < o.length; t++)
    a(o[t]);
  return a;
})(
  {
    1: [
      function(t, e, r) {
        crypto = t('crypto');
      },
      { crypto: 72 },
    ],
    2: [
      function(t, e, r) {
        'use strict';
        const i = r;
        (i.bignum = t('bn.js')),
          (i.define = t('./asn1/api').define),
          (i.base = t('./asn1/base')),
          (i.constants = t('./asn1/constants')),
          (i.decoders = t('./asn1/decoders')),
          (i.encoders = t('./asn1/encoders'));
      },
      {
        './asn1/api': 3,
        './asn1/base': 5,
        './asn1/constants': 9,
        './asn1/decoders': 11,
        './asn1/encoders': 14,
        'bn.js': 16,
      },
    ],
    3: [
      function(t, e, r) {
        'use strict';
        const i = t('./encoders'),
          n = t('./decoders'),
          s = t('inherits'),
          o = r;
        function a(t, e) {
          (this.name = t),
            (this.body = e),
            (this.decoders = {}),
            (this.encoders = {});
        }
        (o.define = function(t, e) {
          return new a(t, e);
        }),
          (a.prototype._createNamed = function(r) {
            const e = this.name;
            function t(t) {
              this._initNamed(t, e);
            }
            return (
              s(t, r),
              (t.prototype._initNamed = function(t, e) {
                r.call(this, t, e);
              }),
              new t(this)
            );
          }),
          (a.prototype._getDecoder = function(t) {
            return (
              this.decoders.hasOwnProperty((t = t || 'der')) ||
                (this.decoders[t] = this._createNamed(n[t])),
              this.decoders[t]
            );
          }),
          (a.prototype.decode = function(t, e, r) {
            return this._getDecoder(e).decode(t, r);
          }),
          (a.prototype._getEncoder = function(t) {
            return (
              this.encoders.hasOwnProperty((t = t || 'der')) ||
                (this.encoders[t] = this._createNamed(i[t])),
              this.encoders[t]
            );
          }),
          (a.prototype.encode = function(t, e, r) {
            return this._getEncoder(e).encode(t, r);
          });
      },
      { './decoders': 11, './encoders': 14, inherits: 133 },
    ],
    4: [
      function(t, e, r) {
        'use strict';
        const i = t('inherits'),
          n = t('../base/reporter').Reporter,
          s = t('safer-buffer').Buffer;
        function o(t, e) {
          n.call(this, e),
            s.isBuffer(t)
              ? ((this.base = t), (this.offset = 0), (this.length = t.length))
              : this.error('Input not Buffer');
        }
        function a(t, e) {
          if (Array.isArray(t))
            (this.length = 0),
              (this.value = t.map(function(t) {
                return (
                  a.isEncoderBuffer(t) || (t = new a(t, e)),
                  (this.length += t.length),
                  t
                );
              }, this));
          else if ('number' == typeof t) {
            if (!(0 <= t && t <= 255))
              return e.error('non-byte EncoderBuffer value');
            (this.value = t), (this.length = 1);
          } else if ('string' == typeof t)
            (this.value = t), (this.length = s.byteLength(t));
          else {
            if (!s.isBuffer(t)) return e.error('Unsupported type: ' + typeof t);
            (this.value = t), (this.length = t.length);
          }
        }
        i(o, n),
          ((r.DecoderBuffer = o).isDecoderBuffer = function(t) {
            return (
              t instanceof o ||
              ('object' == typeof t &&
                s.isBuffer(t.base) &&
                'DecoderBuffer' === t.constructor.name &&
                'number' == typeof t.offset &&
                'number' == typeof t.length &&
                'function' == typeof t.save &&
                'function' == typeof t.restore &&
                'function' == typeof t.isEmpty &&
                'function' == typeof t.readUInt8 &&
                'function' == typeof t.skip &&
                'function' == typeof t.raw)
            );
          }),
          (o.prototype.save = function() {
            return {
              offset: this.offset,
              reporter: n.prototype.save.call(this),
            };
          }),
          (o.prototype.restore = function(t) {
            const e = new o(this.base);
            return (
              (e.offset = t.offset),
              (e.length = this.offset),
              (this.offset = t.offset),
              n.prototype.restore.call(this, t.reporter),
              e
            );
          }),
          (o.prototype.isEmpty = function() {
            return this.offset === this.length;
          }),
          (o.prototype.readUInt8 = function(t) {
            return this.offset + 1 <= this.length
              ? this.base.readUInt8(this.offset++, !0)
              : this.error(t || 'DecoderBuffer overrun');
          }),
          (o.prototype.skip = function(t, e) {
            if (!(this.offset + t <= this.length))
              return this.error(e || 'DecoderBuffer overrun');
            const r = new o(this.base);
            return (
              (r._reporterState = this._reporterState),
              (r.offset = this.offset),
              (r.length = this.offset + t),
              (this.offset += t),
              r
            );
          }),
          (o.prototype.raw = function(t) {
            return this.base.slice((t || this).offset, this.length);
          }),
          ((r.EncoderBuffer = a).isEncoderBuffer = function(t) {
            return (
              t instanceof a ||
              ('object' == typeof t &&
                'EncoderBuffer' === t.constructor.name &&
                'number' == typeof t.length &&
                'function' == typeof t.join)
            );
          }),
          (a.prototype.join = function(e, r) {
            return (
              (e = e || s.alloc(this.length)),
              (r = r || 0),
              0 === this.length ||
                (Array.isArray(this.value)
                  ? this.value.forEach(function(t) {
                      t.join(e, r), (r += t.length);
                    })
                  : ('number' == typeof this.value
                      ? (e[r] = this.value)
                      : 'string' == typeof this.value
                      ? e.write(this.value, r)
                      : s.isBuffer(this.value) && this.value.copy(e, r),
                    (r += this.length))),
              e
            );
          });
      },
      { '../base/reporter': 7, inherits: 133, 'safer-buffer': 162 },
    ],
    5: [
      function(t, e, r) {
        'use strict';
        const i = r;
        (i.Reporter = t('./reporter').Reporter),
          (i.DecoderBuffer = t('./buffer').DecoderBuffer),
          (i.EncoderBuffer = t('./buffer').EncoderBuffer),
          (i.Node = t('./node'));
      },
      { './buffer': 4, './node': 6, './reporter': 7 },
    ],
    6: [
      function(t, e, r) {
        'use strict';
        const h = t('../base/reporter').Reporter,
          i = t('../base/buffer').EncoderBuffer,
          c = t('../base/buffer').DecoderBuffer,
          n = t('minimalistic-assert'),
          s = [
            'seq',
            'seqof',
            'set',
            'setof',
            'objid',
            'bool',
            'gentime',
            'utctime',
            'null_',
            'enum',
            'int',
            'objDesc',
            'bitstr',
            'bmpstr',
            'charstr',
            'genstr',
            'graphstr',
            'ia5str',
            'iso646str',
            'numstr',
            'octstr',
            'printstr',
            't61str',
            'unistr',
            'utf8str',
            'videostr',
          ],
          o = [
            'key',
            'obj',
            'use',
            'optional',
            'explicit',
            'implicit',
            'def',
            'choice',
            'any',
            'contains',
          ].concat(s);
        function a(t, e, r) {
          const i = {};
          (this._baseState = i),
            (i.name = r),
            (i.enc = t),
            (i.parent = e || null),
            (i.children = null),
            (i.tag = null),
            (i.args = null),
            (i.reverseArgs = null),
            (i.choice = null),
            (i.optional = !1),
            (i.any = !1),
            (i.obj = !1),
            (i.use = null),
            (i.useDecoder = null),
            (i.key = null),
            (i.default = null),
            (i.explicit = null),
            (i.implicit = null),
            (i.contains = null),
            i.parent || ((i.children = []), this._wrap());
        }
        e.exports = a;
        const f = [
          'enc',
          'parent',
          'children',
          'tag',
          'args',
          'reverseArgs',
          'choice',
          'optional',
          'any',
          'obj',
          'use',
          'alteredUse',
          'key',
          'default',
          'explicit',
          'implicit',
          'contains',
        ];
        (a.prototype.clone = function() {
          const e = this._baseState,
            r = {};
          f.forEach(function(t) {
            r[t] = e[t];
          });
          const t = new this.constructor(r.parent);
          return (t._baseState = r), t;
        }),
          (a.prototype._wrap = function() {
            const r = this._baseState;
            o.forEach(function(e) {
              this[e] = function() {
                const t = new this.constructor(this);
                return r.children.push(t), t[e].apply(t, arguments);
              };
            }, this);
          }),
          (a.prototype._init = function(t) {
            const e = this._baseState;
            n(null === e.parent),
              t.call(this),
              (e.children = e.children.filter(function(t) {
                return t._baseState.parent === this;
              }, this)),
              n.equal(
                e.children.length,
                1,
                'Root node can have only one child'
              );
          }),
          (a.prototype._useArgs = function(t) {
            const e = this._baseState,
              r = t.filter(function(t) {
                return t instanceof this.constructor;
              }, this);
            (t = t.filter(function(t) {
              return !(t instanceof this.constructor);
            }, this)),
              0 !== r.length &&
                (n(null === e.children),
                (e.children = r),
                r.forEach(function(t) {
                  t._baseState.parent = this;
                }, this)),
              0 !== t.length &&
                (n(null === e.args),
                (e.args = t),
                (e.reverseArgs = t.map(function(r) {
                  if ('object' != typeof r || r.constructor !== Object)
                    return r;
                  const i = {};
                  return (
                    Object.keys(r).forEach(function(t) {
                      t == (0 | t) && (t |= 0);
                      var e = r[t];
                      i[e] = t;
                    }),
                    i
                  );
                })));
          }),
          [
            '_peekTag',
            '_decodeTag',
            '_use',
            '_decodeStr',
            '_decodeObjid',
            '_decodeTime',
            '_decodeNull',
            '_decodeInt',
            '_decodeBool',
            '_decodeList',
            '_encodeComposite',
            '_encodeStr',
            '_encodeObjid',
            '_encodeTime',
            '_encodeNull',
            '_encodeInt',
            '_encodeBool',
          ].forEach(function(e) {
            a.prototype[e] = function() {
              var t = this._baseState;
              throw new Error(e + ' not implemented for encoding: ' + t.enc);
            };
          }),
          s.forEach(function(r) {
            a.prototype[r] = function() {
              const t = this._baseState;
              var e = Array.prototype.slice.call(arguments);
              return n(null === t.tag), (t.tag = r), this._useArgs(e), this;
            };
          }),
          (a.prototype.use = function(t) {
            n(t);
            const e = this._baseState;
            return n(null === e.use), (e.use = t), this;
          }),
          (a.prototype.optional = function() {
            const t = this._baseState;
            return (t.optional = !0), this;
          }),
          (a.prototype.def = function(t) {
            const e = this._baseState;
            return (
              n(null === e.default), (e.default = t), (e.optional = !0), this
            );
          }),
          (a.prototype.explicit = function(t) {
            const e = this._baseState;
            return (
              n(null === e.explicit && null === e.implicit),
              (e.explicit = t),
              this
            );
          }),
          (a.prototype.implicit = function(t) {
            const e = this._baseState;
            return (
              n(null === e.explicit && null === e.implicit),
              (e.implicit = t),
              this
            );
          }),
          (a.prototype.obj = function() {
            const t = this._baseState;
            var e = Array.prototype.slice.call(arguments);
            return (t.obj = !0), 0 !== e.length && this._useArgs(e), this;
          }),
          (a.prototype.key = function(t) {
            const e = this._baseState;
            return n(null === e.key), (e.key = t), this;
          }),
          (a.prototype.any = function() {
            const t = this._baseState;
            return (t.any = !0), this;
          }),
          (a.prototype.choice = function(e) {
            const t = this._baseState;
            return (
              n(null === t.choice),
              (t.choice = e),
              this._useArgs(
                Object.keys(e).map(function(t) {
                  return e[t];
                })
              ),
              this
            );
          }),
          (a.prototype.contains = function(t) {
            const e = this._baseState;
            return n(null === e.use), (e.contains = t), this;
          }),
          (a.prototype._decode = function(e, r) {
            const i = this._baseState;
            if (null === i.parent)
              return e.wrapResult(i.children[0]._decode(e, r));
            let n = i.default,
              s = !0,
              t = null;
            if ((null !== i.key && (t = e.enterKey(i.key)), i.optional)) {
              let t = null;
              if (
                (null !== i.explicit
                  ? (t = i.explicit)
                  : null !== i.implicit
                  ? (t = i.implicit)
                  : null !== i.tag && (t = i.tag),
                null !== t || i.any)
              ) {
                if (((s = this._peekTag(e, t, i.any)), e.isError(s))) return s;
              } else {
                var o = e.save();
                try {
                  null === i.choice
                    ? this._decodeGeneric(i.tag, e, r)
                    : this._decodeChoice(e, r),
                    (s = !0);
                } catch (t) {
                  s = !1;
                }
                e.restore(o);
              }
            }
            let a;
            if ((i.obj && s && (a = e.enterObject()), s)) {
              if (null !== i.explicit) {
                var f = this._decodeTag(e, i.explicit);
                if (e.isError(f)) return f;
                e = f;
              }
              o = e.offset;
              if (null === i.use && null === i.choice) {
                let t;
                i.any && (t = e.save());
                f = this._decodeTag(
                  e,
                  null !== i.implicit ? i.implicit : i.tag,
                  i.any
                );
                if (e.isError(f)) return f;
                i.any ? (n = e.raw(t)) : (e = f);
              }
              if (
                (r &&
                  r.track &&
                  null !== i.tag &&
                  r.track(e.path(), o, e.length, 'tagged'),
                r &&
                  r.track &&
                  null !== i.tag &&
                  r.track(e.path(), e.offset, e.length, 'content'),
                i.any ||
                  (n =
                    null === i.choice
                      ? this._decodeGeneric(i.tag, e, r)
                      : this._decodeChoice(e, r)),
                e.isError(n))
              )
                return n;
              i.any ||
                null !== i.choice ||
                null === i.children ||
                i.children.forEach(function(t) {
                  t._decode(e, r);
                }),
                !i.contains ||
                  ('octstr' !== i.tag && 'bitstr' !== i.tag) ||
                  ((o = new c(n)),
                  (n = this._getUse(i.contains, e._reporterState.obj)._decode(
                    o,
                    r
                  )));
            }
            return (
              i.obj && s && (n = e.leaveObject(a)),
              null === i.key || (null === n && !0 !== s)
                ? null !== t && e.exitKey(t)
                : e.leaveKey(t, i.key, n),
              n
            );
          }),
          (a.prototype._decodeGeneric = function(t, e, r) {
            var i = this._baseState;
            return 'seq' === t || 'set' === t
              ? null
              : 'seqof' === t || 'setof' === t
              ? this._decodeList(e, t, i.args[0], r)
              : /str$/.test(t)
              ? this._decodeStr(e, t, r)
              : 'objid' === t && i.args
              ? this._decodeObjid(e, i.args[0], i.args[1], r)
              : 'objid' === t
              ? this._decodeObjid(e, null, null, r)
              : 'gentime' === t || 'utctime' === t
              ? this._decodeTime(e, t, r)
              : 'null_' === t
              ? this._decodeNull(e, r)
              : 'bool' === t
              ? this._decodeBool(e, r)
              : 'objDesc' === t
              ? this._decodeStr(e, t, r)
              : 'int' === t || 'enum' === t
              ? this._decodeInt(e, i.args && i.args[0], r)
              : null !== i.use
              ? this._getUse(i.use, e._reporterState.obj)._decode(e, r)
              : e.error('unknown tag: ' + t);
          }),
          (a.prototype._getUse = function(t, e) {
            const r = this._baseState;
            return (
              (r.useDecoder = this._use(t, e)),
              n(null === r.useDecoder._baseState.parent),
              (r.useDecoder = r.useDecoder._baseState.children[0]),
              r.implicit !== r.useDecoder._baseState.implicit &&
                ((r.useDecoder = r.useDecoder.clone()),
                (r.useDecoder._baseState.implicit = r.implicit)),
              r.useDecoder
            );
          }),
          (a.prototype._decodeChoice = function(n, s) {
            const o = this._baseState;
            let a = null,
              f = !1;
            return (
              Object.keys(o.choice).some(function(t) {
                var e = n.save();
                const r = o.choice[t];
                try {
                  var i = r._decode(n, s);
                  if (n.isError(i)) return !1;
                  (a = { type: t, value: i }), (f = !0);
                } catch (t) {
                  return n.restore(e), !1;
                }
                return !0;
              }, this),
              f ? a : n.error('Choice not matched')
            );
          }),
          (a.prototype._createEncoderBuffer = function(t) {
            return new i(t, this.reporter);
          }),
          (a.prototype._encode = function(t, e, r) {
            var i = this._baseState;
            if (null === i.default || i.default !== t) {
              t = this._encodeValue(t, e, r);
              if (void 0 !== t && !this._skipDefault(t, e, r)) return t;
            }
          }),
          (a.prototype._encodeValue = function(r, i, t) {
            const e = this._baseState;
            if (null === e.parent)
              return e.children[0]._encode(r, i || new h());
            let n = null;
            if (((this.reporter = i), e.optional && void 0 === r)) {
              if (null === e.default) return;
              r = e.default;
            }
            let s = null,
              o = !1;
            if (e.any) n = this._createEncoderBuffer(r);
            else if (e.choice) n = this._encodeChoice(r, i);
            else if (e.contains)
              (s = this._getUse(e.contains, t)._encode(r, i)), (o = !0);
            else if (e.children)
              (s = e.children
                .map(function(t) {
                  if ('null_' === t._baseState.tag)
                    return t._encode(null, i, r);
                  if (null === t._baseState.key)
                    return i.error('Child should have a key');
                  var e = i.enterKey(t._baseState.key);
                  if ('object' != typeof r)
                    return i.error('Child expected, but input is not object');
                  t = t._encode(r[t._baseState.key], i, r);
                  return i.leaveKey(e), t;
                }, this)
                .filter(function(t) {
                  return t;
                })),
                (s = this._createEncoderBuffer(s));
            else if ('seqof' === e.tag || 'setof' === e.tag) {
              if (!e.args || 1 !== e.args.length)
                return i.error('Too many args for : ' + e.tag);
              if (!Array.isArray(r))
                return i.error('seqof/setof, but data is not Array');
              const f = this.clone();
              (f._baseState.implicit = null),
                (s = this._createEncoderBuffer(
                  r.map(function(t) {
                    var e = this._baseState;
                    return this._getUse(e.args[0], r)._encode(t, i);
                  }, f)
                ));
            } else
              null !== e.use
                ? (n = this._getUse(e.use, t)._encode(r, i))
                : ((s = this._encodePrimitive(e.tag, r)), (o = !0));
            var a;
            return (
              e.any ||
                null !== e.choice ||
                ((a = null !== e.implicit ? e.implicit : e.tag),
                (t = null === e.implicit ? 'universal' : 'context'),
                null === a
                  ? null === e.use &&
                    i.error('Tag could be omitted only for .use()')
                  : null === e.use && (n = this._encodeComposite(a, o, t, s))),
              null !== e.explicit &&
                (n = this._encodeComposite(e.explicit, !1, 'context', n)),
              n
            );
          }),
          (a.prototype._encodeChoice = function(t, e) {
            var r = this._baseState;
            const i = r.choice[t.type];
            return (
              i ||
                n(
                  !1,
                  t.type +
                    ' not found in ' +
                    JSON.stringify(Object.keys(r.choice))
                ),
              i._encode(t.value, e)
            );
          }),
          (a.prototype._encodePrimitive = function(t, e) {
            var r = this._baseState;
            if (/str$/.test(t)) return this._encodeStr(e, t);
            if ('objid' === t && r.args)
              return this._encodeObjid(e, r.reverseArgs[0], r.args[1]);
            if ('objid' === t) return this._encodeObjid(e, null, null);
            if ('gentime' === t || 'utctime' === t)
              return this._encodeTime(e, t);
            if ('null_' === t) return this._encodeNull();
            if ('int' === t || 'enum' === t)
              return this._encodeInt(e, r.args && r.reverseArgs[0]);
            if ('bool' === t) return this._encodeBool(e);
            if ('objDesc' === t) return this._encodeStr(e, t);
            throw new Error('Unsupported tag: ' + t);
          }),
          (a.prototype._isNumstr = function(t) {
            return /^[0-9 ]*$/.test(t);
          }),
          (a.prototype._isPrintstr = function(t) {
            return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(t);
          });
      },
      {
        '../base/buffer': 4,
        '../base/reporter': 7,
        'minimalistic-assert': 137,
      },
    ],
    7: [
      function(t, e, r) {
        'use strict';
        const i = t('inherits');
        function n(t) {
          this._reporterState = {
            obj: null,
            path: [],
            options: t || {},
            errors: [],
          };
        }
        function s(t, e) {
          (this.path = t), this.rethrow(e);
        }
        ((r.Reporter = n).prototype.isError = function(t) {
          return t instanceof s;
        }),
          (n.prototype.save = function() {
            var t = this._reporterState;
            return { obj: t.obj, pathLen: t.path.length };
          }),
          (n.prototype.restore = function(t) {
            const e = this._reporterState;
            (e.obj = t.obj), (e.path = e.path.slice(0, t.pathLen));
          }),
          (n.prototype.enterKey = function(t) {
            return this._reporterState.path.push(t);
          }),
          (n.prototype.exitKey = function(t) {
            const e = this._reporterState;
            e.path = e.path.slice(0, t - 1);
          }),
          (n.prototype.leaveKey = function(t, e, r) {
            const i = this._reporterState;
            this.exitKey(t), null !== i.obj && (i.obj[e] = r);
          }),
          (n.prototype.path = function() {
            return this._reporterState.path.join('/');
          }),
          (n.prototype.enterObject = function() {
            const t = this._reporterState;
            var e = t.obj;
            return (t.obj = {}), e;
          }),
          (n.prototype.leaveObject = function(t) {
            const e = this._reporterState;
            var r = e.obj;
            return (e.obj = t), r;
          }),
          (n.prototype.error = function(t) {
            let e;
            const r = this._reporterState;
            var i = t instanceof s;
            if (
              ((e = i
                ? t
                : new s(
                    r.path
                      .map(function(t) {
                        return '[' + JSON.stringify(t) + ']';
                      })
                      .join(''),
                    t.message || t,
                    t.stack
                  )),
              !r.options.partial)
            )
              throw e;
            return i || r.errors.push(e), e;
          }),
          (n.prototype.wrapResult = function(t) {
            var e = this._reporterState;
            return e.options.partial
              ? { result: this.isError(t) ? null : t, errors: e.errors }
              : t;
          }),
          i(s, Error),
          (s.prototype.rethrow = function(t) {
            if (
              ((this.message = t + ' at: ' + (this.path || '(shallow)')),
              Error.captureStackTrace && Error.captureStackTrace(this, s),
              !this.stack)
            )
              try {
                throw new Error(this.message);
              } catch (t) {
                this.stack = t.stack;
              }
            return this;
          });
      },
      { inherits: 133 },
    ],
    8: [
      function(t, e, r) {
        'use strict';
        function i(r) {
          const i = {};
          return (
            Object.keys(r).forEach(function(t) {
              (0 | t) == t && (t |= 0);
              var e = r[t];
              i[e] = t;
            }),
            i
          );
        }
        (r.tagClass = {
          0: 'universal',
          1: 'application',
          2: 'context',
          3: 'private',
        }),
          (r.tagClassByName = i(r.tagClass)),
          (r.tag = {
            0: 'end',
            1: 'bool',
            2: 'int',
            3: 'bitstr',
            4: 'octstr',
            5: 'null_',
            6: 'objid',
            7: 'objDesc',
            8: 'external',
            9: 'real',
            10: 'enum',
            11: 'embed',
            12: 'utf8str',
            13: 'relativeOid',
            16: 'seq',
            17: 'set',
            18: 'numstr',
            19: 'printstr',
            20: 't61str',
            21: 'videostr',
            22: 'ia5str',
            23: 'utctime',
            24: 'gentime',
            25: 'graphstr',
            26: 'iso646str',
            27: 'genstr',
            28: 'unistr',
            29: 'charstr',
            30: 'bmpstr',
          }),
          (r.tagByName = i(r.tag));
      },
      {},
    ],
    9: [
      function(t, e, r) {
        'use strict';
        const i = r;
        (i._reverse = function(r) {
          const i = {};
          return (
            Object.keys(r).forEach(function(t) {
              (0 | t) == t && (t |= 0);
              var e = r[t];
              i[e] = t;
            }),
            i
          );
        }),
          (i.der = t('./der'));
      },
      { './der': 8 },
    ],
    10: [
      function(t, e, r) {
        'use strict';
        const i = t('inherits'),
          n = t('bn.js'),
          s = t('../base/buffer').DecoderBuffer,
          o = t('../base/node'),
          a = t('../constants/der');
        function f(t) {
          (this.enc = 'der'),
            (this.name = t.name),
            (this.entity = t),
            (this.tree = new h()),
            this.tree._init(t.body);
        }
        function h(t) {
          o.call(this, 'der', t);
        }
        function c(e, r) {
          let i = e.readUInt8(r);
          if (e.isError(i)) return i;
          var t = a.tagClass[i >> 6],
            n = 0 == (32 & i);
          if (31 == (31 & i)) {
            let t = i;
            for (i = 0; 128 == (128 & t); ) {
              if (((t = e.readUInt8(r)), e.isError(t))) return t;
              (i <<= 7), (i |= 127 & t);
            }
          } else i &= 31;
          var s = a.tag[i];
          return { cls: t, primitive: n, tag: i, tagStr: s };
        }
        function u(e, t, r) {
          let i = e.readUInt8(r);
          if (e.isError(i)) return i;
          if (!t && 128 === i) return null;
          if (0 == (128 & i)) return i;
          var n = 127 & i;
          if (4 < n) return e.error('length octect is too long');
          for (let t = (i = 0); t < n; t++) {
            i <<= 8;
            var s = e.readUInt8(r);
            if (e.isError(s)) return s;
            i |= s;
          }
          return i;
        }
        ((e.exports = f).prototype.decode = function(t, e) {
          return (
            s.isDecoderBuffer(t) || (t = new s(t, e)), this.tree._decode(t, e)
          );
        }),
          i(h, o),
          (h.prototype._peekTag = function(t, e, r) {
            if (t.isEmpty()) return !1;
            var i = t.save(),
              n = c(t, 'Failed to peek tag: "' + e + '"');
            return t.isError(n)
              ? n
              : (t.restore(i),
                n.tag === e || n.tagStr === e || n.tagStr + 'of' === e || r);
          }),
          (h.prototype._decodeTag = function(t, e, r) {
            var i = c(t, 'Failed to decode tag of "' + e + '"');
            if (t.isError(i)) return i;
            let n = u(t, i.primitive, 'Failed to get length of "' + e + '"');
            if (t.isError(n)) return n;
            if (!r && i.tag !== e && i.tagStr !== e && i.tagStr + 'of' !== e)
              return t.error('Failed to match tag: "' + e + '"');
            if (i.primitive || null !== n)
              return t.skip(n, 'Failed to match body of: "' + e + '"');
            (r = t.save()),
              (i = this._skipUntilEnd(
                t,
                'Failed to skip indefinite length body: "' + this.tag + '"'
              ));
            return t.isError(i)
              ? i
              : ((n = t.offset - r.offset),
                t.restore(r),
                t.skip(n, 'Failed to match body of: "' + e + '"'));
          }),
          (h.prototype._skipUntilEnd = function(e, r) {
            for (;;) {
              var i = c(e, r);
              if (e.isError(i)) return i;
              var n = u(e, i.primitive, r);
              if (e.isError(n)) return n;
              let t;
              if (
                ((t =
                  i.primitive || null !== n
                    ? e.skip(n)
                    : this._skipUntilEnd(e, r)),
                e.isError(t))
              )
                return t;
              if ('end' === i.tagStr) break;
            }
          }),
          (h.prototype._decodeList = function(t, e, r, i) {
            const n = [];
            for (; !t.isEmpty(); ) {
              var s = this._peekTag(t, 'end');
              if (t.isError(s)) return s;
              var o = r.decode(t, 'der', i);
              if (t.isError(o) && s) break;
              n.push(o);
            }
            return n;
          }),
          (h.prototype._decodeStr = function(t, e) {
            if ('bitstr' === e) {
              var r = t.readUInt8();
              return t.isError(r) ? r : { unused: r, data: t.raw() };
            }
            if ('bmpstr' === e) {
              const i = t.raw();
              if (i.length % 2 == 1)
                return t.error(
                  'Decoding of string type: bmpstr length mismatch'
                );
              let e = '';
              for (let t = 0; t < i.length / 2; t++)
                e += String.fromCharCode(i.readUInt16BE(2 * t));
              return e;
            }
            if ('numstr' === e) {
              r = t.raw().toString('ascii');
              return this._isNumstr(r)
                ? r
                : t.error(
                    'Decoding of string type: numstr unsupported characters'
                  );
            }
            if ('octstr' === e) return t.raw();
            if ('objDesc' === e) return t.raw();
            if ('printstr' !== e)
              return /str$/.test(e)
                ? t.raw().toString()
                : t.error('Decoding of string type: ' + e + ' unsupported');
            e = t.raw().toString('ascii');
            return this._isPrintstr(e)
              ? e
              : t.error(
                  'Decoding of string type: printstr unsupported characters'
                );
          }),
          (h.prototype._decodeObjid = function(t, e, r) {
            let i;
            const n = [];
            let s = 0,
              o = 0;
            for (; !t.isEmpty(); )
              (o = t.readUInt8()),
                (s <<= 7),
                (s |= 127 & o),
                0 == (128 & o) && (n.push(s), (s = 0));
            128 & o && n.push(s);
            const a = (n[0] / 40) | 0,
              f = n[0] % 40;
            if (((i = r ? n : [a, f].concat(n.slice(1))), e)) {
              let t = e[i.join(' ')];
              void 0 === t && (t = e[i.join('.')]), void 0 !== t && (i = t);
            }
            return i;
          }),
          (h.prototype._decodeTime = function(t, e) {
            const r = t.raw().toString();
            let i, n, s, o, a, f;
            if ('gentime' === e)
              (i = 0 | r.slice(0, 4)),
                (n = 0 | r.slice(4, 6)),
                (s = 0 | r.slice(6, 8)),
                (o = 0 | r.slice(8, 10)),
                (a = 0 | r.slice(10, 12)),
                (f = 0 | r.slice(12, 14));
            else {
              if ('utctime' !== e)
                return t.error('Decoding ' + e + ' time is not supported yet');
              (i = 0 | r.slice(0, 2)),
                (n = 0 | r.slice(2, 4)),
                (s = 0 | r.slice(4, 6)),
                (o = 0 | r.slice(6, 8)),
                (a = 0 | r.slice(8, 10)),
                (f = 0 | r.slice(10, 12)),
                (i = i < 70 ? 2e3 + i : 1900 + i);
            }
            return Date.UTC(i, n - 1, s, o, a, f, 0);
          }),
          (h.prototype._decodeNull = function() {
            return null;
          }),
          (h.prototype._decodeBool = function(t) {
            var e = t.readUInt8();
            return t.isError(e) ? e : 0 !== e;
          }),
          (h.prototype._decodeInt = function(t, e) {
            t = t.raw();
            let r = new n(t);
            return e && (r = e[r.toString(10)] || r), r;
          }),
          (h.prototype._use = function(t, e) {
            return (t = 'function' == typeof t ? t(e) : t)._getDecoder('der')
              .tree;
          });
      },
      {
        '../base/buffer': 4,
        '../base/node': 6,
        '../constants/der': 8,
        'bn.js': 16,
        inherits: 133,
      },
    ],
    11: [
      function(t, e, r) {
        'use strict';
        const i = r;
        (i.der = t('./der')), (i.pem = t('./pem'));
      },
      { './der': 10, './pem': 12 },
    ],
    12: [
      function(t, e, r) {
        'use strict';
        const i = t('inherits'),
          h = t('safer-buffer').Buffer,
          c = t('./der');
        function n(t) {
          c.call(this, t), (this.enc = 'pem');
        }
        i(n, c),
          ((e.exports = n).prototype.decode = function(t, e) {
            const r = t.toString().split(/[\r\n]+/g);
            var i = e.label.toUpperCase(),
              n = /^-----(BEGIN|END) ([^-]+)-----$/;
            let s = -1,
              o = -1;
            for (let t = 0; t < r.length; t++) {
              var a = r[t].match(n);
              if (null !== a && a[2] === i) {
                if (-1 !== s) {
                  if ('END' !== a[1]) break;
                  o = t;
                  break;
                }
                if ('BEGIN' !== a[1]) break;
                s = t;
              }
            }
            if (-1 === s || -1 === o)
              throw new Error('PEM section not found for: ' + i);
            const f = r.slice(s + 1, o).join('');
            f.replace(/[^a-z0-9+/=]+/gi, '');
            t = h.from(f, 'base64');
            return c.prototype.decode.call(this, t, e);
          });
      },
      { './der': 10, inherits: 133, 'safer-buffer': 162 },
    ],
    13: [
      function(t, e, r) {
        'use strict';
        const i = t('inherits'),
          o = t('safer-buffer').Buffer,
          n = t('../base/node'),
          a = t('../constants/der');
        function s(t) {
          (this.enc = 'der'),
            (this.name = t.name),
            (this.entity = t),
            (this.tree = new f()),
            this.tree._init(t.body);
        }
        function f(t) {
          n.call(this, 'der', t);
        }
        function h(t) {
          return t < 10 ? '0' + t : t;
        }
        ((e.exports = s).prototype.encode = function(t, e) {
          return this.tree._encode(t, e).join();
        }),
          i(f, n),
          (f.prototype._encodeComposite = function(t, e, r, i) {
            r = (function(t, e, r, i) {
              let n;
              'seqof' === t ? (t = 'seq') : 'setof' === t && (t = 'set');
              if (a.tagByName.hasOwnProperty(t)) n = a.tagByName[t];
              else {
                if ('number' != typeof t || (0 | t) !== t)
                  return i.error('Unknown tag: ' + t);
                n = t;
              }
              if (31 <= n)
                return i.error('Multi-octet tag encoding unsupported');
              e || (n |= 32);
              return (n |= a.tagClassByName[r || 'universal'] << 6), n;
            })(t, e, r, this.reporter);
            if (i.length < 128) {
              const s = o.alloc(2);
              return (
                (s[0] = r), (s[1] = i.length), this._createEncoderBuffer([s, i])
              );
            }
            let n = 1;
            for (let t = i.length; 256 <= t; t >>= 8) n++;
            const s = o.alloc(2 + n);
            (s[0] = r), (s[1] = 128 | n);
            for (let t = 1 + n, e = i.length; 0 < e; t--, e >>= 8)
              s[t] = 255 & e;
            return this._createEncoderBuffer([s, i]);
          }),
          (f.prototype._encodeStr = function(e, t) {
            if ('bitstr' === t)
              return this._createEncoderBuffer([0 | e.unused, e.data]);
            if ('bmpstr' !== t)
              return 'numstr' === t
                ? this._isNumstr(e)
                  ? this._createEncoderBuffer(e)
                  : this.reporter.error(
                      'Encoding of string type: numstr supports only digits and space'
                    )
                : 'printstr' === t
                ? this._isPrintstr(e)
                  ? this._createEncoderBuffer(e)
                  : this.reporter.error(
                      'Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark'
                    )
                : /str$/.test(t) || 'objDesc' === t
                ? this._createEncoderBuffer(e)
                : this.reporter.error(
                    'Encoding of string type: ' + t + ' unsupported'
                  );
            {
              const r = o.alloc(2 * e.length);
              for (let t = 0; t < e.length; t++)
                r.writeUInt16BE(e.charCodeAt(t), 2 * t);
              return this._createEncoderBuffer(r);
            }
          }),
          (f.prototype._encodeObjid = function(r, t, e) {
            if ('string' == typeof r) {
              if (!t)
                return this.reporter.error(
                  'string objid given, but no values map found'
                );
              if (!t.hasOwnProperty(r))
                return this.reporter.error('objid not found in values map');
              r = t[r].split(/[\s.]+/g);
              for (let t = 0; t < r.length; t++) r[t] |= 0;
            } else if (Array.isArray(r)) {
              r = r.slice();
              for (let t = 0; t < r.length; t++) r[t] |= 0;
            }
            if (!Array.isArray(r))
              return this.reporter.error(
                'objid() should be either array or string, got: ' +
                  JSON.stringify(r)
              );
            if (!e) {
              if (40 <= r[1])
                return this.reporter.error('Second objid identifier OOB');
              r.splice(0, 2, 40 * r[0] + r[1]);
            }
            let i = 0;
            for (let e = 0; e < r.length; e++) {
              let t = r[e];
              for (i++; 128 <= t; t >>= 7) i++;
            }
            const n = o.alloc(i);
            let s = n.length - 1;
            for (let e = r.length - 1; 0 <= e; e--) {
              let t = r[e];
              for (n[s--] = 127 & t; 0 < (t >>= 7); ) n[s--] = 128 | (127 & t);
            }
            return this._createEncoderBuffer(n);
          }),
          (f.prototype._encodeTime = function(t, e) {
            let r;
            const i = new Date(t);
            return (
              'gentime' === e
                ? (r = [
                    h(i.getUTCFullYear()),
                    h(i.getUTCMonth() + 1),
                    h(i.getUTCDate()),
                    h(i.getUTCHours()),
                    h(i.getUTCMinutes()),
                    h(i.getUTCSeconds()),
                    'Z',
                  ].join(''))
                : 'utctime' === e
                ? (r = [
                    h(i.getUTCFullYear() % 100),
                    h(i.getUTCMonth() + 1),
                    h(i.getUTCDate()),
                    h(i.getUTCHours()),
                    h(i.getUTCMinutes()),
                    h(i.getUTCSeconds()),
                    'Z',
                  ].join(''))
                : this.reporter.error(
                    'Encoding ' + e + ' time is not supported yet'
                  ),
              this._encodeStr(r, 'octstr')
            );
          }),
          (f.prototype._encodeNull = function() {
            return this._createEncoderBuffer('');
          }),
          (f.prototype._encodeInt = function(e, t) {
            if ('string' == typeof e) {
              if (!t)
                return this.reporter.error(
                  'String int or enum given, but no values map'
                );
              if (!t.hasOwnProperty(e))
                return this.reporter.error(
                  "Values map doesn't contain: " + JSON.stringify(e)
                );
              e = t[e];
            }
            if ('number' != typeof e && !o.isBuffer(e)) {
              const n = e.toArray();
              !e.sign && 128 & n[0] && n.unshift(0), (e = o.from(n));
            }
            if (o.isBuffer(e)) {
              let t = e.length;
              0 === e.length && t++;
              const i = o.alloc(t);
              return (
                e.copy(i),
                0 === e.length && (i[0] = 0),
                this._createEncoderBuffer(i)
              );
            }
            if (e < 128) return this._createEncoderBuffer(e);
            if (e < 256) return this._createEncoderBuffer([0, e]);
            let r = 1;
            for (let t = e; 256 <= t; t >>= 8) r++;
            const i = new Array(r);
            for (let t = i.length - 1; 0 <= t; t--) (i[t] = 255 & e), (e >>= 8);
            return (
              128 & i[0] && i.unshift(0), this._createEncoderBuffer(o.from(i))
            );
          }),
          (f.prototype._encodeBool = function(t) {
            return this._createEncoderBuffer(t ? 255 : 0);
          }),
          (f.prototype._use = function(t, e) {
            return (t = 'function' == typeof t ? t(e) : t)._getEncoder('der')
              .tree;
          }),
          (f.prototype._skipDefault = function(t, e, r) {
            const i = this._baseState;
            let n;
            if (null === i.default) return !1;
            var s = t.join();
            if (
              (void 0 === i.defaultBuffer &&
                (i.defaultBuffer = this._encodeValue(i.default, e, r).join()),
              s.length !== i.defaultBuffer.length)
            )
              return !1;
            for (n = 0; n < s.length; n++)
              if (s[n] !== i.defaultBuffer[n]) return !1;
            return !0;
          });
      },
      {
        '../base/node': 6,
        '../constants/der': 8,
        inherits: 133,
        'safer-buffer': 162,
      },
    ],
    14: [
      function(t, e, r) {
        'use strict';
        const i = r;
        (i.der = t('./der')), (i.pem = t('./pem'));
      },
      { './der': 13, './pem': 15 },
    ],
    15: [
      function(t, e, r) {
        'use strict';
        const i = t('inherits'),
          s = t('./der');
        function n(t) {
          s.call(this, t), (this.enc = 'pem');
        }
        i(n, s),
          ((e.exports = n).prototype.encode = function(t, e) {
            const r = s.prototype.encode.call(this, t),
              i = r.toString('base64'),
              n = ['-----BEGIN ' + e.label + '-----'];
            for (let t = 0; t < i.length; t += 64) n.push(i.slice(t, t + 64));
            return n.push('-----END ' + e.label + '-----'), n.join('\n');
          });
      },
      { './der': 13, inherits: 133 },
    ],
    16: [
      function(E, t, e) {
        !(function(t, e) {
          'use strict';
          function b(t, e) {
            if (!t) throw new Error(e || 'Assertion failed');
          }
          function r(t, e) {
            t.super_ = e;
            function r() {}
            (r.prototype = e.prototype),
              (t.prototype = new r()),
              (t.prototype.constructor = t);
          }
          function m(t, e, r) {
            if (m.isBN(t)) return t;
            (this.negative = 0),
              (this.words = null),
              (this.length = 0),
              (this.red = null) !== t &&
                (('le' !== e && 'be' !== e) || ((r = e), (e = 10)),
                this._init(t || 0, e || 10, r || 'be'));
          }
          var i;
          'object' == typeof t ? (t.exports = m) : (e.BN = m),
            ((m.BN = m).wordSize = 26);
          try {
            i = ('undefined' != typeof window && void 0 !== window.Buffer
              ? window
              : E('buffer')
            ).Buffer;
          } catch (t) {}
          function n(t, e) {
            e = t.charCodeAt(e);
            return 65 <= e && e <= 70
              ? e - 55
              : 97 <= e && e <= 102
              ? e - 87
              : (e - 48) & 15;
          }
          function a(t, e, r) {
            var i = n(t, r);
            return e <= r - 1 && (i |= n(t, r - 1) << 4), i;
          }
          function u(t, e, r, i) {
            for (var n = 0, s = Math.min(t.length, r), o = e; o < s; o++) {
              var a = t.charCodeAt(o) - 48;
              (n *= i),
                (n += 49 <= a ? a - 49 + 10 : 17 <= a ? a - 17 + 10 : a);
            }
            return n;
          }
          (m.isBN = function(t) {
            return (
              t instanceof m ||
              (null !== t &&
                'object' == typeof t &&
                t.constructor.wordSize === m.wordSize &&
                Array.isArray(t.words))
            );
          }),
            (m.max = function(t, e) {
              return 0 < t.cmp(e) ? t : e;
            }),
            (m.min = function(t, e) {
              return t.cmp(e) < 0 ? t : e;
            }),
            (m.prototype._init = function(t, e, r) {
              if ('number' == typeof t) return this._initNumber(t, e, r);
              if ('object' == typeof t) return this._initArray(t, e, r);
              b((e = 'hex' === e ? 16 : e) === (0 | e) && 2 <= e && e <= 36);
              var i = 0;
              '-' === (t = t.toString().replace(/\s+/g, ''))[0] &&
                (i++, (this.negative = 1)),
                i < t.length &&
                  (16 === e
                    ? this._parseHex(t, i, r)
                    : (this._parseBase(t, e, i),
                      'le' === r && this._initArray(this.toArray(), e, r)));
            }),
            (m.prototype._initNumber = function(t, e, r) {
              t < 0 && ((this.negative = 1), (t = -t)),
                t < 67108864
                  ? ((this.words = [67108863 & t]), (this.length = 1))
                  : t < 4503599627370496
                  ? ((this.words = [67108863 & t, (t / 67108864) & 67108863]),
                    (this.length = 2))
                  : (b(t < 9007199254740992),
                    (this.words = [67108863 & t, (t / 67108864) & 67108863, 1]),
                    (this.length = 3)),
                'le' === r && this._initArray(this.toArray(), e, r);
            }),
            (m.prototype._initArray = function(t, e, r) {
              if ((b('number' == typeof t.length), t.length <= 0))
                return (this.words = [0]), (this.length = 1), this;
              (this.length = Math.ceil(t.length / 3)),
                (this.words = new Array(this.length));
              for (var i, n, s = 0; s < this.length; s++) this.words[s] = 0;
              var o = 0;
              if ('be' === r)
                for (s = t.length - 1, i = 0; 0 <= s; s -= 3)
                  (n = t[s] | (t[s - 1] << 8) | (t[s - 2] << 16)),
                    (this.words[i] |= (n << o) & 67108863),
                    (this.words[i + 1] = (n >>> (26 - o)) & 67108863),
                    26 <= (o += 24) && ((o -= 26), i++);
              else if ('le' === r)
                for (i = s = 0; s < t.length; s += 3)
                  (n = t[s] | (t[s + 1] << 8) | (t[s + 2] << 16)),
                    (this.words[i] |= (n << o) & 67108863),
                    (this.words[i + 1] = (n >>> (26 - o)) & 67108863),
                    26 <= (o += 24) && ((o -= 26), i++);
              return this.strip();
            }),
            (m.prototype._parseHex = function(t, e, r) {
              (this.length = Math.ceil((t.length - e) / 6)),
                (this.words = new Array(this.length));
              for (var i = 0; i < this.length; i++) this.words[i] = 0;
              var n,
                s = 0,
                o = 0;
              if ('be' === r)
                for (i = t.length - 1; e <= i; i -= 2)
                  (n = a(t, e, i) << s),
                    (this.words[o] |= 67108863 & n),
                    18 <= s
                      ? ((s -= 18), (this.words[(o += 1)] |= n >>> 26))
                      : (s += 8);
              else
                for (
                  i = (t.length - e) % 2 == 0 ? e + 1 : e;
                  i < t.length;
                  i += 2
                )
                  (n = a(t, e, i) << s),
                    (this.words[o] |= 67108863 & n),
                    18 <= s
                      ? ((s -= 18), (this.words[(o += 1)] |= n >>> 26))
                      : (s += 8);
              this.strip();
            }),
            (m.prototype._parseBase = function(t, e, r) {
              this.words = [0];
              for (var i = 0, n = (this.length = 1); n <= 67108863; n *= e) i++;
              for (
                var n = (n / e) | 0,
                  s = t.length - r,
                  o = s % --i,
                  a = Math.min(s, s - o) + r,
                  f = 0,
                  h = r;
                h < a;
                h += i
              )
                (f = u(t, h, h + i, e)),
                  this.imuln(n),
                  this.words[0] + f < 67108864
                    ? (this.words[0] += f)
                    : this._iaddn(f);
              if (0 != o) {
                for (var c = 1, f = u(t, h, t.length, e), h = 0; h < o; h++)
                  c *= e;
                this.imuln(c),
                  this.words[0] + f < 67108864
                    ? (this.words[0] += f)
                    : this._iaddn(f);
              }
              this.strip();
            }),
            (m.prototype.copy = function(t) {
              t.words = new Array(this.length);
              for (var e = 0; e < this.length; e++) t.words[e] = this.words[e];
              (t.length = this.length),
                (t.negative = this.negative),
                (t.red = this.red);
            }),
            (m.prototype.clone = function() {
              var t = new m(null);
              return this.copy(t), t;
            }),
            (m.prototype._expand = function(t) {
              for (; this.length < t; ) this.words[this.length++] = 0;
              return this;
            }),
            (m.prototype.strip = function() {
              for (; 1 < this.length && 0 === this.words[this.length - 1]; )
                this.length--;
              return this._normSign();
            }),
            (m.prototype._normSign = function() {
              return (
                1 === this.length && 0 === this.words[0] && (this.negative = 0),
                this
              );
            }),
            (m.prototype.inspect = function() {
              return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
            });
          var d = [
              '',
              '0',
              '00',
              '000',
              '0000',
              '00000',
              '000000',
              '0000000',
              '00000000',
              '000000000',
              '0000000000',
              '00000000000',
              '000000000000',
              '0000000000000',
              '00000000000000',
              '000000000000000',
              '0000000000000000',
              '00000000000000000',
              '000000000000000000',
              '0000000000000000000',
              '00000000000000000000',
              '000000000000000000000',
              '0000000000000000000000',
              '00000000000000000000000',
              '000000000000000000000000',
              '0000000000000000000000000',
            ],
            l = [
              0,
              0,
              25,
              16,
              12,
              11,
              10,
              9,
              8,
              8,
              7,
              7,
              7,
              7,
              6,
              6,
              6,
              6,
              6,
              6,
              6,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
            ],
            p = [
              0,
              0,
              33554432,
              43046721,
              16777216,
              48828125,
              60466176,
              40353607,
              16777216,
              43046721,
              1e7,
              19487171,
              35831808,
              62748517,
              7529536,
              11390625,
              16777216,
              24137569,
              34012224,
              47045881,
              64e6,
              4084101,
              5153632,
              6436343,
              7962624,
              9765625,
              11881376,
              14348907,
              17210368,
              20511149,
              243e5,
              28629151,
              33554432,
              39135393,
              45435424,
              52521875,
              60466176,
            ];
          function s(t, e, r) {
            r.negative = e.negative ^ t.negative;
            var i = (t.length + e.length) | 0,
              i = ((r.length = i) - 1) | 0,
              n = ((o = (0 | t.words[0]) * (0 | e.words[0])) / 67108864) | 0;
            r.words[0] = 67108863 & o;
            for (var s = 1; s < i; s++) {
              for (
                var o,
                  a = n >>> 26,
                  f = 67108863 & n,
                  h = Math.min(s, e.length - 1),
                  c = Math.max(0, s - t.length + 1);
                c <= h;
                c++
              )
                (a +=
                  ((o = (0 | t.words[(s - c) | 0]) * (0 | e.words[c]) + f) /
                    67108864) |
                  0),
                  (f = 67108863 & o);
              (r.words[s] = 0 | f), (n = 0 | a);
            }
            return 0 !== n ? (r.words[s] = 0 | n) : r.length--, r.strip();
          }
          (m.prototype.toString = function(t, e) {
            if (((e = 0 | e || 1), 16 === (t = t || 10) || 'hex' === t)) {
              a = '';
              for (var r = 0, i = 0, n = 0; n < this.length; n++) {
                var s = this.words[n],
                  o = (16777215 & ((s << r) | i)).toString(16),
                  a =
                    0 !== (i = (s >>> (24 - r)) & 16777215) ||
                    n !== this.length - 1
                      ? d[6 - o.length] + o + a
                      : o + a;
                26 <= (r += 2) && ((r -= 26), n--);
              }
              for (0 !== i && (a = i.toString(16) + a); a.length % e != 0; )
                a = '0' + a;
              return (a = 0 !== this.negative ? '-' + a : a);
            }
            if (t === (0 | t) && 2 <= t && t <= 36) {
              var f = l[t],
                h = p[t];
              for (a = '', (c = this.clone()).negative = 0; !c.isZero(); ) {
                var c,
                  u = c.modn(h).toString(t);
                a = (c = c.idivn(h)).isZero() ? u + a : d[f - u.length] + u + a;
              }
              for (this.isZero() && (a = '0' + a); a.length % e != 0; )
                a = '0' + a;
              return (a = 0 !== this.negative ? '-' + a : a);
            }
            b(!1, 'Base should be between 2 and 36');
          }),
            (m.prototype.toNumber = function() {
              var t = this.words[0];
              return (
                2 === this.length
                  ? (t += 67108864 * this.words[1])
                  : 3 === this.length && 1 === this.words[2]
                  ? (t += 4503599627370496 + 67108864 * this.words[1])
                  : 2 < this.length &&
                    b(!1, 'Number can only safely store up to 53 bits'),
                0 !== this.negative ? -t : t
              );
            }),
            (m.prototype.toJSON = function() {
              return this.toString(16);
            }),
            (m.prototype.toBuffer = function(t, e) {
              return b(void 0 !== i), this.toArrayLike(i, t, e);
            }),
            (m.prototype.toArray = function(t, e) {
              return this.toArrayLike(Array, t, e);
            }),
            (m.prototype.toArrayLike = function(t, e, r) {
              var i = this.byteLength(),
                n = r || Math.max(1, i);
              b(i <= n, 'byte array longer than desired length'),
                b(0 < n, 'Requested array length <= 0'),
                this.strip();
              var s,
                o,
                e = 'le' === e,
                a = new t(n),
                f = this.clone();
              if (e) {
                for (o = 0; !f.isZero(); o++)
                  (s = f.andln(255)), f.iushrn(8), (a[o] = s);
                for (; o < n; o++) a[o] = 0;
              } else {
                for (o = 0; o < n - i; o++) a[o] = 0;
                for (o = 0; !f.isZero(); o++)
                  (s = f.andln(255)), f.iushrn(8), (a[n - o - 1] = s);
              }
              return a;
            }),
            Math.clz32
              ? (m.prototype._countBits = function(t) {
                  return 32 - Math.clz32(t);
                })
              : (m.prototype._countBits = function(t) {
                  var e = t,
                    t = 0;
                  return (
                    4096 <= e && ((t += 13), (e >>>= 13)),
                    64 <= e && ((t += 7), (e >>>= 7)),
                    8 <= e && ((t += 4), (e >>>= 4)),
                    2 <= e && ((t += 2), (e >>>= 2)),
                    t + e
                  );
                }),
            (m.prototype._zeroBits = function(t) {
              if (0 === t) return 26;
              var e = t,
                t = 0;
              return (
                0 == (8191 & e) && ((t += 13), (e >>>= 13)),
                0 == (127 & e) && ((t += 7), (e >>>= 7)),
                0 == (15 & e) && ((t += 4), (e >>>= 4)),
                0 == (3 & e) && ((t += 2), (e >>>= 2)),
                0 == (1 & e) && t++,
                t
              );
            }),
            (m.prototype.bitLength = function() {
              var t = this.words[this.length - 1],
                t = this._countBits(t);
              return 26 * (this.length - 1) + t;
            }),
            (m.prototype.zeroBits = function() {
              if (this.isZero()) return 0;
              for (var t = 0, e = 0; e < this.length; e++) {
                var r = this._zeroBits(this.words[e]);
                if (((t += r), 26 !== r)) break;
              }
              return t;
            }),
            (m.prototype.byteLength = function() {
              return Math.ceil(this.bitLength() / 8);
            }),
            (m.prototype.toTwos = function(t) {
              return 0 !== this.negative
                ? this.abs()
                    .inotn(t)
                    .iaddn(1)
                : this.clone();
            }),
            (m.prototype.fromTwos = function(t) {
              return this.testn(t - 1)
                ? this.notn(t)
                    .iaddn(1)
                    .ineg()
                : this.clone();
            }),
            (m.prototype.isNeg = function() {
              return 0 !== this.negative;
            }),
            (m.prototype.neg = function() {
              return this.clone().ineg();
            }),
            (m.prototype.ineg = function() {
              return this.isZero() || (this.negative ^= 1), this;
            }),
            (m.prototype.iuor = function(t) {
              for (; this.length < t.length; ) this.words[this.length++] = 0;
              for (var e = 0; e < t.length; e++)
                this.words[e] = this.words[e] | t.words[e];
              return this.strip();
            }),
            (m.prototype.ior = function(t) {
              return b(0 == (this.negative | t.negative)), this.iuor(t);
            }),
            (m.prototype.or = function(t) {
              return this.length > t.length
                ? this.clone().ior(t)
                : t.clone().ior(this);
            }),
            (m.prototype.uor = function(t) {
              return this.length > t.length
                ? this.clone().iuor(t)
                : t.clone().iuor(this);
            }),
            (m.prototype.iuand = function(t) {
              for (
                var e = this.length > t.length ? t : this, r = 0;
                r < e.length;
                r++
              )
                this.words[r] = this.words[r] & t.words[r];
              return (this.length = e.length), this.strip();
            }),
            (m.prototype.iand = function(t) {
              return b(0 == (this.negative | t.negative)), this.iuand(t);
            }),
            (m.prototype.and = function(t) {
              return this.length > t.length
                ? this.clone().iand(t)
                : t.clone().iand(this);
            }),
            (m.prototype.uand = function(t) {
              return this.length > t.length
                ? this.clone().iuand(t)
                : t.clone().iuand(this);
            }),
            (m.prototype.iuxor = function(t) {
              for (
                var e,
                  r =
                    this.length > t.length ? ((e = this), t) : ((e = t), this),
                  i = 0;
                i < r.length;
                i++
              )
                this.words[i] = e.words[i] ^ r.words[i];
              if (this !== e)
                for (; i < e.length; i++) this.words[i] = e.words[i];
              return (this.length = e.length), this.strip();
            }),
            (m.prototype.ixor = function(t) {
              return b(0 == (this.negative | t.negative)), this.iuxor(t);
            }),
            (m.prototype.xor = function(t) {
              return this.length > t.length
                ? this.clone().ixor(t)
                : t.clone().ixor(this);
            }),
            (m.prototype.uxor = function(t) {
              return this.length > t.length
                ? this.clone().iuxor(t)
                : t.clone().iuxor(this);
            }),
            (m.prototype.inotn = function(t) {
              b('number' == typeof t && 0 <= t);
              var e = 0 | Math.ceil(t / 26),
                t = t % 26;
              this._expand(e), 0 < t && e--;
              for (var r = 0; r < e; r++)
                this.words[r] = 67108863 & ~this.words[r];
              return (
                0 < t &&
                  (this.words[r] = ~this.words[r] & (67108863 >> (26 - t))),
                this.strip()
              );
            }),
            (m.prototype.notn = function(t) {
              return this.clone().inotn(t);
            }),
            (m.prototype.setn = function(t, e) {
              b('number' == typeof t && 0 <= t);
              var r = (t / 26) | 0,
                t = t % 26;
              return (
                this._expand(1 + r),
                (this.words[r] = e
                  ? this.words[r] | (1 << t)
                  : this.words[r] & ~(1 << t)),
                this.strip()
              );
            }),
            (m.prototype.iadd = function(t) {
              var e, r;
              if (0 !== this.negative && 0 === t.negative)
                return (
                  (this.negative = 0),
                  (e = this.isub(t)),
                  (this.negative ^= 1),
                  this._normSign()
                );
              if (0 === this.negative && 0 !== t.negative)
                return (
                  (t.negative = 0),
                  (e = this.isub(t)),
                  (t.negative = 1),
                  e._normSign()
                );
              for (
                var i =
                    this.length > t.length ? ((r = this), t) : ((r = t), this),
                  n = 0,
                  s = 0;
                s < i.length;
                s++
              )
                (e = (0 | r.words[s]) + (0 | i.words[s]) + n),
                  (this.words[s] = 67108863 & e),
                  (n = e >>> 26);
              for (; 0 !== n && s < r.length; s++)
                (e = (0 | r.words[s]) + n),
                  (this.words[s] = 67108863 & e),
                  (n = e >>> 26);
              if (((this.length = r.length), 0 !== n))
                (this.words[this.length] = n), this.length++;
              else if (r !== this)
                for (; s < r.length; s++) this.words[s] = r.words[s];
              return this;
            }),
            (m.prototype.add = function(t) {
              var e;
              return 0 !== t.negative && 0 === this.negative
                ? ((t.negative = 0), (e = this.sub(t)), (t.negative ^= 1), e)
                : 0 === t.negative && 0 !== this.negative
                ? ((this.negative = 0),
                  (e = t.sub(this)),
                  (this.negative = 1),
                  e)
                : this.length > t.length
                ? this.clone().iadd(t)
                : t.clone().iadd(this);
            }),
            (m.prototype.isub = function(t) {
              if (0 !== t.negative) {
                t.negative = 0;
                var e = this.iadd(t);
                return (t.negative = 1), e._normSign();
              }
              if (0 !== this.negative)
                return (
                  (this.negative = 0),
                  this.iadd(t),
                  (this.negative = 1),
                  this._normSign()
                );
              var r,
                i = this.cmp(t);
              if (0 === i)
                return (
                  (this.negative = 0),
                  (this.length = 1),
                  (this.words[0] = 0),
                  this
                );
              for (
                var n = 0 < i ? ((r = this), t) : ((r = t), this), s = 0, o = 0;
                o < n.length;
                o++
              )
                (s = (e = (0 | r.words[o]) - (0 | n.words[o]) + s) >> 26),
                  (this.words[o] = 67108863 & e);
              for (; 0 !== s && o < r.length; o++)
                (s = (e = (0 | r.words[o]) + s) >> 26),
                  (this.words[o] = 67108863 & e);
              if (0 === s && o < r.length && r !== this)
                for (; o < r.length; o++) this.words[o] = r.words[o];
              return (
                (this.length = Math.max(this.length, o)),
                r !== this && (this.negative = 1),
                this.strip()
              );
            }),
            (m.prototype.sub = function(t) {
              return this.clone().isub(t);
            });
          var o = function(t, e, r) {
            var i = t.words,
              n = e.words,
              s = r.words,
              o = 0 | i[0],
              a = 8191 & o,
              f = o >>> 13,
              h = 0 | i[1],
              c = 8191 & h,
              u = h >>> 13,
              d = 0 | i[2],
              l = 8191 & d,
              p = d >>> 13,
              b = 0 | i[3],
              m = 8191 & b,
              y = b >>> 13,
              g = 0 | i[4],
              v = 8191 & g,
              _ = g >>> 13,
              w = 0 | i[5],
              M = 8191 & w,
              S = w >>> 13,
              E = 0 | i[6],
              k = 8191 & E,
              A = E >>> 13,
              x = 0 | i[7],
              B = 8191 & x,
              I = x >>> 13,
              R = 0 | i[8],
              j = 8191 & R,
              T = R >>> 13,
              C = 0 | i[9],
              L = 8191 & C,
              P = C >>> 13,
              O = 0 | n[0],
              D = 8191 & O,
              N = O >>> 13,
              q = 0 | n[1],
              U = 8191 & q,
              z = q >>> 13,
              K = 0 | n[2],
              F = 8191 & K,
              H = K >>> 13,
              W = 0 | n[3],
              V = 8191 & W,
              Z = W >>> 13,
              X = 0 | n[4],
              G = 8191 & X,
              Y = X >>> 13,
              J = 0 | n[5],
              $ = 8191 & J,
              Q = J >>> 13,
              o = 0 | n[6],
              h = 8191 & o,
              d = o >>> 13,
              b = 0 | n[7],
              g = 8191 & b,
              w = b >>> 13,
              E = 0 | n[8],
              x = 8191 & E,
              R = E >>> 13,
              i = 0 | n[9],
              C = 8191 & i,
              O = i >>> 13;
            (r.negative = t.negative ^ e.negative), (r.length = 19);
            var W =
                (((0 + Math.imul(a, D)) | 0) +
                  ((8191 &
                    (K = ((K = Math.imul(a, N)) + Math.imul(f, D)) | 0)) <<
                    13)) |
                0,
              tt =
                ((((X = Math.imul(f, N)) + (K >>> 13)) | 0) + (W >>> 26)) | 0;
            (W &= 67108863),
              (q = Math.imul(c, D)),
              (K = ((K = Math.imul(c, N)) + Math.imul(u, D)) | 0),
              (X = Math.imul(u, N));
            J =
              (((tt + ((q + Math.imul(a, U)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(a, z)) | 0) + Math.imul(f, U)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(f, z)) | 0) + (K >>> 13)) | 0) +
                (J >>> 26)) |
              0),
              (J &= 67108863),
              (q = Math.imul(l, D)),
              (K = ((K = Math.imul(l, N)) + Math.imul(p, D)) | 0),
              (X = Math.imul(p, N)),
              (q = (q + Math.imul(c, U)) | 0),
              (K = ((K = (K + Math.imul(c, z)) | 0) + Math.imul(u, U)) | 0),
              (X = (X + Math.imul(u, z)) | 0);
            o =
              (((tt + ((q + Math.imul(a, F)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(a, H)) | 0) + Math.imul(f, F)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(f, H)) | 0) + (K >>> 13)) | 0) +
                (o >>> 26)) |
              0),
              (o &= 67108863),
              (q = Math.imul(m, D)),
              (K = ((K = Math.imul(m, N)) + Math.imul(y, D)) | 0),
              (X = Math.imul(y, N)),
              (q = (q + Math.imul(l, U)) | 0),
              (K = ((K = (K + Math.imul(l, z)) | 0) + Math.imul(p, U)) | 0),
              (X = (X + Math.imul(p, z)) | 0),
              (q = (q + Math.imul(c, F)) | 0),
              (K = ((K = (K + Math.imul(c, H)) | 0) + Math.imul(u, F)) | 0),
              (X = (X + Math.imul(u, H)) | 0);
            b =
              (((tt + ((q + Math.imul(a, V)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(a, Z)) | 0) + Math.imul(f, V)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(f, Z)) | 0) + (K >>> 13)) | 0) +
                (b >>> 26)) |
              0),
              (b &= 67108863),
              (q = Math.imul(v, D)),
              (K = ((K = Math.imul(v, N)) + Math.imul(_, D)) | 0),
              (X = Math.imul(_, N)),
              (q = (q + Math.imul(m, U)) | 0),
              (K = ((K = (K + Math.imul(m, z)) | 0) + Math.imul(y, U)) | 0),
              (X = (X + Math.imul(y, z)) | 0),
              (q = (q + Math.imul(l, F)) | 0),
              (K = ((K = (K + Math.imul(l, H)) | 0) + Math.imul(p, F)) | 0),
              (X = (X + Math.imul(p, H)) | 0),
              (q = (q + Math.imul(c, V)) | 0),
              (K = ((K = (K + Math.imul(c, Z)) | 0) + Math.imul(u, V)) | 0),
              (X = (X + Math.imul(u, Z)) | 0);
            E =
              (((tt + ((q + Math.imul(a, G)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(a, Y)) | 0) + Math.imul(f, G)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(f, Y)) | 0) + (K >>> 13)) | 0) +
                (E >>> 26)) |
              0),
              (E &= 67108863),
              (q = Math.imul(M, D)),
              (K = ((K = Math.imul(M, N)) + Math.imul(S, D)) | 0),
              (X = Math.imul(S, N)),
              (q = (q + Math.imul(v, U)) | 0),
              (K = ((K = (K + Math.imul(v, z)) | 0) + Math.imul(_, U)) | 0),
              (X = (X + Math.imul(_, z)) | 0),
              (q = (q + Math.imul(m, F)) | 0),
              (K = ((K = (K + Math.imul(m, H)) | 0) + Math.imul(y, F)) | 0),
              (X = (X + Math.imul(y, H)) | 0),
              (q = (q + Math.imul(l, V)) | 0),
              (K = ((K = (K + Math.imul(l, Z)) | 0) + Math.imul(p, V)) | 0),
              (X = (X + Math.imul(p, Z)) | 0),
              (q = (q + Math.imul(c, G)) | 0),
              (K = ((K = (K + Math.imul(c, Y)) | 0) + Math.imul(u, G)) | 0),
              (X = (X + Math.imul(u, Y)) | 0);
            n =
              (((tt + ((q + Math.imul(a, $)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(a, Q)) | 0) + Math.imul(f, $)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(f, Q)) | 0) + (K >>> 13)) | 0) +
                (n >>> 26)) |
              0),
              (n &= 67108863),
              (q = Math.imul(k, D)),
              (K = ((K = Math.imul(k, N)) + Math.imul(A, D)) | 0),
              (X = Math.imul(A, N)),
              (q = (q + Math.imul(M, U)) | 0),
              (K = ((K = (K + Math.imul(M, z)) | 0) + Math.imul(S, U)) | 0),
              (X = (X + Math.imul(S, z)) | 0),
              (q = (q + Math.imul(v, F)) | 0),
              (K = ((K = (K + Math.imul(v, H)) | 0) + Math.imul(_, F)) | 0),
              (X = (X + Math.imul(_, H)) | 0),
              (q = (q + Math.imul(m, V)) | 0),
              (K = ((K = (K + Math.imul(m, Z)) | 0) + Math.imul(y, V)) | 0),
              (X = (X + Math.imul(y, Z)) | 0),
              (q = (q + Math.imul(l, G)) | 0),
              (K = ((K = (K + Math.imul(l, Y)) | 0) + Math.imul(p, G)) | 0),
              (X = (X + Math.imul(p, Y)) | 0),
              (q = (q + Math.imul(c, $)) | 0),
              (K = ((K = (K + Math.imul(c, Q)) | 0) + Math.imul(u, $)) | 0),
              (X = (X + Math.imul(u, Q)) | 0);
            i =
              (((tt + ((q + Math.imul(a, h)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(a, d)) | 0) + Math.imul(f, h)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(f, d)) | 0) + (K >>> 13)) | 0) +
                (i >>> 26)) |
              0),
              (i &= 67108863),
              (q = Math.imul(B, D)),
              (K = ((K = Math.imul(B, N)) + Math.imul(I, D)) | 0),
              (X = Math.imul(I, N)),
              (q = (q + Math.imul(k, U)) | 0),
              (K = ((K = (K + Math.imul(k, z)) | 0) + Math.imul(A, U)) | 0),
              (X = (X + Math.imul(A, z)) | 0),
              (q = (q + Math.imul(M, F)) | 0),
              (K = ((K = (K + Math.imul(M, H)) | 0) + Math.imul(S, F)) | 0),
              (X = (X + Math.imul(S, H)) | 0),
              (q = (q + Math.imul(v, V)) | 0),
              (K = ((K = (K + Math.imul(v, Z)) | 0) + Math.imul(_, V)) | 0),
              (X = (X + Math.imul(_, Z)) | 0),
              (q = (q + Math.imul(m, G)) | 0),
              (K = ((K = (K + Math.imul(m, Y)) | 0) + Math.imul(y, G)) | 0),
              (X = (X + Math.imul(y, Y)) | 0),
              (q = (q + Math.imul(l, $)) | 0),
              (K = ((K = (K + Math.imul(l, Q)) | 0) + Math.imul(p, $)) | 0),
              (X = (X + Math.imul(p, Q)) | 0),
              (q = (q + Math.imul(c, h)) | 0),
              (K = ((K = (K + Math.imul(c, d)) | 0) + Math.imul(u, h)) | 0),
              (X = (X + Math.imul(u, d)) | 0);
            t =
              (((tt + ((q + Math.imul(a, g)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(a, w)) | 0) + Math.imul(f, g)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(f, w)) | 0) + (K >>> 13)) | 0) +
                (t >>> 26)) |
              0),
              (t &= 67108863),
              (q = Math.imul(j, D)),
              (K = ((K = Math.imul(j, N)) + Math.imul(T, D)) | 0),
              (X = Math.imul(T, N)),
              (q = (q + Math.imul(B, U)) | 0),
              (K = ((K = (K + Math.imul(B, z)) | 0) + Math.imul(I, U)) | 0),
              (X = (X + Math.imul(I, z)) | 0),
              (q = (q + Math.imul(k, F)) | 0),
              (K = ((K = (K + Math.imul(k, H)) | 0) + Math.imul(A, F)) | 0),
              (X = (X + Math.imul(A, H)) | 0),
              (q = (q + Math.imul(M, V)) | 0),
              (K = ((K = (K + Math.imul(M, Z)) | 0) + Math.imul(S, V)) | 0),
              (X = (X + Math.imul(S, Z)) | 0),
              (q = (q + Math.imul(v, G)) | 0),
              (K = ((K = (K + Math.imul(v, Y)) | 0) + Math.imul(_, G)) | 0),
              (X = (X + Math.imul(_, Y)) | 0),
              (q = (q + Math.imul(m, $)) | 0),
              (K = ((K = (K + Math.imul(m, Q)) | 0) + Math.imul(y, $)) | 0),
              (X = (X + Math.imul(y, Q)) | 0),
              (q = (q + Math.imul(l, h)) | 0),
              (K = ((K = (K + Math.imul(l, d)) | 0) + Math.imul(p, h)) | 0),
              (X = (X + Math.imul(p, d)) | 0),
              (q = (q + Math.imul(c, g)) | 0),
              (K = ((K = (K + Math.imul(c, w)) | 0) + Math.imul(u, g)) | 0),
              (X = (X + Math.imul(u, w)) | 0);
            e =
              (((tt + ((q + Math.imul(a, x)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(a, R)) | 0) + Math.imul(f, x)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(f, R)) | 0) + (K >>> 13)) | 0) +
                (e >>> 26)) |
              0),
              (e &= 67108863),
              (q = Math.imul(L, D)),
              (K = ((K = Math.imul(L, N)) + Math.imul(P, D)) | 0),
              (X = Math.imul(P, N)),
              (q = (q + Math.imul(j, U)) | 0),
              (K = ((K = (K + Math.imul(j, z)) | 0) + Math.imul(T, U)) | 0),
              (X = (X + Math.imul(T, z)) | 0),
              (q = (q + Math.imul(B, F)) | 0),
              (K = ((K = (K + Math.imul(B, H)) | 0) + Math.imul(I, F)) | 0),
              (X = (X + Math.imul(I, H)) | 0),
              (q = (q + Math.imul(k, V)) | 0),
              (K = ((K = (K + Math.imul(k, Z)) | 0) + Math.imul(A, V)) | 0),
              (X = (X + Math.imul(A, Z)) | 0),
              (q = (q + Math.imul(M, G)) | 0),
              (K = ((K = (K + Math.imul(M, Y)) | 0) + Math.imul(S, G)) | 0),
              (X = (X + Math.imul(S, Y)) | 0),
              (q = (q + Math.imul(v, $)) | 0),
              (K = ((K = (K + Math.imul(v, Q)) | 0) + Math.imul(_, $)) | 0),
              (X = (X + Math.imul(_, Q)) | 0),
              (q = (q + Math.imul(m, h)) | 0),
              (K = ((K = (K + Math.imul(m, d)) | 0) + Math.imul(y, h)) | 0),
              (X = (X + Math.imul(y, d)) | 0),
              (q = (q + Math.imul(l, g)) | 0),
              (K = ((K = (K + Math.imul(l, w)) | 0) + Math.imul(p, g)) | 0),
              (X = (X + Math.imul(p, w)) | 0),
              (q = (q + Math.imul(c, x)) | 0),
              (K = ((K = (K + Math.imul(c, R)) | 0) + Math.imul(u, x)) | 0),
              (X = (X + Math.imul(u, R)) | 0);
            a =
              (((tt + ((q + Math.imul(a, C)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(a, O)) | 0) + Math.imul(f, C)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(f, O)) | 0) + (K >>> 13)) | 0) +
                (a >>> 26)) |
              0),
              (a &= 67108863),
              (q = Math.imul(L, U)),
              (K = ((K = Math.imul(L, z)) + Math.imul(P, U)) | 0),
              (X = Math.imul(P, z)),
              (q = (q + Math.imul(j, F)) | 0),
              (K = ((K = (K + Math.imul(j, H)) | 0) + Math.imul(T, F)) | 0),
              (X = (X + Math.imul(T, H)) | 0),
              (q = (q + Math.imul(B, V)) | 0),
              (K = ((K = (K + Math.imul(B, Z)) | 0) + Math.imul(I, V)) | 0),
              (X = (X + Math.imul(I, Z)) | 0),
              (q = (q + Math.imul(k, G)) | 0),
              (K = ((K = (K + Math.imul(k, Y)) | 0) + Math.imul(A, G)) | 0),
              (X = (X + Math.imul(A, Y)) | 0),
              (q = (q + Math.imul(M, $)) | 0),
              (K = ((K = (K + Math.imul(M, Q)) | 0) + Math.imul(S, $)) | 0),
              (X = (X + Math.imul(S, Q)) | 0),
              (q = (q + Math.imul(v, h)) | 0),
              (K = ((K = (K + Math.imul(v, d)) | 0) + Math.imul(_, h)) | 0),
              (X = (X + Math.imul(_, d)) | 0),
              (q = (q + Math.imul(m, g)) | 0),
              (K = ((K = (K + Math.imul(m, w)) | 0) + Math.imul(y, g)) | 0),
              (X = (X + Math.imul(y, w)) | 0),
              (q = (q + Math.imul(l, x)) | 0),
              (K = ((K = (K + Math.imul(l, R)) | 0) + Math.imul(p, x)) | 0),
              (X = (X + Math.imul(p, R)) | 0);
            c =
              (((tt + ((q + Math.imul(c, C)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(c, O)) | 0) + Math.imul(u, C)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(u, O)) | 0) + (K >>> 13)) | 0) +
                (c >>> 26)) |
              0),
              (c &= 67108863),
              (q = Math.imul(L, F)),
              (K = ((K = Math.imul(L, H)) + Math.imul(P, F)) | 0),
              (X = Math.imul(P, H)),
              (q = (q + Math.imul(j, V)) | 0),
              (K = ((K = (K + Math.imul(j, Z)) | 0) + Math.imul(T, V)) | 0),
              (X = (X + Math.imul(T, Z)) | 0),
              (q = (q + Math.imul(B, G)) | 0),
              (K = ((K = (K + Math.imul(B, Y)) | 0) + Math.imul(I, G)) | 0),
              (X = (X + Math.imul(I, Y)) | 0),
              (q = (q + Math.imul(k, $)) | 0),
              (K = ((K = (K + Math.imul(k, Q)) | 0) + Math.imul(A, $)) | 0),
              (X = (X + Math.imul(A, Q)) | 0),
              (q = (q + Math.imul(M, h)) | 0),
              (K = ((K = (K + Math.imul(M, d)) | 0) + Math.imul(S, h)) | 0),
              (X = (X + Math.imul(S, d)) | 0),
              (q = (q + Math.imul(v, g)) | 0),
              (K = ((K = (K + Math.imul(v, w)) | 0) + Math.imul(_, g)) | 0),
              (X = (X + Math.imul(_, w)) | 0),
              (q = (q + Math.imul(m, x)) | 0),
              (K = ((K = (K + Math.imul(m, R)) | 0) + Math.imul(y, x)) | 0),
              (X = (X + Math.imul(y, R)) | 0);
            l =
              (((tt + ((q + Math.imul(l, C)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(l, O)) | 0) + Math.imul(p, C)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(p, O)) | 0) + (K >>> 13)) | 0) +
                (l >>> 26)) |
              0),
              (l &= 67108863),
              (q = Math.imul(L, V)),
              (K = ((K = Math.imul(L, Z)) + Math.imul(P, V)) | 0),
              (X = Math.imul(P, Z)),
              (q = (q + Math.imul(j, G)) | 0),
              (K = ((K = (K + Math.imul(j, Y)) | 0) + Math.imul(T, G)) | 0),
              (X = (X + Math.imul(T, Y)) | 0),
              (q = (q + Math.imul(B, $)) | 0),
              (K = ((K = (K + Math.imul(B, Q)) | 0) + Math.imul(I, $)) | 0),
              (X = (X + Math.imul(I, Q)) | 0),
              (q = (q + Math.imul(k, h)) | 0),
              (K = ((K = (K + Math.imul(k, d)) | 0) + Math.imul(A, h)) | 0),
              (X = (X + Math.imul(A, d)) | 0),
              (q = (q + Math.imul(M, g)) | 0),
              (K = ((K = (K + Math.imul(M, w)) | 0) + Math.imul(S, g)) | 0),
              (X = (X + Math.imul(S, w)) | 0),
              (q = (q + Math.imul(v, x)) | 0),
              (K = ((K = (K + Math.imul(v, R)) | 0) + Math.imul(_, x)) | 0),
              (X = (X + Math.imul(_, R)) | 0);
            m =
              (((tt + ((q + Math.imul(m, C)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(m, O)) | 0) + Math.imul(y, C)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(y, O)) | 0) + (K >>> 13)) | 0) +
                (m >>> 26)) |
              0),
              (m &= 67108863),
              (q = Math.imul(L, G)),
              (K = ((K = Math.imul(L, Y)) + Math.imul(P, G)) | 0),
              (X = Math.imul(P, Y)),
              (q = (q + Math.imul(j, $)) | 0),
              (K = ((K = (K + Math.imul(j, Q)) | 0) + Math.imul(T, $)) | 0),
              (X = (X + Math.imul(T, Q)) | 0),
              (q = (q + Math.imul(B, h)) | 0),
              (K = ((K = (K + Math.imul(B, d)) | 0) + Math.imul(I, h)) | 0),
              (X = (X + Math.imul(I, d)) | 0),
              (q = (q + Math.imul(k, g)) | 0),
              (K = ((K = (K + Math.imul(k, w)) | 0) + Math.imul(A, g)) | 0),
              (X = (X + Math.imul(A, w)) | 0),
              (q = (q + Math.imul(M, x)) | 0),
              (K = ((K = (K + Math.imul(M, R)) | 0) + Math.imul(S, x)) | 0),
              (X = (X + Math.imul(S, R)) | 0);
            v =
              (((tt + ((q + Math.imul(v, C)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(v, O)) | 0) + Math.imul(_, C)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(_, O)) | 0) + (K >>> 13)) | 0) +
                (v >>> 26)) |
              0),
              (v &= 67108863),
              (q = Math.imul(L, $)),
              (K = ((K = Math.imul(L, Q)) + Math.imul(P, $)) | 0),
              (X = Math.imul(P, Q)),
              (q = (q + Math.imul(j, h)) | 0),
              (K = ((K = (K + Math.imul(j, d)) | 0) + Math.imul(T, h)) | 0),
              (X = (X + Math.imul(T, d)) | 0),
              (q = (q + Math.imul(B, g)) | 0),
              (K = ((K = (K + Math.imul(B, w)) | 0) + Math.imul(I, g)) | 0),
              (X = (X + Math.imul(I, w)) | 0),
              (q = (q + Math.imul(k, x)) | 0),
              (K = ((K = (K + Math.imul(k, R)) | 0) + Math.imul(A, x)) | 0),
              (X = (X + Math.imul(A, R)) | 0);
            M =
              (((tt + ((q + Math.imul(M, C)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(M, O)) | 0) + Math.imul(S, C)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(S, O)) | 0) + (K >>> 13)) | 0) +
                (M >>> 26)) |
              0),
              (M &= 67108863),
              (q = Math.imul(L, h)),
              (K = ((K = Math.imul(L, d)) + Math.imul(P, h)) | 0),
              (X = Math.imul(P, d)),
              (q = (q + Math.imul(j, g)) | 0),
              (K = ((K = (K + Math.imul(j, w)) | 0) + Math.imul(T, g)) | 0),
              (X = (X + Math.imul(T, w)) | 0),
              (q = (q + Math.imul(B, x)) | 0),
              (K = ((K = (K + Math.imul(B, R)) | 0) + Math.imul(I, x)) | 0),
              (X = (X + Math.imul(I, R)) | 0);
            k =
              (((tt + ((q + Math.imul(k, C)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(k, O)) | 0) + Math.imul(A, C)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(A, O)) | 0) + (K >>> 13)) | 0) +
                (k >>> 26)) |
              0),
              (k &= 67108863),
              (q = Math.imul(L, g)),
              (K = ((K = Math.imul(L, w)) + Math.imul(P, g)) | 0),
              (X = Math.imul(P, w)),
              (q = (q + Math.imul(j, x)) | 0),
              (K = ((K = (K + Math.imul(j, R)) | 0) + Math.imul(T, x)) | 0),
              (X = (X + Math.imul(T, R)) | 0);
            B =
              (((tt + ((q + Math.imul(B, C)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(B, O)) | 0) + Math.imul(I, C)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(I, O)) | 0) + (K >>> 13)) | 0) +
                (B >>> 26)) |
              0),
              (B &= 67108863),
              (q = Math.imul(L, x)),
              (K = ((K = Math.imul(L, R)) + Math.imul(P, x)) | 0),
              (X = Math.imul(P, R));
            j =
              (((tt + ((q + Math.imul(j, C)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(j, O)) | 0) + Math.imul(T, C)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(T, O)) | 0) + (K >>> 13)) | 0) +
                (j >>> 26)) |
              0),
              (j &= 67108863);
            C =
              (((tt + Math.imul(L, C)) | 0) +
                ((8191 & (K = ((K = Math.imul(L, O)) + Math.imul(P, C)) | 0)) <<
                  13)) |
              0;
            return (
              (tt =
                ((((X = Math.imul(P, O)) + (K >>> 13)) | 0) + (C >>> 26)) | 0),
              (C &= 67108863),
              (s[0] = W),
              (s[1] = J),
              (s[2] = o),
              (s[3] = b),
              (s[4] = E),
              (s[5] = n),
              (s[6] = i),
              (s[7] = t),
              (s[8] = e),
              (s[9] = a),
              (s[10] = c),
              (s[11] = l),
              (s[12] = m),
              (s[13] = v),
              (s[14] = M),
              (s[15] = k),
              (s[16] = B),
              (s[17] = j),
              (s[18] = C),
              0 != tt && ((s[19] = tt), r.length++),
              r
            );
          };
          function f(t, e, r) {
            return new h().mulp(t, e, r);
          }
          function h(t, e) {
            (this.x = t), (this.y = e);
          }
          Math.imul || (o = s),
            (m.prototype.mulTo = function(t, e) {
              var r = this.length + t.length,
                e = (10 === this.length && 10 === t.length
                  ? o
                  : r < 63
                  ? s
                  : r < 1024
                  ? function(t, e, r) {
                      (r.negative = e.negative ^ t.negative),
                        (r.length = t.length + e.length);
                      for (var i = 0, n = 0, s = 0; s < r.length - 1; s++) {
                        for (
                          var o = n,
                            n = 0,
                            a = 67108863 & i,
                            f = Math.min(s, e.length - 1),
                            h = Math.max(0, s - t.length + 1);
                          h <= f;
                          h++
                        ) {
                          var c,
                            u = (0 | t.words[s - h]) * (0 | e.words[h]),
                            a = 67108863 & (c = ((c = 67108863 & u) + a) | 0);
                          (n +=
                            (o =
                              ((o = (o + ((u / 67108864) | 0)) | 0) +
                                (c >>> 26)) |
                              0) >>> 26),
                            (o &= 67108863);
                        }
                        (r.words[s] = a), (i = o), (o = n);
                      }
                      return 0 !== i ? (r.words[s] = i) : r.length--, r.strip();
                    }
                  : f)(this, t, e);
              return e;
            }),
            (h.prototype.makeRBT = function(t) {
              for (
                var e = new Array(t), r = m.prototype._countBits(t) - 1, i = 0;
                i < t;
                i++
              )
                e[i] = this.revBin(i, r, t);
              return e;
            }),
            (h.prototype.revBin = function(t, e, r) {
              if (0 === t || t === r - 1) return t;
              for (var i = 0, n = 0; n < e; n++)
                (i |= (1 & t) << (e - n - 1)), (t >>= 1);
              return i;
            }),
            (h.prototype.permute = function(t, e, r, i, n, s) {
              for (var o = 0; o < s; o++) (i[o] = e[t[o]]), (n[o] = r[t[o]]);
            }),
            (h.prototype.transform = function(t, e, r, i, n, s) {
              this.permute(s, t, e, r, i, n);
              for (var o = 1; o < n; o <<= 1)
                for (
                  var a = o << 1,
                    f = Math.cos((2 * Math.PI) / a),
                    h = Math.sin((2 * Math.PI) / a),
                    c = 0;
                  c < n;
                  c += a
                )
                  for (var u = f, d = h, l = 0; l < o; l++) {
                    var p = r[c + l],
                      b = i[c + l],
                      m = r[c + l + o],
                      y = u * m - d * (g = i[c + l + o]),
                      g = u * g + d * m;
                    (r[c + l] = p + (m = y)),
                      (i[c + l] = b + g),
                      (r[c + l + o] = p - m),
                      (i[c + l + o] = b - g),
                      l !== a &&
                        ((y = f * u - h * d), (d = f * d + h * u), (u = y));
                  }
            }),
            (h.prototype.guessLen13b = function(t, e) {
              for (
                var t = 1 & (i = 1 | Math.max(e, t)), r = 0, i = (i / 2) | 0;
                i;
                i >>>= 1
              )
                r++;
              return 1 << (r + 1 + t);
            }),
            (h.prototype.conjugate = function(t, e, r) {
              if (!(r <= 1))
                for (var i = 0; i < r / 2; i++) {
                  var n = t[i];
                  (t[i] = t[r - i - 1]),
                    (t[r - i - 1] = n),
                    (n = e[i]),
                    (e[i] = -e[r - i - 1]),
                    (e[r - i - 1] = -n);
                }
            }),
            (h.prototype.normalize13b = function(t, e) {
              for (var r = 0, i = 0; i < e / 2; i++) {
                var n =
                  8192 * Math.round(t[2 * i + 1] / e) +
                  Math.round(t[2 * i] / e) +
                  r;
                (t[i] = 67108863 & n),
                  (r = n < 67108864 ? 0 : (n / 67108864) | 0);
              }
              return t;
            }),
            (h.prototype.convert13b = function(t, e, r, i) {
              for (var n = 0, s = 0; s < e; s++)
                (n += 0 | t[s]),
                  (r[2 * s] = 8191 & n),
                  (r[2 * s + 1] = 8191 & (n >>>= 13)),
                  (n >>>= 13);
              for (s = 2 * e; s < i; ++s) r[s] = 0;
              b(0 === n), b(0 == (-8192 & n));
            }),
            (h.prototype.stub = function(t) {
              for (var e = new Array(t), r = 0; r < t; r++) e[r] = 0;
              return e;
            }),
            (h.prototype.mulp = function(t, e, r) {
              var i = 2 * this.guessLen13b(t.length, e.length),
                n = this.makeRBT(i),
                s = this.stub(i),
                o = new Array(i),
                a = new Array(i),
                f = new Array(i),
                h = new Array(i),
                c = new Array(i),
                u = new Array(i),
                d = r.words;
              (d.length = i),
                this.convert13b(t.words, t.length, o, i),
                this.convert13b(e.words, e.length, h, i),
                this.transform(o, s, a, f, i, n),
                this.transform(h, s, c, u, i, n);
              for (var l = 0; l < i; l++) {
                var p = a[l] * c[l] - f[l] * u[l];
                (f[l] = a[l] * u[l] + f[l] * c[l]), (a[l] = p);
              }
              return (
                this.conjugate(a, f, i),
                this.transform(a, f, d, s, i, n),
                this.conjugate(d, s, i),
                this.normalize13b(d, i),
                (r.negative = t.negative ^ e.negative),
                (r.length = t.length + e.length),
                r.strip()
              );
            }),
            (m.prototype.mul = function(t) {
              var e = new m(null);
              return (
                (e.words = new Array(this.length + t.length)), this.mulTo(t, e)
              );
            }),
            (m.prototype.mulf = function(t) {
              var e = new m(null);
              return (
                (e.words = new Array(this.length + t.length)), f(this, t, e)
              );
            }),
            (m.prototype.imul = function(t) {
              return this.clone().mulTo(t, this);
            }),
            (m.prototype.imuln = function(t) {
              b('number' == typeof t), b(t < 67108864);
              for (var e = 0, r = 0; r < this.length; r++) {
                var i = (0 | this.words[r]) * t,
                  n = (67108863 & i) + (67108863 & e);
                (e >>= 26),
                  (e += (i / 67108864) | 0),
                  (e += n >>> 26),
                  (this.words[r] = 67108863 & n);
              }
              return 0 !== e && ((this.words[r] = e), this.length++), this;
            }),
            (m.prototype.muln = function(t) {
              return this.clone().imuln(t);
            }),
            (m.prototype.sqr = function() {
              return this.mul(this);
            }),
            (m.prototype.isqr = function() {
              return this.imul(this.clone());
            }),
            (m.prototype.pow = function(t) {
              var e = (function(t) {
                for (
                  var e = new Array(t.bitLength()), r = 0;
                  r < e.length;
                  r++
                ) {
                  var i = r % 26;
                  e[r] = (t.words[(r / 26) | 0] & (1 << i)) >>> i;
                }
                return e;
              })(t);
              if (0 === e.length) return new m(1);
              for (
                var r = this, i = 0;
                i < e.length && 0 === e[i];
                i++, r = r.sqr()
              );
              if (++i < e.length)
                for (var n = r.sqr(); i < e.length; i++, n = n.sqr())
                  0 !== e[i] && (r = r.mul(n));
              return r;
            }),
            (m.prototype.iushln = function(t) {
              b('number' == typeof t && 0 <= t);
              var e = t % 26,
                r = (t - e) / 26,
                i = (67108863 >>> (26 - e)) << (26 - e);
              if (0 != e) {
                for (var n = 0, s = 0; s < this.length; s++) {
                  var o = this.words[s] & i,
                    a = ((0 | this.words[s]) - o) << e;
                  (this.words[s] = a | n), (n = o >>> (26 - e));
                }
                n && ((this.words[s] = n), this.length++);
              }
              if (0 != r) {
                for (s = this.length - 1; 0 <= s; s--)
                  this.words[s + r] = this.words[s];
                for (s = 0; s < r; s++) this.words[s] = 0;
                this.length += r;
              }
              return this.strip();
            }),
            (m.prototype.ishln = function(t) {
              return b(0 === this.negative), this.iushln(t);
            }),
            (m.prototype.iushrn = function(t, e, r) {
              b('number' == typeof t && 0 <= t);
              var i = e ? (e - (e % 26)) / 26 : 0,
                n = t % 26,
                s = Math.min((t - n) / 26, this.length),
                o = 67108863 ^ ((67108863 >>> n) << n),
                a = r;
              if (((i -= s), (i = Math.max(0, i)), a)) {
                for (var f = 0; f < s; f++) a.words[f] = this.words[f];
                a.length = s;
              }
              if (0 !== s)
                if (this.length > s)
                  for (this.length -= s, f = 0; f < this.length; f++)
                    this.words[f] = this.words[f + s];
                else (this.words[0] = 0), (this.length = 1);
              for (
                var h = 0, f = this.length - 1;
                0 <= f && (0 !== h || i <= f);
                f--
              ) {
                var c = 0 | this.words[f];
                (this.words[f] = (h << (26 - n)) | (c >>> n)), (h = c & o);
              }
              return (
                a && 0 !== h && (a.words[a.length++] = h),
                0 === this.length && ((this.words[0] = 0), (this.length = 1)),
                this.strip()
              );
            }),
            (m.prototype.ishrn = function(t, e, r) {
              return b(0 === this.negative), this.iushrn(t, e, r);
            }),
            (m.prototype.shln = function(t) {
              return this.clone().ishln(t);
            }),
            (m.prototype.ushln = function(t) {
              return this.clone().iushln(t);
            }),
            (m.prototype.shrn = function(t) {
              return this.clone().ishrn(t);
            }),
            (m.prototype.ushrn = function(t) {
              return this.clone().iushrn(t);
            }),
            (m.prototype.testn = function(t) {
              b('number' == typeof t && 0 <= t);
              var e = t % 26,
                t = (t - e) / 26;
              return !(this.length <= t) && !!(this.words[t] & (1 << e));
            }),
            (m.prototype.imaskn = function(t) {
              b('number' == typeof t && 0 <= t);
              var e = t % 26,
                t = (t - e) / 26;
              return (
                b(
                  0 === this.negative,
                  'imaskn works only with positive numbers'
                ),
                this.length <= t
                  ? this
                  : (0 != e && t++,
                    (this.length = Math.min(t, this.length)),
                    0 != e &&
                      (this.words[this.length - 1] &=
                        67108863 ^ ((67108863 >>> e) << e)),
                    this.strip())
              );
            }),
            (m.prototype.maskn = function(t) {
              return this.clone().imaskn(t);
            }),
            (m.prototype.iaddn = function(t) {
              return (
                b('number' == typeof t),
                b(t < 67108864),
                t < 0
                  ? this.isubn(-t)
                  : 0 !== this.negative
                  ? (1 === this.length && (0 | this.words[0]) < t
                      ? ((this.words[0] = t - (0 | this.words[0])),
                        (this.negative = 0))
                      : ((this.negative = 0),
                        this.isubn(t),
                        (this.negative = 1)),
                    this)
                  : this._iaddn(t)
              );
            }),
            (m.prototype._iaddn = function(t) {
              this.words[0] += t;
              for (var e = 0; e < this.length && 67108864 <= this.words[e]; e++)
                (this.words[e] -= 67108864),
                  e === this.length - 1
                    ? (this.words[e + 1] = 1)
                    : this.words[e + 1]++;
              return (this.length = Math.max(this.length, e + 1)), this;
            }),
            (m.prototype.isubn = function(t) {
              if ((b('number' == typeof t), b(t < 67108864), t < 0))
                return this.iaddn(-t);
              if (0 !== this.negative)
                return (
                  (this.negative = 0), this.iaddn(t), (this.negative = 1), this
                );
              if (
                ((this.words[0] -= t), 1 === this.length && this.words[0] < 0)
              )
                (this.words[0] = -this.words[0]), (this.negative = 1);
              else
                for (var e = 0; e < this.length && this.words[e] < 0; e++)
                  (this.words[e] += 67108864), --this.words[e + 1];
              return this.strip();
            }),
            (m.prototype.addn = function(t) {
              return this.clone().iaddn(t);
            }),
            (m.prototype.subn = function(t) {
              return this.clone().isubn(t);
            }),
            (m.prototype.iabs = function() {
              return (this.negative = 0), this;
            }),
            (m.prototype.abs = function() {
              return this.clone().iabs();
            }),
            (m.prototype._ishlnsubmul = function(t, e, r) {
              var i = t.length + r;
              this._expand(i);
              for (var n = 0, s = 0; s < t.length; s++) {
                var o = (0 | this.words[s + r]) + n,
                  a = (0 | t.words[s]) * e,
                  n = ((o -= 67108863 & a) >> 26) - ((a / 67108864) | 0);
                this.words[s + r] = 67108863 & o;
              }
              for (; s < this.length - r; s++)
                (n = (o = (0 | this.words[s + r]) + n) >> 26),
                  (this.words[s + r] = 67108863 & o);
              if (0 === n) return this.strip();
              for (b(-1 === n), s = n = 0; s < this.length; s++)
                (n = (o = -(0 | this.words[s]) + n) >> 26),
                  (this.words[s] = 67108863 & o);
              return (this.negative = 1), this.strip();
            }),
            (m.prototype._wordDiv = function(t, e) {
              var r = this.length - t.length,
                i = this.clone(),
                n = t,
                s = 0 | n.words[n.length - 1];
              0 != (r = 26 - this._countBits(s)) &&
                ((n = n.ushln(r)),
                i.iushln(r),
                (s = 0 | n.words[n.length - 1]));
              var o,
                a = i.length - n.length;
              if ('mod' !== e) {
                ((o = new m(null)).length = 1 + a),
                  (o.words = new Array(o.length));
                for (var f = 0; f < o.length; f++) o.words[f] = 0;
              }
              t = i.clone()._ishlnsubmul(n, 1, a);
              0 === t.negative && ((i = t), o && (o.words[a] = 1));
              for (var h = a - 1; 0 <= h; h--) {
                var c =
                    67108864 * (0 | i.words[n.length + h]) +
                    (0 | i.words[n.length + h - 1]),
                  c = Math.min((c / s) | 0, 67108863);
                for (i._ishlnsubmul(n, c, h); 0 !== i.negative; )
                  c--,
                    (i.negative = 0),
                    i._ishlnsubmul(n, 1, h),
                    i.isZero() || (i.negative ^= 1);
                o && (o.words[h] = c);
              }
              return (
                o && o.strip(),
                i.strip(),
                'div' !== e && 0 != r && i.iushrn(r),
                { div: o || null, mod: i }
              );
            }),
            (m.prototype.divmod = function(t, e, r) {
              return (
                b(!t.isZero()),
                this.isZero()
                  ? { div: new m(0), mod: new m(0) }
                  : 0 !== this.negative && 0 === t.negative
                  ? ((s = this.neg().divmod(t, e)),
                    'mod' !== e && (i = s.div.neg()),
                    'div' !== e &&
                      ((n = s.mod.neg()), r && 0 !== n.negative && n.iadd(t)),
                    { div: i, mod: n })
                  : 0 === this.negative && 0 !== t.negative
                  ? ((s = this.divmod(t.neg(), e)),
                    { div: (i = 'mod' !== e ? s.div.neg() : i), mod: s.mod })
                  : 0 != (this.negative & t.negative)
                  ? ((s = this.neg().divmod(t.neg(), e)),
                    'div' !== e &&
                      ((n = s.mod.neg()), r && 0 !== n.negative && n.isub(t)),
                    { div: s.div, mod: n })
                  : t.length > this.length || this.cmp(t) < 0
                  ? { div: new m(0), mod: this }
                  : 1 === t.length
                  ? 'div' === e
                    ? { div: this.divn(t.words[0]), mod: null }
                    : 'mod' === e
                    ? { div: null, mod: new m(this.modn(t.words[0])) }
                    : {
                        div: this.divn(t.words[0]),
                        mod: new m(this.modn(t.words[0])),
                      }
                  : this._wordDiv(t, e)
              );
              var i, n, s;
            }),
            (m.prototype.div = function(t) {
              return this.divmod(t, 'div', !1).div;
            }),
            (m.prototype.mod = function(t) {
              return this.divmod(t, 'mod', !1).mod;
            }),
            (m.prototype.umod = function(t) {
              return this.divmod(t, 'mod', !0).mod;
            }),
            (m.prototype.divRound = function(t) {
              var e = this.divmod(t);
              if (e.mod.isZero()) return e.div;
              var r = 0 !== e.div.negative ? e.mod.isub(t) : e.mod,
                i = t.ushrn(1),
                t = t.andln(1),
                i = r.cmp(i);
              return i < 0 || (1 === t && 0 === i)
                ? e.div
                : 0 !== e.div.negative
                ? e.div.isubn(1)
                : e.div.iaddn(1);
            }),
            (m.prototype.modn = function(t) {
              b(t <= 67108863);
              for (
                var e = (1 << 26) % t, r = 0, i = this.length - 1;
                0 <= i;
                i--
              )
                r = (e * r + (0 | this.words[i])) % t;
              return r;
            }),
            (m.prototype.idivn = function(t) {
              b(t <= 67108863);
              for (var e = 0, r = this.length - 1; 0 <= r; r--) {
                var i = (0 | this.words[r]) + 67108864 * e;
                (this.words[r] = (i / t) | 0), (e = i % t);
              }
              return this.strip();
            }),
            (m.prototype.divn = function(t) {
              return this.clone().idivn(t);
            }),
            (m.prototype.egcd = function(t) {
              b(0 === t.negative), b(!t.isZero());
              for (
                var e = this,
                  r = t.clone(),
                  e = 0 !== e.negative ? e.umod(t) : e.clone(),
                  i = new m(1),
                  n = new m(0),
                  s = new m(0),
                  o = new m(1),
                  a = 0;
                e.isEven() && r.isEven();

              )
                e.iushrn(1), r.iushrn(1), ++a;
              for (var f = r.clone(), h = e.clone(); !e.isZero(); ) {
                for (
                  var c = 0, u = 1;
                  0 == (e.words[0] & u) && c < 26;
                  ++c, u <<= 1
                );
                if (0 < c)
                  for (e.iushrn(c); 0 < c--; )
                    (i.isOdd() || n.isOdd()) && (i.iadd(f), n.isub(h)),
                      i.iushrn(1),
                      n.iushrn(1);
                for (
                  var d = 0, l = 1;
                  0 == (r.words[0] & l) && d < 26;
                  ++d, l <<= 1
                );
                if (0 < d)
                  for (r.iushrn(d); 0 < d--; )
                    (s.isOdd() || o.isOdd()) && (s.iadd(f), o.isub(h)),
                      s.iushrn(1),
                      o.iushrn(1);
                0 <= e.cmp(r)
                  ? (e.isub(r), i.isub(s), n.isub(o))
                  : (r.isub(e), s.isub(i), o.isub(n));
              }
              return { a: s, b: o, gcd: r.iushln(a) };
            }),
            (m.prototype._invmp = function(t) {
              b(0 === t.negative), b(!t.isZero());
              for (
                var e,
                  r = this,
                  i = t.clone(),
                  r = 0 !== r.negative ? r.umod(t) : r.clone(),
                  n = new m(1),
                  s = new m(0),
                  o = i.clone();
                0 < r.cmpn(1) && 0 < i.cmpn(1);

              ) {
                for (
                  var a = 0, f = 1;
                  0 == (r.words[0] & f) && a < 26;
                  ++a, f <<= 1
                );
                if (0 < a)
                  for (r.iushrn(a); 0 < a--; )
                    n.isOdd() && n.iadd(o), n.iushrn(1);
                for (
                  var h = 0, c = 1;
                  0 == (i.words[0] & c) && h < 26;
                  ++h, c <<= 1
                );
                if (0 < h)
                  for (i.iushrn(h); 0 < h--; )
                    s.isOdd() && s.iadd(o), s.iushrn(1);
                0 <= r.cmp(i) ? (r.isub(i), n.isub(s)) : (i.isub(r), s.isub(n));
              }
              return (e = 0 === r.cmpn(1) ? n : s).cmpn(0) < 0 && e.iadd(t), e;
            }),
            (m.prototype.gcd = function(t) {
              if (this.isZero()) return t.abs();
              if (t.isZero()) return this.abs();
              var e = this.clone(),
                r = t.clone();
              e.negative = 0;
              for (var i = (r.negative = 0); e.isEven() && r.isEven(); i++)
                e.iushrn(1), r.iushrn(1);
              for (;;) {
                for (; e.isEven(); ) e.iushrn(1);
                for (; r.isEven(); ) r.iushrn(1);
                var n = e.cmp(r);
                if (n < 0)
                  var s = e,
                    e = r,
                    r = s;
                else if (0 === n || 0 === r.cmpn(1)) break;
                e.isub(r);
              }
              return r.iushln(i);
            }),
            (m.prototype.invm = function(t) {
              return this.egcd(t).a.umod(t);
            }),
            (m.prototype.isEven = function() {
              return 0 == (1 & this.words[0]);
            }),
            (m.prototype.isOdd = function() {
              return 1 == (1 & this.words[0]);
            }),
            (m.prototype.andln = function(t) {
              return this.words[0] & t;
            }),
            (m.prototype.bincn = function(t) {
              b('number' == typeof t);
              var e = t % 26,
                t = (t - e) / 26,
                e = 1 << e;
              if (this.length <= t)
                return this._expand(1 + t), (this.words[t] |= e), this;
              for (var r = e, i = t; 0 !== r && i < this.length; i++) {
                var n = 0 | this.words[i],
                  r = (n += r) >>> 26;
                (n &= 67108863), (this.words[i] = n);
              }
              return 0 !== r && ((this.words[i] = r), this.length++), this;
            }),
            (m.prototype.isZero = function() {
              return 1 === this.length && 0 === this.words[0];
            }),
            (m.prototype.cmpn = function(t) {
              var e = t < 0;
              return 0 === this.negative || e
                ? 0 === this.negative && e
                  ? 1
                  : (this.strip(),
                    (t =
                      1 < this.length
                        ? 1
                        : (b((t = e ? -t : t) <= 67108863, 'Number is too big'),
                          (e = 0 | this.words[0]) === t ? 0 : e < t ? -1 : 1)),
                    0 !== this.negative ? 0 | -t : t)
                : -1;
            }),
            (m.prototype.cmp = function(t) {
              if (0 !== this.negative && 0 === t.negative) return -1;
              if (0 === this.negative && 0 !== t.negative) return 1;
              t = this.ucmp(t);
              return 0 !== this.negative ? 0 | -t : t;
            }),
            (m.prototype.ucmp = function(t) {
              if (this.length > t.length) return 1;
              if (this.length < t.length) return -1;
              for (var e = 0, r = this.length - 1; 0 <= r; r--) {
                var i = 0 | this.words[r],
                  n = 0 | t.words[r];
                if (i != n) {
                  i < n ? (e = -1) : n < i && (e = 1);
                  break;
                }
              }
              return e;
            }),
            (m.prototype.gtn = function(t) {
              return 1 === this.cmpn(t);
            }),
            (m.prototype.gt = function(t) {
              return 1 === this.cmp(t);
            }),
            (m.prototype.gten = function(t) {
              return 0 <= this.cmpn(t);
            }),
            (m.prototype.gte = function(t) {
              return 0 <= this.cmp(t);
            }),
            (m.prototype.ltn = function(t) {
              return -1 === this.cmpn(t);
            }),
            (m.prototype.lt = function(t) {
              return -1 === this.cmp(t);
            }),
            (m.prototype.lten = function(t) {
              return this.cmpn(t) <= 0;
            }),
            (m.prototype.lte = function(t) {
              return this.cmp(t) <= 0;
            }),
            (m.prototype.eqn = function(t) {
              return 0 === this.cmpn(t);
            }),
            (m.prototype.eq = function(t) {
              return 0 === this.cmp(t);
            }),
            (m.red = function(t) {
              return new M(t);
            }),
            (m.prototype.toRed = function(t) {
              return (
                b(!this.red, 'Already a number in reduction context'),
                b(0 === this.negative, 'red works only with positives'),
                t.convertTo(this)._forceRed(t)
              );
            }),
            (m.prototype.fromRed = function() {
              return (
                b(
                  this.red,
                  'fromRed works only with numbers in reduction context'
                ),
                this.red.convertFrom(this)
              );
            }),
            (m.prototype._forceRed = function(t) {
              return (this.red = t), this;
            }),
            (m.prototype.forceRed = function(t) {
              return (
                b(!this.red, 'Already a number in reduction context'),
                this._forceRed(t)
              );
            }),
            (m.prototype.redAdd = function(t) {
              return (
                b(this.red, 'redAdd works only with red numbers'),
                this.red.add(this, t)
              );
            }),
            (m.prototype.redIAdd = function(t) {
              return (
                b(this.red, 'redIAdd works only with red numbers'),
                this.red.iadd(this, t)
              );
            }),
            (m.prototype.redSub = function(t) {
              return (
                b(this.red, 'redSub works only with red numbers'),
                this.red.sub(this, t)
              );
            }),
            (m.prototype.redISub = function(t) {
              return (
                b(this.red, 'redISub works only with red numbers'),
                this.red.isub(this, t)
              );
            }),
            (m.prototype.redShl = function(t) {
              return (
                b(this.red, 'redShl works only with red numbers'),
                this.red.shl(this, t)
              );
            }),
            (m.prototype.redMul = function(t) {
              return (
                b(this.red, 'redMul works only with red numbers'),
                this.red._verify2(this, t),
                this.red.mul(this, t)
              );
            }),
            (m.prototype.redIMul = function(t) {
              return (
                b(this.red, 'redMul works only with red numbers'),
                this.red._verify2(this, t),
                this.red.imul(this, t)
              );
            }),
            (m.prototype.redSqr = function() {
              return (
                b(this.red, 'redSqr works only with red numbers'),
                this.red._verify1(this),
                this.red.sqr(this)
              );
            }),
            (m.prototype.redISqr = function() {
              return (
                b(this.red, 'redISqr works only with red numbers'),
                this.red._verify1(this),
                this.red.isqr(this)
              );
            }),
            (m.prototype.redSqrt = function() {
              return (
                b(this.red, 'redSqrt works only with red numbers'),
                this.red._verify1(this),
                this.red.sqrt(this)
              );
            }),
            (m.prototype.redInvm = function() {
              return (
                b(this.red, 'redInvm works only with red numbers'),
                this.red._verify1(this),
                this.red.invm(this)
              );
            }),
            (m.prototype.redNeg = function() {
              return (
                b(this.red, 'redNeg works only with red numbers'),
                this.red._verify1(this),
                this.red.neg(this)
              );
            }),
            (m.prototype.redPow = function(t) {
              return (
                b(this.red && !t.red, 'redPow(normalNum)'),
                this.red._verify1(this),
                this.red.pow(this, t)
              );
            });
          var c = { k256: null, p224: null, p192: null, p25519: null };
          function y(t, e) {
            (this.name = t),
              (this.p = new m(e, 16)),
              (this.n = this.p.bitLength()),
              (this.k = new m(1).iushln(this.n).isub(this.p)),
              (this.tmp = this._tmp());
          }
          function g() {
            y.call(
              this,
              'k256',
              'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f'
            );
          }
          function v() {
            y.call(
              this,
              'p224',
              'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001'
            );
          }
          function _() {
            y.call(
              this,
              'p192',
              'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff'
            );
          }
          function w() {
            y.call(
              this,
              '25519',
              '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed'
            );
          }
          function M(t) {
            var e;
            'string' == typeof t
              ? ((e = m._prime(t)), (this.m = e.p), (this.prime = e))
              : (b(t.gtn(1), 'modulus must be greater than 1'),
                (this.m = t),
                (this.prime = null));
          }
          function S(t) {
            M.call(this, t),
              (this.shift = this.m.bitLength()),
              this.shift % 26 != 0 && (this.shift += 26 - (this.shift % 26)),
              (this.r = new m(1).iushln(this.shift)),
              (this.r2 = this.imod(this.r.sqr())),
              (this.rinv = this.r._invmp(this.m)),
              (this.minv = this.rinv
                .mul(this.r)
                .isubn(1)
                .div(this.m)),
              (this.minv = this.minv.umod(this.r)),
              (this.minv = this.r.sub(this.minv));
          }
          (y.prototype._tmp = function() {
            var t = new m(null);
            return (t.words = new Array(Math.ceil(this.n / 13))), t;
          }),
            (y.prototype.ireduce = function(t) {
              for (
                var e, r = t;
                this.split(r, this.tmp),
                  (e = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength()) >
                    this.n;

              );
              t = e < this.n ? -1 : r.ucmp(this.p);
              return (
                0 === t
                  ? ((r.words[0] = 0), (r.length = 1))
                  : 0 < t
                  ? r.isub(this.p)
                  : void 0 !== r.strip
                  ? r.strip()
                  : r._strip(),
                r
              );
            }),
            (y.prototype.split = function(t, e) {
              t.iushrn(this.n, 0, e);
            }),
            (y.prototype.imulK = function(t) {
              return t.imul(this.k);
            }),
            r(g, y),
            (g.prototype.split = function(t, e) {
              for (var r = Math.min(t.length, 9), i = 0; i < r; i++)
                e.words[i] = t.words[i];
              if (((e.length = r), t.length <= 9))
                return (t.words[0] = 0), void (t.length = 1);
              var n = t.words[9];
              for (
                e.words[e.length++] = 4194303 & n, i = 10;
                i < t.length;
                i++
              ) {
                var s = 0 | t.words[i];
                (t.words[i - 10] = ((4194303 & s) << 4) | (n >>> 22)), (n = s);
              }
              0 === (t.words[i - 10] = n >>>= 22) && 10 < t.length
                ? (t.length -= 10)
                : (t.length -= 9);
            }),
            (g.prototype.imulK = function(t) {
              (t.words[t.length] = 0),
                (t.words[t.length + 1] = 0),
                (t.length += 2);
              for (var e = 0, r = 0; r < t.length; r++) {
                var i = 0 | t.words[r];
                (e += 977 * i),
                  (t.words[r] = 67108863 & e),
                  (e = 64 * i + ((e / 67108864) | 0));
              }
              return (
                0 === t.words[t.length - 1] &&
                  (t.length--, 0 === t.words[t.length - 1] && t.length--),
                t
              );
            }),
            r(v, y),
            r(_, y),
            r(w, y),
            (w.prototype.imulK = function(t) {
              for (var e = 0, r = 0; r < t.length; r++) {
                var i = 19 * (0 | t.words[r]) + e,
                  n = 67108863 & i;
                (i >>>= 26), (t.words[r] = n), (e = i);
              }
              return 0 !== e && (t.words[t.length++] = e), t;
            }),
            (m._prime = function(t) {
              if (c[t]) return c[t];
              var e;
              if ('k256' === t) e = new g();
              else if ('p224' === t) e = new v();
              else if ('p192' === t) e = new _();
              else {
                if ('p25519' !== t) throw new Error('Unknown prime ' + t);
                e = new w();
              }
              return (c[t] = e);
            }),
            (M.prototype._verify1 = function(t) {
              b(0 === t.negative, 'red works only with positives'),
                b(t.red, 'red works only with red numbers');
            }),
            (M.prototype._verify2 = function(t, e) {
              b(
                0 == (t.negative | e.negative),
                'red works only with positives'
              ),
                b(t.red && t.red === e.red, 'red works only with red numbers');
            }),
            (M.prototype.imod = function(t) {
              return (this.prime
                ? this.prime.ireduce(t)
                : t.umod(this.m)
              )._forceRed(this);
            }),
            (M.prototype.neg = function(t) {
              return t.isZero() ? t.clone() : this.m.sub(t)._forceRed(this);
            }),
            (M.prototype.add = function(t, e) {
              this._verify2(t, e);
              e = t.add(e);
              return 0 <= e.cmp(this.m) && e.isub(this.m), e._forceRed(this);
            }),
            (M.prototype.iadd = function(t, e) {
              this._verify2(t, e);
              e = t.iadd(e);
              return 0 <= e.cmp(this.m) && e.isub(this.m), e;
            }),
            (M.prototype.sub = function(t, e) {
              this._verify2(t, e);
              e = t.sub(e);
              return e.cmpn(0) < 0 && e.iadd(this.m), e._forceRed(this);
            }),
            (M.prototype.isub = function(t, e) {
              this._verify2(t, e);
              e = t.isub(e);
              return e.cmpn(0) < 0 && e.iadd(this.m), e;
            }),
            (M.prototype.shl = function(t, e) {
              return this._verify1(t), this.imod(t.ushln(e));
            }),
            (M.prototype.imul = function(t, e) {
              return this._verify2(t, e), this.imod(t.imul(e));
            }),
            (M.prototype.mul = function(t, e) {
              return this._verify2(t, e), this.imod(t.mul(e));
            }),
            (M.prototype.isqr = function(t) {
              return this.imul(t, t.clone());
            }),
            (M.prototype.sqr = function(t) {
              return this.mul(t, t);
            }),
            (M.prototype.sqrt = function(t) {
              if (t.isZero()) return t.clone();
              var e = this.m.andln(3);
              if ((b(e % 2 == 1), 3 === e)) {
                e = this.m.add(new m(1)).iushrn(2);
                return this.pow(t, e);
              }
              for (
                var r = this.m.subn(1), i = 0;
                !r.isZero() && 0 === r.andln(1);

              )
                i++, r.iushrn(1);
              b(!r.isZero());
              for (
                var n = new m(1).toRed(this),
                  s = n.redNeg(),
                  o = this.m.subn(1).iushrn(1),
                  a = new m(2 * (a = this.m.bitLength()) * a).toRed(this);
                0 !== this.pow(a, o).cmp(s);

              )
                a.redIAdd(s);
              for (
                var f = this.pow(a, r),
                  h = this.pow(t, r.addn(1).iushrn(1)),
                  c = this.pow(t, r),
                  u = i;
                0 !== c.cmp(n);

              ) {
                for (var d = c, l = 0; 0 !== d.cmp(n); l++) d = d.redSqr();
                b(l < u);
                var p = this.pow(f, new m(1).iushln(u - l - 1)),
                  h = h.redMul(p),
                  f = p.redSqr(),
                  c = c.redMul(f),
                  u = l;
              }
              return h;
            }),
            (M.prototype.invm = function(t) {
              t = t._invmp(this.m);
              return 0 !== t.negative
                ? ((t.negative = 0), this.imod(t).redNeg())
                : this.imod(t);
            }),
            (M.prototype.pow = function(t, e) {
              if (e.isZero()) return new m(1).toRed(this);
              if (0 === e.cmpn(1)) return t.clone();
              var r = new Array(16);
              (r[0] = new m(1).toRed(this)), (r[1] = t);
              for (var i = 2; i < r.length; i++) r[i] = this.mul(r[i - 1], t);
              var n = r[0],
                s = 0,
                o = 0,
                a = e.bitLength() % 26;
              for (0 === a && (a = 26), i = e.length - 1; 0 <= i; i--) {
                for (var f = e.words[i], h = a - 1; 0 <= h; h--) {
                  var c = (f >> h) & 1;
                  n !== r[0] && (n = this.sqr(n)),
                    0 != c || 0 !== s
                      ? ((s <<= 1),
                        (s |= c),
                        (4 === ++o || (0 === i && 0 === h)) &&
                          ((n = this.mul(n, r[s])), (s = o = 0)))
                      : (o = 0);
                }
                a = 26;
              }
              return n;
            }),
            (M.prototype.convertTo = function(t) {
              var e = t.umod(this.m);
              return e === t ? e.clone() : e;
            }),
            (M.prototype.convertFrom = function(t) {
              t = t.clone();
              return (t.red = null), t;
            }),
            (m.mont = function(t) {
              return new S(t);
            }),
            r(S, M),
            (S.prototype.convertTo = function(t) {
              return this.imod(t.ushln(this.shift));
            }),
            (S.prototype.convertFrom = function(t) {
              t = this.imod(t.mul(this.rinv));
              return (t.red = null), t;
            }),
            (S.prototype.imul = function(t, e) {
              if (t.isZero() || e.isZero())
                return (t.words[0] = 0), (t.length = 1), t;
              (t = t.imul(e)),
                (e = t
                  .maskn(this.shift)
                  .mul(this.minv)
                  .imaskn(this.shift)
                  .mul(this.m)),
                (t = t.isub(e).iushrn(this.shift)),
                (e = t);
              return (
                0 <= t.cmp(this.m)
                  ? (e = t.isub(this.m))
                  : t.cmpn(0) < 0 && (e = t.iadd(this.m)),
                e._forceRed(this)
              );
            }),
            (S.prototype.mul = function(t, e) {
              if (t.isZero() || e.isZero()) return new m(0)._forceRed(this);
              (t = t.mul(e)),
                (e = t
                  .maskn(this.shift)
                  .mul(this.minv)
                  .imaskn(this.shift)
                  .mul(this.m)),
                (t = t.isub(e).iushrn(this.shift)),
                (e = t);
              return (
                0 <= t.cmp(this.m)
                  ? (e = t.isub(this.m))
                  : t.cmpn(0) < 0 && (e = t.iadd(this.m)),
                e._forceRed(this)
              );
            }),
            (S.prototype.invm = function(t) {
              return this.imod(t._invmp(this.m).mul(this.r2))._forceRed(this);
            });
        })(void 0 === t || t, this);
      },
      { buffer: 20 },
    ],
    17: [
      function(t, e, r) {
        'use strict';
        (r.byteLength = function(t) {
          var e = c(t),
            t = e[0],
            e = e[1];
          return (3 * (t + e)) / 4 - e;
        }),
          (r.toByteArray = function(t) {
            var e,
              r,
              i = c(t),
              n = i[0],
              i = i[1],
              s = new h(
                (function(t, e) {
                  return (3 * (t + e)) / 4 - e;
                })(n, i)
              ),
              o = 0,
              a = 0 < i ? n - 4 : n;
            for (r = 0; r < a; r += 4)
              (e =
                (f[t.charCodeAt(r)] << 18) |
                (f[t.charCodeAt(r + 1)] << 12) |
                (f[t.charCodeAt(r + 2)] << 6) |
                f[t.charCodeAt(r + 3)]),
                (s[o++] = (e >> 16) & 255),
                (s[o++] = (e >> 8) & 255),
                (s[o++] = 255 & e);
            2 === i &&
              ((e = (f[t.charCodeAt(r)] << 2) | (f[t.charCodeAt(r + 1)] >> 4)),
              (s[o++] = 255 & e));
            1 === i &&
              ((e =
                (f[t.charCodeAt(r)] << 10) |
                (f[t.charCodeAt(r + 1)] << 4) |
                (f[t.charCodeAt(r + 2)] >> 2)),
              (s[o++] = (e >> 8) & 255),
              (s[o++] = 255 & e));
            return s;
          }),
          (r.fromByteArray = function(t) {
            for (
              var e, r = t.length, i = r % 3, n = [], s = 0, o = r - i;
              s < o;
              s += 16383
            )
              n.push(
                (function(t, e, r) {
                  for (var i, n = [], s = e; s < r; s += 3)
                    (i =
                      ((t[s] << 16) & 16711680) +
                      ((t[s + 1] << 8) & 65280) +
                      (255 & t[s + 2])),
                      n.push(
                        (function(t) {
                          return (
                            a[(t >> 18) & 63] +
                            a[(t >> 12) & 63] +
                            a[(t >> 6) & 63] +
                            a[63 & t]
                          );
                        })(i)
                      );
                  return n.join('');
                })(t, s, o < s + 16383 ? o : s + 16383)
              );
            1 == i
              ? ((e = t[r - 1]), n.push(a[e >> 2] + a[(e << 4) & 63] + '=='))
              : 2 == i &&
                ((e = (t[r - 2] << 8) + t[r - 1]),
                n.push(a[e >> 10] + a[(e >> 4) & 63] + a[(e << 2) & 63] + '='));
            return n.join('');
          });
        for (
          var a = [],
            f = [],
            h = 'undefined' != typeof Uint8Array ? Uint8Array : Array,
            i =
              'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
            n = 0,
            s = i.length;
          n < s;
          ++n
        )
          (a[n] = i[n]), (f[i.charCodeAt(n)] = n);
        function c(t) {
          var e = t.length;
          if (0 < e % 4)
            throw new Error('Invalid string. Length must be a multiple of 4');
          t = t.indexOf('=');
          return [(t = -1 === t ? e : t), t === e ? 0 : 4 - (t % 4)];
        }
        (f['-'.charCodeAt(0)] = 62), (f['_'.charCodeAt(0)] = 63);
      },
      {},
    ],
    18: [
      function(A, t, e) {
        !(function(t, e) {
          'use strict';
          function b(t, e) {
            if (!t) throw new Error(e || 'Assertion failed');
          }
          function r(t, e) {
            t.super_ = e;
            function r() {}
            (r.prototype = e.prototype),
              (t.prototype = new r()),
              (t.prototype.constructor = t);
          }
          function m(t, e, r) {
            if (m.isBN(t)) return t;
            (this.negative = 0),
              (this.words = null),
              (this.length = 0),
              (this.red = null) !== t &&
                (('le' !== e && 'be' !== e) || ((r = e), (e = 10)),
                this._init(t || 0, e || 10, r || 'be'));
          }
          var i;
          'object' == typeof t ? (t.exports = m) : (e.BN = m),
            ((m.BN = m).wordSize = 26);
          try {
            i = ('undefined' != typeof window && void 0 !== window.Buffer
              ? window
              : A('buffer')
            ).Buffer;
          } catch (t) {}
          function n(t, e) {
            e = t.charCodeAt(e);
            return 48 <= e && e <= 57
              ? e - 48
              : 65 <= e && e <= 70
              ? e - 55
              : 97 <= e && e <= 102
              ? e - 87
              : void b(!1, 'Invalid character in ' + t);
          }
          function a(t, e, r) {
            var i = n(t, r);
            return e <= r - 1 && (i |= n(t, r - 1) << 4), i;
          }
          function u(t, e, r, i) {
            for (
              var n = 0, s = 0, o = Math.min(t.length, r), a = e;
              a < o;
              a++
            ) {
              var f = t.charCodeAt(a) - 48;
              (n *= i),
                (s = 49 <= f ? f - 49 + 10 : 17 <= f ? f - 17 + 10 : f),
                b(0 <= f && s < i, 'Invalid character'),
                (n += s);
            }
            return n;
          }
          function s(t, e) {
            (t.words = e.words),
              (t.length = e.length),
              (t.negative = e.negative),
              (t.red = e.red);
          }
          if (
            ((m.isBN = function(t) {
              return (
                t instanceof m ||
                (null !== t &&
                  'object' == typeof t &&
                  t.constructor.wordSize === m.wordSize &&
                  Array.isArray(t.words))
              );
            }),
            (m.max = function(t, e) {
              return 0 < t.cmp(e) ? t : e;
            }),
            (m.min = function(t, e) {
              return t.cmp(e) < 0 ? t : e;
            }),
            (m.prototype._init = function(t, e, r) {
              if ('number' == typeof t) return this._initNumber(t, e, r);
              if ('object' == typeof t) return this._initArray(t, e, r);
              b((e = 'hex' === e ? 16 : e) === (0 | e) && 2 <= e && e <= 36);
              var i = 0;
              '-' === (t = t.toString().replace(/\s+/g, ''))[0] &&
                (i++, (this.negative = 1)),
                i < t.length &&
                  (16 === e
                    ? this._parseHex(t, i, r)
                    : (this._parseBase(t, e, i),
                      'le' === r && this._initArray(this.toArray(), e, r)));
            }),
            (m.prototype._initNumber = function(t, e, r) {
              t < 0 && ((this.negative = 1), (t = -t)),
                t < 67108864
                  ? ((this.words = [67108863 & t]), (this.length = 1))
                  : t < 4503599627370496
                  ? ((this.words = [67108863 & t, (t / 67108864) & 67108863]),
                    (this.length = 2))
                  : (b(t < 9007199254740992),
                    (this.words = [67108863 & t, (t / 67108864) & 67108863, 1]),
                    (this.length = 3)),
                'le' === r && this._initArray(this.toArray(), e, r);
            }),
            (m.prototype._initArray = function(t, e, r) {
              if ((b('number' == typeof t.length), t.length <= 0))
                return (this.words = [0]), (this.length = 1), this;
              (this.length = Math.ceil(t.length / 3)),
                (this.words = new Array(this.length));
              for (var i, n, s = 0; s < this.length; s++) this.words[s] = 0;
              var o = 0;
              if ('be' === r)
                for (s = t.length - 1, i = 0; 0 <= s; s -= 3)
                  (n = t[s] | (t[s - 1] << 8) | (t[s - 2] << 16)),
                    (this.words[i] |= (n << o) & 67108863),
                    (this.words[i + 1] = (n >>> (26 - o)) & 67108863),
                    26 <= (o += 24) && ((o -= 26), i++);
              else if ('le' === r)
                for (i = s = 0; s < t.length; s += 3)
                  (n = t[s] | (t[s + 1] << 8) | (t[s + 2] << 16)),
                    (this.words[i] |= (n << o) & 67108863),
                    (this.words[i + 1] = (n >>> (26 - o)) & 67108863),
                    26 <= (o += 24) && ((o -= 26), i++);
              return this._strip();
            }),
            (m.prototype._parseHex = function(t, e, r) {
              (this.length = Math.ceil((t.length - e) / 6)),
                (this.words = new Array(this.length));
              for (var i = 0; i < this.length; i++) this.words[i] = 0;
              var n,
                s = 0,
                o = 0;
              if ('be' === r)
                for (i = t.length - 1; e <= i; i -= 2)
                  (n = a(t, e, i) << s),
                    (this.words[o] |= 67108863 & n),
                    18 <= s
                      ? ((s -= 18), (this.words[(o += 1)] |= n >>> 26))
                      : (s += 8);
              else
                for (
                  i = (t.length - e) % 2 == 0 ? e + 1 : e;
                  i < t.length;
                  i += 2
                )
                  (n = a(t, e, i) << s),
                    (this.words[o] |= 67108863 & n),
                    18 <= s
                      ? ((s -= 18), (this.words[(o += 1)] |= n >>> 26))
                      : (s += 8);
              this._strip();
            }),
            (m.prototype._parseBase = function(t, e, r) {
              this.words = [0];
              for (var i = 0, n = (this.length = 1); n <= 67108863; n *= e) i++;
              for (
                var n = (n / e) | 0,
                  s = t.length - r,
                  o = s % --i,
                  a = Math.min(s, s - o) + r,
                  f = 0,
                  h = r;
                h < a;
                h += i
              )
                (f = u(t, h, h + i, e)),
                  this.imuln(n),
                  this.words[0] + f < 67108864
                    ? (this.words[0] += f)
                    : this._iaddn(f);
              if (0 != o) {
                for (var c = 1, f = u(t, h, t.length, e), h = 0; h < o; h++)
                  c *= e;
                this.imuln(c),
                  this.words[0] + f < 67108864
                    ? (this.words[0] += f)
                    : this._iaddn(f);
              }
              this._strip();
            }),
            (m.prototype.copy = function(t) {
              t.words = new Array(this.length);
              for (var e = 0; e < this.length; e++) t.words[e] = this.words[e];
              (t.length = this.length),
                (t.negative = this.negative),
                (t.red = this.red);
            }),
            (m.prototype._move = function(t) {
              s(t, this);
            }),
            (m.prototype.clone = function() {
              var t = new m(null);
              return this.copy(t), t;
            }),
            (m.prototype._expand = function(t) {
              for (; this.length < t; ) this.words[this.length++] = 0;
              return this;
            }),
            (m.prototype._strip = function() {
              for (; 1 < this.length && 0 === this.words[this.length - 1]; )
                this.length--;
              return this._normSign();
            }),
            (m.prototype._normSign = function() {
              return (
                1 === this.length && 0 === this.words[0] && (this.negative = 0),
                this
              );
            }),
            'undefined' != typeof Symbol && 'function' == typeof Symbol.for)
          )
            try {
              m.prototype[Symbol.for('nodejs.util.inspect.custom')] = o;
            } catch (t) {
              m.prototype.inspect = o;
            }
          else m.prototype.inspect = o;
          function o() {
            return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
          }
          var d = [
              '',
              '0',
              '00',
              '000',
              '0000',
              '00000',
              '000000',
              '0000000',
              '00000000',
              '000000000',
              '0000000000',
              '00000000000',
              '000000000000',
              '0000000000000',
              '00000000000000',
              '000000000000000',
              '0000000000000000',
              '00000000000000000',
              '000000000000000000',
              '0000000000000000000',
              '00000000000000000000',
              '000000000000000000000',
              '0000000000000000000000',
              '00000000000000000000000',
              '000000000000000000000000',
              '0000000000000000000000000',
            ],
            l = [
              0,
              0,
              25,
              16,
              12,
              11,
              10,
              9,
              8,
              8,
              7,
              7,
              7,
              7,
              6,
              6,
              6,
              6,
              6,
              6,
              6,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
            ],
            p = [
              0,
              0,
              33554432,
              43046721,
              16777216,
              48828125,
              60466176,
              40353607,
              16777216,
              43046721,
              1e7,
              19487171,
              35831808,
              62748517,
              7529536,
              11390625,
              16777216,
              24137569,
              34012224,
              47045881,
              64e6,
              4084101,
              5153632,
              6436343,
              7962624,
              9765625,
              11881376,
              14348907,
              17210368,
              20511149,
              243e5,
              28629151,
              33554432,
              39135393,
              45435424,
              52521875,
              60466176,
            ];
          (m.prototype.toString = function(t, e) {
            if (((e = 0 | e || 1), 16 === (t = t || 10) || 'hex' === t)) {
              a = '';
              for (var r = 0, i = 0, n = 0; n < this.length; n++) {
                var s = this.words[n],
                  o = (16777215 & ((s << r) | i)).toString(16),
                  a =
                    0 !== (i = (s >>> (24 - r)) & 16777215) ||
                    n !== this.length - 1
                      ? d[6 - o.length] + o + a
                      : o + a;
                26 <= (r += 2) && ((r -= 26), n--);
              }
              for (0 !== i && (a = i.toString(16) + a); a.length % e != 0; )
                a = '0' + a;
              return (a = 0 !== this.negative ? '-' + a : a);
            }
            if (t === (0 | t) && 2 <= t && t <= 36) {
              var f = l[t],
                h = p[t];
              for (a = '', (c = this.clone()).negative = 0; !c.isZero(); ) {
                var c,
                  u = c.modrn(h).toString(t);
                a = (c = c.idivn(h)).isZero() ? u + a : d[f - u.length] + u + a;
              }
              for (this.isZero() && (a = '0' + a); a.length % e != 0; )
                a = '0' + a;
              return (a = 0 !== this.negative ? '-' + a : a);
            }
            b(!1, 'Base should be between 2 and 36');
          }),
            (m.prototype.toNumber = function() {
              var t = this.words[0];
              return (
                2 === this.length
                  ? (t += 67108864 * this.words[1])
                  : 3 === this.length && 1 === this.words[2]
                  ? (t += 4503599627370496 + 67108864 * this.words[1])
                  : 2 < this.length &&
                    b(!1, 'Number can only safely store up to 53 bits'),
                0 !== this.negative ? -t : t
              );
            }),
            (m.prototype.toJSON = function() {
              return this.toString(16, 2);
            }),
            i &&
              (m.prototype.toBuffer = function(t, e) {
                return this.toArrayLike(i, t, e);
              }),
            (m.prototype.toArray = function(t, e) {
              return this.toArrayLike(Array, t, e);
            });
          function f(t, e, r) {
            r.negative = e.negative ^ t.negative;
            var i = (t.length + e.length) | 0,
              i = ((r.length = i) - 1) | 0,
              n = ((o = (0 | t.words[0]) * (0 | e.words[0])) / 67108864) | 0;
            r.words[0] = 67108863 & o;
            for (var s = 1; s < i; s++) {
              for (
                var o,
                  a = n >>> 26,
                  f = 67108863 & n,
                  h = Math.min(s, e.length - 1),
                  c = Math.max(0, s - t.length + 1);
                c <= h;
                c++
              )
                (a +=
                  ((o = (0 | t.words[(s - c) | 0]) * (0 | e.words[c]) + f) /
                    67108864) |
                  0),
                  (f = 67108863 & o);
              (r.words[s] = 0 | f), (n = 0 | a);
            }
            return 0 !== n ? (r.words[s] = 0 | n) : r.length--, r._strip();
          }
          (m.prototype.toArrayLike = function(t, e, r) {
            this._strip();
            var i = this.byteLength(),
              r = r || Math.max(1, i);
            b(i <= r, 'byte array longer than desired length'),
              b(0 < r, 'Requested array length <= 0');
            (r = r), (r = (t = t).allocUnsafe ? t.allocUnsafe(r) : new t(r));
            return this['_toArrayLike' + ('le' === e ? 'LE' : 'BE')](r, i), r;
          }),
            (m.prototype._toArrayLikeLE = function(t, e) {
              for (var r = 0, i = 0, n = 0, s = 0; n < this.length; n++) {
                var o = (this.words[n] << s) | i;
                (t[r++] = 255 & o),
                  r < t.length && (t[r++] = (o >> 8) & 255),
                  r < t.length && (t[r++] = (o >> 16) & 255),
                  6 === s
                    ? (r < t.length && (t[r++] = (o >> 24) & 255), (s = i = 0))
                    : ((i = o >>> 24), (s += 2));
              }
              if (r < t.length) for (t[r++] = i; r < t.length; ) t[r++] = 0;
            }),
            (m.prototype._toArrayLikeBE = function(t, e) {
              for (
                var r = t.length - 1, i = 0, n = 0, s = 0;
                n < this.length;
                n++
              ) {
                var o = (this.words[n] << s) | i;
                (t[r--] = 255 & o),
                  0 <= r && (t[r--] = (o >> 8) & 255),
                  0 <= r && (t[r--] = (o >> 16) & 255),
                  6 === s
                    ? (0 <= r && (t[r--] = (o >> 24) & 255), (s = i = 0))
                    : ((i = o >>> 24), (s += 2));
              }
              if (0 <= r) for (t[r--] = i; 0 <= r; ) t[r--] = 0;
            }),
            Math.clz32
              ? (m.prototype._countBits = function(t) {
                  return 32 - Math.clz32(t);
                })
              : (m.prototype._countBits = function(t) {
                  var e = t,
                    t = 0;
                  return (
                    4096 <= e && ((t += 13), (e >>>= 13)),
                    64 <= e && ((t += 7), (e >>>= 7)),
                    8 <= e && ((t += 4), (e >>>= 4)),
                    2 <= e && ((t += 2), (e >>>= 2)),
                    t + e
                  );
                }),
            (m.prototype._zeroBits = function(t) {
              if (0 === t) return 26;
              var e = t,
                t = 0;
              return (
                0 == (8191 & e) && ((t += 13), (e >>>= 13)),
                0 == (127 & e) && ((t += 7), (e >>>= 7)),
                0 == (15 & e) && ((t += 4), (e >>>= 4)),
                0 == (3 & e) && ((t += 2), (e >>>= 2)),
                0 == (1 & e) && t++,
                t
              );
            }),
            (m.prototype.bitLength = function() {
              var t = this.words[this.length - 1],
                t = this._countBits(t);
              return 26 * (this.length - 1) + t;
            }),
            (m.prototype.zeroBits = function() {
              if (this.isZero()) return 0;
              for (var t = 0, e = 0; e < this.length; e++) {
                var r = this._zeroBits(this.words[e]);
                if (((t += r), 26 !== r)) break;
              }
              return t;
            }),
            (m.prototype.byteLength = function() {
              return Math.ceil(this.bitLength() / 8);
            }),
            (m.prototype.toTwos = function(t) {
              return 0 !== this.negative
                ? this.abs()
                    .inotn(t)
                    .iaddn(1)
                : this.clone();
            }),
            (m.prototype.fromTwos = function(t) {
              return this.testn(t - 1)
                ? this.notn(t)
                    .iaddn(1)
                    .ineg()
                : this.clone();
            }),
            (m.prototype.isNeg = function() {
              return 0 !== this.negative;
            }),
            (m.prototype.neg = function() {
              return this.clone().ineg();
            }),
            (m.prototype.ineg = function() {
              return this.isZero() || (this.negative ^= 1), this;
            }),
            (m.prototype.iuor = function(t) {
              for (; this.length < t.length; ) this.words[this.length++] = 0;
              for (var e = 0; e < t.length; e++)
                this.words[e] = this.words[e] | t.words[e];
              return this._strip();
            }),
            (m.prototype.ior = function(t) {
              return b(0 == (this.negative | t.negative)), this.iuor(t);
            }),
            (m.prototype.or = function(t) {
              return this.length > t.length
                ? this.clone().ior(t)
                : t.clone().ior(this);
            }),
            (m.prototype.uor = function(t) {
              return this.length > t.length
                ? this.clone().iuor(t)
                : t.clone().iuor(this);
            }),
            (m.prototype.iuand = function(t) {
              for (
                var e = this.length > t.length ? t : this, r = 0;
                r < e.length;
                r++
              )
                this.words[r] = this.words[r] & t.words[r];
              return (this.length = e.length), this._strip();
            }),
            (m.prototype.iand = function(t) {
              return b(0 == (this.negative | t.negative)), this.iuand(t);
            }),
            (m.prototype.and = function(t) {
              return this.length > t.length
                ? this.clone().iand(t)
                : t.clone().iand(this);
            }),
            (m.prototype.uand = function(t) {
              return this.length > t.length
                ? this.clone().iuand(t)
                : t.clone().iuand(this);
            }),
            (m.prototype.iuxor = function(t) {
              for (
                var e,
                  r =
                    this.length > t.length ? ((e = this), t) : ((e = t), this),
                  i = 0;
                i < r.length;
                i++
              )
                this.words[i] = e.words[i] ^ r.words[i];
              if (this !== e)
                for (; i < e.length; i++) this.words[i] = e.words[i];
              return (this.length = e.length), this._strip();
            }),
            (m.prototype.ixor = function(t) {
              return b(0 == (this.negative | t.negative)), this.iuxor(t);
            }),
            (m.prototype.xor = function(t) {
              return this.length > t.length
                ? this.clone().ixor(t)
                : t.clone().ixor(this);
            }),
            (m.prototype.uxor = function(t) {
              return this.length > t.length
                ? this.clone().iuxor(t)
                : t.clone().iuxor(this);
            }),
            (m.prototype.inotn = function(t) {
              b('number' == typeof t && 0 <= t);
              var e = 0 | Math.ceil(t / 26),
                t = t % 26;
              this._expand(e), 0 < t && e--;
              for (var r = 0; r < e; r++)
                this.words[r] = 67108863 & ~this.words[r];
              return (
                0 < t &&
                  (this.words[r] = ~this.words[r] & (67108863 >> (26 - t))),
                this._strip()
              );
            }),
            (m.prototype.notn = function(t) {
              return this.clone().inotn(t);
            }),
            (m.prototype.setn = function(t, e) {
              b('number' == typeof t && 0 <= t);
              var r = (t / 26) | 0,
                t = t % 26;
              return (
                this._expand(1 + r),
                (this.words[r] = e
                  ? this.words[r] | (1 << t)
                  : this.words[r] & ~(1 << t)),
                this._strip()
              );
            }),
            (m.prototype.iadd = function(t) {
              var e, r;
              if (0 !== this.negative && 0 === t.negative)
                return (
                  (this.negative = 0),
                  (e = this.isub(t)),
                  (this.negative ^= 1),
                  this._normSign()
                );
              if (0 === this.negative && 0 !== t.negative)
                return (
                  (t.negative = 0),
                  (e = this.isub(t)),
                  (t.negative = 1),
                  e._normSign()
                );
              for (
                var i =
                    this.length > t.length ? ((r = this), t) : ((r = t), this),
                  n = 0,
                  s = 0;
                s < i.length;
                s++
              )
                (e = (0 | r.words[s]) + (0 | i.words[s]) + n),
                  (this.words[s] = 67108863 & e),
                  (n = e >>> 26);
              for (; 0 !== n && s < r.length; s++)
                (e = (0 | r.words[s]) + n),
                  (this.words[s] = 67108863 & e),
                  (n = e >>> 26);
              if (((this.length = r.length), 0 !== n))
                (this.words[this.length] = n), this.length++;
              else if (r !== this)
                for (; s < r.length; s++) this.words[s] = r.words[s];
              return this;
            }),
            (m.prototype.add = function(t) {
              var e;
              return 0 !== t.negative && 0 === this.negative
                ? ((t.negative = 0), (e = this.sub(t)), (t.negative ^= 1), e)
                : 0 === t.negative && 0 !== this.negative
                ? ((this.negative = 0),
                  (e = t.sub(this)),
                  (this.negative = 1),
                  e)
                : this.length > t.length
                ? this.clone().iadd(t)
                : t.clone().iadd(this);
            }),
            (m.prototype.isub = function(t) {
              if (0 !== t.negative) {
                t.negative = 0;
                var e = this.iadd(t);
                return (t.negative = 1), e._normSign();
              }
              if (0 !== this.negative)
                return (
                  (this.negative = 0),
                  this.iadd(t),
                  (this.negative = 1),
                  this._normSign()
                );
              var r,
                i = this.cmp(t);
              if (0 === i)
                return (
                  (this.negative = 0),
                  (this.length = 1),
                  (this.words[0] = 0),
                  this
                );
              for (
                var n = 0 < i ? ((r = this), t) : ((r = t), this), s = 0, o = 0;
                o < n.length;
                o++
              )
                (s = (e = (0 | r.words[o]) - (0 | n.words[o]) + s) >> 26),
                  (this.words[o] = 67108863 & e);
              for (; 0 !== s && o < r.length; o++)
                (s = (e = (0 | r.words[o]) + s) >> 26),
                  (this.words[o] = 67108863 & e);
              if (0 === s && o < r.length && r !== this)
                for (; o < r.length; o++) this.words[o] = r.words[o];
              return (
                (this.length = Math.max(this.length, o)),
                r !== this && (this.negative = 1),
                this._strip()
              );
            }),
            (m.prototype.sub = function(t) {
              return this.clone().isub(t);
            });
          var h = function(t, e, r) {
            var i = t.words,
              n = e.words,
              s = r.words,
              o = 0 | i[0],
              a = 8191 & o,
              f = o >>> 13,
              h = 0 | i[1],
              c = 8191 & h,
              u = h >>> 13,
              d = 0 | i[2],
              l = 8191 & d,
              p = d >>> 13,
              b = 0 | i[3],
              m = 8191 & b,
              y = b >>> 13,
              g = 0 | i[4],
              v = 8191 & g,
              _ = g >>> 13,
              w = 0 | i[5],
              M = 8191 & w,
              S = w >>> 13,
              E = 0 | i[6],
              k = 8191 & E,
              A = E >>> 13,
              x = 0 | i[7],
              B = 8191 & x,
              I = x >>> 13,
              R = 0 | i[8],
              j = 8191 & R,
              T = R >>> 13,
              C = 0 | i[9],
              L = 8191 & C,
              P = C >>> 13,
              O = 0 | n[0],
              D = 8191 & O,
              N = O >>> 13,
              q = 0 | n[1],
              U = 8191 & q,
              z = q >>> 13,
              K = 0 | n[2],
              F = 8191 & K,
              H = K >>> 13,
              W = 0 | n[3],
              V = 8191 & W,
              Z = W >>> 13,
              X = 0 | n[4],
              G = 8191 & X,
              Y = X >>> 13,
              J = 0 | n[5],
              $ = 8191 & J,
              Q = J >>> 13,
              o = 0 | n[6],
              h = 8191 & o,
              d = o >>> 13,
              b = 0 | n[7],
              g = 8191 & b,
              w = b >>> 13,
              E = 0 | n[8],
              x = 8191 & E,
              R = E >>> 13,
              i = 0 | n[9],
              C = 8191 & i,
              O = i >>> 13;
            (r.negative = t.negative ^ e.negative), (r.length = 19);
            var W =
                (((0 + Math.imul(a, D)) | 0) +
                  ((8191 &
                    (K = ((K = Math.imul(a, N)) + Math.imul(f, D)) | 0)) <<
                    13)) |
                0,
              tt =
                ((((X = Math.imul(f, N)) + (K >>> 13)) | 0) + (W >>> 26)) | 0;
            (W &= 67108863),
              (q = Math.imul(c, D)),
              (K = ((K = Math.imul(c, N)) + Math.imul(u, D)) | 0),
              (X = Math.imul(u, N));
            J =
              (((tt + ((q + Math.imul(a, U)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(a, z)) | 0) + Math.imul(f, U)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(f, z)) | 0) + (K >>> 13)) | 0) +
                (J >>> 26)) |
              0),
              (J &= 67108863),
              (q = Math.imul(l, D)),
              (K = ((K = Math.imul(l, N)) + Math.imul(p, D)) | 0),
              (X = Math.imul(p, N)),
              (q = (q + Math.imul(c, U)) | 0),
              (K = ((K = (K + Math.imul(c, z)) | 0) + Math.imul(u, U)) | 0),
              (X = (X + Math.imul(u, z)) | 0);
            o =
              (((tt + ((q + Math.imul(a, F)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(a, H)) | 0) + Math.imul(f, F)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(f, H)) | 0) + (K >>> 13)) | 0) +
                (o >>> 26)) |
              0),
              (o &= 67108863),
              (q = Math.imul(m, D)),
              (K = ((K = Math.imul(m, N)) + Math.imul(y, D)) | 0),
              (X = Math.imul(y, N)),
              (q = (q + Math.imul(l, U)) | 0),
              (K = ((K = (K + Math.imul(l, z)) | 0) + Math.imul(p, U)) | 0),
              (X = (X + Math.imul(p, z)) | 0),
              (q = (q + Math.imul(c, F)) | 0),
              (K = ((K = (K + Math.imul(c, H)) | 0) + Math.imul(u, F)) | 0),
              (X = (X + Math.imul(u, H)) | 0);
            b =
              (((tt + ((q + Math.imul(a, V)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(a, Z)) | 0) + Math.imul(f, V)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(f, Z)) | 0) + (K >>> 13)) | 0) +
                (b >>> 26)) |
              0),
              (b &= 67108863),
              (q = Math.imul(v, D)),
              (K = ((K = Math.imul(v, N)) + Math.imul(_, D)) | 0),
              (X = Math.imul(_, N)),
              (q = (q + Math.imul(m, U)) | 0),
              (K = ((K = (K + Math.imul(m, z)) | 0) + Math.imul(y, U)) | 0),
              (X = (X + Math.imul(y, z)) | 0),
              (q = (q + Math.imul(l, F)) | 0),
              (K = ((K = (K + Math.imul(l, H)) | 0) + Math.imul(p, F)) | 0),
              (X = (X + Math.imul(p, H)) | 0),
              (q = (q + Math.imul(c, V)) | 0),
              (K = ((K = (K + Math.imul(c, Z)) | 0) + Math.imul(u, V)) | 0),
              (X = (X + Math.imul(u, Z)) | 0);
            E =
              (((tt + ((q + Math.imul(a, G)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(a, Y)) | 0) + Math.imul(f, G)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(f, Y)) | 0) + (K >>> 13)) | 0) +
                (E >>> 26)) |
              0),
              (E &= 67108863),
              (q = Math.imul(M, D)),
              (K = ((K = Math.imul(M, N)) + Math.imul(S, D)) | 0),
              (X = Math.imul(S, N)),
              (q = (q + Math.imul(v, U)) | 0),
              (K = ((K = (K + Math.imul(v, z)) | 0) + Math.imul(_, U)) | 0),
              (X = (X + Math.imul(_, z)) | 0),
              (q = (q + Math.imul(m, F)) | 0),
              (K = ((K = (K + Math.imul(m, H)) | 0) + Math.imul(y, F)) | 0),
              (X = (X + Math.imul(y, H)) | 0),
              (q = (q + Math.imul(l, V)) | 0),
              (K = ((K = (K + Math.imul(l, Z)) | 0) + Math.imul(p, V)) | 0),
              (X = (X + Math.imul(p, Z)) | 0),
              (q = (q + Math.imul(c, G)) | 0),
              (K = ((K = (K + Math.imul(c, Y)) | 0) + Math.imul(u, G)) | 0),
              (X = (X + Math.imul(u, Y)) | 0);
            n =
              (((tt + ((q + Math.imul(a, $)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(a, Q)) | 0) + Math.imul(f, $)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(f, Q)) | 0) + (K >>> 13)) | 0) +
                (n >>> 26)) |
              0),
              (n &= 67108863),
              (q = Math.imul(k, D)),
              (K = ((K = Math.imul(k, N)) + Math.imul(A, D)) | 0),
              (X = Math.imul(A, N)),
              (q = (q + Math.imul(M, U)) | 0),
              (K = ((K = (K + Math.imul(M, z)) | 0) + Math.imul(S, U)) | 0),
              (X = (X + Math.imul(S, z)) | 0),
              (q = (q + Math.imul(v, F)) | 0),
              (K = ((K = (K + Math.imul(v, H)) | 0) + Math.imul(_, F)) | 0),
              (X = (X + Math.imul(_, H)) | 0),
              (q = (q + Math.imul(m, V)) | 0),
              (K = ((K = (K + Math.imul(m, Z)) | 0) + Math.imul(y, V)) | 0),
              (X = (X + Math.imul(y, Z)) | 0),
              (q = (q + Math.imul(l, G)) | 0),
              (K = ((K = (K + Math.imul(l, Y)) | 0) + Math.imul(p, G)) | 0),
              (X = (X + Math.imul(p, Y)) | 0),
              (q = (q + Math.imul(c, $)) | 0),
              (K = ((K = (K + Math.imul(c, Q)) | 0) + Math.imul(u, $)) | 0),
              (X = (X + Math.imul(u, Q)) | 0);
            i =
              (((tt + ((q + Math.imul(a, h)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(a, d)) | 0) + Math.imul(f, h)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(f, d)) | 0) + (K >>> 13)) | 0) +
                (i >>> 26)) |
              0),
              (i &= 67108863),
              (q = Math.imul(B, D)),
              (K = ((K = Math.imul(B, N)) + Math.imul(I, D)) | 0),
              (X = Math.imul(I, N)),
              (q = (q + Math.imul(k, U)) | 0),
              (K = ((K = (K + Math.imul(k, z)) | 0) + Math.imul(A, U)) | 0),
              (X = (X + Math.imul(A, z)) | 0),
              (q = (q + Math.imul(M, F)) | 0),
              (K = ((K = (K + Math.imul(M, H)) | 0) + Math.imul(S, F)) | 0),
              (X = (X + Math.imul(S, H)) | 0),
              (q = (q + Math.imul(v, V)) | 0),
              (K = ((K = (K + Math.imul(v, Z)) | 0) + Math.imul(_, V)) | 0),
              (X = (X + Math.imul(_, Z)) | 0),
              (q = (q + Math.imul(m, G)) | 0),
              (K = ((K = (K + Math.imul(m, Y)) | 0) + Math.imul(y, G)) | 0),
              (X = (X + Math.imul(y, Y)) | 0),
              (q = (q + Math.imul(l, $)) | 0),
              (K = ((K = (K + Math.imul(l, Q)) | 0) + Math.imul(p, $)) | 0),
              (X = (X + Math.imul(p, Q)) | 0),
              (q = (q + Math.imul(c, h)) | 0),
              (K = ((K = (K + Math.imul(c, d)) | 0) + Math.imul(u, h)) | 0),
              (X = (X + Math.imul(u, d)) | 0);
            t =
              (((tt + ((q + Math.imul(a, g)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(a, w)) | 0) + Math.imul(f, g)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(f, w)) | 0) + (K >>> 13)) | 0) +
                (t >>> 26)) |
              0),
              (t &= 67108863),
              (q = Math.imul(j, D)),
              (K = ((K = Math.imul(j, N)) + Math.imul(T, D)) | 0),
              (X = Math.imul(T, N)),
              (q = (q + Math.imul(B, U)) | 0),
              (K = ((K = (K + Math.imul(B, z)) | 0) + Math.imul(I, U)) | 0),
              (X = (X + Math.imul(I, z)) | 0),
              (q = (q + Math.imul(k, F)) | 0),
              (K = ((K = (K + Math.imul(k, H)) | 0) + Math.imul(A, F)) | 0),
              (X = (X + Math.imul(A, H)) | 0),
              (q = (q + Math.imul(M, V)) | 0),
              (K = ((K = (K + Math.imul(M, Z)) | 0) + Math.imul(S, V)) | 0),
              (X = (X + Math.imul(S, Z)) | 0),
              (q = (q + Math.imul(v, G)) | 0),
              (K = ((K = (K + Math.imul(v, Y)) | 0) + Math.imul(_, G)) | 0),
              (X = (X + Math.imul(_, Y)) | 0),
              (q = (q + Math.imul(m, $)) | 0),
              (K = ((K = (K + Math.imul(m, Q)) | 0) + Math.imul(y, $)) | 0),
              (X = (X + Math.imul(y, Q)) | 0),
              (q = (q + Math.imul(l, h)) | 0),
              (K = ((K = (K + Math.imul(l, d)) | 0) + Math.imul(p, h)) | 0),
              (X = (X + Math.imul(p, d)) | 0),
              (q = (q + Math.imul(c, g)) | 0),
              (K = ((K = (K + Math.imul(c, w)) | 0) + Math.imul(u, g)) | 0),
              (X = (X + Math.imul(u, w)) | 0);
            e =
              (((tt + ((q + Math.imul(a, x)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(a, R)) | 0) + Math.imul(f, x)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(f, R)) | 0) + (K >>> 13)) | 0) +
                (e >>> 26)) |
              0),
              (e &= 67108863),
              (q = Math.imul(L, D)),
              (K = ((K = Math.imul(L, N)) + Math.imul(P, D)) | 0),
              (X = Math.imul(P, N)),
              (q = (q + Math.imul(j, U)) | 0),
              (K = ((K = (K + Math.imul(j, z)) | 0) + Math.imul(T, U)) | 0),
              (X = (X + Math.imul(T, z)) | 0),
              (q = (q + Math.imul(B, F)) | 0),
              (K = ((K = (K + Math.imul(B, H)) | 0) + Math.imul(I, F)) | 0),
              (X = (X + Math.imul(I, H)) | 0),
              (q = (q + Math.imul(k, V)) | 0),
              (K = ((K = (K + Math.imul(k, Z)) | 0) + Math.imul(A, V)) | 0),
              (X = (X + Math.imul(A, Z)) | 0),
              (q = (q + Math.imul(M, G)) | 0),
              (K = ((K = (K + Math.imul(M, Y)) | 0) + Math.imul(S, G)) | 0),
              (X = (X + Math.imul(S, Y)) | 0),
              (q = (q + Math.imul(v, $)) | 0),
              (K = ((K = (K + Math.imul(v, Q)) | 0) + Math.imul(_, $)) | 0),
              (X = (X + Math.imul(_, Q)) | 0),
              (q = (q + Math.imul(m, h)) | 0),
              (K = ((K = (K + Math.imul(m, d)) | 0) + Math.imul(y, h)) | 0),
              (X = (X + Math.imul(y, d)) | 0),
              (q = (q + Math.imul(l, g)) | 0),
              (K = ((K = (K + Math.imul(l, w)) | 0) + Math.imul(p, g)) | 0),
              (X = (X + Math.imul(p, w)) | 0),
              (q = (q + Math.imul(c, x)) | 0),
              (K = ((K = (K + Math.imul(c, R)) | 0) + Math.imul(u, x)) | 0),
              (X = (X + Math.imul(u, R)) | 0);
            a =
              (((tt + ((q + Math.imul(a, C)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(a, O)) | 0) + Math.imul(f, C)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(f, O)) | 0) + (K >>> 13)) | 0) +
                (a >>> 26)) |
              0),
              (a &= 67108863),
              (q = Math.imul(L, U)),
              (K = ((K = Math.imul(L, z)) + Math.imul(P, U)) | 0),
              (X = Math.imul(P, z)),
              (q = (q + Math.imul(j, F)) | 0),
              (K = ((K = (K + Math.imul(j, H)) | 0) + Math.imul(T, F)) | 0),
              (X = (X + Math.imul(T, H)) | 0),
              (q = (q + Math.imul(B, V)) | 0),
              (K = ((K = (K + Math.imul(B, Z)) | 0) + Math.imul(I, V)) | 0),
              (X = (X + Math.imul(I, Z)) | 0),
              (q = (q + Math.imul(k, G)) | 0),
              (K = ((K = (K + Math.imul(k, Y)) | 0) + Math.imul(A, G)) | 0),
              (X = (X + Math.imul(A, Y)) | 0),
              (q = (q + Math.imul(M, $)) | 0),
              (K = ((K = (K + Math.imul(M, Q)) | 0) + Math.imul(S, $)) | 0),
              (X = (X + Math.imul(S, Q)) | 0),
              (q = (q + Math.imul(v, h)) | 0),
              (K = ((K = (K + Math.imul(v, d)) | 0) + Math.imul(_, h)) | 0),
              (X = (X + Math.imul(_, d)) | 0),
              (q = (q + Math.imul(m, g)) | 0),
              (K = ((K = (K + Math.imul(m, w)) | 0) + Math.imul(y, g)) | 0),
              (X = (X + Math.imul(y, w)) | 0),
              (q = (q + Math.imul(l, x)) | 0),
              (K = ((K = (K + Math.imul(l, R)) | 0) + Math.imul(p, x)) | 0),
              (X = (X + Math.imul(p, R)) | 0);
            c =
              (((tt + ((q + Math.imul(c, C)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(c, O)) | 0) + Math.imul(u, C)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(u, O)) | 0) + (K >>> 13)) | 0) +
                (c >>> 26)) |
              0),
              (c &= 67108863),
              (q = Math.imul(L, F)),
              (K = ((K = Math.imul(L, H)) + Math.imul(P, F)) | 0),
              (X = Math.imul(P, H)),
              (q = (q + Math.imul(j, V)) | 0),
              (K = ((K = (K + Math.imul(j, Z)) | 0) + Math.imul(T, V)) | 0),
              (X = (X + Math.imul(T, Z)) | 0),
              (q = (q + Math.imul(B, G)) | 0),
              (K = ((K = (K + Math.imul(B, Y)) | 0) + Math.imul(I, G)) | 0),
              (X = (X + Math.imul(I, Y)) | 0),
              (q = (q + Math.imul(k, $)) | 0),
              (K = ((K = (K + Math.imul(k, Q)) | 0) + Math.imul(A, $)) | 0),
              (X = (X + Math.imul(A, Q)) | 0),
              (q = (q + Math.imul(M, h)) | 0),
              (K = ((K = (K + Math.imul(M, d)) | 0) + Math.imul(S, h)) | 0),
              (X = (X + Math.imul(S, d)) | 0),
              (q = (q + Math.imul(v, g)) | 0),
              (K = ((K = (K + Math.imul(v, w)) | 0) + Math.imul(_, g)) | 0),
              (X = (X + Math.imul(_, w)) | 0),
              (q = (q + Math.imul(m, x)) | 0),
              (K = ((K = (K + Math.imul(m, R)) | 0) + Math.imul(y, x)) | 0),
              (X = (X + Math.imul(y, R)) | 0);
            l =
              (((tt + ((q + Math.imul(l, C)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(l, O)) | 0) + Math.imul(p, C)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(p, O)) | 0) + (K >>> 13)) | 0) +
                (l >>> 26)) |
              0),
              (l &= 67108863),
              (q = Math.imul(L, V)),
              (K = ((K = Math.imul(L, Z)) + Math.imul(P, V)) | 0),
              (X = Math.imul(P, Z)),
              (q = (q + Math.imul(j, G)) | 0),
              (K = ((K = (K + Math.imul(j, Y)) | 0) + Math.imul(T, G)) | 0),
              (X = (X + Math.imul(T, Y)) | 0),
              (q = (q + Math.imul(B, $)) | 0),
              (K = ((K = (K + Math.imul(B, Q)) | 0) + Math.imul(I, $)) | 0),
              (X = (X + Math.imul(I, Q)) | 0),
              (q = (q + Math.imul(k, h)) | 0),
              (K = ((K = (K + Math.imul(k, d)) | 0) + Math.imul(A, h)) | 0),
              (X = (X + Math.imul(A, d)) | 0),
              (q = (q + Math.imul(M, g)) | 0),
              (K = ((K = (K + Math.imul(M, w)) | 0) + Math.imul(S, g)) | 0),
              (X = (X + Math.imul(S, w)) | 0),
              (q = (q + Math.imul(v, x)) | 0),
              (K = ((K = (K + Math.imul(v, R)) | 0) + Math.imul(_, x)) | 0),
              (X = (X + Math.imul(_, R)) | 0);
            m =
              (((tt + ((q + Math.imul(m, C)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(m, O)) | 0) + Math.imul(y, C)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(y, O)) | 0) + (K >>> 13)) | 0) +
                (m >>> 26)) |
              0),
              (m &= 67108863),
              (q = Math.imul(L, G)),
              (K = ((K = Math.imul(L, Y)) + Math.imul(P, G)) | 0),
              (X = Math.imul(P, Y)),
              (q = (q + Math.imul(j, $)) | 0),
              (K = ((K = (K + Math.imul(j, Q)) | 0) + Math.imul(T, $)) | 0),
              (X = (X + Math.imul(T, Q)) | 0),
              (q = (q + Math.imul(B, h)) | 0),
              (K = ((K = (K + Math.imul(B, d)) | 0) + Math.imul(I, h)) | 0),
              (X = (X + Math.imul(I, d)) | 0),
              (q = (q + Math.imul(k, g)) | 0),
              (K = ((K = (K + Math.imul(k, w)) | 0) + Math.imul(A, g)) | 0),
              (X = (X + Math.imul(A, w)) | 0),
              (q = (q + Math.imul(M, x)) | 0),
              (K = ((K = (K + Math.imul(M, R)) | 0) + Math.imul(S, x)) | 0),
              (X = (X + Math.imul(S, R)) | 0);
            v =
              (((tt + ((q + Math.imul(v, C)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(v, O)) | 0) + Math.imul(_, C)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(_, O)) | 0) + (K >>> 13)) | 0) +
                (v >>> 26)) |
              0),
              (v &= 67108863),
              (q = Math.imul(L, $)),
              (K = ((K = Math.imul(L, Q)) + Math.imul(P, $)) | 0),
              (X = Math.imul(P, Q)),
              (q = (q + Math.imul(j, h)) | 0),
              (K = ((K = (K + Math.imul(j, d)) | 0) + Math.imul(T, h)) | 0),
              (X = (X + Math.imul(T, d)) | 0),
              (q = (q + Math.imul(B, g)) | 0),
              (K = ((K = (K + Math.imul(B, w)) | 0) + Math.imul(I, g)) | 0),
              (X = (X + Math.imul(I, w)) | 0),
              (q = (q + Math.imul(k, x)) | 0),
              (K = ((K = (K + Math.imul(k, R)) | 0) + Math.imul(A, x)) | 0),
              (X = (X + Math.imul(A, R)) | 0);
            M =
              (((tt + ((q + Math.imul(M, C)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(M, O)) | 0) + Math.imul(S, C)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(S, O)) | 0) + (K >>> 13)) | 0) +
                (M >>> 26)) |
              0),
              (M &= 67108863),
              (q = Math.imul(L, h)),
              (K = ((K = Math.imul(L, d)) + Math.imul(P, h)) | 0),
              (X = Math.imul(P, d)),
              (q = (q + Math.imul(j, g)) | 0),
              (K = ((K = (K + Math.imul(j, w)) | 0) + Math.imul(T, g)) | 0),
              (X = (X + Math.imul(T, w)) | 0),
              (q = (q + Math.imul(B, x)) | 0),
              (K = ((K = (K + Math.imul(B, R)) | 0) + Math.imul(I, x)) | 0),
              (X = (X + Math.imul(I, R)) | 0);
            k =
              (((tt + ((q + Math.imul(k, C)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(k, O)) | 0) + Math.imul(A, C)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(A, O)) | 0) + (K >>> 13)) | 0) +
                (k >>> 26)) |
              0),
              (k &= 67108863),
              (q = Math.imul(L, g)),
              (K = ((K = Math.imul(L, w)) + Math.imul(P, g)) | 0),
              (X = Math.imul(P, w)),
              (q = (q + Math.imul(j, x)) | 0),
              (K = ((K = (K + Math.imul(j, R)) | 0) + Math.imul(T, x)) | 0),
              (X = (X + Math.imul(T, R)) | 0);
            B =
              (((tt + ((q + Math.imul(B, C)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(B, O)) | 0) + Math.imul(I, C)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(I, O)) | 0) + (K >>> 13)) | 0) +
                (B >>> 26)) |
              0),
              (B &= 67108863),
              (q = Math.imul(L, x)),
              (K = ((K = Math.imul(L, R)) + Math.imul(P, x)) | 0),
              (X = Math.imul(P, R));
            j =
              (((tt + ((q + Math.imul(j, C)) | 0)) | 0) +
                ((8191 &
                  (K =
                    ((K = (K + Math.imul(j, O)) | 0) + Math.imul(T, C)) | 0)) <<
                  13)) |
              0;
            (tt =
              ((((X = (X + Math.imul(T, O)) | 0) + (K >>> 13)) | 0) +
                (j >>> 26)) |
              0),
              (j &= 67108863);
            C =
              (((tt + Math.imul(L, C)) | 0) +
                ((8191 & (K = ((K = Math.imul(L, O)) + Math.imul(P, C)) | 0)) <<
                  13)) |
              0;
            return (
              (tt =
                ((((X = Math.imul(P, O)) + (K >>> 13)) | 0) + (C >>> 26)) | 0),
              (C &= 67108863),
              (s[0] = W),
              (s[1] = J),
              (s[2] = o),
              (s[3] = b),
              (s[4] = E),
              (s[5] = n),
              (s[6] = i),
              (s[7] = t),
              (s[8] = e),
              (s[9] = a),
              (s[10] = c),
              (s[11] = l),
              (s[12] = m),
              (s[13] = v),
              (s[14] = M),
              (s[15] = k),
              (s[16] = B),
              (s[17] = j),
              (s[18] = C),
              0 != tt && ((s[19] = tt), r.length++),
              r
            );
          };
          function c(t, e, r) {
            (r.negative = e.negative ^ t.negative),
              (r.length = t.length + e.length);
            for (var i = 0, n = 0, s = 0; s < r.length - 1; s++) {
              for (
                var o = n,
                  n = 0,
                  a = 67108863 & i,
                  f = Math.min(s, e.length - 1),
                  h = Math.max(0, s - t.length + 1);
                h <= f;
                h++
              ) {
                var c,
                  u = (0 | t.words[s - h]) * (0 | e.words[h]),
                  a = 67108863 & (c = ((c = 67108863 & u) + a) | 0);
                (n +=
                  (o =
                    ((o = (o + ((u / 67108864) | 0)) | 0) + (c >>> 26)) | 0) >>>
                  26),
                  (o &= 67108863);
              }
              (r.words[s] = a), (i = o), (o = n);
            }
            return 0 !== i ? (r.words[s] = i) : r.length--, r._strip();
          }
          function y(t, e, r) {
            return c(t, e, r);
          }
          Math.imul || (h = f),
            (m.prototype.mulTo = function(t, e) {
              var r = this.length + t.length,
                e = (10 === this.length && 10 === t.length
                  ? h
                  : r < 63
                  ? f
                  : r < 1024
                  ? c
                  : y)(this, t, e);
              return e;
            }),
            (m.prototype.mul = function(t) {
              var e = new m(null);
              return (
                (e.words = new Array(this.length + t.length)), this.mulTo(t, e)
              );
            }),
            (m.prototype.mulf = function(t) {
              var e = new m(null);
              return (
                (e.words = new Array(this.length + t.length)), y(this, t, e)
              );
            }),
            (m.prototype.imul = function(t) {
              return this.clone().mulTo(t, this);
            }),
            (m.prototype.imuln = function(t) {
              var e = t < 0;
              b('number' == typeof (t = e ? -t : t)), b(t < 67108864);
              for (var r = 0, i = 0; i < this.length; i++) {
                var n = (0 | this.words[i]) * t,
                  s = (67108863 & n) + (67108863 & r);
                (r >>= 26),
                  (r += (n / 67108864) | 0),
                  (r += s >>> 26),
                  (this.words[i] = 67108863 & s);
              }
              return (
                0 !== r && ((this.words[i] = r), this.length++),
                e ? this.ineg() : this
              );
            }),
            (m.prototype.muln = function(t) {
              return this.clone().imuln(t);
            }),
            (m.prototype.sqr = function() {
              return this.mul(this);
            }),
            (m.prototype.isqr = function() {
              return this.imul(this.clone());
            }),
            (m.prototype.pow = function(t) {
              var e = (function(t) {
                for (var e = new Array(t.bitLength()), r = 0; r < e.length; r++)
                  e[r] = (t.words[(r / 26) | 0] >>> r % 26) & 1;
                return e;
              })(t);
              if (0 === e.length) return new m(1);
              for (
                var r = this, i = 0;
                i < e.length && 0 === e[i];
                i++, r = r.sqr()
              );
              if (++i < e.length)
                for (var n = r.sqr(); i < e.length; i++, n = n.sqr())
                  0 !== e[i] && (r = r.mul(n));
              return r;
            }),
            (m.prototype.iushln = function(t) {
              b('number' == typeof t && 0 <= t);
              var e = t % 26,
                r = (t - e) / 26,
                i = (67108863 >>> (26 - e)) << (26 - e);
              if (0 != e) {
                for (var n = 0, s = 0; s < this.length; s++) {
                  var o = this.words[s] & i,
                    a = ((0 | this.words[s]) - o) << e;
                  (this.words[s] = a | n), (n = o >>> (26 - e));
                }
                n && ((this.words[s] = n), this.length++);
              }
              if (0 != r) {
                for (s = this.length - 1; 0 <= s; s--)
                  this.words[s + r] = this.words[s];
                for (s = 0; s < r; s++) this.words[s] = 0;
                this.length += r;
              }
              return this._strip();
            }),
            (m.prototype.ishln = function(t) {
              return b(0 === this.negative), this.iushln(t);
            }),
            (m.prototype.iushrn = function(t, e, r) {
              b('number' == typeof t && 0 <= t);
              var i = e ? (e - (e % 26)) / 26 : 0,
                n = t % 26,
                s = Math.min((t - n) / 26, this.length),
                o = 67108863 ^ ((67108863 >>> n) << n),
                a = r;
              if (((i -= s), (i = Math.max(0, i)), a)) {
                for (var f = 0; f < s; f++) a.words[f] = this.words[f];
                a.length = s;
              }
              if (0 !== s)
                if (this.length > s)
                  for (this.length -= s, f = 0; f < this.length; f++)
                    this.words[f] = this.words[f + s];
                else (this.words[0] = 0), (this.length = 1);
              for (
                var h = 0, f = this.length - 1;
                0 <= f && (0 !== h || i <= f);
                f--
              ) {
                var c = 0 | this.words[f];
                (this.words[f] = (h << (26 - n)) | (c >>> n)), (h = c & o);
              }
              return (
                a && 0 !== h && (a.words[a.length++] = h),
                0 === this.length && ((this.words[0] = 0), (this.length = 1)),
                this._strip()
              );
            }),
            (m.prototype.ishrn = function(t, e, r) {
              return b(0 === this.negative), this.iushrn(t, e, r);
            }),
            (m.prototype.shln = function(t) {
              return this.clone().ishln(t);
            }),
            (m.prototype.ushln = function(t) {
              return this.clone().iushln(t);
            }),
            (m.prototype.shrn = function(t) {
              return this.clone().ishrn(t);
            }),
            (m.prototype.ushrn = function(t) {
              return this.clone().iushrn(t);
            }),
            (m.prototype.testn = function(t) {
              b('number' == typeof t && 0 <= t);
              var e = t % 26,
                t = (t - e) / 26;
              return !(this.length <= t) && !!(this.words[t] & (1 << e));
            }),
            (m.prototype.imaskn = function(t) {
              b('number' == typeof t && 0 <= t);
              var e = t % 26,
                t = (t - e) / 26;
              return (
                b(
                  0 === this.negative,
                  'imaskn works only with positive numbers'
                ),
                this.length <= t
                  ? this
                  : (0 != e && t++,
                    (this.length = Math.min(t, this.length)),
                    0 != e &&
                      (this.words[this.length - 1] &=
                        67108863 ^ ((67108863 >>> e) << e)),
                    this._strip())
              );
            }),
            (m.prototype.maskn = function(t) {
              return this.clone().imaskn(t);
            }),
            (m.prototype.iaddn = function(t) {
              return (
                b('number' == typeof t),
                b(t < 67108864),
                t < 0
                  ? this.isubn(-t)
                  : 0 !== this.negative
                  ? (1 === this.length && (0 | this.words[0]) <= t
                      ? ((this.words[0] = t - (0 | this.words[0])),
                        (this.negative = 0))
                      : ((this.negative = 0),
                        this.isubn(t),
                        (this.negative = 1)),
                    this)
                  : this._iaddn(t)
              );
            }),
            (m.prototype._iaddn = function(t) {
              this.words[0] += t;
              for (var e = 0; e < this.length && 67108864 <= this.words[e]; e++)
                (this.words[e] -= 67108864),
                  e === this.length - 1
                    ? (this.words[e + 1] = 1)
                    : this.words[e + 1]++;
              return (this.length = Math.max(this.length, e + 1)), this;
            }),
            (m.prototype.isubn = function(t) {
              if ((b('number' == typeof t), b(t < 67108864), t < 0))
                return this.iaddn(-t);
              if (0 !== this.negative)
                return (
                  (this.negative = 0), this.iaddn(t), (this.negative = 1), this
                );
              if (
                ((this.words[0] -= t), 1 === this.length && this.words[0] < 0)
              )
                (this.words[0] = -this.words[0]), (this.negative = 1);
              else
                for (var e = 0; e < this.length && this.words[e] < 0; e++)
                  (this.words[e] += 67108864), --this.words[e + 1];
              return this._strip();
            }),
            (m.prototype.addn = function(t) {
              return this.clone().iaddn(t);
            }),
            (m.prototype.subn = function(t) {
              return this.clone().isubn(t);
            }),
            (m.prototype.iabs = function() {
              return (this.negative = 0), this;
            }),
            (m.prototype.abs = function() {
              return this.clone().iabs();
            }),
            (m.prototype._ishlnsubmul = function(t, e, r) {
              var i = t.length + r;
              this._expand(i);
              for (var n = 0, s = 0; s < t.length; s++) {
                var o = (0 | this.words[s + r]) + n,
                  a = (0 | t.words[s]) * e,
                  n = ((o -= 67108863 & a) >> 26) - ((a / 67108864) | 0);
                this.words[s + r] = 67108863 & o;
              }
              for (; s < this.length - r; s++)
                (n = (o = (0 | this.words[s + r]) + n) >> 26),
                  (this.words[s + r] = 67108863 & o);
              if (0 === n) return this._strip();
              for (b(-1 === n), s = n = 0; s < this.length; s++)
                (n = (o = -(0 | this.words[s]) + n) >> 26),
                  (this.words[s] = 67108863 & o);
              return (this.negative = 1), this._strip();
            }),
            (m.prototype._wordDiv = function(t, e) {
              var r = this.length - t.length,
                i = this.clone(),
                n = t,
                s = 0 | n.words[n.length - 1];
              0 != (r = 26 - this._countBits(s)) &&
                ((n = n.ushln(r)),
                i.iushln(r),
                (s = 0 | n.words[n.length - 1]));
              var o,
                a = i.length - n.length;
              if ('mod' !== e) {
                ((o = new m(null)).length = 1 + a),
                  (o.words = new Array(o.length));
                for (var f = 0; f < o.length; f++) o.words[f] = 0;
              }
              t = i.clone()._ishlnsubmul(n, 1, a);
              0 === t.negative && ((i = t), o && (o.words[a] = 1));
              for (var h = a - 1; 0 <= h; h--) {
                var c =
                    67108864 * (0 | i.words[n.length + h]) +
                    (0 | i.words[n.length + h - 1]),
                  c = Math.min((c / s) | 0, 67108863);
                for (i._ishlnsubmul(n, c, h); 0 !== i.negative; )
                  c--,
                    (i.negative = 0),
                    i._ishlnsubmul(n, 1, h),
                    i.isZero() || (i.negative ^= 1);
                o && (o.words[h] = c);
              }
              return (
                o && o._strip(),
                i._strip(),
                'div' !== e && 0 != r && i.iushrn(r),
                { div: o || null, mod: i }
              );
            }),
            (m.prototype.divmod = function(t, e, r) {
              return (
                b(!t.isZero()),
                this.isZero()
                  ? { div: new m(0), mod: new m(0) }
                  : 0 !== this.negative && 0 === t.negative
                  ? ((s = this.neg().divmod(t, e)),
                    'mod' !== e && (i = s.div.neg()),
                    'div' !== e &&
                      ((n = s.mod.neg()), r && 0 !== n.negative && n.iadd(t)),
                    { div: i, mod: n })
                  : 0 === this.negative && 0 !== t.negative
                  ? ((s = this.divmod(t.neg(), e)),
                    { div: (i = 'mod' !== e ? s.div.neg() : i), mod: s.mod })
                  : 0 != (this.negative & t.negative)
                  ? ((s = this.neg().divmod(t.neg(), e)),
                    'div' !== e &&
                      ((n = s.mod.neg()), r && 0 !== n.negative && n.isub(t)),
                    { div: s.div, mod: n })
                  : t.length > this.length || this.cmp(t) < 0
                  ? { div: new m(0), mod: this }
                  : 1 === t.length
                  ? 'div' === e
                    ? { div: this.divn(t.words[0]), mod: null }
                    : 'mod' === e
                    ? { div: null, mod: new m(this.modrn(t.words[0])) }
                    : {
                        div: this.divn(t.words[0]),
                        mod: new m(this.modrn(t.words[0])),
                      }
                  : this._wordDiv(t, e)
              );
              var i, n, s;
            }),
            (m.prototype.div = function(t) {
              return this.divmod(t, 'div', !1).div;
            }),
            (m.prototype.mod = function(t) {
              return this.divmod(t, 'mod', !1).mod;
            }),
            (m.prototype.umod = function(t) {
              return this.divmod(t, 'mod', !0).mod;
            }),
            (m.prototype.divRound = function(t) {
              var e = this.divmod(t);
              if (e.mod.isZero()) return e.div;
              var r = 0 !== e.div.negative ? e.mod.isub(t) : e.mod,
                i = t.ushrn(1),
                t = t.andln(1),
                i = r.cmp(i);
              return i < 0 || (1 === t && 0 === i)
                ? e.div
                : 0 !== e.div.negative
                ? e.div.isubn(1)
                : e.div.iaddn(1);
            }),
            (m.prototype.modrn = function(t) {
              var e = t < 0;
              b((t = e ? -t : t) <= 67108863);
              for (
                var r = (1 << 26) % t, i = 0, n = this.length - 1;
                0 <= n;
                n--
              )
                i = (r * i + (0 | this.words[n])) % t;
              return e ? -i : i;
            }),
            (m.prototype.modn = function(t) {
              return this.modrn(t);
            }),
            (m.prototype.idivn = function(t) {
              var e = t < 0;
              b((t = e ? -t : t) <= 67108863);
              for (var r = 0, i = this.length - 1; 0 <= i; i--) {
                var n = (0 | this.words[i]) + 67108864 * r;
                (this.words[i] = (n / t) | 0), (r = n % t);
              }
              return this._strip(), e ? this.ineg() : this;
            }),
            (m.prototype.divn = function(t) {
              return this.clone().idivn(t);
            }),
            (m.prototype.egcd = function(t) {
              b(0 === t.negative), b(!t.isZero());
              for (
                var e = this,
                  r = t.clone(),
                  e = 0 !== e.negative ? e.umod(t) : e.clone(),
                  i = new m(1),
                  n = new m(0),
                  s = new m(0),
                  o = new m(1),
                  a = 0;
                e.isEven() && r.isEven();

              )
                e.iushrn(1), r.iushrn(1), ++a;
              for (var f = r.clone(), h = e.clone(); !e.isZero(); ) {
                for (
                  var c = 0, u = 1;
                  0 == (e.words[0] & u) && c < 26;
                  ++c, u <<= 1
                );
                if (0 < c)
                  for (e.iushrn(c); 0 < c--; )
                    (i.isOdd() || n.isOdd()) && (i.iadd(f), n.isub(h)),
                      i.iushrn(1),
                      n.iushrn(1);
                for (
                  var d = 0, l = 1;
                  0 == (r.words[0] & l) && d < 26;
                  ++d, l <<= 1
                );
                if (0 < d)
                  for (r.iushrn(d); 0 < d--; )
                    (s.isOdd() || o.isOdd()) && (s.iadd(f), o.isub(h)),
                      s.iushrn(1),
                      o.iushrn(1);
                0 <= e.cmp(r)
                  ? (e.isub(r), i.isub(s), n.isub(o))
                  : (r.isub(e), s.isub(i), o.isub(n));
              }
              return { a: s, b: o, gcd: r.iushln(a) };
            }),
            (m.prototype._invmp = function(t) {
              b(0 === t.negative), b(!t.isZero());
              for (
                var e,
                  r = this,
                  i = t.clone(),
                  r = 0 !== r.negative ? r.umod(t) : r.clone(),
                  n = new m(1),
                  s = new m(0),
                  o = i.clone();
                0 < r.cmpn(1) && 0 < i.cmpn(1);

              ) {
                for (
                  var a = 0, f = 1;
                  0 == (r.words[0] & f) && a < 26;
                  ++a, f <<= 1
                );
                if (0 < a)
                  for (r.iushrn(a); 0 < a--; )
                    n.isOdd() && n.iadd(o), n.iushrn(1);
                for (
                  var h = 0, c = 1;
                  0 == (i.words[0] & c) && h < 26;
                  ++h, c <<= 1
                );
                if (0 < h)
                  for (i.iushrn(h); 0 < h--; )
                    s.isOdd() && s.iadd(o), s.iushrn(1);
                0 <= r.cmp(i) ? (r.isub(i), n.isub(s)) : (i.isub(r), s.isub(n));
              }
              return (e = 0 === r.cmpn(1) ? n : s).cmpn(0) < 0 && e.iadd(t), e;
            }),
            (m.prototype.gcd = function(t) {
              if (this.isZero()) return t.abs();
              if (t.isZero()) return this.abs();
              var e = this.clone(),
                r = t.clone();
              e.negative = 0;
              for (var i = (r.negative = 0); e.isEven() && r.isEven(); i++)
                e.iushrn(1), r.iushrn(1);
              for (;;) {
                for (; e.isEven(); ) e.iushrn(1);
                for (; r.isEven(); ) r.iushrn(1);
                var n = e.cmp(r);
                if (n < 0)
                  var s = e,
                    e = r,
                    r = s;
                else if (0 === n || 0 === r.cmpn(1)) break;
                e.isub(r);
              }
              return r.iushln(i);
            }),
            (m.prototype.invm = function(t) {
              return this.egcd(t).a.umod(t);
            }),
            (m.prototype.isEven = function() {
              return 0 == (1 & this.words[0]);
            }),
            (m.prototype.isOdd = function() {
              return 1 == (1 & this.words[0]);
            }),
            (m.prototype.andln = function(t) {
              return this.words[0] & t;
            }),
            (m.prototype.bincn = function(t) {
              b('number' == typeof t);
              var e = t % 26,
                t = (t - e) / 26,
                e = 1 << e;
              if (this.length <= t)
                return this._expand(1 + t), (this.words[t] |= e), this;
              for (var r = e, i = t; 0 !== r && i < this.length; i++) {
                var n = 0 | this.words[i],
                  r = (n += r) >>> 26;
                (n &= 67108863), (this.words[i] = n);
              }
              return 0 !== r && ((this.words[i] = r), this.length++), this;
            }),
            (m.prototype.isZero = function() {
              return 1 === this.length && 0 === this.words[0];
            }),
            (m.prototype.cmpn = function(t) {
              var e = t < 0;
              return 0 === this.negative || e
                ? 0 === this.negative && e
                  ? 1
                  : (this._strip(),
                    (t =
                      1 < this.length
                        ? 1
                        : (b((t = e ? -t : t) <= 67108863, 'Number is too big'),
                          (e = 0 | this.words[0]) === t ? 0 : e < t ? -1 : 1)),
                    0 !== this.negative ? 0 | -t : t)
                : -1;
            }),
            (m.prototype.cmp = function(t) {
              if (0 !== this.negative && 0 === t.negative) return -1;
              if (0 === this.negative && 0 !== t.negative) return 1;
              t = this.ucmp(t);
              return 0 !== this.negative ? 0 | -t : t;
            }),
            (m.prototype.ucmp = function(t) {
              if (this.length > t.length) return 1;
              if (this.length < t.length) return -1;
              for (var e = 0, r = this.length - 1; 0 <= r; r--) {
                var i = 0 | this.words[r],
                  n = 0 | t.words[r];
                if (i != n) {
                  i < n ? (e = -1) : n < i && (e = 1);
                  break;
                }
              }
              return e;
            }),
            (m.prototype.gtn = function(t) {
              return 1 === this.cmpn(t);
            }),
            (m.prototype.gt = function(t) {
              return 1 === this.cmp(t);
            }),
            (m.prototype.gten = function(t) {
              return 0 <= this.cmpn(t);
            }),
            (m.prototype.gte = function(t) {
              return 0 <= this.cmp(t);
            }),
            (m.prototype.ltn = function(t) {
              return -1 === this.cmpn(t);
            }),
            (m.prototype.lt = function(t) {
              return -1 === this.cmp(t);
            }),
            (m.prototype.lten = function(t) {
              return this.cmpn(t) <= 0;
            }),
            (m.prototype.lte = function(t) {
              return this.cmp(t) <= 0;
            }),
            (m.prototype.eqn = function(t) {
              return 0 === this.cmpn(t);
            }),
            (m.prototype.eq = function(t) {
              return 0 === this.cmp(t);
            }),
            (m.red = function(t) {
              return new E(t);
            }),
            (m.prototype.toRed = function(t) {
              return (
                b(!this.red, 'Already a number in reduction context'),
                b(0 === this.negative, 'red works only with positives'),
                t.convertTo(this)._forceRed(t)
              );
            }),
            (m.prototype.fromRed = function() {
              return (
                b(
                  this.red,
                  'fromRed works only with numbers in reduction context'
                ),
                this.red.convertFrom(this)
              );
            }),
            (m.prototype._forceRed = function(t) {
              return (this.red = t), this;
            }),
            (m.prototype.forceRed = function(t) {
              return (
                b(!this.red, 'Already a number in reduction context'),
                this._forceRed(t)
              );
            }),
            (m.prototype.redAdd = function(t) {
              return (
                b(this.red, 'redAdd works only with red numbers'),
                this.red.add(this, t)
              );
            }),
            (m.prototype.redIAdd = function(t) {
              return (
                b(this.red, 'redIAdd works only with red numbers'),
                this.red.iadd(this, t)
              );
            }),
            (m.prototype.redSub = function(t) {
              return (
                b(this.red, 'redSub works only with red numbers'),
                this.red.sub(this, t)
              );
            }),
            (m.prototype.redISub = function(t) {
              return (
                b(this.red, 'redISub works only with red numbers'),
                this.red.isub(this, t)
              );
            }),
            (m.prototype.redShl = function(t) {
              return (
                b(this.red, 'redShl works only with red numbers'),
                this.red.shl(this, t)
              );
            }),
            (m.prototype.redMul = function(t) {
              return (
                b(this.red, 'redMul works only with red numbers'),
                this.red._verify2(this, t),
                this.red.mul(this, t)
              );
            }),
            (m.prototype.redIMul = function(t) {
              return (
                b(this.red, 'redMul works only with red numbers'),
                this.red._verify2(this, t),
                this.red.imul(this, t)
              );
            }),
            (m.prototype.redSqr = function() {
              return (
                b(this.red, 'redSqr works only with red numbers'),
                this.red._verify1(this),
                this.red.sqr(this)
              );
            }),
            (m.prototype.redISqr = function() {
              return (
                b(this.red, 'redISqr works only with red numbers'),
                this.red._verify1(this),
                this.red.isqr(this)
              );
            }),
            (m.prototype.redSqrt = function() {
              return (
                b(this.red, 'redSqrt works only with red numbers'),
                this.red._verify1(this),
                this.red.sqrt(this)
              );
            }),
            (m.prototype.redInvm = function() {
              return (
                b(this.red, 'redInvm works only with red numbers'),
                this.red._verify1(this),
                this.red.invm(this)
              );
            }),
            (m.prototype.redNeg = function() {
              return (
                b(this.red, 'redNeg works only with red numbers'),
                this.red._verify1(this),
                this.red.neg(this)
              );
            }),
            (m.prototype.redPow = function(t) {
              return (
                b(this.red && !t.red, 'redPow(normalNum)'),
                this.red._verify1(this),
                this.red.pow(this, t)
              );
            });
          var g = { k256: null, p224: null, p192: null, p25519: null };
          function v(t, e) {
            (this.name = t),
              (this.p = new m(e, 16)),
              (this.n = this.p.bitLength()),
              (this.k = new m(1).iushln(this.n).isub(this.p)),
              (this.tmp = this._tmp());
          }
          function _() {
            v.call(
              this,
              'k256',
              'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f'
            );
          }
          function w() {
            v.call(
              this,
              'p224',
              'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001'
            );
          }
          function M() {
            v.call(
              this,
              'p192',
              'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff'
            );
          }
          function S() {
            v.call(
              this,
              '25519',
              '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed'
            );
          }
          function E(t) {
            var e;
            'string' == typeof t
              ? ((e = m._prime(t)), (this.m = e.p), (this.prime = e))
              : (b(t.gtn(1), 'modulus must be greater than 1'),
                (this.m = t),
                (this.prime = null));
          }
          function k(t) {
            E.call(this, t),
              (this.shift = this.m.bitLength()),
              this.shift % 26 != 0 && (this.shift += 26 - (this.shift % 26)),
              (this.r = new m(1).iushln(this.shift)),
              (this.r2 = this.imod(this.r.sqr())),
              (this.rinv = this.r._invmp(this.m)),
              (this.minv = this.rinv
                .mul(this.r)
                .isubn(1)
                .div(this.m)),
              (this.minv = this.minv.umod(this.r)),
              (this.minv = this.r.sub(this.minv));
          }
          (v.prototype._tmp = function() {
            var t = new m(null);
            return (t.words = new Array(Math.ceil(this.n / 13))), t;
          }),
            (v.prototype.ireduce = function(t) {
              for (
                var e, r = t;
                this.split(r, this.tmp),
                  (e = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength()) >
                    this.n;

              );
              t = e < this.n ? -1 : r.ucmp(this.p);
              return (
                0 === t
                  ? ((r.words[0] = 0), (r.length = 1))
                  : 0 < t
                  ? r.isub(this.p)
                  : void 0 !== r.strip
                  ? r.strip()
                  : r._strip(),
                r
              );
            }),
            (v.prototype.split = function(t, e) {
              t.iushrn(this.n, 0, e);
            }),
            (v.prototype.imulK = function(t) {
              return t.imul(this.k);
            }),
            r(_, v),
            (_.prototype.split = function(t, e) {
              for (var r = Math.min(t.length, 9), i = 0; i < r; i++)
                e.words[i] = t.words[i];
              if (((e.length = r), t.length <= 9))
                return (t.words[0] = 0), void (t.length = 1);
              var n = t.words[9];
              for (
                e.words[e.length++] = 4194303 & n, i = 10;
                i < t.length;
                i++
              ) {
                var s = 0 | t.words[i];
                (t.words[i - 10] = ((4194303 & s) << 4) | (n >>> 22)), (n = s);
              }
              0 === (t.words[i - 10] = n >>>= 22) && 10 < t.length
                ? (t.length -= 10)
                : (t.length -= 9);
            }),
            (_.prototype.imulK = function(t) {
              (t.words[t.length] = 0),
                (t.words[t.length + 1] = 0),
                (t.length += 2);
              for (var e = 0, r = 0; r < t.length; r++) {
                var i = 0 | t.words[r];
                (e += 977 * i),
                  (t.words[r] = 67108863 & e),
                  (e = 64 * i + ((e / 67108864) | 0));
              }
              return (
                0 === t.words[t.length - 1] &&
                  (t.length--, 0 === t.words[t.length - 1] && t.length--),
                t
              );
            }),
            r(w, v),
            r(M, v),
            r(S, v),
            (S.prototype.imulK = function(t) {
              for (var e = 0, r = 0; r < t.length; r++) {
                var i = 19 * (0 | t.words[r]) + e,
                  n = 67108863 & i;
                (i >>>= 26), (t.words[r] = n), (e = i);
              }
              return 0 !== e && (t.words[t.length++] = e), t;
            }),
            (m._prime = function(t) {
              if (g[t]) return g[t];
              var e;
              if ('k256' === t) e = new _();
              else if ('p224' === t) e = new w();
              else if ('p192' === t) e = new M();
              else {
                if ('p25519' !== t) throw new Error('Unknown prime ' + t);
                e = new S();
              }
              return (g[t] = e);
            }),
            (E.prototype._verify1 = function(t) {
              b(0 === t.negative, 'red works only with positives'),
                b(t.red, 'red works only with red numbers');
            }),
            (E.prototype._verify2 = function(t, e) {
              b(
                0 == (t.negative | e.negative),
                'red works only with positives'
              ),
                b(t.red && t.red === e.red, 'red works only with red numbers');
            }),
            (E.prototype.imod = function(t) {
              return this.prime
                ? this.prime.ireduce(t)._forceRed(this)
                : (s(t, t.umod(this.m)._forceRed(this)), t);
            }),
            (E.prototype.neg = function(t) {
              return t.isZero() ? t.clone() : this.m.sub(t)._forceRed(this);
            }),
            (E.prototype.add = function(t, e) {
              this._verify2(t, e);
              e = t.add(e);
              return 0 <= e.cmp(this.m) && e.isub(this.m), e._forceRed(this);
            }),
            (E.prototype.iadd = function(t, e) {
              this._verify2(t, e);
              e = t.iadd(e);
              return 0 <= e.cmp(this.m) && e.isub(this.m), e;
            }),
            (E.prototype.sub = function(t, e) {
              this._verify2(t, e);
              e = t.sub(e);
              return e.cmpn(0) < 0 && e.iadd(this.m), e._forceRed(this);
            }),
            (E.prototype.isub = function(t, e) {
              this._verify2(t, e);
              e = t.isub(e);
              return e.cmpn(0) < 0 && e.iadd(this.m), e;
            }),
            (E.prototype.shl = function(t, e) {
              return this._verify1(t), this.imod(t.ushln(e));
            }),
            (E.prototype.imul = function(t, e) {
              return this._verify2(t, e), this.imod(t.imul(e));
            }),
            (E.prototype.mul = function(t, e) {
              return this._verify2(t, e), this.imod(t.mul(e));
            }),
            (E.prototype.isqr = function(t) {
              return this.imul(t, t.clone());
            }),
            (E.prototype.sqr = function(t) {
              return this.mul(t, t);
            }),
            (E.prototype.sqrt = function(t) {
              if (t.isZero()) return t.clone();
              var e = this.m.andln(3);
              if ((b(e % 2 == 1), 3 === e)) {
                e = this.m.add(new m(1)).iushrn(2);
                return this.pow(t, e);
              }
              for (
                var r = this.m.subn(1), i = 0;
                !r.isZero() && 0 === r.andln(1);

              )
                i++, r.iushrn(1);
              b(!r.isZero());
              for (
                var n = new m(1).toRed(this),
                  s = n.redNeg(),
                  o = this.m.subn(1).iushrn(1),
                  a = new m(2 * (a = this.m.bitLength()) * a).toRed(this);
                0 !== this.pow(a, o).cmp(s);

              )
                a.redIAdd(s);
              for (
                var f = this.pow(a, r),
                  h = this.pow(t, r.addn(1).iushrn(1)),
                  c = this.pow(t, r),
                  u = i;
                0 !== c.cmp(n);

              ) {
                for (var d = c, l = 0; 0 !== d.cmp(n); l++) d = d.redSqr();
                b(l < u);
                var p = this.pow(f, new m(1).iushln(u - l - 1)),
                  h = h.redMul(p),
                  f = p.redSqr(),
                  c = c.redMul(f),
                  u = l;
              }
              return h;
            }),
            (E.prototype.invm = function(t) {
              t = t._invmp(this.m);
              return 0 !== t.negative
                ? ((t.negative = 0), this.imod(t).redNeg())
                : this.imod(t);
            }),
            (E.prototype.pow = function(t, e) {
              if (e.isZero()) return new m(1).toRed(this);
              if (0 === e.cmpn(1)) return t.clone();
              var r = new Array(16);
              (r[0] = new m(1).toRed(this)), (r[1] = t);
              for (var i = 2; i < r.length; i++) r[i] = this.mul(r[i - 1], t);
              var n = r[0],
                s = 0,
                o = 0,
                a = e.bitLength() % 26;
              for (0 === a && (a = 26), i = e.length - 1; 0 <= i; i--) {
                for (var f = e.words[i], h = a - 1; 0 <= h; h--) {
                  var c = (f >> h) & 1;
                  n !== r[0] && (n = this.sqr(n)),
                    0 != c || 0 !== s
                      ? ((s <<= 1),
                        (s |= c),
                        (4 === ++o || (0 === i && 0 === h)) &&
                          ((n = this.mul(n, r[s])), (s = o = 0)))
                      : (o = 0);
                }
                a = 26;
              }
              return n;
            }),
            (E.prototype.convertTo = function(t) {
              var e = t.umod(this.m);
              return e === t ? e.clone() : e;
            }),
            (E.prototype.convertFrom = function(t) {
              t = t.clone();
              return (t.red = null), t;
            }),
            (m.mont = function(t) {
              return new k(t);
            }),
            r(k, E),
            (k.prototype.convertTo = function(t) {
              return this.imod(t.ushln(this.shift));
            }),
            (k.prototype.convertFrom = function(t) {
              t = this.imod(t.mul(this.rinv));
              return (t.red = null), t;
            }),
            (k.prototype.imul = function(t, e) {
              if (t.isZero() || e.isZero())
                return (t.words[0] = 0), (t.length = 1), t;
              (t = t.imul(e)),
                (e = t
                  .maskn(this.shift)
                  .mul(this.minv)
                  .imaskn(this.shift)
                  .mul(this.m)),
                (t = t.isub(e).iushrn(this.shift)),
                (e = t);
              return (
                0 <= t.cmp(this.m)
                  ? (e = t.isub(this.m))
                  : t.cmpn(0) < 0 && (e = t.iadd(this.m)),
                e._forceRed(this)
              );
            }),
            (k.prototype.mul = function(t, e) {
              if (t.isZero() || e.isZero()) return new m(0)._forceRed(this);
              (t = t.mul(e)),
                (e = t
                  .maskn(this.shift)
                  .mul(this.minv)
                  .imaskn(this.shift)
                  .mul(this.m)),
                (t = t.isub(e).iushrn(this.shift)),
                (e = t);
              return (
                0 <= t.cmp(this.m)
                  ? (e = t.isub(this.m))
                  : t.cmpn(0) < 0 && (e = t.iadd(this.m)),
                e._forceRed(this)
              );
            }),
            (k.prototype.invm = function(t) {
              return this.imod(t._invmp(this.m).mul(this.r2))._forceRed(this);
            });
        })(void 0 === t || t, this);
      },
      { buffer: 20 },
    ],
    19: [
      function(t, e, r) {
        var i;
        function n(t) {
          this.rand = t;
        }
        if (
          ((e.exports = function(t) {
            return (i = i || new n(null)).generate(t);
          }),
          ((e.exports.Rand = n).prototype.generate = function(t) {
            return this._rand(t);
          }),
          (n.prototype._rand = function(t) {
            if (this.rand.getBytes) return this.rand.getBytes(t);
            for (var e = new Uint8Array(t), r = 0; r < e.length; r++)
              e[r] = this.rand.getByte();
            return e;
          }),
          'object' == typeof self)
        )
          self.crypto && self.crypto.getRandomValues
            ? (n.prototype._rand = function(t) {
                t = new Uint8Array(t);
                return self.crypto.getRandomValues(t), t;
              })
            : self.msCrypto && self.msCrypto.getRandomValues
            ? (n.prototype._rand = function(t) {
                t = new Uint8Array(t);
                return self.msCrypto.getRandomValues(t), t;
              })
            : 'object' == typeof window &&
              (n.prototype._rand = function() {
                throw new Error('Not implemented yet');
              });
        else
          try {
            if ('function' != typeof (crypto = t('crypto')).randomBytes)
              throw new Error('Not supported');
            n.prototype._rand = function(t) {
              return crypto.randomBytes(t);
            };
          } catch (t) {}
      },
      { crypto: 20 },
    ],
    20: [function(t, e, r) {}, {}],
    21: [
      function(t, e, r) {
        var n = t('safe-buffer').Buffer;
        function i(t) {
          for (
            var e = ((t = !n.isBuffer(t) ? n.from(t) : t).length / 4) | 0,
              r = new Array(e),
              i = 0;
            i < e;
            i++
          )
            r[i] = t.readUInt32BE(4 * i);
          return r;
        }
        function s(t) {
          for (; 0 < t.length; t++) t[0] = 0;
        }
        function o(t, e, r, i, n) {
          for (
            var s,
              o,
              a,
              f,
              h = r[0],
              c = r[1],
              u = r[2],
              d = r[3],
              l = t[0] ^ e[0],
              p = t[1] ^ e[1],
              b = t[2] ^ e[2],
              m = t[3] ^ e[3],
              y = 4,
              g = 1;
            g < n;
            g++
          )
            (s =
              h[l >>> 24] ^
              c[(p >>> 16) & 255] ^
              u[(b >>> 8) & 255] ^
              d[255 & m] ^
              e[y++]),
              (o =
                h[p >>> 24] ^
                c[(b >>> 16) & 255] ^
                u[(m >>> 8) & 255] ^
                d[255 & l] ^
                e[y++]),
              (a =
                h[b >>> 24] ^
                c[(m >>> 16) & 255] ^
                u[(l >>> 8) & 255] ^
                d[255 & p] ^
                e[y++]),
              (f =
                h[m >>> 24] ^
                c[(l >>> 16) & 255] ^
                u[(p >>> 8) & 255] ^
                d[255 & b] ^
                e[y++]),
              (l = s),
              (p = o),
              (b = a),
              (m = f);
          return (
            (s =
              ((i[l >>> 24] << 24) |
                (i[(p >>> 16) & 255] << 16) |
                (i[(b >>> 8) & 255] << 8) |
                i[255 & m]) ^
              e[y++]),
            (o =
              ((i[p >>> 24] << 24) |
                (i[(b >>> 16) & 255] << 16) |
                (i[(m >>> 8) & 255] << 8) |
                i[255 & l]) ^
              e[y++]),
            (a =
              ((i[b >>> 24] << 24) |
                (i[(m >>> 16) & 255] << 16) |
                (i[(l >>> 8) & 255] << 8) |
                i[255 & p]) ^
              e[y++]),
            (f =
              ((i[m >>> 24] << 24) |
                (i[(l >>> 16) & 255] << 16) |
                (i[(p >>> 8) & 255] << 8) |
                i[255 & b]) ^
              e[y++]),
            [(s >>>= 0), (o >>>= 0), (a >>>= 0), (f >>>= 0)]
          );
        }
        var u = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54],
          d = (function() {
            for (var t = new Array(256), e = 0; e < 256; e++)
              t[e] = e < 128 ? e << 1 : (e << 1) ^ 283;
            for (
              var r = [],
                i = [],
                n = [[], [], [], []],
                s = [[], [], [], []],
                o = 0,
                a = 0,
                f = 0;
              f < 256;
              ++f
            ) {
              var h = a ^ (a << 1) ^ (a << 2) ^ (a << 3) ^ (a << 4);
              r[o] = h = (h >>> 8) ^ (255 & h) ^ 99;
              var c = t[(i[h] = o)],
                u = t[c],
                d = t[u],
                l = (257 * t[h]) ^ (16843008 * h);
              (n[0][o] = (l << 24) | (l >>> 8)),
                (n[1][o] = (l << 16) | (l >>> 16)),
                (n[2][o] = (l << 8) | (l >>> 24)),
                (n[3][o] = l),
                (s[0][h] =
                  ((l =
                    (16843009 * d) ^
                    (65537 * u) ^
                    (257 * c) ^
                    (16843008 * o)) <<
                    24) |
                  (l >>> 8)),
                (s[1][h] = (l << 16) | (l >>> 16)),
                (s[2][h] = (l << 8) | (l >>> 24)),
                (s[3][h] = l),
                0 === o
                  ? (o = a = 1)
                  : ((o = c ^ t[t[t[d ^ c]]]), (a ^= t[t[a]]));
            }
            return { SBOX: r, INV_SBOX: i, SUB_MIX: n, INV_SUB_MIX: s };
          })();
        function a(t) {
          (this._key = i(t)), this._reset();
        }
        (a.blockSize = 16),
          (a.keySize = 32),
          (a.prototype.blockSize = a.blockSize),
          (a.prototype.keySize = a.keySize),
          (a.prototype._reset = function() {
            for (
              var t = this._key,
                e = t.length,
                r = e + 6,
                i = 4 * (r + 1),
                n = [],
                s = 0;
              s < e;
              s++
            )
              n[s] = t[s];
            for (s = e; s < i; s++) {
              var o = n[s - 1];
              s % e == 0
                ? ((o =
                    (d.SBOX[(o = (o << 8) | (o >>> 24)) >>> 24] << 24) |
                    (d.SBOX[(o >>> 16) & 255] << 16) |
                    (d.SBOX[(o >>> 8) & 255] << 8) |
                    d.SBOX[255 & o]),
                  (o ^= u[(s / e) | 0] << 24))
                : 6 < e &&
                  s % e == 4 &&
                  (o =
                    (d.SBOX[o >>> 24] << 24) |
                    (d.SBOX[(o >>> 16) & 255] << 16) |
                    (d.SBOX[(o >>> 8) & 255] << 8) |
                    d.SBOX[255 & o]),
                (n[s] = n[s - e] ^ o);
            }
            for (var a = [], f = 0; f < i; f++) {
              var h = i - f,
                c = n[h - (f % 4 ? 0 : 4)];
              a[f] =
                f < 4 || h <= 4
                  ? c
                  : d.INV_SUB_MIX[0][d.SBOX[c >>> 24]] ^
                    d.INV_SUB_MIX[1][d.SBOX[(c >>> 16) & 255]] ^
                    d.INV_SUB_MIX[2][d.SBOX[(c >>> 8) & 255]] ^
                    d.INV_SUB_MIX[3][d.SBOX[255 & c]];
            }
            (this._nRounds = r),
              (this._keySchedule = n),
              (this._invKeySchedule = a);
          }),
          (a.prototype.encryptBlockRaw = function(t) {
            return o(
              (t = i(t)),
              this._keySchedule,
              d.SUB_MIX,
              d.SBOX,
              this._nRounds
            );
          }),
          (a.prototype.encryptBlock = function(t) {
            var e = this.encryptBlockRaw(t),
              t = n.allocUnsafe(16);
            return (
              t.writeUInt32BE(e[0], 0),
              t.writeUInt32BE(e[1], 4),
              t.writeUInt32BE(e[2], 8),
              t.writeUInt32BE(e[3], 12),
              t
            );
          }),
          (a.prototype.decryptBlock = function(t) {
            var e = (t = i(t))[1];
            (t[1] = t[3]), (t[3] = e);
            (e = o(
              t,
              this._invKeySchedule,
              d.INV_SUB_MIX,
              d.INV_SBOX,
              this._nRounds
            )),
              (t = n.allocUnsafe(16));
            return (
              t.writeUInt32BE(e[0], 0),
              t.writeUInt32BE(e[3], 4),
              t.writeUInt32BE(e[2], 8),
              t.writeUInt32BE(e[1], 12),
              t
            );
          }),
          (a.prototype.scrub = function() {
            s(this._keySchedule), s(this._invKeySchedule), s(this._key);
          }),
          (e.exports.AES = a);
      },
      { 'safe-buffer': 161 },
    ],
    22: [
      function(t, e, r) {
        var s = t('./aes'),
          o = t('safe-buffer').Buffer,
          a = t('cipher-base'),
          i = t('inherits'),
          f = t('./ghash'),
          n = t('buffer-xor'),
          h = t('./incr32');
        function c(t, e, r, i) {
          a.call(this);
          var n = o.alloc(4, 0);
          this._cipher = new s.AES(e);
          n = this._cipher.encryptBlock(n);
          (this._ghash = new f(n)),
            (r = (function(t, e, r) {
              if (12 === e.length)
                return (
                  (t._finID = o.concat([e, o.from([0, 0, 0, 1])])),
                  o.concat([e, o.from([0, 0, 0, 2])])
                );
              var i = new f(r),
                n = e.length,
                r = n % 16;
              return (
                i.update(e),
                r && i.update(o.alloc((r = 16 - r), 0)),
                i.update(o.alloc(8, 0)),
                (r = 8 * n),
                (n = o.alloc(8)).writeUIntBE(r, 0, 8),
                i.update(n),
                (t._finID = i.state),
                (t = o.from(t._finID)),
                h(t),
                t
              );
            })(this, r, n)),
            (this._prev = o.from(r)),
            (this._cache = o.allocUnsafe(0)),
            (this._secCache = o.allocUnsafe(0)),
            (this._decrypt = i),
            (this._alen = 0),
            (this._len = 0),
            (this._mode = t),
            (this._authTag = null),
            (this._called = !1);
        }
        i(c, a),
          (c.prototype._update = function(t) {
            this._called ||
              !this._alen ||
              ((e = 16 - (this._alen % 16)) < 16 &&
                ((e = o.alloc(e, 0)), this._ghash.update(e))),
              (this._called = !0);
            var e = this._mode.encrypt(this, t);
            return (
              this._decrypt ? this._ghash.update(t) : this._ghash.update(e),
              (this._len += t.length),
              e
            );
          }),
          (c.prototype._final = function() {
            if (this._decrypt && !this._authTag)
              throw new Error(
                'Unsupported state or unable to authenticate data'
              );
            var t = n(
              this._ghash.final(8 * this._alen, 8 * this._len),
              this._cipher.encryptBlock(this._finID)
            );
            if (
              this._decrypt &&
              (function(t, e) {
                var r = 0;
                t.length !== e.length && r++;
                for (var i = Math.min(t.length, e.length), n = 0; n < i; ++n)
                  r += t[n] ^ e[n];
                return r;
              })(t, this._authTag)
            )
              throw new Error(
                'Unsupported state or unable to authenticate data'
              );
            (this._authTag = t), this._cipher.scrub();
          }),
          (c.prototype.getAuthTag = function() {
            if (this._decrypt || !o.isBuffer(this._authTag))
              throw new Error(
                'Attempting to get auth tag in unsupported state'
              );
            return this._authTag;
          }),
          (c.prototype.setAuthTag = function(t) {
            if (!this._decrypt)
              throw new Error(
                'Attempting to set auth tag in unsupported state'
              );
            this._authTag = t;
          }),
          (c.prototype.setAAD = function(t) {
            if (this._called)
              throw new Error('Attempting to set AAD in unsupported state');
            this._ghash.update(t), (this._alen += t.length);
          }),
          (e.exports = c);
      },
      {
        './aes': 21,
        './ghash': 26,
        './incr32': 27,
        'buffer-xor': 63,
        'cipher-base': 65,
        inherits: 133,
        'safe-buffer': 161,
      },
    ],
    23: [
      function(t, e, r) {
        var i = t('./encrypter'),
          n = t('./decrypter'),
          s = t('./modes/list.json');
        (r.createCipher = r.Cipher = i.createCipher),
          (r.createCipheriv = r.Cipheriv = i.createCipheriv),
          (r.createDecipher = r.Decipher = n.createDecipher),
          (r.createDecipheriv = r.Decipheriv = n.createDecipheriv),
          (r.listCiphers = r.getCiphers = function() {
            return Object.keys(s);
          });
      },
      { './decrypter': 24, './encrypter': 25, './modes/list.json': 35 },
    ],
    24: [
      function(t, e, r) {
        var i = t('./authCipher'),
          n = t('safe-buffer').Buffer,
          s = t('./modes'),
          o = t('./streamCipher'),
          a = t('cipher-base'),
          f = t('./aes'),
          h = t('evp_bytestokey');
        function c(t, e, r) {
          a.call(this),
            (this._cache = new u()),
            (this._last = void 0),
            (this._cipher = new f.AES(e)),
            (this._prev = n.from(r)),
            (this._mode = t),
            (this._autopadding = !0);
        }
        function u() {
          this.cache = n.allocUnsafe(0);
        }
        function d(t, e, r) {
          t = s[t.toLowerCase()];
          if (!t) throw new TypeError('invalid suite type');
          if (
            ('string' == typeof r && (r = n.from(r)),
            'GCM' !== t.mode && r.length !== t.iv)
          )
            throw new TypeError('invalid iv length ' + r.length);
          if ((e = 'string' == typeof e ? n.from(e) : e).length !== t.key / 8)
            throw new TypeError('invalid key length ' + e.length);
          return 'stream' === t.type
            ? new o(t.module, e, r, !0)
            : 'auth' === t.type
            ? new i(t.module, e, r, !0)
            : new c(t.module, e, r);
        }
        t('inherits')(c, a),
          (c.prototype._update = function(t) {
            var e;
            this._cache.add(t);
            for (var r = []; (e = this._cache.get(this._autopadding)); )
              (e = this._mode.decrypt(this, e)), r.push(e);
            return n.concat(r);
          }),
          (c.prototype._final = function() {
            var t = this._cache.flush();
            if (this._autopadding)
              return (function(t) {
                var e = t[15];
                if (e < 1 || 16 < e) throw new Error('unable to decrypt data');
                var r = -1;
                for (; ++r < e; )
                  if (t[r + (16 - e)] !== e)
                    throw new Error('unable to decrypt data');
                if (16 !== e) return t.slice(0, 16 - e);
              })(this._mode.decrypt(this, t));
            if (t) throw new Error('data not multiple of block length');
          }),
          (c.prototype.setAutoPadding = function(t) {
            return (this._autopadding = !!t), this;
          }),
          (u.prototype.add = function(t) {
            this.cache = n.concat([this.cache, t]);
          }),
          (u.prototype.get = function(t) {
            var e;
            if (t) {
              if (16 < this.cache.length)
                return (
                  (e = this.cache.slice(0, 16)),
                  (this.cache = this.cache.slice(16)),
                  e
                );
            } else if (16 <= this.cache.length)
              return (
                (e = this.cache.slice(0, 16)),
                (this.cache = this.cache.slice(16)),
                e
              );
            return null;
          }),
          (u.prototype.flush = function() {
            if (this.cache.length) return this.cache;
          }),
          (r.createDecipher = function(t, e) {
            var r = s[t.toLowerCase()];
            if (!r) throw new TypeError('invalid suite type');
            return (r = h(e, !1, r.key, r.iv)), d(t, r.key, r.iv);
          }),
          (r.createDecipheriv = d);
      },
      {
        './aes': 21,
        './authCipher': 22,
        './modes': 34,
        './streamCipher': 37,
        'cipher-base': 65,
        evp_bytestokey: 102,
        inherits: 133,
        'safe-buffer': 161,
      },
    ],
    25: [
      function(t, e, r) {
        var i = t('./modes'),
          n = t('./authCipher'),
          s = t('safe-buffer').Buffer,
          o = t('./streamCipher'),
          a = t('cipher-base'),
          f = t('./aes'),
          h = t('evp_bytestokey');
        function c(t, e, r) {
          a.call(this),
            (this._cache = new d()),
            (this._cipher = new f.AES(e)),
            (this._prev = s.from(r)),
            (this._mode = t),
            (this._autopadding = !0);
        }
        t('inherits')(c, a),
          (c.prototype._update = function(t) {
            var e;
            this._cache.add(t);
            for (var r = []; (e = this._cache.get()); )
              (e = this._mode.encrypt(this, e)), r.push(e);
            return s.concat(r);
          });
        var u = s.alloc(16, 16);
        function d() {
          this.cache = s.allocUnsafe(0);
        }
        function l(t, e, r) {
          t = i[t.toLowerCase()];
          if (!t) throw new TypeError('invalid suite type');
          if ((e = 'string' == typeof e ? s.from(e) : e).length !== t.key / 8)
            throw new TypeError('invalid key length ' + e.length);
          if (
            ('string' == typeof r && (r = s.from(r)),
            'GCM' !== t.mode && r.length !== t.iv)
          )
            throw new TypeError('invalid iv length ' + r.length);
          return new ('stream' === t.type ? o : 'auth' === t.type ? n : c)(
            t.module,
            e,
            r
          );
        }
        (c.prototype._final = function() {
          var t = this._cache.flush();
          if (this._autopadding)
            return (t = this._mode.encrypt(this, t)), this._cipher.scrub(), t;
          if (!t.equals(u))
            throw (this._cipher.scrub(),
            new Error('data not multiple of block length'));
        }),
          (c.prototype.setAutoPadding = function(t) {
            return (this._autopadding = !!t), this;
          }),
          (d.prototype.add = function(t) {
            this.cache = s.concat([this.cache, t]);
          }),
          (d.prototype.get = function() {
            if (15 < this.cache.length) {
              var t = this.cache.slice(0, 16);
              return (this.cache = this.cache.slice(16)), t;
            }
            return null;
          }),
          (d.prototype.flush = function() {
            for (
              var t = 16 - this.cache.length, e = s.allocUnsafe(t), r = -1;
              ++r < t;

            )
              e.writeUInt8(t, r);
            return s.concat([this.cache, e]);
          }),
          (r.createCipheriv = l),
          (r.createCipher = function(t, e) {
            var r = i[t.toLowerCase()];
            if (!r) throw new TypeError('invalid suite type');
            return (r = h(e, !1, r.key, r.iv)), l(t, r.key, r.iv);
          });
      },
      {
        './aes': 21,
        './authCipher': 22,
        './modes': 34,
        './streamCipher': 37,
        'cipher-base': 65,
        evp_bytestokey: 102,
        inherits: 133,
        'safe-buffer': 161,
      },
    ],
    26: [
      function(t, e, r) {
        var i = t('safe-buffer').Buffer,
          n = i.alloc(16, 0);
        function o(t) {
          var e = i.allocUnsafe(16);
          return (
            e.writeUInt32BE(t[0] >>> 0, 0),
            e.writeUInt32BE(t[1] >>> 0, 4),
            e.writeUInt32BE(t[2] >>> 0, 8),
            e.writeUInt32BE(t[3] >>> 0, 12),
            e
          );
        }
        function s(t) {
          (this.h = t),
            (this.state = i.alloc(16, 0)),
            (this.cache = i.allocUnsafe(0));
        }
        (s.prototype.ghash = function(t) {
          for (var e = -1; ++e < t.length; ) this.state[e] ^= t[e];
          this._multiply();
        }),
          (s.prototype._multiply = function() {
            for (
              var t,
                e,
                r,
                i = [
                  (t = this.h).readUInt32BE(0),
                  t.readUInt32BE(4),
                  t.readUInt32BE(8),
                  t.readUInt32BE(12),
                ],
                n = [0, 0, 0, 0],
                s = -1;
              ++s < 128;

            ) {
              for (
                0 != (this.state[~~(s / 8)] & (1 << (7 - (s % 8)))) &&
                  ((n[0] ^= i[0]),
                  (n[1] ^= i[1]),
                  (n[2] ^= i[2]),
                  (n[3] ^= i[3])),
                  r = 0 != (1 & i[3]),
                  e = 3;
                0 < e;
                e--
              )
                i[e] = (i[e] >>> 1) | ((1 & i[e - 1]) << 31);
              (i[0] = i[0] >>> 1), r && (i[0] = i[0] ^ (225 << 24));
            }
            this.state = o(n);
          }),
          (s.prototype.update = function(t) {
            var e;
            for (
              this.cache = i.concat([this.cache, t]);
              16 <= this.cache.length;

            )
              (e = this.cache.slice(0, 16)),
                (this.cache = this.cache.slice(16)),
                this.ghash(e);
          }),
          (s.prototype.final = function(t, e) {
            return (
              this.cache.length && this.ghash(i.concat([this.cache, n], 16)),
              this.ghash(o([0, t, 0, e])),
              this.state
            );
          }),
          (e.exports = s);
      },
      { 'safe-buffer': 161 },
    ],
    27: [
      function(t, e, r) {
        e.exports = function(t) {
          for (var e, r = t.length; r--; ) {
            if (255 !== (e = t.readUInt8(r))) {
              e++, t.writeUInt8(e, r);
              break;
            }
            t.writeUInt8(0, r);
          }
        };
      },
      {},
    ],
    28: [
      function(t, e, r) {
        var i = t('buffer-xor');
        (r.encrypt = function(t, e) {
          e = i(e, t._prev);
          return (t._prev = t._cipher.encryptBlock(e)), t._prev;
        }),
          (r.decrypt = function(t, e) {
            var r = t._prev;
            t._prev = e;
            e = t._cipher.decryptBlock(e);
            return i(e, r);
          });
      },
      { 'buffer-xor': 63 },
    ],
    29: [
      function(t, e, r) {
        var s = t('safe-buffer').Buffer,
          o = t('buffer-xor');
        function a(t, e, r) {
          var i = e.length,
            n = o(e, t._cache);
          return (
            (t._cache = t._cache.slice(i)),
            (t._prev = s.concat([t._prev, r ? e : n])),
            n
          );
        }
        r.encrypt = function(t, e, r) {
          for (var i, n = s.allocUnsafe(0); e.length; ) {
            if (
              (0 === t._cache.length &&
                ((t._cache = t._cipher.encryptBlock(t._prev)),
                (t._prev = s.allocUnsafe(0))),
              !(t._cache.length <= e.length))
            ) {
              n = s.concat([n, a(t, e, r)]);
              break;
            }
            (i = t._cache.length),
              (n = s.concat([n, a(t, e.slice(0, i), r)])),
              (e = e.slice(i));
          }
          return n;
        };
      },
      { 'buffer-xor': 63, 'safe-buffer': 161 },
    ],
    30: [
      function(t, e, r) {
        var a = t('safe-buffer').Buffer;
        function o(t, e, r) {
          for (var i, n, s = -1, o = 0; ++s < 8; )
            (o +=
              (128 &
                (n =
                  t._cipher.encryptBlock(t._prev)[0] ^
                  (i = e & (1 << (7 - s)) ? 128 : 0))) >>
              s % 8),
              (t._prev = (function(t, e) {
                var r = t.length,
                  i = -1,
                  n = a.allocUnsafe(t.length);
                t = a.concat([t, a.from([e])]);
                for (; ++i < r; ) n[i] = (t[i] << 1) | (t[i + 1] >> 7);
                return n;
              })(t._prev, r ? i : n));
          return o;
        }
        r.encrypt = function(t, e, r) {
          for (var i = e.length, n = a.allocUnsafe(i), s = -1; ++s < i; )
            n[s] = o(t, e[s], r);
          return n;
        };
      },
      { 'safe-buffer': 161 },
    ],
    31: [
      function(t, e, r) {
        var c = t('safe-buffer').Buffer;
        r.encrypt = function(t, e, r) {
          for (
            var i, n, s, o, a = e.length, f = c.allocUnsafe(a), h = -1;
            ++h < a;

          )
            f[h] =
              ((i = t),
              (n = e[h]),
              (s = r),
              (o = void 0),
              (o = i._cipher.encryptBlock(i._prev)[0] ^ n),
              (i._prev = c.concat([i._prev.slice(1), c.from([s ? n : o])])),
              o);
          return f;
        };
      },
      { 'safe-buffer': 161 },
    ],
    32: [
      function(t, e, r) {
        var f = t('buffer-xor'),
          h = t('safe-buffer').Buffer,
          c = t('../incr32');
        r.encrypt = function(t, e) {
          var r = Math.ceil(e.length / 16),
            i = t._cache.length;
          t._cache = h.concat([t._cache, h.allocUnsafe(16 * r)]);
          for (var n = 0; n < r; n++) {
            var s =
                ((o = void 0),
                (o = (s = t)._cipher.encryptBlockRaw(s._prev)),
                c(s._prev),
                o),
              o = i + 16 * n;
            t._cache.writeUInt32BE(s[0], o + 0),
              t._cache.writeUInt32BE(s[1], o + 4),
              t._cache.writeUInt32BE(s[2], o + 8),
              t._cache.writeUInt32BE(s[3], o + 12);
          }
          var a = t._cache.slice(0, e.length);
          return (t._cache = t._cache.slice(e.length)), f(e, a);
        };
      },
      { '../incr32': 27, 'buffer-xor': 63, 'safe-buffer': 161 },
    ],
    33: [
      function(t, e, r) {
        (r.encrypt = function(t, e) {
          return t._cipher.encryptBlock(e);
        }),
          (r.decrypt = function(t, e) {
            return t._cipher.decryptBlock(e);
          });
      },
      {},
    ],
    34: [
      function(t, e, r) {
        var i,
          n = {
            ECB: t('./ecb'),
            CBC: t('./cbc'),
            CFB: t('./cfb'),
            CFB8: t('./cfb8'),
            CFB1: t('./cfb1'),
            OFB: t('./ofb'),
            CTR: t('./ctr'),
            GCM: t('./ctr'),
          },
          s = t('./list.json');
        for (i in s) s[i].module = n[s[i].mode];
        e.exports = s;
      },
      {
        './cbc': 28,
        './cfb': 29,
        './cfb1': 30,
        './cfb8': 31,
        './ctr': 32,
        './ecb': 33,
        './list.json': 35,
        './ofb': 36,
      },
    ],
    35: [
      function(t, e, r) {
        e.exports = {
          'aes-128-ecb': {
            cipher: 'AES',
            key: 128,
            iv: 0,
            mode: 'ECB',
            type: 'block',
          },
          'aes-192-ecb': {
            cipher: 'AES',
            key: 192,
            iv: 0,
            mode: 'ECB',
            type: 'block',
          },
          'aes-256-ecb': {
            cipher: 'AES',
            key: 256,
            iv: 0,
            mode: 'ECB',
            type: 'block',
          },
          'aes-128-cbc': {
            cipher: 'AES',
            key: 128,
            iv: 16,
            mode: 'CBC',
            type: 'block',
          },
          'aes-192-cbc': {
            cipher: 'AES',
            key: 192,
            iv: 16,
            mode: 'CBC',
            type: 'block',
          },
          'aes-256-cbc': {
            cipher: 'AES',
            key: 256,
            iv: 16,
            mode: 'CBC',
            type: 'block',
          },
          aes128: {
            cipher: 'AES',
            key: 128,
            iv: 16,
            mode: 'CBC',
            type: 'block',
          },
          aes192: {
            cipher: 'AES',
            key: 192,
            iv: 16,
            mode: 'CBC',
            type: 'block',
          },
          aes256: {
            cipher: 'AES',
            key: 256,
            iv: 16,
            mode: 'CBC',
            type: 'block',
          },
          'aes-128-cfb': {
            cipher: 'AES',
            key: 128,
            iv: 16,
            mode: 'CFB',
            type: 'stream',
          },
          'aes-192-cfb': {
            cipher: 'AES',
            key: 192,
            iv: 16,
            mode: 'CFB',
            type: 'stream',
          },
          'aes-256-cfb': {
            cipher: 'AES',
            key: 256,
            iv: 16,
            mode: 'CFB',
            type: 'stream',
          },
          'aes-128-cfb8': {
            cipher: 'AES',
            key: 128,
            iv: 16,
            mode: 'CFB8',
            type: 'stream',
          },
          'aes-192-cfb8': {
            cipher: 'AES',
            key: 192,
            iv: 16,
            mode: 'CFB8',
            type: 'stream',
          },
          'aes-256-cfb8': {
            cipher: 'AES',
            key: 256,
            iv: 16,
            mode: 'CFB8',
            type: 'stream',
          },
          'aes-128-cfb1': {
            cipher: 'AES',
            key: 128,
            iv: 16,
            mode: 'CFB1',
            type: 'stream',
          },
          'aes-192-cfb1': {
            cipher: 'AES',
            key: 192,
            iv: 16,
            mode: 'CFB1',
            type: 'stream',
          },
          'aes-256-cfb1': {
            cipher: 'AES',
            key: 256,
            iv: 16,
            mode: 'CFB1',
            type: 'stream',
          },
          'aes-128-ofb': {
            cipher: 'AES',
            key: 128,
            iv: 16,
            mode: 'OFB',
            type: 'stream',
          },
          'aes-192-ofb': {
            cipher: 'AES',
            key: 192,
            iv: 16,
            mode: 'OFB',
            type: 'stream',
          },
          'aes-256-ofb': {
            cipher: 'AES',
            key: 256,
            iv: 16,
            mode: 'OFB',
            type: 'stream',
          },
          'aes-128-ctr': {
            cipher: 'AES',
            key: 128,
            iv: 16,
            mode: 'CTR',
            type: 'stream',
          },
          'aes-192-ctr': {
            cipher: 'AES',
            key: 192,
            iv: 16,
            mode: 'CTR',
            type: 'stream',
          },
          'aes-256-ctr': {
            cipher: 'AES',
            key: 256,
            iv: 16,
            mode: 'CTR',
            type: 'stream',
          },
          'aes-128-gcm': {
            cipher: 'AES',
            key: 128,
            iv: 12,
            mode: 'GCM',
            type: 'auth',
          },
          'aes-192-gcm': {
            cipher: 'AES',
            key: 192,
            iv: 12,
            mode: 'GCM',
            type: 'auth',
          },
          'aes-256-gcm': {
            cipher: 'AES',
            key: 256,
            iv: 12,
            mode: 'GCM',
            type: 'auth',
          },
        };
      },
      {},
    ],
    36: [
      function(t, e, r) {
        !function(s) {
          !function() {
            var n = t('buffer-xor');
            r.encrypt = function(t, e) {
              for (; t._cache.length < e.length; )
                t._cache = s.concat([
                  t._cache,
                  (((r = t)._prev = r._cipher.encryptBlock(r._prev)), r._prev),
                ]);
              var r,
                i = t._cache.slice(0, e.length);
              return (t._cache = t._cache.slice(e.length)), n(e, i);
            };
          }.call(this);
        }.call(this, t('buffer').Buffer);
      },
      { buffer: 64, 'buffer-xor': 63 },
    ],
    37: [
      function(t, e, r) {
        var n = t('./aes'),
          s = t('safe-buffer').Buffer,
          o = t('cipher-base');
        function i(t, e, r, i) {
          o.call(this),
            (this._cipher = new n.AES(e)),
            (this._prev = s.from(r)),
            (this._cache = s.allocUnsafe(0)),
            (this._secCache = s.allocUnsafe(0)),
            (this._decrypt = i),
            (this._mode = t);
        }
        t('inherits')(i, o),
          (i.prototype._update = function(t) {
            return this._mode.encrypt(this, t, this._decrypt);
          }),
          (i.prototype._final = function() {
            this._cipher.scrub();
          }),
          (e.exports = i);
      },
      { './aes': 21, 'cipher-base': 65, inherits: 133, 'safe-buffer': 161 },
    ],
    38: [
      function(t, e, r) {
        var i = t('browserify-des'),
          n = t('browserify-aes/browser'),
          s = t('browserify-aes/modes'),
          o = t('browserify-des/modes'),
          a = t('evp_bytestokey');
        function f(t, e, r) {
          if (((t = t.toLowerCase()), s[t])) return n.createCipheriv(t, e, r);
          if (o[t]) return new i({ key: e, iv: r, mode: t });
          throw new TypeError('invalid suite type');
        }
        function h(t, e, r) {
          if (((t = t.toLowerCase()), s[t])) return n.createDecipheriv(t, e, r);
          if (o[t]) return new i({ key: e, iv: r, mode: t, decrypt: !0 });
          throw new TypeError('invalid suite type');
        }
        (r.createCipher = r.Cipher = function(t, e) {
          var r;
          if (((t = t.toLowerCase()), s[t])) (r = s[t].key), (i = s[t].iv);
          else {
            if (!o[t]) throw new TypeError('invalid suite type');
            (r = 8 * o[t].key), (i = o[t].iv);
          }
          var i = a(e, !1, r, i);
          return f(t, i.key, i.iv);
        }),
          (r.createCipheriv = r.Cipheriv = f),
          (r.createDecipher = r.Decipher = function(t, e) {
            var r;
            if (((t = t.toLowerCase()), s[t])) (r = s[t].key), (i = s[t].iv);
            else {
              if (!o[t]) throw new TypeError('invalid suite type');
              (r = 8 * o[t].key), (i = o[t].iv);
            }
            var i = a(e, !1, r, i);
            return h(t, i.key, i.iv);
          }),
          (r.createDecipheriv = r.Decipheriv = h),
          (r.listCiphers = r.getCiphers = function() {
            return Object.keys(o).concat(n.getCiphers());
          });
      },
      {
        'browserify-aes/browser': 23,
        'browserify-aes/modes': 34,
        'browserify-des': 39,
        'browserify-des/modes': 40,
        evp_bytestokey: 102,
      },
    ],
    39: [
      function(t, e, r) {
        var s = t('cipher-base'),
          i = t('des.js'),
          n = t('inherits'),
          o = t('safe-buffer').Buffer,
          a = {
            'des-ede3-cbc': i.CBC.instantiate(i.EDE),
            'des-ede3': i.EDE,
            'des-ede-cbc': i.CBC.instantiate(i.EDE),
            'des-ede': i.EDE,
            'des-cbc': i.CBC.instantiate(i.DES),
            'des-ecb': i.DES,
          };
        function f(t) {
          s.call(this);
          var e = t.mode.toLowerCase(),
            r = a[e],
            i = t.decrypt ? 'decrypt' : 'encrypt',
            n = t.key;
          o.isBuffer(n) || (n = o.from(n)),
            ('des-ede' !== e && 'des-ede-cbc' !== e) ||
              (n = o.concat([n, n.slice(0, 8)]));
          t = t.iv;
          o.isBuffer(t) || (t = o.from(t)),
            (this._des = r.create({ key: n, iv: t, type: i }));
        }
        (a.des = a['des-cbc']),
          (a.des3 = a['des-ede3-cbc']),
          n((e.exports = f), s),
          (f.prototype._update = function(t) {
            return o.from(this._des.update(t));
          }),
          (f.prototype._final = function() {
            return o.from(this._des.final());
          });
      },
      { 'cipher-base': 65, 'des.js': 73, inherits: 133, 'safe-buffer': 161 },
    ],
    40: [
      function(t, e, r) {
        (r['des-ecb'] = { key: 8, iv: 0 }),
          (r['des-cbc'] = r.des = { key: 8, iv: 8 }),
          (r['des-ede3-cbc'] = r.des3 = { key: 24, iv: 8 }),
          (r['des-ede3'] = { key: 24, iv: 0 }),
          (r['des-ede-cbc'] = { key: 16, iv: 8 }),
          (r['des-ede'] = { key: 16, iv: 0 });
      },
      {},
    ],
    41: [
      function(e, r, t) {
        !function(c) {
          !function() {
            var f = e('bn.js'),
              i = e('randombytes');
            function h(t) {
              for (
                var e, r = t.modulus.byteLength();
                0 <= (e = new f(i(r))).cmp(t.modulus) ||
                !e.umod(t.prime1) ||
                !e.umod(t.prime2);

              );
              return e;
            }
            function t(t, e) {
              var r = {
                  blinder: (o = h((a = e)))
                    .toRed(f.mont(a.modulus))
                    .redPow(new f(a.publicExponent))
                    .fromRed(),
                  unblinder: o.invm(a.modulus),
                },
                i = e.modulus.byteLength(),
                n = new f(t).mul(r.blinder).umod(e.modulus),
                s = n.toRed(f.mont(e.prime1)),
                o = n.toRed(f.mont(e.prime2)),
                a = e.coefficient,
                t = e.prime1,
                n = e.prime2,
                s = s.redPow(e.exponent1).fromRed(),
                o = o.redPow(e.exponent2).fromRed(),
                n = s
                  .isub(o)
                  .imul(a)
                  .umod(t)
                  .imul(n);
              return o
                .iadd(n)
                .imul(r.unblinder)
                .umod(e.modulus)
                .toArrayLike(c, 'be', i);
            }
            (t.getr = h), (r.exports = t);
          }.call(this);
        }.call(this, e('buffer').Buffer);
      },
      { 'bn.js': 18, buffer: 64, randombytes: 158 },
    ],
    42: [
      function(t, e, r) {
        e.exports = t('./browser/algorithms.json');
      },
      { './browser/algorithms.json': 43 },
    ],
    43: [
      function(t, e, r) {
        e.exports = {
          sha224WithRSAEncryption: {
            sign: 'rsa',
            hash: 'sha224',
            id: '302d300d06096086480165030402040500041c',
          },
          'RSA-SHA224': {
            sign: 'ecdsa/rsa',
            hash: 'sha224',
            id: '302d300d06096086480165030402040500041c',
          },
          sha256WithRSAEncryption: {
            sign: 'rsa',
            hash: 'sha256',
            id: '3031300d060960864801650304020105000420',
          },
          'RSA-SHA256': {
            sign: 'ecdsa/rsa',
            hash: 'sha256',
            id: '3031300d060960864801650304020105000420',
          },
          sha384WithRSAEncryption: {
            sign: 'rsa',
            hash: 'sha384',
            id: '3041300d060960864801650304020205000430',
          },
          'RSA-SHA384': {
            sign: 'ecdsa/rsa',
            hash: 'sha384',
            id: '3041300d060960864801650304020205000430',
          },
          sha512WithRSAEncryption: {
            sign: 'rsa',
            hash: 'sha512',
            id: '3051300d060960864801650304020305000440',
          },
          'RSA-SHA512': {
            sign: 'ecdsa/rsa',
            hash: 'sha512',
            id: '3051300d060960864801650304020305000440',
          },
          'RSA-SHA1': {
            sign: 'rsa',
            hash: 'sha1',
            id: '3021300906052b0e03021a05000414',
          },
          'ecdsa-with-SHA1': { sign: 'ecdsa', hash: 'sha1', id: '' },
          sha256: { sign: 'ecdsa', hash: 'sha256', id: '' },
          sha224: { sign: 'ecdsa', hash: 'sha224', id: '' },
          sha384: { sign: 'ecdsa', hash: 'sha384', id: '' },
          sha512: { sign: 'ecdsa', hash: 'sha512', id: '' },
          'DSA-SHA': { sign: 'dsa', hash: 'sha1', id: '' },
          'DSA-SHA1': { sign: 'dsa', hash: 'sha1', id: '' },
          DSA: { sign: 'dsa', hash: 'sha1', id: '' },
          'DSA-WITH-SHA224': { sign: 'dsa', hash: 'sha224', id: '' },
          'DSA-SHA224': { sign: 'dsa', hash: 'sha224', id: '' },
          'DSA-WITH-SHA256': { sign: 'dsa', hash: 'sha256', id: '' },
          'DSA-SHA256': { sign: 'dsa', hash: 'sha256', id: '' },
          'DSA-WITH-SHA384': { sign: 'dsa', hash: 'sha384', id: '' },
          'DSA-SHA384': { sign: 'dsa', hash: 'sha384', id: '' },
          'DSA-WITH-SHA512': { sign: 'dsa', hash: 'sha512', id: '' },
          'DSA-SHA512': { sign: 'dsa', hash: 'sha512', id: '' },
          'DSA-RIPEMD160': { sign: 'dsa', hash: 'rmd160', id: '' },
          ripemd160WithRSA: {
            sign: 'rsa',
            hash: 'rmd160',
            id: '3021300906052b2403020105000414',
          },
          'RSA-RIPEMD160': {
            sign: 'rsa',
            hash: 'rmd160',
            id: '3021300906052b2403020105000414',
          },
          md5WithRSAEncryption: {
            sign: 'rsa',
            hash: 'md5',
            id: '3020300c06082a864886f70d020505000410',
          },
          'RSA-MD5': {
            sign: 'rsa',
            hash: 'md5',
            id: '3020300c06082a864886f70d020505000410',
          },
        };
      },
      {},
    ],
    44: [
      function(t, e, r) {
        e.exports = {
          '1.3.132.0.10': 'secp256k1',
          '1.3.132.0.33': 'p224',
          '1.2.840.10045.3.1.1': 'p192',
          '1.2.840.10045.3.1.7': 'p256',
          '1.3.132.0.34': 'p384',
          '1.3.132.0.35': 'p521',
        };
      },
      {},
    ],
    45: [
      function(t, e, r) {
        var i = t('safe-buffer').Buffer,
          n = t('create-hash'),
          s = t('readable-stream'),
          o = t('inherits'),
          a = t('./sign'),
          f = t('./verify'),
          h = t('./algorithms.json');
        function c(t) {
          s.Writable.call(this);
          t = h[t];
          if (!t) throw new Error('Unknown message digest');
          (this._hashType = t.hash),
            (this._hash = n(t.hash)),
            (this._tag = t.id),
            (this._signType = t.sign);
        }
        function u(t) {
          s.Writable.call(this);
          t = h[t];
          if (!t) throw new Error('Unknown message digest');
          (this._hash = n(t.hash)),
            (this._tag = t.id),
            (this._signType = t.sign);
        }
        function d(t) {
          return new c(t);
        }
        function l(t) {
          return new u(t);
        }
        Object.keys(h).forEach(function(t) {
          (h[t].id = i.from(h[t].id, 'hex')), (h[t.toLowerCase()] = h[t]);
        }),
          o(c, s.Writable),
          (c.prototype._write = function(t, e, r) {
            this._hash.update(t), r();
          }),
          (c.prototype.update = function(t, e) {
            return (
              'string' == typeof t && (t = i.from(t, e)),
              this._hash.update(t),
              this
            );
          }),
          (c.prototype.sign = function(t, e) {
            this.end();
            var r = this._hash.digest(),
              t = a(r, t, this._hashType, this._signType, this._tag);
            return e ? t.toString(e) : t;
          }),
          o(u, s.Writable),
          (u.prototype._write = function(t, e, r) {
            this._hash.update(t), r();
          }),
          (u.prototype.update = function(t, e) {
            return (
              'string' == typeof t && (t = i.from(t, e)),
              this._hash.update(t),
              this
            );
          }),
          (u.prototype.verify = function(t, e, r) {
            'string' == typeof e && (e = i.from(e, r)), this.end();
            r = this._hash.digest();
            return f(e, r, t, this._signType, this._tag);
          }),
          (e.exports = { Sign: d, Verify: l, createSign: d, createVerify: l });
      },
      {
        './algorithms.json': 43,
        './sign': 46,
        './verify': 47,
        'create-hash': 68,
        inherits: 133,
        'readable-stream': 62,
        'safe-buffer': 161,
      },
    ],
    46: [
      function(t, e, r) {
        var d = t('safe-buffer').Buffer,
          s = t('create-hmac'),
          f = t('browserify-rsa'),
          h = t('elliptic').ec,
          l = t('bn.js'),
          c = t('parse-asn1'),
          u = t('./curves.json');
        function p(t, e, r, i) {
          (t = d.from(t.toArray())).length < e.byteLength() &&
            ((n = d.alloc(e.byteLength() - t.length)), (t = d.concat([n, t])));
          var n = r.length,
            r = (function(t, e) {
              t = (t = b(t, e)).mod(e);
              t = d.from(t.toArray());
              t.length < e.byteLength() &&
                ((e = d.alloc(e.byteLength() - t.length)),
                (t = d.concat([e, t])));
              return t;
            })(r, e);
          (e = d.alloc(n)).fill(1);
          (n = d.alloc(n)),
            (n = s(i, n)
              .update(e)
              .update(d.from([0]))
              .update(t)
              .update(r)
              .digest()),
            (e = s(i, n)
              .update(e)
              .digest());
          return {
            k: (n = s(i, n)
              .update(e)
              .update(d.from([1]))
              .update(t)
              .update(r)
              .digest()),
            v: (e = s(i, n)
              .update(e)
              .digest()),
          };
        }
        function b(t, e) {
          var r = new l(t),
            e = (t.length << 3) - e.bitLength();
          return 0 < e && r.ishrn(e), r;
        }
        function m(t, e, r) {
          var i, n;
          do {
            for (i = d.alloc(0); 8 * i.length < t.bitLength(); )
              (e.v = s(r, e.k)
                .update(e.v)
                .digest()),
                (i = d.concat([i, e.v]));
          } while (
            ((n = b(i, t)),
            (e.k = s(r, e.k)
              .update(e.v)
              .update(d.from([0]))
              .digest()),
            (e.v = s(r, e.k)
              .update(e.v)
              .digest()),
            -1 !== n.cmp(t))
          );
          return n;
        }
        (e.exports = function(t, e, r, i, n) {
          if ((e = c(e)).curve) {
            if ('ecdsa' !== i && 'ecdsa/rsa' !== i)
              throw new Error('wrong private key type');
            return (function(t, e) {
              var r = u[e.curve.join('.')];
              if (!r) throw new Error('unknown curve ' + e.curve.join('.'));
              t = new h(r).keyFromPrivate(e.privateKey).sign(t);
              return d.from(t.toDER());
            })(t, e);
          }
          if ('dsa' === e.type) {
            if ('dsa' !== i) throw new Error('wrong private key type');
            return (function(t, e, r) {
              var i,
                n = e.params.priv_key,
                s = e.params.p,
                o = e.params.q,
                a = e.params.g,
                f = new l(0),
                h = b(t, o).mod(o),
                c = !1,
                u = p(n, o, t, r);
              for (; !1 === c; )
                (i = m(o, u, r)),
                  (f = (function(t, e, r, i) {
                    return t
                      .toRed(l.mont(r))
                      .redPow(e)
                      .fromRed()
                      .mod(i);
                  })(a, i, s, o)),
                  0 ===
                    (c = i
                      .invm(o)
                      .imul(h.add(n.mul(f)))
                      .mod(o)).cmpn(0) && ((c = !1), (f = new l(0)));
              return (function(t, e) {
                (t = t.toArray()),
                  (e = e.toArray()),
                  128 & t[0] && (t = [0].concat(t));
                128 & e[0] && (e = [0].concat(e));
                var r = [48, t.length + e.length + 4, 2, t.length];
                return (r = r.concat(t, [2, e.length], e)), d.from(r);
              })(f, c);
            })(t, e, r);
          }
          if ('rsa' !== i && 'ecdsa/rsa' !== i)
            throw new Error('wrong private key type');
          t = d.concat([n, t]);
          for (
            var s = e.modulus.byteLength(), o = [0, 1];
            t.length + o.length + 1 < s;

          )
            o.push(255);
          o.push(0);
          for (var a = -1; ++a < t.length; ) o.push(t[a]);
          return f(o, e);
        }),
          (e.exports.getKey = p),
          (e.exports.makeKey = m);
      },
      {
        './curves.json': 44,
        'bn.js': 18,
        'browserify-rsa': 41,
        'create-hmac': 70,
        elliptic: 84,
        'parse-asn1': 143,
        'safe-buffer': 161,
      },
    ],
    47: [
      function(t, e, r) {
        var c = t('safe-buffer').Buffer,
          u = t('bn.js'),
          d = t('elliptic').ec,
          l = t('parse-asn1'),
          p = t('./curves.json');
        function b(t, e) {
          if (t.cmpn(0) <= 0) throw new Error('invalid sig');
          if (t.cmp(e) >= e) throw new Error('invalid sig');
        }
        e.exports = function(t, e, r, i, n) {
          if ('ec' === (r = l(r)).type) {
            if ('ecdsa' !== i && 'ecdsa/rsa' !== i)
              throw new Error('wrong public key type');
            return (function(t, e, r) {
              var i = p[r.data.algorithm.curve.join('.')];
              if (!i)
                throw new Error(
                  'unknown curve ' + r.data.algorithm.curve.join('.')
                );
              (i = new d(i)), (r = r.data.subjectPrivateKey.data);
              return i.verify(e, t, r);
            })(t, e, r);
          }
          if ('dsa' === r.type) {
            if ('dsa' !== i) throw new Error('wrong public key type');
            return (function(t, e, r) {
              var i = r.data.p,
                n = r.data.q,
                s = r.data.g,
                o = r.data.pub_key,
                a = l.signature.decode(t, 'der'),
                r = a.s,
                t = a.r;
              b(r, n), b(t, n);
              (a = u.mont(i)), (r = r.invm(n));
              return (
                0 ===
                s
                  .toRed(a)
                  .redPow(new u(e).mul(r).mod(n))
                  .fromRed()
                  .mul(
                    o
                      .toRed(a)
                      .redPow(t.mul(r).mod(n))
                      .fromRed()
                  )
                  .mod(i)
                  .mod(n)
                  .cmp(t)
              );
            })(t, e, r);
          }
          if ('rsa' !== i && 'ecdsa/rsa' !== i)
            throw new Error('wrong public key type');
          e = c.concat([n, e]);
          for (
            var s = r.modulus.byteLength(), o = [1], a = 0;
            e.length + o.length + 2 < s;

          )
            o.push(255), a++;
          o.push(0);
          for (var f = -1; ++f < e.length; ) o.push(e[f]);
          (o = c.from(o)),
            (n = u.mont(r.modulus)),
            (t = (t = new u(t).toRed(n)).redPow(new u(r.publicExponent))),
            (t = c.from(t.fromRed().toArray()));
          var h = a < 8 ? 1 : 0,
            s = Math.min(t.length, o.length);
          for (t.length !== o.length && (h = 1), f = -1; ++f < s; )
            h |= t[f] ^ o[f];
          return 0 === h;
        };
      },
      {
        './curves.json': 44,
        'bn.js': 18,
        elliptic: 84,
        'parse-asn1': 143,
        'safe-buffer': 161,
      },
    ],
    48: [
      function(t, e, r) {
        'use strict';
        var i = {};
        function n(t, n, e) {
          var r = (function(i) {
            var t, e;
            function r(t, e, r) {
              return (
                i.call(
                  this,
                  ((t = t),
                  (e = e),
                  (r = r),
                  'string' == typeof n ? n : n(t, e, r))
                ) || this
              );
            }
            return (
              (e = i),
              ((t = r).prototype = Object.create(e.prototype)),
              ((t.prototype.constructor = t).__proto__ = e),
              r
            );
          })((e = e || Error));
          (r.prototype.name = e.name), (r.prototype.code = t), (i[t] = r);
        }
        function f(t, e) {
          if (Array.isArray(t)) {
            var r = t.length;
            return (
              (t = t.map(function(t) {
                return String(t);
              })),
              2 < r
                ? 'one of '
                    .concat(e, ' ')
                    .concat(t.slice(0, r - 1).join(', '), ', or ') + t[r - 1]
                : 2 === r
                ? 'one of '
                    .concat(e, ' ')
                    .concat(t[0], ' or ')
                    .concat(t[1])
                : 'of '.concat(e, ' ').concat(t[0])
            );
          }
          return 'of '.concat(e, ' ').concat(String(t));
        }
        n(
          'ERR_INVALID_OPT_VALUE',
          function(t, e) {
            return 'The value "' + e + '" is invalid for option "' + t + '"';
          },
          TypeError
        ),
          n(
            'ERR_INVALID_ARG_TYPE',
            function(t, e, r) {
              var i, n, s, o, a;
              return (
                'string' == typeof e &&
                ((o = 'not '), e.substr(!s || s < 0 ? 0 : +s, o.length) === o)
                  ? ((i = 'must not be'), (e = e.replace(/^not /, '')))
                  : (i = 'must be'),
                (s = t),
                (o = ' argument'),
                (void 0 === a || a > s.length) && (a = s.length),
                (e =
                  s.substring(a - o.length, a) === o
                    ? 'The '
                        .concat(t, ' ')
                        .concat(i, ' ')
                        .concat(f(e, 'type'))
                    : ((n =
                        (n = 'number' != typeof n ? 0 : n) + (a = '.').length >
                          (o = t).length || -1 === o.indexOf(a, n)
                          ? 'argument'
                          : 'property'),
                      'The "'
                        .concat(t, '" ')
                        .concat(n, ' ')
                        .concat(i, ' ')
                        .concat(f(e, 'type')))),
                (e += '. Received type '.concat(typeof r))
              );
            },
            TypeError
          ),
          n('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF'),
          n('ERR_METHOD_NOT_IMPLEMENTED', function(t) {
            return 'The ' + t + ' method is not implemented';
          }),
          n('ERR_STREAM_PREMATURE_CLOSE', 'Premature close'),
          n('ERR_STREAM_DESTROYED', function(t) {
            return 'Cannot call ' + t + ' after a stream was destroyed';
          }),
          n('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times'),
          n('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable'),
          n('ERR_STREAM_WRITE_AFTER_END', 'write after end'),
          n(
            'ERR_STREAM_NULL_VALUES',
            'May not write null values to stream',
            TypeError
          ),
          n(
            'ERR_UNKNOWN_ENCODING',
            function(t) {
              return 'Unknown encoding: ' + t;
            },
            TypeError
          ),
          n(
            'ERR_STREAM_UNSHIFT_AFTER_END_EVENT',
            'stream.unshift() after end event'
          ),
          (e.exports.codes = i);
      },
      {},
    ],
    49: [
      function(c, u, t) {
        !function(h) {
          !function() {
            'use strict';
            var t =
              Object.keys ||
              function(t) {
                var e,
                  r = [];
                for (e in t) r.push(e);
                return r;
              };
            u.exports = o;
            var e = c('./_stream_readable'),
              r = c('./_stream_writable');
            c('inherits')(o, e);
            for (var i = t(r.prototype), n = 0; n < i.length; n++) {
              var s = i[n];
              o.prototype[s] || (o.prototype[s] = r.prototype[s]);
            }
            function o(t) {
              if (!(this instanceof o)) return new o(t);
              e.call(this, t),
                r.call(this, t),
                (this.allowHalfOpen = !0),
                t &&
                  (!1 === t.readable && (this.readable = !1),
                  !1 === t.writable && (this.writable = !1),
                  !1 === t.allowHalfOpen &&
                    ((this.allowHalfOpen = !1), this.once('end', a)));
            }
            function a() {
              this._writableState.ended || h.nextTick(f, this);
            }
            function f(t) {
              t.end();
            }
            Object.defineProperty(o.prototype, 'writableHighWaterMark', {
              enumerable: !1,
              get: function() {
                return this._writableState.highWaterMark;
              },
            }),
              Object.defineProperty(o.prototype, 'writableBuffer', {
                enumerable: !1,
                get: function() {
                  return this._writableState && this._writableState.getBuffer();
                },
              }),
              Object.defineProperty(o.prototype, 'writableLength', {
                enumerable: !1,
                get: function() {
                  return this._writableState.length;
                },
              }),
              Object.defineProperty(o.prototype, 'destroyed', {
                enumerable: !1,
                get: function() {
                  return (
                    void 0 !== this._readableState &&
                    void 0 !== this._writableState &&
                    (this._readableState.destroyed &&
                      this._writableState.destroyed)
                  );
                },
                set: function(t) {
                  void 0 !== this._readableState &&
                    void 0 !== this._writableState &&
                    ((this._readableState.destroyed = t),
                    (this._writableState.destroyed = t));
                },
              });
          }.call(this);
        }.call(this, c('_process'));
      },
      {
        './_stream_readable': 51,
        './_stream_writable': 53,
        _process: 150,
        inherits: 133,
      },
    ],
    50: [
      function(t, e, r) {
        'use strict';
        e.exports = n;
        var i = t('./_stream_transform');
        function n(t) {
          if (!(this instanceof n)) return new n(t);
          i.call(this, t);
        }
        t('inherits')(n, i),
          (n.prototype._transform = function(t, e, r) {
            r(null, t);
          });
      },
      { './_stream_transform': 52, inherits: 133 },
    ],
    51: [
      function(q, U, t) {
        !function(D, N) {
          !function() {
            'use strict';
            var i;
            (U.exports = _).ReadableState = v;
            function p(t, e) {
              return t.listeners(e).length;
            }
            q('events').EventEmitter;
            var n = q('./internal/streams/stream'),
              c = q('buffer').Buffer,
              u = N.Uint8Array || function() {};
            var s,
              t,
              r,
              e = q('util'),
              b = e && e.debuglog ? e.debuglog('stream') : function() {},
              o = q('./internal/streams/buffer_list'),
              a = q('./internal/streams/destroy'),
              f = q('./internal/streams/state').getHighWaterMark,
              e = q('../errors').codes,
              d = e.ERR_INVALID_ARG_TYPE,
              l = e.ERR_STREAM_PUSH_AFTER_EOF,
              h = e.ERR_METHOD_NOT_IMPLEMENTED,
              m = e.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
            q('inherits')(_, n);
            var y = a.errorOrDestroy,
              g = ['error', 'close', 'destroy', 'pause', 'resume'];
            function v(t, e, r) {
              (i = i || q('./_stream_duplex')),
                'boolean' != typeof r && (r = e instanceof i),
                (this.objectMode = !!(t = t || {}).objectMode),
                r &&
                  (this.objectMode = this.objectMode || !!t.readableObjectMode),
                (this.highWaterMark = f(this, t, 'readableHighWaterMark', r)),
                (this.buffer = new o()),
                (this.length = 0),
                (this.pipes = null),
                (this.pipesCount = 0),
                (this.flowing = null),
                (this.ended = !1),
                (this.endEmitted = !1),
                (this.reading = !1),
                (this.sync = !0),
                (this.needReadable = !1),
                (this.emittedReadable = !1),
                (this.readableListening = !1),
                (this.resumeScheduled = !1),
                (this.paused = !0),
                (this.emitClose = !1 !== t.emitClose),
                (this.autoDestroy = !!t.autoDestroy),
                (this.destroyed = !1),
                (this.defaultEncoding = t.defaultEncoding || 'utf8'),
                (this.awaitDrain = 0),
                (this.readingMore = !1),
                (this.decoder = null),
                (this.encoding = null),
                t.encoding &&
                  ((s = s || q('string_decoder/').StringDecoder),
                  (this.decoder = new s(t.encoding)),
                  (this.encoding = t.encoding));
            }
            function _(t) {
              if (((i = i || q('./_stream_duplex')), !(this instanceof _)))
                return new _(t);
              var e = this instanceof i;
              (this._readableState = new v(t, this, e)),
                (this.readable = !0),
                t &&
                  ('function' == typeof t.read && (this._read = t.read),
                  'function' == typeof t.destroy &&
                    (this._destroy = t.destroy)),
                n.call(this);
            }
            function w(t, e, r, i, n) {
              b('readableAddChunk', e);
              var s,
                o,
                a,
                f,
                h = t._readableState;
              if (null === e)
                (h.reading = !1),
                  (o = t),
                  (a = h),
                  b('onEofChunk'),
                  a.ended ||
                    (!a.decoder ||
                      ((f = a.decoder.end()) &&
                        f.length &&
                        (a.buffer.push(f),
                        (a.length += a.objectMode ? 1 : f.length))),
                    (a.ended = !0),
                    a.sync
                      ? k(o)
                      : ((a.needReadable = !1),
                        a.emittedReadable || ((a.emittedReadable = !0), A(o))));
              else if (
                (s = !n
                  ? (function(t, e) {
                      var r;
                      (function(t) {
                        return c.isBuffer(t) || t instanceof u;
                      })(e) ||
                        'string' == typeof e ||
                        void 0 === e ||
                        t.objectMode ||
                        (r = new d(
                          'chunk',
                          ['string', 'Buffer', 'Uint8Array'],
                          e
                        ));
                      return r;
                    })(h, e)
                  : s)
              )
                y(t, s);
              else if (h.objectMode || (e && 0 < e.length))
                if (
                  ('string' == typeof e ||
                    h.objectMode ||
                    Object.getPrototypeOf(e) === c.prototype ||
                    ((s = e), (e = c.from(s))),
                  i)
                )
                  h.endEmitted ? y(t, new m()) : M(t, h, e, !0);
                else if (h.ended) y(t, new l());
                else {
                  if (h.destroyed) return !1;
                  (h.reading = !1),
                    h.decoder && !r
                      ? ((e = h.decoder.write(e)),
                        h.objectMode || 0 !== e.length
                          ? M(t, h, e, !1)
                          : x(t, h))
                      : M(t, h, e, !1);
                }
              else i || ((h.reading = !1), x(t, h));
              return !h.ended && (h.length < h.highWaterMark || 0 === h.length);
            }
            function M(t, e, r, i) {
              e.flowing && 0 === e.length && !e.sync
                ? ((e.awaitDrain = 0), t.emit('data', r))
                : ((e.length += e.objectMode ? 1 : r.length),
                  i ? e.buffer.unshift(r) : e.buffer.push(r),
                  e.needReadable && k(t)),
                x(t, e);
            }
            Object.defineProperty(_.prototype, 'destroyed', {
              enumerable: !1,
              get: function() {
                return (
                  void 0 !== this._readableState &&
                  this._readableState.destroyed
                );
              },
              set: function(t) {
                this._readableState && (this._readableState.destroyed = t);
              },
            }),
              (_.prototype.destroy = a.destroy),
              (_.prototype._undestroy = a.undestroy),
              (_.prototype._destroy = function(t, e) {
                e(t);
              }),
              (_.prototype.push = function(t, e) {
                var r,
                  i = this._readableState;
                return (
                  i.objectMode
                    ? (r = !0)
                    : 'string' == typeof t &&
                      ((e = e || i.defaultEncoding) !== i.encoding &&
                        ((t = c.from(t, e)), (e = '')),
                      (r = !0)),
                  w(this, t, e, !1, r)
                );
              }),
              (_.prototype.unshift = function(t) {
                return w(this, t, null, !0, !1);
              }),
              (_.prototype.isPaused = function() {
                return !1 === this._readableState.flowing;
              }),
              (_.prototype.setEncoding = function(t) {
                var e = new (s = s || q('string_decoder/').StringDecoder)(t);
                (this._readableState.decoder = e),
                  (this._readableState.encoding = this._readableState.decoder.encoding);
                for (
                  var r = this._readableState.buffer.head, i = '';
                  null !== r;

                )
                  (i += e.write(r.data)), (r = r.next);
                return (
                  this._readableState.buffer.clear(),
                  '' !== i && this._readableState.buffer.push(i),
                  (this._readableState.length = i.length),
                  this
                );
              });
            var S = 1073741824;
            function E(t, e) {
              return t <= 0 || (0 === e.length && e.ended)
                ? 0
                : e.objectMode
                ? 1
                : t != t
                ? (e.flowing && e.length ? e.buffer.head.data : e).length
                : (t > e.highWaterMark &&
                    (e.highWaterMark =
                      (S <= (r = t)
                        ? (r = S)
                        : (r--,
                          (r |= r >>> 1),
                          (r |= r >>> 2),
                          (r |= r >>> 4),
                          (r |= r >>> 8),
                          (r |= r >>> 16),
                          r++),
                      r)),
                  t <= e.length
                    ? t
                    : e.ended
                    ? e.length
                    : ((e.needReadable = !0), 0));
              var r;
            }
            function k(t) {
              var e = t._readableState;
              b('emitReadable', e.needReadable, e.emittedReadable),
                (e.needReadable = !1),
                e.emittedReadable ||
                  (b('emitReadable', e.flowing),
                  (e.emittedReadable = !0),
                  D.nextTick(A, t));
            }
            function A(t) {
              var e = t._readableState;
              b('emitReadable_', e.destroyed, e.length, e.ended),
                e.destroyed ||
                  (!e.length && !e.ended) ||
                  (t.emit('readable'), (e.emittedReadable = !1)),
                (e.needReadable =
                  !e.flowing && !e.ended && e.length <= e.highWaterMark),
                T(t);
            }
            function x(t, e) {
              e.readingMore || ((e.readingMore = !0), D.nextTick(B, t, e));
            }
            function B(t, e) {
              for (
                ;
                !e.reading &&
                !e.ended &&
                (e.length < e.highWaterMark || (e.flowing && 0 === e.length));

              ) {
                var r = e.length;
                if ((b('maybeReadMore read 0'), t.read(0), r === e.length))
                  break;
              }
              e.readingMore = !1;
            }
            function I(t) {
              var e = t._readableState;
              (e.readableListening = 0 < t.listenerCount('readable')),
                e.resumeScheduled && !e.paused
                  ? (e.flowing = !0)
                  : 0 < t.listenerCount('data') && t.resume();
            }
            function R(t) {
              b('readable nexttick read 0'), t.read(0);
            }
            function j(t, e) {
              b('resume', e.reading),
                e.reading || t.read(0),
                (e.resumeScheduled = !1),
                t.emit('resume'),
                T(t),
                e.flowing && !e.reading && t.read(0);
            }
            function T(t) {
              var e = t._readableState;
              for (b('flow', e.flowing); e.flowing && null !== t.read(); );
            }
            function C(t, e) {
              return 0 === e.length
                ? null
                : (e.objectMode
                    ? (r = e.buffer.shift())
                    : !t || t >= e.length
                    ? ((r = e.decoder
                        ? e.buffer.join('')
                        : 1 === e.buffer.length
                        ? e.buffer.first()
                        : e.buffer.concat(e.length)),
                      e.buffer.clear())
                    : (r = e.buffer.consume(t, e.decoder)),
                  r);
              var r;
            }
            function L(t) {
              var e = t._readableState;
              b('endReadable', e.endEmitted),
                e.endEmitted || ((e.ended = !0), D.nextTick(P, e, t));
            }
            function P(t, e) {
              b('endReadableNT', t.endEmitted, t.length),
                t.endEmitted ||
                  0 !== t.length ||
                  ((t.endEmitted = !0),
                  (e.readable = !1),
                  e.emit('end'),
                  !t.autoDestroy ||
                    ((!(t = e._writableState) ||
                      (t.autoDestroy && t.finished)) &&
                      e.destroy()));
            }
            function O(t, e) {
              for (var r = 0, i = t.length; r < i; r++)
                if (t[r] === e) return r;
              return -1;
            }
            (_.prototype.read = function(t) {
              b('read', t), (t = parseInt(t, 10));
              var e = this._readableState,
                r = t;
              if (
                (0 !== t && (e.emittedReadable = !1),
                0 === t &&
                  e.needReadable &&
                  ((0 !== e.highWaterMark
                    ? e.length >= e.highWaterMark
                    : 0 < e.length) ||
                    e.ended))
              )
                return (
                  b('read: emitReadable', e.length, e.ended),
                  (0 === e.length && e.ended ? L : k)(this),
                  null
                );
              if (0 === (t = E(t, e)) && e.ended)
                return 0 === e.length && L(this), null;
              var i = e.needReadable;
              return (
                b('need readable', i),
                (0 === e.length || e.length - t < e.highWaterMark) &&
                  b('length less than watermark', (i = !0)),
                e.ended || e.reading
                  ? b('reading or ended', (i = !1))
                  : i &&
                    (b('do read'),
                    (e.reading = !0),
                    (e.sync = !0),
                    0 === e.length && (e.needReadable = !0),
                    this._read(e.highWaterMark),
                    (e.sync = !1),
                    e.reading || (t = E(r, e))),
                null === (i = 0 < t ? C(t, e) : null)
                  ? ((e.needReadable = e.length <= e.highWaterMark), (t = 0))
                  : ((e.length -= t), (e.awaitDrain = 0)),
                0 === e.length &&
                  (e.ended || (e.needReadable = !0),
                  r !== t && e.ended && L(this)),
                null !== i && this.emit('data', i),
                i
              );
            }),
              (_.prototype._read = function(t) {
                y(this, new h('_read()'));
              }),
              (_.prototype.pipe = function(r, t) {
                var i = this,
                  n = this._readableState;
                switch (n.pipesCount) {
                  case 0:
                    n.pipes = r;
                    break;
                  case 1:
                    n.pipes = [n.pipes, r];
                    break;
                  default:
                    n.pipes.push(r);
                }
                (n.pipesCount += 1),
                  b('pipe count=%d opts=%j', n.pipesCount, t);
                t =
                  (!t || !1 !== t.end) && r !== D.stdout && r !== D.stderr
                    ? o
                    : l;
                function s(t, e) {
                  b('onunpipe'),
                    t === i &&
                      e &&
                      !1 === e.hasUnpiped &&
                      ((e.hasUnpiped = !0),
                      b('cleanup'),
                      r.removeListener('close', u),
                      r.removeListener('finish', d),
                      r.removeListener('drain', a),
                      r.removeListener('error', c),
                      r.removeListener('unpipe', s),
                      i.removeListener('end', o),
                      i.removeListener('end', l),
                      i.removeListener('data', h),
                      (f = !0),
                      !n.awaitDrain ||
                        (r._writableState && !r._writableState.needDrain) ||
                        a());
                }
                function o() {
                  b('onend'), r.end();
                }
                n.endEmitted ? D.nextTick(t) : i.once('end', t),
                  r.on('unpipe', s);
                var e,
                  a =
                    ((e = i),
                    function() {
                      var t = e._readableState;
                      b('pipeOnDrain', t.awaitDrain),
                        t.awaitDrain && t.awaitDrain--,
                        0 === t.awaitDrain &&
                          p(e, 'data') &&
                          ((t.flowing = !0), T(e));
                    });
                r.on('drain', a);
                var f = !1;
                function h(t) {
                  b('ondata');
                  t = r.write(t);
                  b('dest.write', t),
                    !1 === t &&
                      (((1 === n.pipesCount && n.pipes === r) ||
                        (1 < n.pipesCount && -1 !== O(n.pipes, r))) &&
                        !f &&
                        (b('false write response, pause', n.awaitDrain),
                        n.awaitDrain++),
                      i.pause());
                }
                function c(t) {
                  b('onerror', t),
                    l(),
                    r.removeListener('error', c),
                    0 === p(r, 'error') && y(r, t);
                }
                function u() {
                  r.removeListener('finish', d), l();
                }
                function d() {
                  b('onfinish'), r.removeListener('close', u), l();
                }
                function l() {
                  b('unpipe'), i.unpipe(r);
                }
                return (
                  i.on('data', h),
                  (function(t, e, r) {
                    if ('function' == typeof t.prependListener)
                      return t.prependListener(e, r);
                    t._events && t._events[e]
                      ? Array.isArray(t._events[e])
                        ? t._events[e].unshift(r)
                        : (t._events[e] = [r, t._events[e]])
                      : t.on(e, r);
                  })(r, 'error', c),
                  r.once('close', u),
                  r.once('finish', d),
                  r.emit('pipe', i),
                  n.flowing || (b('pipe resume'), i.resume()),
                  r
                );
              }),
              (_.prototype.unpipe = function(t) {
                var e = this._readableState,
                  r = { hasUnpiped: !1 };
                if (0 === e.pipesCount) return this;
                if (1 === e.pipesCount)
                  return (
                    (t && t !== e.pipes) ||
                      ((t = t || e.pipes),
                      (e.pipes = null),
                      (e.pipesCount = 0),
                      (e.flowing = !1),
                      t && t.emit('unpipe', this, r)),
                    this
                  );
                if (!t) {
                  var i = e.pipes,
                    n = e.pipesCount;
                  (e.pipes = null), (e.pipesCount = 0), (e.flowing = !1);
                  for (var s = 0; s < n; s++)
                    i[s].emit('unpipe', this, { hasUnpiped: !1 });
                  return this;
                }
                var o = O(e.pipes, t);
                return (
                  -1 === o ||
                    (e.pipes.splice(o, 1),
                    --e.pipesCount,
                    1 === e.pipesCount && (e.pipes = e.pipes[0]),
                    t.emit('unpipe', this, r)),
                  this
                );
              }),
              (_.prototype.on = function(t, e) {
                var r = n.prototype.on.call(this, t, e),
                  e = this._readableState;
                return (
                  'data' === t
                    ? ((e.readableListening =
                        0 < this.listenerCount('readable')),
                      !1 !== e.flowing && this.resume())
                    : 'readable' === t &&
                      (e.endEmitted ||
                        e.readableListening ||
                        ((e.readableListening = e.needReadable = !0),
                        (e.flowing = !1),
                        (e.emittedReadable = !1),
                        b('on readable', e.length, e.reading),
                        e.length ? k(this) : e.reading || D.nextTick(R, this))),
                  r
                );
              }),
              (_.prototype.addListener = _.prototype.on),
              (_.prototype.removeListener = function(t, e) {
                e = n.prototype.removeListener.call(this, t, e);
                return 'readable' === t && D.nextTick(I, this), e;
              }),
              (_.prototype.removeAllListeners = function(t) {
                var e = n.prototype.removeAllListeners.apply(this, arguments);
                return (
                  ('readable' !== t && void 0 !== t) || D.nextTick(I, this), e
                );
              }),
              (_.prototype.resume = function() {
                var t,
                  e,
                  r = this._readableState;
                return (
                  r.flowing ||
                    (b('resume'),
                    (r.flowing = !r.readableListening),
                    (t = this),
                    (e = r).resumeScheduled ||
                      ((e.resumeScheduled = !0), D.nextTick(j, t, e))),
                  (r.paused = !1),
                  this
                );
              }),
              (_.prototype.pause = function() {
                return (
                  b('call pause flowing=%j', this._readableState.flowing),
                  !1 !== this._readableState.flowing &&
                    (b('pause'),
                    (this._readableState.flowing = !1),
                    this.emit('pause')),
                  (this._readableState.paused = !0),
                  this
                );
              }),
              (_.prototype.wrap = function(e) {
                var t,
                  r = this,
                  i = this._readableState,
                  n = !1;
                for (t in (e.on('end', function() {
                  var t;
                  b('wrapped end'),
                    !i.decoder ||
                      i.ended ||
                      ((t = i.decoder.end()) && t.length && r.push(t)),
                    r.push(null);
                }),
                e.on('data', function(t) {
                  b('wrapped data'),
                    i.decoder && (t = i.decoder.write(t)),
                    (i.objectMode && null == t) ||
                      ((i.objectMode || (t && t.length)) &&
                        (r.push(t) || ((n = !0), e.pause())));
                }),
                e))
                  void 0 === this[t] &&
                    'function' == typeof e[t] &&
                    (this[t] = (function(t) {
                      return function() {
                        return e[t].apply(e, arguments);
                      };
                    })(t));
                for (var s = 0; s < g.length; s++)
                  e.on(g[s], this.emit.bind(this, g[s]));
                return (
                  (this._read = function(t) {
                    b('wrapped _read', t), n && ((n = !1), e.resume());
                  }),
                  this
                );
              }),
              'function' == typeof Symbol &&
                (_.prototype[Symbol.asyncIterator] = function() {
                  return (t =
                    void 0 === t ? q('./internal/streams/async_iterator') : t)(
                    this
                  );
                }),
              Object.defineProperty(_.prototype, 'readableHighWaterMark', {
                enumerable: !1,
                get: function() {
                  return this._readableState.highWaterMark;
                },
              }),
              Object.defineProperty(_.prototype, 'readableBuffer', {
                enumerable: !1,
                get: function() {
                  return this._readableState && this._readableState.buffer;
                },
              }),
              Object.defineProperty(_.prototype, 'readableFlowing', {
                enumerable: !1,
                get: function() {
                  return this._readableState.flowing;
                },
                set: function(t) {
                  this._readableState && (this._readableState.flowing = t);
                },
              }),
              (_._fromList = C),
              Object.defineProperty(_.prototype, 'readableLength', {
                enumerable: !1,
                get: function() {
                  return this._readableState.length;
                },
              }),
              'function' == typeof Symbol &&
                (_.from = function(t, e) {
                  return (r = void 0 === r ? q('./internal/streams/from') : r)(
                    _,
                    t,
                    e
                  );
                });
          }.call(this);
        }.call(
          this,
          q('_process'),
          'undefined' != typeof global
            ? global
            : 'undefined' != typeof self
            ? self
            : 'undefined' != typeof window
            ? window
            : {}
        );
      },
      {
        '../errors': 48,
        './_stream_duplex': 49,
        './internal/streams/async_iterator': 54,
        './internal/streams/buffer_list': 55,
        './internal/streams/destroy': 56,
        './internal/streams/from': 58,
        './internal/streams/state': 60,
        './internal/streams/stream': 61,
        _process: 150,
        buffer: 64,
        events: 101,
        inherits: 133,
        'string_decoder/': 186,
        util: 20,
      },
    ],
    52: [
      function(t, e, r) {
        'use strict';
        e.exports = f;
        var e = t('../errors').codes,
          i = e.ERR_METHOD_NOT_IMPLEMENTED,
          n = e.ERR_MULTIPLE_CALLBACK,
          s = e.ERR_TRANSFORM_ALREADY_TRANSFORMING,
          o = e.ERR_TRANSFORM_WITH_LENGTH_0,
          a = t('./_stream_duplex');
        function f(t) {
          if (!(this instanceof f)) return new f(t);
          a.call(this, t),
            (this._transformState = {
              afterTransform: function(t, e) {
                var r = this._transformState;
                r.transforming = !1;
                var i = r.writecb;
                if (null === i) return this.emit('error', new n());
                (r.writechunk = null),
                  (r.writecb = null) != e && this.push(e),
                  i(t),
                  ((t = this._readableState).reading = !1),
                  (t.needReadable || t.length < t.highWaterMark) &&
                    this._read(t.highWaterMark);
              }.bind(this),
              needTransform: !1,
              transforming: !1,
              writecb: null,
              writechunk: null,
              writeencoding: null,
            }),
            (this._readableState.needReadable = !0),
            (this._readableState.sync = !1),
            t &&
              ('function' == typeof t.transform &&
                (this._transform = t.transform),
              'function' == typeof t.flush && (this._flush = t.flush)),
            this.on('prefinish', h);
        }
        function h() {
          var r = this;
          'function' != typeof this._flush || this._readableState.destroyed
            ? c(this, null, null)
            : this._flush(function(t, e) {
                c(r, t, e);
              });
        }
        function c(t, e, r) {
          if (e) return t.emit('error', e);
          if ((null != r && t.push(r), t._writableState.length)) throw new o();
          if (t._transformState.transforming) throw new s();
          return t.push(null);
        }
        t('inherits')(f, a),
          (f.prototype.push = function(t, e) {
            return (
              (this._transformState.needTransform = !1),
              a.prototype.push.call(this, t, e)
            );
          }),
          (f.prototype._transform = function(t, e, r) {
            r(new i('_transform()'));
          }),
          (f.prototype._write = function(t, e, r) {
            var i = this._transformState;
            (i.writecb = r),
              (i.writechunk = t),
              (i.writeencoding = e),
              i.transforming ||
                ((e = this._readableState),
                (i.needTransform ||
                  e.needReadable ||
                  e.length < e.highWaterMark) &&
                  this._read(e.highWaterMark));
          }),
          (f.prototype._read = function(t) {
            var e = this._transformState;
            null === e.writechunk || e.transforming
              ? (e.needTransform = !0)
              : ((e.transforming = !0),
                this._transform(
                  e.writechunk,
                  e.writeencoding,
                  e.afterTransform
                ));
          }),
          (f.prototype._destroy = function(t, e) {
            a.prototype._destroy.call(this, t, function(t) {
              e(t);
            });
          });
      },
      { '../errors': 48, './_stream_duplex': 49, inherits: 133 },
    ],
    53: [
      function(R, j, t) {
        !function(B, I) {
          !function() {
            'use strict';
            function c(t) {
              var e = this;
              (this.next = null),
                (this.entry = null),
                (this.finish = function() {
                  !(function(t, e, r) {
                    var i = t.entry;
                    t.entry = null;
                    for (; i; ) {
                      var n = i.callback;
                      e.pendingcb--, n(r), (i = i.next);
                    }
                    e.corkedRequestsFree.next = t;
                  })(e, t);
                });
            }
            var i;
            (j.exports = w).WritableState = _;
            var t = { deprecate: R('util-deprecate') },
              r = R('./internal/streams/stream'),
              u = R('buffer').Buffer,
              d = I.Uint8Array || function() {};
            var n,
              e = R('./internal/streams/destroy'),
              s = R('./internal/streams/state').getHighWaterMark,
              o = R('../errors').codes,
              l = o.ERR_INVALID_ARG_TYPE,
              a = o.ERR_METHOD_NOT_IMPLEMENTED,
              f = o.ERR_MULTIPLE_CALLBACK,
              h = o.ERR_STREAM_CANNOT_PIPE,
              p = o.ERR_STREAM_DESTROYED,
              b = o.ERR_STREAM_NULL_VALUES,
              m = o.ERR_STREAM_WRITE_AFTER_END,
              y = o.ERR_UNKNOWN_ENCODING,
              g = e.errorOrDestroy;
            function v() {}
            function _(t, e, r) {
              (i = i || R('./_stream_duplex')),
                'boolean' != typeof r && (r = e instanceof i),
                (this.objectMode = !!(t = t || {}).objectMode),
                r &&
                  (this.objectMode = this.objectMode || !!t.writableObjectMode),
                (this.highWaterMark = s(this, t, 'writableHighWaterMark', r)),
                (this.finalCalled = !1),
                (this.needDrain = !1),
                (this.ending = !1),
                (this.ended = !1),
                (this.finished = !1);
              r = (this.destroyed = !1) === t.decodeStrings;
              (this.decodeStrings = !r),
                (this.defaultEncoding = t.defaultEncoding || 'utf8'),
                (this.length = 0),
                (this.writing = !1),
                (this.corked = 0),
                (this.sync = !0),
                (this.bufferProcessing = !1),
                (this.onwrite = function(t) {
                  !(function(t, e) {
                    var r = t._writableState,
                      i = r.sync,
                      n = r.writecb;
                    if ('function' != typeof n) throw new f();
                    (function(t) {
                      (t.writing = !1),
                        (t.writecb = null),
                        (t.length -= t.writelen),
                        (t.writelen = 0);
                    })(r),
                      e
                        ? (function(t, e, r, i, n) {
                            --e.pendingcb,
                              r
                                ? (B.nextTick(n, i),
                                  B.nextTick(x, t, e),
                                  (t._writableState.errorEmitted = !0),
                                  g(t, i))
                                : (n(i),
                                  (t._writableState.errorEmitted = !0),
                                  g(t, i),
                                  x(t, e));
                          })(t, r, i, e, n)
                        : ((e = k(r) || t.destroyed) ||
                            r.corked ||
                            r.bufferProcessing ||
                            !r.bufferedRequest ||
                            E(t, r),
                          i ? B.nextTick(S, t, r, e, n) : S(t, r, e, n));
                  })(e, t);
                }),
                (this.writecb = null),
                (this.writelen = 0),
                (this.bufferedRequest = null),
                (this.lastBufferedRequest = null),
                (this.pendingcb = 0),
                (this.prefinished = !1),
                (this.errorEmitted = !1),
                (this.emitClose = !1 !== t.emitClose),
                (this.autoDestroy = !!t.autoDestroy),
                (this.bufferedRequestCount = 0),
                (this.corkedRequestsFree = new c(this));
            }
            function w(t) {
              var e = this instanceof (i = i || R('./_stream_duplex'));
              if (!e && !n.call(w, this)) return new w(t);
              (this._writableState = new _(t, this, e)),
                (this.writable = !0),
                t &&
                  ('function' == typeof t.write && (this._write = t.write),
                  'function' == typeof t.writev && (this._writev = t.writev),
                  'function' == typeof t.destroy && (this._destroy = t.destroy),
                  'function' == typeof t.final && (this._final = t.final)),
                r.call(this);
            }
            function M(t, e, r, i, n, s, o) {
              (e.writelen = i),
                (e.writecb = o),
                (e.writing = !0),
                (e.sync = !0),
                e.destroyed
                  ? e.onwrite(new p('write'))
                  : r
                  ? t._writev(n, e.onwrite)
                  : t._write(n, s, e.onwrite),
                (e.sync = !1);
            }
            function S(t, e, r, i) {
              var n;
              r ||
                ((n = t),
                0 === (r = e).length &&
                  r.needDrain &&
                  ((r.needDrain = !1), n.emit('drain'))),
                e.pendingcb--,
                i(),
                x(t, e);
            }
            function E(t, e) {
              e.bufferProcessing = !0;
              var r = e.bufferedRequest;
              if (t._writev && r && r.next) {
                var i = e.bufferedRequestCount,
                  n = new Array(i),
                  i = e.corkedRequestsFree;
                i.entry = r;
                for (var s = 0, o = !0; r; )
                  (n[s] = r).isBuf || (o = !1), (r = r.next), (s += 1);
                (n.allBuffers = o),
                  M(t, e, !0, e.length, n, '', i.finish),
                  e.pendingcb++,
                  (e.lastBufferedRequest = null),
                  i.next
                    ? ((e.corkedRequestsFree = i.next), (i.next = null))
                    : (e.corkedRequestsFree = new c(e)),
                  (e.bufferedRequestCount = 0);
              } else {
                for (; r; ) {
                  var a = r.chunk,
                    f = r.encoding,
                    h = r.callback;
                  if (
                    (M(t, e, !1, e.objectMode ? 1 : a.length, a, f, h),
                    (r = r.next),
                    e.bufferedRequestCount--,
                    e.writing)
                  )
                    break;
                }
                null === r && (e.lastBufferedRequest = null);
              }
              (e.bufferedRequest = r), (e.bufferProcessing = !1);
            }
            function k(t) {
              return (
                t.ending &&
                0 === t.length &&
                null === t.bufferedRequest &&
                !t.finished &&
                !t.writing
              );
            }
            function A(e, r) {
              e._final(function(t) {
                r.pendingcb--,
                  t && g(e, t),
                  (r.prefinished = !0),
                  e.emit('prefinish'),
                  x(e, r);
              });
            }
            function x(t, e) {
              var r,
                i,
                n = k(e);
              return (
                n &&
                  ((r = t),
                  (i = e).prefinished ||
                    i.finalCalled ||
                    ('function' != typeof r._final || i.destroyed
                      ? ((i.prefinished = !0), r.emit('prefinish'))
                      : (i.pendingcb++,
                        (i.finalCalled = !0),
                        B.nextTick(A, r, i))),
                  0 === e.pendingcb &&
                    ((e.finished = !0),
                    t.emit('finish'),
                    !e.autoDestroy ||
                      ((!(e = t._readableState) ||
                        (e.autoDestroy && e.endEmitted)) &&
                        t.destroy()))),
                n
              );
            }
            R('inherits')(w, r),
              (_.prototype.getBuffer = function() {
                for (var t = this.bufferedRequest, e = []; t; )
                  e.push(t), (t = t.next);
                return e;
              }),
              (function() {
                try {
                  Object.defineProperty(_.prototype, 'buffer', {
                    get: t.deprecate(
                      function() {
                        return this.getBuffer();
                      },
                      '_writableState.buffer is deprecated. Use _writableState.getBuffer instead.',
                      'DEP0003'
                    ),
                  });
                } catch (t) {}
              })(),
              'function' == typeof Symbol &&
              Symbol.hasInstance &&
              'function' == typeof Function.prototype[Symbol.hasInstance]
                ? ((n = Function.prototype[Symbol.hasInstance]),
                  Object.defineProperty(w, Symbol.hasInstance, {
                    value: function(t) {
                      return (
                        !!n.call(this, t) ||
                        (this === w && (t && t._writableState instanceof _))
                      );
                    },
                  }))
                : (n = function(t) {
                    return t instanceof this;
                  }),
              (w.prototype.pipe = function() {
                g(this, new h());
              }),
              (w.prototype.write = function(t, e, r) {
                var i,
                  n,
                  s,
                  o,
                  a,
                  f,
                  h = this._writableState,
                  c = !1,
                  i =
                    !h.objectMode && ((i = t), u.isBuffer(i) || i instanceof d);
                return (
                  i && !u.isBuffer(t) && ((n = t), (t = u.from(n))),
                  'function' == typeof e && ((r = e), (e = null)),
                  (e = i ? 'buffer' : e || h.defaultEncoding),
                  'function' != typeof r && (r = v),
                  h.ending
                    ? ((o = this),
                      (a = r),
                      (f = new m()),
                      g(o, f),
                      B.nextTick(a, f))
                    : (!i &&
                        ((n = this),
                        (o = h),
                        (a = r),
                        null === (f = t)
                          ? (s = new b())
                          : 'string' == typeof f ||
                            o.objectMode ||
                            (s = new l('chunk', ['string', 'Buffer'], f)),
                        s && (g(n, s), !void B.nextTick(a, s)))) ||
                      (h.pendingcb++,
                      (c = (function(t, e, r, i, n, s) {
                        r ||
                          ((f = (function(t, e, r) {
                            t.objectMode ||
                              !1 === t.decodeStrings ||
                              'string' != typeof e ||
                              (e = u.from(e, r));
                            return e;
                          })(e, i, n)),
                          i !== f && ((r = !0), (n = 'buffer'), (i = f)));
                        var o = e.objectMode ? 1 : i.length;
                        e.length += o;
                        var a = e.length < e.highWaterMark;
                        a || (e.needDrain = !0);
                        {
                          var f;
                          e.writing || e.corked
                            ? ((f = e.lastBufferedRequest),
                              (e.lastBufferedRequest = {
                                chunk: i,
                                encoding: n,
                                isBuf: r,
                                callback: s,
                                next: null,
                              }),
                              f
                                ? (f.next = e.lastBufferedRequest)
                                : (e.bufferedRequest = e.lastBufferedRequest),
                              (e.bufferedRequestCount += 1))
                            : M(t, e, !1, o, i, n, s);
                        }
                        return a;
                      })(this, h, i, t, e, r))),
                  c
                );
              }),
              (w.prototype.cork = function() {
                this._writableState.corked++;
              }),
              (w.prototype.uncork = function() {
                var t = this._writableState;
                t.corked &&
                  (t.corked--,
                  t.writing ||
                    t.corked ||
                    t.bufferProcessing ||
                    !t.bufferedRequest ||
                    E(this, t));
              }),
              (w.prototype.setDefaultEncoding = function(t) {
                if (
                  ('string' == typeof t && (t = t.toLowerCase()),
                  !(
                    -1 <
                    [
                      'hex',
                      'utf8',
                      'utf-8',
                      'ascii',
                      'binary',
                      'base64',
                      'ucs2',
                      'ucs-2',
                      'utf16le',
                      'utf-16le',
                      'raw',
                    ].indexOf((t + '').toLowerCase())
                  ))
                )
                  throw new y(t);
                return (this._writableState.defaultEncoding = t), this;
              }),
              Object.defineProperty(w.prototype, 'writableBuffer', {
                enumerable: !1,
                get: function() {
                  return this._writableState && this._writableState.getBuffer();
                },
              }),
              Object.defineProperty(w.prototype, 'writableHighWaterMark', {
                enumerable: !1,
                get: function() {
                  return this._writableState.highWaterMark;
                },
              }),
              (w.prototype._write = function(t, e, r) {
                r(new a('_write()'));
              }),
              (w.prototype._writev = null),
              (w.prototype.end = function(t, e, r) {
                var i = this._writableState;
                return (
                  'function' == typeof t
                    ? ((r = t), (e = t = null))
                    : 'function' == typeof e && ((r = e), (e = null)),
                  null != t && this.write(t, e),
                  i.corked && ((i.corked = 1), this.uncork()),
                  i.ending ||
                    (function(t, e, r) {
                      (e.ending = !0),
                        x(t, e),
                        r && (e.finished ? B.nextTick(r) : t.once('finish', r));
                      (e.ended = !0), (t.writable = !1);
                    })(this, i, r),
                  this
                );
              }),
              Object.defineProperty(w.prototype, 'writableLength', {
                enumerable: !1,
                get: function() {
                  return this._writableState.length;
                },
              }),
              Object.defineProperty(w.prototype, 'destroyed', {
                enumerable: !1,
                get: function() {
                  return (
                    void 0 !== this._writableState &&
                    this._writableState.destroyed
                  );
                },
                set: function(t) {
                  this._writableState && (this._writableState.destroyed = t);
                },
              }),
              (w.prototype.destroy = e.destroy),
              (w.prototype._undestroy = e.undestroy),
              (w.prototype._destroy = function(t, e) {
                e(t);
              });
          }.call(this);
        }.call(
          this,
          R('_process'),
          'undefined' != typeof global
            ? global
            : 'undefined' != typeof self
            ? self
            : 'undefined' != typeof window
            ? window
            : {}
        );
      },
      {
        '../errors': 48,
        './_stream_duplex': 49,
        './internal/streams/destroy': 56,
        './internal/streams/state': 60,
        './internal/streams/stream': 61,
        _process: 150,
        buffer: 64,
        inherits: 133,
        'util-deprecate': 187,
      },
    ],
    54: [
      function(i, m, t) {
        !function(b) {
          !function() {
            'use strict';
            var t;
            function r(t, e, r) {
              return (
                e in t
                  ? Object.defineProperty(t, e, {
                      value: r,
                      enumerable: !0,
                      configurable: !0,
                      writable: !0,
                    })
                  : (t[e] = r),
                t
              );
            }
            var n = i('./end-of-stream'),
              s = Symbol('lastResolve'),
              o = Symbol('lastReject'),
              a = Symbol('error'),
              f = Symbol('ended'),
              h = Symbol('lastPromise'),
              c = Symbol('handlePromise'),
              u = Symbol('stream');
            function d(t, e) {
              return { value: t, done: e };
            }
            function l(t) {
              var e,
                r = t[s];
              null === r ||
                (null !== (e = t[u].read()) &&
                  ((t[h] = null), (t[s] = null), (t[o] = null), r(d(e, !1))));
            }
            var e = Object.getPrototypeOf(function() {}),
              p = Object.setPrototypeOf(
                (r(
                  (t = {
                    get stream() {
                      return this[u];
                    },
                    next: function() {
                      var r = this,
                        t = this[a];
                      if (null !== t) return Promise.reject(t);
                      if (this[f]) return Promise.resolve(d(void 0, !0));
                      if (this[u].destroyed)
                        return new Promise(function(t, e) {
                          b.nextTick(function() {
                            r[a] ? e(r[a]) : t(d(void 0, !0));
                          });
                        });
                      var e,
                        i,
                        n,
                        t = this[h];
                      if (t)
                        e = new Promise(
                          ((i = t),
                          (n = this),
                          function(t, e) {
                            i.then(function() {
                              n[f] ? t(d(void 0, !0)) : n[c](t, e);
                            }, e);
                          })
                        );
                      else {
                        t = this[u].read();
                        if (null !== t) return Promise.resolve(d(t, !1));
                        e = new Promise(this[c]);
                      }
                      return (this[h] = e);
                    },
                  }),
                  Symbol.asyncIterator,
                  function() {
                    return this;
                  }
                ),
                r(t, 'return', function() {
                  var t = this;
                  return new Promise(function(e, r) {
                    t[u].destroy(null, function(t) {
                      t ? r(t) : e(d(void 0, !0));
                    });
                  });
                }),
                t),
                e
              );
            m.exports = function(t) {
              var e,
                i = Object.create(
                  p,
                  (r((e = {}), u, { value: t, writable: !0 }),
                  r(e, s, { value: null, writable: !0 }),
                  r(e, o, { value: null, writable: !0 }),
                  r(e, a, { value: null, writable: !0 }),
                  r(e, f, { value: t._readableState.endEmitted, writable: !0 }),
                  r(e, c, {
                    value: function(t, e) {
                      var r = i[u].read();
                      r
                        ? ((i[h] = null),
                          (i[s] = null),
                          (i[o] = null),
                          t(d(r, !1)))
                        : ((i[s] = t), (i[o] = e));
                    },
                    writable: !0,
                  }),
                  e)
                );
              return (
                (i[h] = null),
                n(t, function(t) {
                  if (t && 'ERR_STREAM_PREMATURE_CLOSE' !== t.code) {
                    var e = i[o];
                    return (
                      null !== e &&
                        ((i[h] = null), (i[s] = null), (i[o] = null), e(t)),
                      void (i[a] = t)
                    );
                  }
                  t = i[s];
                  null !== t &&
                    ((i[h] = null),
                    (i[s] = null),
                    t(d(void 0, !(i[o] = null)))),
                    (i[f] = !0);
                }),
                t.on(
                  'readable',
                  function(t) {
                    b.nextTick(l, t);
                  }.bind(null, i)
                ),
                i
              );
            };
          }.call(this);
        }.call(this, i('_process'));
      },
      { './end-of-stream': 57, _process: 150 },
    ],
    55: [
      function(t, e, r) {
        'use strict';
        function s(e, t) {
          var r,
            i = Object.keys(e);
          return (
            Object.getOwnPropertySymbols &&
              ((r = Object.getOwnPropertySymbols(e)),
              t &&
                (r = r.filter(function(t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
              i.push.apply(i, r)),
            i
          );
        }
        function n(i) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2
              ? s(Object(n), !0).forEach(function(t) {
                  var e, r;
                  (e = i),
                    (t = n[(r = t)]),
                    r in e
                      ? Object.defineProperty(e, r, {
                          value: t,
                          enumerable: !0,
                          configurable: !0,
                          writable: !0,
                        })
                      : (e[r] = t);
                })
              : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(n))
              : s(Object(n)).forEach(function(t) {
                  Object.defineProperty(
                    i,
                    t,
                    Object.getOwnPropertyDescriptor(n, t)
                  );
                });
          }
          return i;
        }
        function o(t, e) {
          for (var r = 0; r < e.length; r++) {
            var i = e[r];
            (i.enumerable = i.enumerable || !1),
              (i.configurable = !0),
              'value' in i && (i.writable = !0),
              Object.defineProperty(t, i.key, i);
          }
        }
        var a = t('buffer').Buffer,
          f = t('util').inspect,
          h = (f && f.custom) || 'inspect';
        e.exports = (function() {
          function t() {
            !(function(t, e) {
              if (!(t instanceof e))
                throw new TypeError('Cannot call a class as a function');
            })(this, t),
              (this.head = null),
              (this.tail = null),
              (this.length = 0);
          }
          var e, r, i;
          return (
            (e = t),
            (r = [
              {
                key: 'push',
                value: function(t) {
                  t = { data: t, next: null };
                  0 < this.length ? (this.tail.next = t) : (this.head = t),
                    (this.tail = t),
                    ++this.length;
                },
              },
              {
                key: 'unshift',
                value: function(t) {
                  t = { data: t, next: this.head };
                  0 === this.length && (this.tail = t),
                    (this.head = t),
                    ++this.length;
                },
              },
              {
                key: 'shift',
                value: function() {
                  if (0 !== this.length) {
                    var t = this.head.data;
                    return (
                      1 === this.length
                        ? (this.head = this.tail = null)
                        : (this.head = this.head.next),
                      --this.length,
                      t
                    );
                  }
                },
              },
              {
                key: 'clear',
                value: function() {
                  (this.head = this.tail = null), (this.length = 0);
                },
              },
              {
                key: 'join',
                value: function(t) {
                  if (0 === this.length) return '';
                  for (var e = this.head, r = '' + e.data; (e = e.next); )
                    r += t + e.data;
                  return r;
                },
              },
              {
                key: 'concat',
                value: function(t) {
                  if (0 === this.length) return a.alloc(0);
                  for (
                    var e, r, i = a.allocUnsafe(t >>> 0), n = this.head, s = 0;
                    n;

                  )
                    (e = n.data),
                      (r = s),
                      a.prototype.copy.call(e, i, r),
                      (s += n.data.length),
                      (n = n.next);
                  return i;
                },
              },
              {
                key: 'consume',
                value: function(t, e) {
                  var r;
                  return (
                    t < this.head.data.length
                      ? ((r = this.head.data.slice(0, t)),
                        (this.head.data = this.head.data.slice(t)))
                      : (r =
                          t === this.head.data.length
                            ? this.shift()
                            : e
                            ? this._getString(t)
                            : this._getBuffer(t)),
                    r
                  );
                },
              },
              {
                key: 'first',
                value: function() {
                  return this.head.data;
                },
              },
              {
                key: '_getString',
                value: function(t) {
                  var e = this.head,
                    r = 1,
                    i = e.data;
                  for (t -= i.length; (e = e.next); ) {
                    var n = e.data,
                      s = t > n.length ? n.length : t;
                    if (
                      (s === n.length ? (i += n) : (i += n.slice(0, t)),
                      0 === (t -= s))
                    ) {
                      s === n.length
                        ? (++r,
                          e.next
                            ? (this.head = e.next)
                            : (this.head = this.tail = null))
                        : ((this.head = e).data = n.slice(s));
                      break;
                    }
                    ++r;
                  }
                  return (this.length -= r), i;
                },
              },
              {
                key: '_getBuffer',
                value: function(t) {
                  var e = a.allocUnsafe(t),
                    r = this.head,
                    i = 1;
                  for (r.data.copy(e), t -= r.data.length; (r = r.next); ) {
                    var n = r.data,
                      s = t > n.length ? n.length : t;
                    if ((n.copy(e, e.length - t, 0, s), 0 === (t -= s))) {
                      s === n.length
                        ? (++i,
                          r.next
                            ? (this.head = r.next)
                            : (this.head = this.tail = null))
                        : ((this.head = r).data = n.slice(s));
                      break;
                    }
                    ++i;
                  }
                  return (this.length -= i), e;
                },
              },
              {
                key: h,
                value: function(t, e) {
                  return f(this, n({}, e, { depth: 0, customInspect: !1 }));
                },
              },
            ]) && o(e.prototype, r),
            i && o(e, i),
            t
          );
        })();
      },
      { buffer: 64, util: 20 },
    ],
    56: [
      function(t, e, r) {
        !function(f) {
          !function() {
            'use strict';
            function s(t, e) {
              a(t, e), o(t);
            }
            function o(t) {
              (t._writableState && !t._writableState.emitClose) ||
                (t._readableState && !t._readableState.emitClose) ||
                t.emit('close');
            }
            function a(t, e) {
              t.emit('error', e);
            }
            e.exports = {
              destroy: function(t, e) {
                var r = this,
                  i = this._readableState && this._readableState.destroyed,
                  n = this._writableState && this._writableState.destroyed;
                return (
                  i || n
                    ? e
                      ? e(t)
                      : t &&
                        (this._writableState
                          ? this._writableState.errorEmitted ||
                            ((this._writableState.errorEmitted = !0),
                            f.nextTick(a, this, t))
                          : f.nextTick(a, this, t))
                    : (this._readableState &&
                        (this._readableState.destroyed = !0),
                      this._writableState &&
                        (this._writableState.destroyed = !0),
                      this._destroy(t || null, function(t) {
                        !e && t
                          ? r._writableState
                            ? r._writableState.errorEmitted
                              ? f.nextTick(o, r)
                              : ((r._writableState.errorEmitted = !0),
                                f.nextTick(s, r, t))
                            : f.nextTick(s, r, t)
                          : e
                          ? (f.nextTick(o, r), e(t))
                          : f.nextTick(o, r);
                      })),
                  this
                );
              },
              undestroy: function() {
                this._readableState &&
                  ((this._readableState.destroyed = !1),
                  (this._readableState.reading = !1),
                  (this._readableState.ended = !1),
                  (this._readableState.endEmitted = !1)),
                  this._writableState &&
                    ((this._writableState.destroyed = !1),
                    (this._writableState.ended = !1),
                    (this._writableState.ending = !1),
                    (this._writableState.finalCalled = !1),
                    (this._writableState.prefinished = !1),
                    (this._writableState.finished = !1),
                    (this._writableState.errorEmitted = !1));
              },
              errorOrDestroy: function(t, e) {
                var r = t._readableState,
                  i = t._writableState;
                (r && r.autoDestroy) || (i && i.autoDestroy)
                  ? t.destroy(e)
                  : t.emit('error', e);
              },
            };
          }.call(this);
        }.call(this, t('_process'));
      },
      { _process: 150 },
    ],
    57: [
      function(t, e, r) {
        'use strict';
        var y = t('../../../errors').codes.ERR_STREAM_PREMATURE_CLOSE;
        function g() {}
        e.exports = function t(e, r, i) {
          if ('function' == typeof r) return t(e, null, r);
          var n, s;
          (n = i || g),
            (s = !1),
            (i = function() {
              if (!s) {
                s = !0;
                for (
                  var t = arguments.length, e = new Array(t), r = 0;
                  r < t;
                  r++
                )
                  e[r] = arguments[r];
                n.apply(this, e);
              }
            });
          function o() {
            e.writable || a();
          }
          function a() {
            (b = !(p = !1)), l || i.call(e);
          }
          function f() {
            (m = !(l = !1)), p || i.call(e);
          }
          function h(t) {
            i.call(e, t);
          }
          function c() {
            var t;
            return l && !m
              ? ((e._readableState && e._readableState.ended) || (t = new y()),
                i.call(e, t))
              : p && !b
              ? ((e._writableState && e._writableState.ended) || (t = new y()),
                i.call(e, t))
              : void 0;
          }
          function u() {
            e.req.on('finish', a);
          }
          var d,
            l = (r = r || {}).readable || (!1 !== r.readable && e.readable),
            p = r.writable || (!1 !== r.writable && e.writable),
            b = e._writableState && e._writableState.finished,
            m = e._readableState && e._readableState.endEmitted;
          return (
            (d = e).setHeader && 'function' == typeof d.abort
              ? (e.on('complete', a),
                e.on('abort', c),
                e.req ? u() : e.on('request', u))
              : p && !e._writableState && (e.on('end', o), e.on('close', o)),
            e.on('end', f),
            e.on('finish', a),
            !1 !== r.error && e.on('error', h),
            e.on('close', c),
            function() {
              e.removeListener('complete', a),
                e.removeListener('abort', c),
                e.removeListener('request', u),
                e.req && e.req.removeListener('finish', a),
                e.removeListener('end', o),
                e.removeListener('close', o),
                e.removeListener('finish', a),
                e.removeListener('end', f),
                e.removeListener('error', h),
                e.removeListener('close', c);
            }
          );
        };
      },
      { '../../../errors': 48 },
    ],
    58: [
      function(t, e, r) {
        e.exports = function() {
          throw new Error('Readable.from is not available in the browser');
        };
      },
      {},
    ],
    59: [
      function(f, t, e) {
        'use strict';
        var h;
        var r = f('../../../errors').codes,
          a = r.ERR_MISSING_ARGS,
          c = r.ERR_STREAM_DESTROYED;
        function u(t) {
          if (t) throw t;
        }
        function d(r, t, e, i) {
          var n, s;
          (n = i), (s = !1);
          var o = !(i = function() {
            s || ((s = !0), n.apply(void 0, arguments));
          });
          r.on('close', function() {
            o = !0;
          }),
            (h = void 0 === h ? f('./end-of-stream') : h)(
              r,
              { readable: t, writable: e },
              function(t) {
                return t ? i(t) : ((o = !0), void i());
              }
            );
          var a = !1;
          return function(t) {
            var e;
            if (!o && !a)
              return (
                (a = !0),
                (e = r).setHeader && 'function' == typeof e.abort
                  ? r.abort()
                  : 'function' == typeof r.destroy
                  ? r.destroy()
                  : void i(t || new c('pipe'))
              );
          };
        }
        function l(t) {
          t();
        }
        function p(t, e) {
          return t.pipe(e);
        }
        t.exports = function() {
          for (var t = arguments.length, i = new Array(t), e = 0; e < t; e++)
            i[e] = arguments[e];
          var r,
            n,
            s =
              !(r = i).length || 'function' != typeof r[r.length - 1]
                ? u
                : r.pop();
          if ((i = Array.isArray(i[0]) ? i[0] : i).length < 2)
            throw new a('streams');
          var o = i.map(function(t, e) {
            var r = e < i.length - 1;
            return d(t, r, 0 < e, function(t) {
              (n = n || t), t && o.forEach(l), r || (o.forEach(l), s(n));
            });
          });
          return i.reduce(p);
        };
      },
      { '../../../errors': 48, './end-of-stream': 57 },
    ],
    60: [
      function(t, e, r) {
        'use strict';
        var o = t('../../../errors').codes.ERR_INVALID_OPT_VALUE;
        e.exports = {
          getHighWaterMark: function(t, e, r, i) {
            var n,
              s =
                ((n = i),
                (s = r),
                null != (e = e).highWaterMark
                  ? e.highWaterMark
                  : n
                  ? e[s]
                  : null);
            if (null == s) return t.objectMode ? 16 : 16384;
            if (!isFinite(s) || Math.floor(s) !== s || s < 0)
              throw new o(i ? r : 'highWaterMark', s);
            return Math.floor(s);
          },
        };
      },
      { '../../../errors': 48 },
    ],
    61: [
      function(t, e, r) {
        e.exports = t('events').EventEmitter;
      },
      { events: 101 },
    ],
    62: [
      function(t, e, r) {
        ((((r = e.exports = t(
          './lib/_stream_readable.js'
        )).Stream = r).Readable = r).Writable = t('./lib/_stream_writable.js')),
          (r.Duplex = t('./lib/_stream_duplex.js')),
          (r.Transform = t('./lib/_stream_transform.js')),
          (r.PassThrough = t('./lib/_stream_passthrough.js')),
          (r.finished = t('./lib/internal/streams/end-of-stream.js')),
          (r.pipeline = t('./lib/internal/streams/pipeline.js'));
      },
      {
        './lib/_stream_duplex.js': 49,
        './lib/_stream_passthrough.js': 50,
        './lib/_stream_readable.js': 51,
        './lib/_stream_transform.js': 52,
        './lib/_stream_writable.js': 53,
        './lib/internal/streams/end-of-stream.js': 57,
        './lib/internal/streams/pipeline.js': 59,
      },
    ],
    63: [
      function(t, e, r) {
        !function(s) {
          !function() {
            e.exports = function(t, e) {
              for (
                var r = Math.min(t.length, e.length), i = new s(r), n = 0;
                n < r;
                ++n
              )
                i[n] = t[n] ^ e[n];
              return i;
            };
          }.call(this);
        }.call(this, t('buffer').Buffer);
      },
      { buffer: 64 },
    ],
    64: [
      function(j, t, T) {
        !function(t) {
          !function() {
            'use strict';
            var a = j('base64-js'),
              s = j('ieee754');
            (T.Buffer = u),
              (T.SlowBuffer = function(t) {
                +t != t && (t = 0);
                return u.alloc(+t);
              }),
              (T.INSPECT_MAX_BYTES = 50);
            var e = 2147483647;
            function n(t) {
              if (e < t)
                throw new RangeError(
                  'The value "' + t + '" is invalid for option "size"'
                );
              t = new Uint8Array(t);
              return (t.__proto__ = u.prototype), t;
            }
            function u(t, e, r) {
              if ('number' != typeof t) return i(t, e, r);
              if ('string' == typeof e)
                throw new TypeError(
                  'The "string" argument must be of type string. Received type number'
                );
              return f(t);
            }
            function i(t, e, r) {
              if ('string' == typeof t)
                return (function(t, e) {
                  ('string' == typeof e && '' !== e) || (e = 'utf8');
                  if (!u.isEncoding(e))
                    throw new TypeError('Unknown encoding: ' + e);
                  var r = 0 | d(t, e),
                    i = n(r),
                    e = i.write(t, e);
                  e !== r && (i = i.slice(0, e));
                  return i;
                })(t, e);
              if (ArrayBuffer.isView(t)) return h(t);
              if (null == t)
                throw TypeError(
                  'The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type ' +
                    typeof t
                );
              if (I(t, ArrayBuffer) || (t && I(t.buffer, ArrayBuffer)))
                return (function(t, e, r) {
                  if (e < 0 || t.byteLength < e)
                    throw new RangeError(
                      '"offset" is outside of buffer bounds'
                    );
                  if (t.byteLength < e + (r || 0))
                    throw new RangeError(
                      '"length" is outside of buffer bounds'
                    );
                  r =
                    void 0 === e && void 0 === r
                      ? new Uint8Array(t)
                      : void 0 === r
                      ? new Uint8Array(t, e)
                      : new Uint8Array(t, e, r);
                  return (r.__proto__ = u.prototype), r;
                })(t, e, r);
              if ('number' == typeof t)
                throw new TypeError(
                  'The "value" argument must not be of type number. Received type number'
                );
              var i = t.valueOf && t.valueOf();
              if (null != i && i !== t) return u.from(i, e, r);
              i = (function(t) {
                if (u.isBuffer(t)) {
                  var e = 0 | c(t.length),
                    r = n(e);
                  return 0 === r.length ? r : (t.copy(r, 0, 0, e), r);
                }
                if (void 0 !== t.length)
                  return 'number' != typeof t.length || R(t.length)
                    ? n(0)
                    : h(t);
                if ('Buffer' === t.type && Array.isArray(t.data))
                  return h(t.data);
              })(t);
              if (i) return i;
              if (
                'undefined' != typeof Symbol &&
                null != Symbol.toPrimitive &&
                'function' == typeof t[Symbol.toPrimitive]
              )
                return u.from(t[Symbol.toPrimitive]('string'), e, r);
              throw new TypeError(
                'The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type ' +
                  typeof t
              );
            }
            function o(t) {
              if ('number' != typeof t)
                throw new TypeError('"size" argument must be of type number');
              if (t < 0)
                throw new RangeError(
                  'The value "' + t + '" is invalid for option "size"'
                );
            }
            function f(t) {
              return o(t), n(t < 0 ? 0 : 0 | c(t));
            }
            function h(t) {
              for (
                var e = t.length < 0 ? 0 : 0 | c(t.length), r = n(e), i = 0;
                i < e;
                i += 1
              )
                r[i] = 255 & t[i];
              return r;
            }
            function c(t) {
              if (e <= t)
                throw new RangeError(
                  'Attempt to allocate Buffer larger than maximum size: 0x' +
                    e.toString(16) +
                    ' bytes'
                );
              return 0 | t;
            }
            function d(t, e) {
              if (u.isBuffer(t)) return t.length;
              if (ArrayBuffer.isView(t) || I(t, ArrayBuffer))
                return t.byteLength;
              if ('string' != typeof t)
                throw new TypeError(
                  'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' +
                    typeof t
                );
              var r = t.length,
                i = 2 < arguments.length && !0 === arguments[2];
              if (!i && 0 === r) return 0;
              for (var n = !1; ; )
                switch (e) {
                  case 'ascii':
                  case 'latin1':
                  case 'binary':
                    return r;
                  case 'utf8':
                  case 'utf-8':
                    return A(t).length;
                  case 'ucs2':
                  case 'ucs-2':
                  case 'utf16le':
                  case 'utf-16le':
                    return 2 * r;
                  case 'hex':
                    return r >>> 1;
                  case 'base64':
                    return x(t).length;
                  default:
                    if (n) return i ? -1 : A(t).length;
                    (e = ('' + e).toLowerCase()), (n = !0);
                }
            }
            function r(t, e, r) {
              var i,
                n,
                s,
                o = !1;
              if ((e = void 0 === e || e < 0 ? 0 : e) > this.length) return '';
              if ((r = void 0 === r || r > this.length ? this.length : r) <= 0)
                return '';
              if ((r >>>= 0) <= (e >>>= 0)) return '';
              for (t = t || 'utf8'; ; )
                switch (t) {
                  case 'hex':
                    return (function(t, e, r) {
                      var i = t.length;
                      (!e || e < 0) && (e = 0);
                      (!r || r < 0 || i < r) && (r = i);
                      for (var n = '', s = e; s < r; ++s)
                        n += (function(t) {
                          return t < 16 ? '0' + t.toString(16) : t.toString(16);
                        })(t[s]);
                      return n;
                    })(this, e, r);
                  case 'utf8':
                  case 'utf-8':
                    return g(this, e, r);
                  case 'ascii':
                    return (function(t, e, r) {
                      var i = '';
                      r = Math.min(t.length, r);
                      for (var n = e; n < r; ++n)
                        i += String.fromCharCode(127 & t[n]);
                      return i;
                    })(this, e, r);
                  case 'latin1':
                  case 'binary':
                    return (function(t, e, r) {
                      var i = '';
                      r = Math.min(t.length, r);
                      for (var n = e; n < r; ++n)
                        i += String.fromCharCode(t[n]);
                      return i;
                    })(this, e, r);
                  case 'base64':
                    return (
                      (i = this),
                      (s = r),
                      0 === (n = e) && s === i.length
                        ? a.fromByteArray(i)
                        : a.fromByteArray(i.slice(n, s))
                    );
                  case 'ucs2':
                  case 'ucs-2':
                  case 'utf16le':
                  case 'utf-16le':
                    return (function(t, e, r) {
                      for (
                        var i = t.slice(e, r), n = '', s = 0;
                        s < i.length;
                        s += 2
                      )
                        n += String.fromCharCode(i[s] + 256 * i[s + 1]);
                      return n;
                    })(this, e, r);
                  default:
                    if (o) throw new TypeError('Unknown encoding: ' + t);
                    (t = (t + '').toLowerCase()), (o = !0);
                }
            }
            function l(t, e, r) {
              var i = t[e];
              (t[e] = t[r]), (t[r] = i);
            }
            function p(t, e, r, i, n) {
              if (0 === t.length) return -1;
              if (
                ('string' == typeof r
                  ? ((i = r), (r = 0))
                  : 2147483647 < r
                  ? (r = 2147483647)
                  : r < -2147483648 && (r = -2147483648),
                (r =
                  (r = R((r = +r)) ? (n ? 0 : t.length - 1) : r) < 0
                    ? t.length + r
                    : r) >= t.length)
              ) {
                if (n) return -1;
                r = t.length - 1;
              } else if (r < 0) {
                if (!n) return -1;
                r = 0;
              }
              if (('string' == typeof e && (e = u.from(e, i)), u.isBuffer(e)))
                return 0 === e.length ? -1 : b(t, e, r, i, n);
              if ('number' == typeof e)
                return (
                  (e &= 255),
                  'function' == typeof Uint8Array.prototype.indexOf
                    ? (n
                        ? Uint8Array.prototype.indexOf
                        : Uint8Array.prototype.lastIndexOf
                      ).call(t, e, r)
                    : b(t, [e], r, i, n)
                );
              throw new TypeError('val must be string, number or Buffer');
            }
            function b(t, e, r, i, n) {
              var s = 1,
                o = t.length,
                a = e.length;
              if (
                void 0 !== i &&
                ('ucs2' === (i = String(i).toLowerCase()) ||
                  'ucs-2' === i ||
                  'utf16le' === i ||
                  'utf-16le' === i)
              ) {
                if (t.length < 2 || e.length < 2) return -1;
                (o /= s = 2), (a /= 2), (r /= 2);
              }
              function f(t, e) {
                return 1 === s ? t[e] : t.readUInt16BE(e * s);
              }
              if (n)
                for (var h = -1, c = r; c < o; c++)
                  if (f(t, c) === f(e, -1 === h ? 0 : c - h)) {
                    if (c - (h = -1 === h ? c : h) + 1 === a) return h * s;
                  } else -1 !== h && (c -= c - h), (h = -1);
              else
                for (c = r = o < r + a ? o - a : r; 0 <= c; c--) {
                  for (var u = !0, d = 0; d < a; d++)
                    if (f(t, c + d) !== f(e, d)) {
                      u = !1;
                      break;
                    }
                  if (u) return c;
                }
              return -1;
            }
            function m(t, e, r, i) {
              return B(
                (function(t) {
                  for (var e = [], r = 0; r < t.length; ++r)
                    e.push(255 & t.charCodeAt(r));
                  return e;
                })(e),
                t,
                r,
                i
              );
            }
            function y(t, e, r, i) {
              return B(
                (function(t, e) {
                  for (
                    var r, i, n = [], s = 0;
                    s < t.length && !((e -= 2) < 0);
                    ++s
                  )
                    (i = t.charCodeAt(s)),
                      (r = i >> 8),
                      (i = i % 256),
                      n.push(i),
                      n.push(r);
                  return n;
                })(e, t.length - r),
                t,
                r,
                i
              );
            }
            function g(t, e, r) {
              r = Math.min(t.length, r);
              for (var i = [], n = e; n < r; ) {
                var s,
                  o,
                  a,
                  f,
                  h = t[n],
                  c = null,
                  u = 239 < h ? 4 : 223 < h ? 3 : 191 < h ? 2 : 1;
                if (n + u <= r)
                  switch (u) {
                    case 1:
                      h < 128 && (c = h);
                      break;
                    case 2:
                      128 == (192 & (s = t[n + 1])) &&
                        127 < (f = ((31 & h) << 6) | (63 & s)) &&
                        (c = f);
                      break;
                    case 3:
                      (s = t[n + 1]),
                        (o = t[n + 2]),
                        128 == (192 & s) &&
                          128 == (192 & o) &&
                          2047 <
                            (f =
                              ((15 & h) << 12) | ((63 & s) << 6) | (63 & o)) &&
                          (f < 55296 || 57343 < f) &&
                          (c = f);
                      break;
                    case 4:
                      (s = t[n + 1]),
                        (o = t[n + 2]),
                        (a = t[n + 3]),
                        128 == (192 & s) &&
                          128 == (192 & o) &&
                          128 == (192 & a) &&
                          65535 <
                            (f =
                              ((15 & h) << 18) |
                              ((63 & s) << 12) |
                              ((63 & o) << 6) |
                              (63 & a)) &&
                          f < 1114112 &&
                          (c = f);
                  }
                null === c
                  ? ((c = 65533), (u = 1))
                  : 65535 < c &&
                    ((c -= 65536),
                    i.push(((c >>> 10) & 1023) | 55296),
                    (c = 56320 | (1023 & c))),
                  i.push(c),
                  (n += u);
              }
              return (function(t) {
                var e = t.length;
                if (e <= v) return String.fromCharCode.apply(String, t);
                var r = '',
                  i = 0;
                for (; i < e; )
                  r += String.fromCharCode.apply(String, t.slice(i, (i += v)));
                return r;
              })(i);
            }
            (T.kMaxLength = e),
              (u.TYPED_ARRAY_SUPPORT = (function() {
                try {
                  var t = new Uint8Array(1);
                  return (
                    (t.__proto__ = {
                      __proto__: Uint8Array.prototype,
                      foo: function() {
                        return 42;
                      },
                    }),
                    42 === t.foo()
                  );
                } catch (t) {
                  return !1;
                }
              })()) ||
                'undefined' == typeof console ||
                'function' != typeof console.error ||
                console.error(
                  'This browser lacks typed array (Uint8Array) support which is reqqqd by `buffer` v5.x. Use `buffer` v4.x if you reqqq old browser support.'
                ),
              Object.defineProperty(u.prototype, 'parent', {
                enumerable: !0,
                get: function() {
                  if (u.isBuffer(this)) return this.buffer;
                },
              }),
              Object.defineProperty(u.prototype, 'offset', {
                enumerable: !0,
                get: function() {
                  if (u.isBuffer(this)) return this.byteOffset;
                },
              }),
              'undefined' != typeof Symbol &&
                null != Symbol.species &&
                u[Symbol.species] === u &&
                Object.defineProperty(u, Symbol.species, {
                  value: null,
                  configurable: !0,
                  enumerable: !1,
                  writable: !1,
                }),
              (u.poolSize = 8192),
              (u.from = i),
              (u.prototype.__proto__ = Uint8Array.prototype),
              (u.__proto__ = Uint8Array),
              (u.alloc = function(t, e, r) {
                return (
                  (e = e),
                  (r = r),
                  o((t = t)),
                  !(t <= 0) && void 0 !== e
                    ? 'string' == typeof r
                      ? n(t).fill(e, r)
                      : n(t).fill(e)
                    : n(t)
                );
              }),
              (u.allocUnsafe = f),
              (u.allocUnsafeSlow = f),
              (u.isBuffer = function(t) {
                return null != t && !0 === t._isBuffer && t !== u.prototype;
              }),
              (u.compare = function(t, e) {
                if (
                  (I(t, Uint8Array) && (t = u.from(t, t.offset, t.byteLength)),
                  I(e, Uint8Array) && (e = u.from(e, e.offset, e.byteLength)),
                  !u.isBuffer(t) || !u.isBuffer(e))
                )
                  throw new TypeError(
                    'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
                  );
                if (t === e) return 0;
                for (
                  var r = t.length, i = e.length, n = 0, s = Math.min(r, i);
                  n < s;
                  ++n
                )
                  if (t[n] !== e[n]) {
                    (r = t[n]), (i = e[n]);
                    break;
                  }
                return r < i ? -1 : i < r ? 1 : 0;
              }),
              (u.isEncoding = function(t) {
                switch (String(t).toLowerCase()) {
                  case 'hex':
                  case 'utf8':
                  case 'utf-8':
                  case 'ascii':
                  case 'latin1':
                  case 'binary':
                  case 'base64':
                  case 'ucs2':
                  case 'ucs-2':
                  case 'utf16le':
                  case 'utf-16le':
                    return !0;
                  default:
                    return !1;
                }
              }),
              (u.concat = function(t, e) {
                if (!Array.isArray(t))
                  throw new TypeError(
                    '"list" argument must be an Array of Buffers'
                  );
                if (0 === t.length) return u.alloc(0);
                if (void 0 === e)
                  for (n = e = 0; n < t.length; ++n) e += t[n].length;
                for (
                  var r = u.allocUnsafe(e), i = 0, n = 0;
                  n < t.length;
                  ++n
                ) {
                  var s = t[n];
                  if ((I(s, Uint8Array) && (s = u.from(s)), !u.isBuffer(s)))
                    throw new TypeError(
                      '"list" argument must be an Array of Buffers'
                    );
                  s.copy(r, i), (i += s.length);
                }
                return r;
              }),
              (u.byteLength = d),
              (u.prototype._isBuffer = !0),
              (u.prototype.swap16 = function() {
                var t = this.length;
                if (t % 2 != 0)
                  throw new RangeError(
                    'Buffer size must be a multiple of 16-bits'
                  );
                for (var e = 0; e < t; e += 2) l(this, e, e + 1);
                return this;
              }),
              (u.prototype.swap32 = function() {
                var t = this.length;
                if (t % 4 != 0)
                  throw new RangeError(
                    'Buffer size must be a multiple of 32-bits'
                  );
                for (var e = 0; e < t; e += 4)
                  l(this, e, e + 3), l(this, e + 1, e + 2);
                return this;
              }),
              (u.prototype.swap64 = function() {
                var t = this.length;
                if (t % 8 != 0)
                  throw new RangeError(
                    'Buffer size must be a multiple of 64-bits'
                  );
                for (var e = 0; e < t; e += 8)
                  l(this, e, e + 7),
                    l(this, e + 1, e + 6),
                    l(this, e + 2, e + 5),
                    l(this, e + 3, e + 4);
                return this;
              }),
              (u.prototype.toLocaleString = u.prototype.toString = function() {
                var t = this.length;
                return 0 === t
                  ? ''
                  : 0 === arguments.length
                  ? g(this, 0, t)
                  : r.apply(this, arguments);
              }),
              (u.prototype.equals = function(t) {
                if (!u.isBuffer(t))
                  throw new TypeError('Argument must be a Buffer');
                return this === t || 0 === u.compare(this, t);
              }),
              (u.prototype.inspect = function() {
                var t = '',
                  e = T.INSPECT_MAX_BYTES,
                  t = this.toString('hex', 0, e)
                    .replace(/(.{2})/g, '$1 ')
                    .trim();
                return this.length > e && (t += ' ... '), '<Buffer ' + t + '>';
              }),
              (u.prototype.compare = function(t, e, r, i, n) {
                if (
                  (I(t, Uint8Array) && (t = u.from(t, t.offset, t.byteLength)),
                  !u.isBuffer(t))
                )
                  throw new TypeError(
                    'The "target" argument must be one of type Buffer or Uint8Array. Received type ' +
                      typeof t
                  );
                if (
                  (void 0 === r && (r = t ? t.length : 0),
                  void 0 === i && (i = 0),
                  void 0 === n && (n = this.length),
                  (e = void 0 === e ? 0 : e) < 0 ||
                    r > t.length ||
                    i < 0 ||
                    n > this.length)
                )
                  throw new RangeError('out of range index');
                if (n <= i && r <= e) return 0;
                if (n <= i) return -1;
                if (r <= e) return 1;
                if (this === t) return 0;
                for (
                  var s = (n >>>= 0) - (i >>>= 0),
                    o = (r >>>= 0) - (e >>>= 0),
                    a = Math.min(s, o),
                    f = this.slice(i, n),
                    h = t.slice(e, r),
                    c = 0;
                  c < a;
                  ++c
                )
                  if (f[c] !== h[c]) {
                    (s = f[c]), (o = h[c]);
                    break;
                  }
                return s < o ? -1 : o < s ? 1 : 0;
              }),
              (u.prototype.includes = function(t, e, r) {
                return -1 !== this.indexOf(t, e, r);
              }),
              (u.prototype.indexOf = function(t, e, r) {
                return p(this, t, e, r, !0);
              }),
              (u.prototype.lastIndexOf = function(t, e, r) {
                return p(this, t, e, r, !1);
              }),
              (u.prototype.write = function(t, e, r, i) {
                if (void 0 === e) (i = 'utf8'), (r = this.length), (e = 0);
                else if (void 0 === r && 'string' == typeof e)
                  (i = e), (r = this.length), (e = 0);
                else {
                  if (!isFinite(e))
                    throw new Error(
                      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
                    );
                  (e >>>= 0),
                    isFinite(r)
                      ? ((r >>>= 0), void 0 === i && (i = 'utf8'))
                      : ((i = r), (r = void 0));
                }
                var n = this.length - e;
                if (
                  ((void 0 === r || n < r) && (r = n),
                  (0 < t.length && (r < 0 || e < 0)) || e > this.length)
                )
                  throw new RangeError(
                    'Attempt to write outside buffer bounds'
                  );
                i = i || 'utf8';
                for (var s, o, a, f = !1; ; )
                  switch (i) {
                    case 'hex':
                      return (function(t, e, r, i) {
                        r = Number(r) || 0;
                        var n = t.length - r;
                        (!i || n < (i = Number(i))) && (i = n),
                          (n = e.length) / 2 < i && (i = n / 2);
                        for (var s = 0; s < i; ++s) {
                          var o = parseInt(e.substr(2 * s, 2), 16);
                          if (R(o)) return s;
                          t[r + s] = o;
                        }
                        return s;
                      })(this, t, e, r);
                    case 'utf8':
                    case 'utf-8':
                      return (
                        (o = e),
                        (a = r),
                        B(A(t, (s = this).length - o), s, o, a)
                      );
                    case 'ascii':
                      return m(this, t, e, r);
                    case 'latin1':
                    case 'binary':
                      return m(this, t, e, r);
                    case 'base64':
                      return (s = this), (o = e), (a = r), B(x(t), s, o, a);
                    case 'ucs2':
                    case 'ucs-2':
                    case 'utf16le':
                    case 'utf-16le':
                      return y(this, t, e, r);
                    default:
                      if (f) throw new TypeError('Unknown encoding: ' + i);
                      (i = ('' + i).toLowerCase()), (f = !0);
                  }
              }),
              (u.prototype.toJSON = function() {
                return {
                  type: 'Buffer',
                  data: Array.prototype.slice.call(this._arr || this, 0),
                };
              });
            var v = 4096;
            function _(t, e, r) {
              if (t % 1 != 0 || t < 0)
                throw new RangeError('offset is not uint');
              if (r < t + e)
                throw new RangeError('Trying to access beyond buffer length');
            }
            function w(t, e, r, i, n, s) {
              if (!u.isBuffer(t))
                throw new TypeError(
                  '"buffer" argument must be a Buffer instance'
                );
              if (n < e || e < s)
                throw new RangeError('"value" argument is out of bounds');
              if (r + i > t.length) throw new RangeError('Index out of range');
            }
            function M(t, e, r, i) {
              if (r + i > t.length) throw new RangeError('Index out of range');
              if (r < 0) throw new RangeError('Index out of range');
            }
            function S(t, e, r, i, n) {
              return (
                (e = +e),
                (r >>>= 0),
                n || M(t, 0, r, 4),
                s.write(t, e, r, i, 23, 4),
                r + 4
              );
            }
            function E(t, e, r, i, n) {
              return (
                (e = +e),
                (r >>>= 0),
                n || M(t, 0, r, 8),
                s.write(t, e, r, i, 52, 8),
                r + 8
              );
            }
            (u.prototype.slice = function(t, e) {
              var r = this.length;
              (t = ~~t) < 0 ? (t += r) < 0 && (t = 0) : r < t && (t = r),
                (e = void 0 === e ? r : ~~e) < 0
                  ? (e += r) < 0 && (e = 0)
                  : r < e && (e = r),
                e < t && (e = t);
              e = this.subarray(t, e);
              return (e.__proto__ = u.prototype), e;
            }),
              (u.prototype.readUIntLE = function(t, e, r) {
                (t >>>= 0), (e >>>= 0), r || _(t, e, this.length);
                for (var i = this[t], n = 1, s = 0; ++s < e && (n *= 256); )
                  i += this[t + s] * n;
                return i;
              }),
              (u.prototype.readUIntBE = function(t, e, r) {
                (t >>>= 0), (e >>>= 0), r || _(t, e, this.length);
                for (var i = this[t + --e], n = 1; 0 < e && (n *= 256); )
                  i += this[t + --e] * n;
                return i;
              }),
              (u.prototype.readUInt8 = function(t, e) {
                return (t >>>= 0), e || _(t, 1, this.length), this[t];
              }),
              (u.prototype.readUInt16LE = function(t, e) {
                return (
                  (t >>>= 0),
                  e || _(t, 2, this.length),
                  this[t] | (this[t + 1] << 8)
                );
              }),
              (u.prototype.readUInt16BE = function(t, e) {
                return (
                  (t >>>= 0),
                  e || _(t, 2, this.length),
                  (this[t] << 8) | this[t + 1]
                );
              }),
              (u.prototype.readUInt32LE = function(t, e) {
                return (
                  (t >>>= 0),
                  e || _(t, 4, this.length),
                  (this[t] | (this[t + 1] << 8) | (this[t + 2] << 16)) +
                    16777216 * this[t + 3]
                );
              }),
              (u.prototype.readUInt32BE = function(t, e) {
                return (
                  (t >>>= 0),
                  e || _(t, 4, this.length),
                  16777216 * this[t] +
                    ((this[t + 1] << 16) | (this[t + 2] << 8) | this[t + 3])
                );
              }),
              (u.prototype.readIntLE = function(t, e, r) {
                (t >>>= 0), (e >>>= 0), r || _(t, e, this.length);
                for (var i = this[t], n = 1, s = 0; ++s < e && (n *= 256); )
                  i += this[t + s] * n;
                return (n *= 128) <= i && (i -= Math.pow(2, 8 * e)), i;
              }),
              (u.prototype.readIntBE = function(t, e, r) {
                (t >>>= 0), (e >>>= 0), r || _(t, e, this.length);
                for (var i = e, n = 1, s = this[t + --i]; 0 < i && (n *= 256); )
                  s += this[t + --i] * n;
                return (n *= 128) <= s && (s -= Math.pow(2, 8 * e)), s;
              }),
              (u.prototype.readInt8 = function(t, e) {
                return (
                  (t >>>= 0),
                  e || _(t, 1, this.length),
                  128 & this[t] ? -1 * (255 - this[t] + 1) : this[t]
                );
              }),
              (u.prototype.readInt16LE = function(t, e) {
                (t >>>= 0), e || _(t, 2, this.length);
                t = this[t] | (this[t + 1] << 8);
                return 32768 & t ? 4294901760 | t : t;
              }),
              (u.prototype.readInt16BE = function(t, e) {
                (t >>>= 0), e || _(t, 2, this.length);
                t = this[t + 1] | (this[t] << 8);
                return 32768 & t ? 4294901760 | t : t;
              }),
              (u.prototype.readInt32LE = function(t, e) {
                return (
                  (t >>>= 0),
                  e || _(t, 4, this.length),
                  this[t] |
                    (this[t + 1] << 8) |
                    (this[t + 2] << 16) |
                    (this[t + 3] << 24)
                );
              }),
              (u.prototype.readInt32BE = function(t, e) {
                return (
                  (t >>>= 0),
                  e || _(t, 4, this.length),
                  (this[t] << 24) |
                    (this[t + 1] << 16) |
                    (this[t + 2] << 8) |
                    this[t + 3]
                );
              }),
              (u.prototype.readFloatLE = function(t, e) {
                return (
                  (t >>>= 0),
                  e || _(t, 4, this.length),
                  s.read(this, t, !0, 23, 4)
                );
              }),
              (u.prototype.readFloatBE = function(t, e) {
                return (
                  (t >>>= 0),
                  e || _(t, 4, this.length),
                  s.read(this, t, !1, 23, 4)
                );
              }),
              (u.prototype.readDoubleLE = function(t, e) {
                return (
                  (t >>>= 0),
                  e || _(t, 8, this.length),
                  s.read(this, t, !0, 52, 8)
                );
              }),
              (u.prototype.readDoubleBE = function(t, e) {
                return (
                  (t >>>= 0),
                  e || _(t, 8, this.length),
                  s.read(this, t, !1, 52, 8)
                );
              }),
              (u.prototype.writeUIntLE = function(t, e, r, i) {
                (t = +t),
                  (e >>>= 0),
                  (r >>>= 0),
                  i || w(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
                var n = 1,
                  s = 0;
                for (this[e] = 255 & t; ++s < r && (n *= 256); )
                  this[e + s] = (t / n) & 255;
                return e + r;
              }),
              (u.prototype.writeUIntBE = function(t, e, r, i) {
                (t = +t),
                  (e >>>= 0),
                  (r >>>= 0),
                  i || w(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
                var n = r - 1,
                  s = 1;
                for (this[e + n] = 255 & t; 0 <= --n && (s *= 256); )
                  this[e + n] = (t / s) & 255;
                return e + r;
              }),
              (u.prototype.writeUInt8 = function(t, e, r) {
                return (
                  (t = +t),
                  (e >>>= 0),
                  r || w(this, t, e, 1, 255, 0),
                  (this[e] = 255 & t),
                  e + 1
                );
              }),
              (u.prototype.writeUInt16LE = function(t, e, r) {
                return (
                  (t = +t),
                  (e >>>= 0),
                  r || w(this, t, e, 2, 65535, 0),
                  (this[e] = 255 & t),
                  (this[e + 1] = t >>> 8),
                  e + 2
                );
              }),
              (u.prototype.writeUInt16BE = function(t, e, r) {
                return (
                  (t = +t),
                  (e >>>= 0),
                  r || w(this, t, e, 2, 65535, 0),
                  (this[e] = t >>> 8),
                  (this[e + 1] = 255 & t),
                  e + 2
                );
              }),
              (u.prototype.writeUInt32LE = function(t, e, r) {
                return (
                  (t = +t),
                  (e >>>= 0),
                  r || w(this, t, e, 4, 4294967295, 0),
                  (this[e + 3] = t >>> 24),
                  (this[e + 2] = t >>> 16),
                  (this[e + 1] = t >>> 8),
                  (this[e] = 255 & t),
                  e + 4
                );
              }),
              (u.prototype.writeUInt32BE = function(t, e, r) {
                return (
                  (t = +t),
                  (e >>>= 0),
                  r || w(this, t, e, 4, 4294967295, 0),
                  (this[e] = t >>> 24),
                  (this[e + 1] = t >>> 16),
                  (this[e + 2] = t >>> 8),
                  (this[e + 3] = 255 & t),
                  e + 4
                );
              }),
              (u.prototype.writeIntLE = function(t, e, r, i) {
                (t = +t),
                  (e >>>= 0),
                  i || w(this, t, e, r, (i = Math.pow(2, 8 * r - 1)) - 1, -i);
                var n = 0,
                  s = 1,
                  o = 0;
                for (this[e] = 255 & t; ++n < r && (s *= 256); )
                  t < 0 && 0 === o && 0 !== this[e + n - 1] && (o = 1),
                    (this[e + n] = (((t / s) >> 0) - o) & 255);
                return e + r;
              }),
              (u.prototype.writeIntBE = function(t, e, r, i) {
                (t = +t),
                  (e >>>= 0),
                  i || w(this, t, e, r, (i = Math.pow(2, 8 * r - 1)) - 1, -i);
                var n = r - 1,
                  s = 1,
                  o = 0;
                for (this[e + n] = 255 & t; 0 <= --n && (s *= 256); )
                  t < 0 && 0 === o && 0 !== this[e + n + 1] && (o = 1),
                    (this[e + n] = (((t / s) >> 0) - o) & 255);
                return e + r;
              }),
              (u.prototype.writeInt8 = function(t, e, r) {
                return (
                  (t = +t),
                  (e >>>= 0),
                  r || w(this, t, e, 1, 127, -128),
                  (this[e] = 255 & (t = t < 0 ? 255 + t + 1 : t)),
                  e + 1
                );
              }),
              (u.prototype.writeInt16LE = function(t, e, r) {
                return (
                  (t = +t),
                  (e >>>= 0),
                  r || w(this, t, e, 2, 32767, -32768),
                  (this[e] = 255 & t),
                  (this[e + 1] = t >>> 8),
                  e + 2
                );
              }),
              (u.prototype.writeInt16BE = function(t, e, r) {
                return (
                  (t = +t),
                  (e >>>= 0),
                  r || w(this, t, e, 2, 32767, -32768),
                  (this[e] = t >>> 8),
                  (this[e + 1] = 255 & t),
                  e + 2
                );
              }),
              (u.prototype.writeInt32LE = function(t, e, r) {
                return (
                  (t = +t),
                  (e >>>= 0),
                  r || w(this, t, e, 4, 2147483647, -2147483648),
                  (this[e] = 255 & t),
                  (this[e + 1] = t >>> 8),
                  (this[e + 2] = t >>> 16),
                  (this[e + 3] = t >>> 24),
                  e + 4
                );
              }),
              (u.prototype.writeInt32BE = function(t, e, r) {
                return (
                  (t = +t),
                  (e >>>= 0),
                  r || w(this, t, e, 4, 2147483647, -2147483648),
                  (this[e] = (t = t < 0 ? 4294967295 + t + 1 : t) >>> 24),
                  (this[e + 1] = t >>> 16),
                  (this[e + 2] = t >>> 8),
                  (this[e + 3] = 255 & t),
                  e + 4
                );
              }),
              (u.prototype.writeFloatLE = function(t, e, r) {
                return S(this, t, e, !0, r);
              }),
              (u.prototype.writeFloatBE = function(t, e, r) {
                return S(this, t, e, !1, r);
              }),
              (u.prototype.writeDoubleLE = function(t, e, r) {
                return E(this, t, e, !0, r);
              }),
              (u.prototype.writeDoubleBE = function(t, e, r) {
                return E(this, t, e, !1, r);
              }),
              (u.prototype.copy = function(t, e, r, i) {
                if (!u.isBuffer(t))
                  throw new TypeError('argument should be a Buffer');
                if (
                  ((r = r || 0),
                  i || 0 === i || (i = this.length),
                  e >= t.length && (e = t.length),
                  (i = 0 < i && i < r ? r : i) === r)
                )
                  return 0;
                if (0 === t.length || 0 === this.length) return 0;
                if ((e = e || 0) < 0)
                  throw new RangeError('targetStart out of bounds');
                if (r < 0 || r >= this.length)
                  throw new RangeError('Index out of range');
                if (i < 0) throw new RangeError('sourceEnd out of bounds');
                i > this.length && (i = this.length);
                var n = (i = t.length - e < i - r ? t.length - e + r : i) - r;
                if (
                  this === t &&
                  'function' == typeof Uint8Array.prototype.copyWithin
                )
                  this.copyWithin(e, r, i);
                else if (this === t && r < e && e < i)
                  for (var s = n - 1; 0 <= s; --s) t[s + e] = this[s + r];
                else Uint8Array.prototype.set.call(t, this.subarray(r, i), e);
                return n;
              }),
              (u.prototype.fill = function(t, e, r, i) {
                if ('string' == typeof t) {
                  if (
                    ('string' == typeof e
                      ? ((i = e), (e = 0), (r = this.length))
                      : 'string' == typeof r && ((i = r), (r = this.length)),
                    void 0 !== i && 'string' != typeof i)
                  )
                    throw new TypeError('encoding must be a string');
                  if ('string' == typeof i && !u.isEncoding(i))
                    throw new TypeError('Unknown encoding: ' + i);
                  var n;
                  1 === t.length &&
                    ((n = t.charCodeAt(0)),
                    (('utf8' === i && n < 128) || 'latin1' === i) && (t = n));
                } else 'number' == typeof t && (t &= 255);
                if (e < 0 || this.length < e || this.length < r)
                  throw new RangeError('Out of range index');
                if (r <= e) return this;
                var s;
                if (
                  ((e >>>= 0),
                  (r = void 0 === r ? this.length : r >>> 0),
                  'number' == typeof (t = t || 0))
                )
                  for (s = e; s < r; ++s) this[s] = t;
                else {
                  var o = u.isBuffer(t) ? t : u.from(t, i),
                    a = o.length;
                  if (0 === a)
                    throw new TypeError(
                      'The value "' + t + '" is invalid for argument "value"'
                    );
                  for (s = 0; s < r - e; ++s) this[s + e] = o[s % a];
                }
                return this;
              });
            var k = /[^+/0-9A-Za-z-_]/g;
            function A(t, e) {
              var r;
              e = e || 1 / 0;
              for (var i = t.length, n = null, s = [], o = 0; o < i; ++o) {
                if (55295 < (r = t.charCodeAt(o)) && r < 57344) {
                  if (!n) {
                    if (56319 < r) {
                      -1 < (e -= 3) && s.push(239, 191, 189);
                      continue;
                    }
                    if (o + 1 === i) {
                      -1 < (e -= 3) && s.push(239, 191, 189);
                      continue;
                    }
                    n = r;
                    continue;
                  }
                  if (r < 56320) {
                    -1 < (e -= 3) && s.push(239, 191, 189), (n = r);
                    continue;
                  }
                  r = 65536 + (((n - 55296) << 10) | (r - 56320));
                } else n && -1 < (e -= 3) && s.push(239, 191, 189);
                if (((n = null), r < 128)) {
                  if (--e < 0) break;
                  s.push(r);
                } else if (r < 2048) {
                  if ((e -= 2) < 0) break;
                  s.push((r >> 6) | 192, (63 & r) | 128);
                } else if (r < 65536) {
                  if ((e -= 3) < 0) break;
                  s.push(
                    (r >> 12) | 224,
                    ((r >> 6) & 63) | 128,
                    (63 & r) | 128
                  );
                } else {
                  if (!(r < 1114112)) throw new Error('Invalid code point');
                  if ((e -= 4) < 0) break;
                  s.push(
                    (r >> 18) | 240,
                    ((r >> 12) & 63) | 128,
                    ((r >> 6) & 63) | 128,
                    (63 & r) | 128
                  );
                }
              }
              return s;
            }
            function x(t) {
              return a.toByteArray(
                (function(t) {
                  if (
                    (t = (t = t.split('=')[0]).trim().replace(k, '')).length < 2
                  )
                    return '';
                  for (; t.length % 4 != 0; ) t += '=';
                  return t;
                })(t)
              );
            }
            function B(t, e, r, i) {
              for (
                var n = 0;
                n < i && !(n + r >= e.length || n >= t.length);
                ++n
              )
                e[n + r] = t[n];
              return n;
            }
            function I(t, e) {
              return (
                t instanceof e ||
                (null != t &&
                  null != t.constructor &&
                  null != t.constructor.name &&
                  t.constructor.name === e.name)
              );
            }
            function R(t) {
              return t != t;
            }
          }.call(this);
        }.call(this, j('buffer').Buffer);
      },
      { 'base64-js': 17, buffer: 64, ieee754: 132 },
    ],
    65: [
      function(t, e, r) {
        var i = t('safe-buffer').Buffer,
          n = t('stream').Transform,
          s = t('string_decoder').StringDecoder;
        function o(t) {
          n.call(this),
            (this.hashMode = 'string' == typeof t),
            this.hashMode
              ? (this[t] = this._finalOrDigest)
              : (this.final = this._finalOrDigest),
            this._final && ((this.__final = this._final), (this._final = null)),
            (this._decoder = null),
            (this._encoding = null);
        }
        t('inherits')(o, n),
          (o.prototype.update = function(t, e, r) {
            'string' == typeof t && (t = i.from(t, e));
            t = this._update(t);
            return this.hashMode ? this : r ? this._toString(t, r) : t;
          }),
          (o.prototype.setAutoPadding = function() {}),
          (o.prototype.getAuthTag = function() {
            throw new Error('trying to get auth tag in unsupported state');
          }),
          (o.prototype.setAuthTag = function() {
            throw new Error('trying to set auth tag in unsupported state');
          }),
          (o.prototype.setAAD = function() {
            throw new Error('trying to set aad in unsupported state');
          }),
          (o.prototype._transform = function(t, e, r) {
            var i;
            try {
              this.hashMode ? this._update(t) : this.push(this._update(t));
            } catch (t) {
              i = t;
            } finally {
              r(i);
            }
          }),
          (o.prototype._flush = function(t) {
            var e;
            try {
              this.push(this.__final());
            } catch (t) {
              e = t;
            }
            t(e);
          }),
          (o.prototype._finalOrDigest = function(t) {
            var e = this.__final() || i.alloc(0);
            return (e = t ? this._toString(e, t, !0) : e);
          }),
          (o.prototype._toString = function(t, e, r) {
            if (
              (this._decoder ||
                ((this._decoder = new s(e)), (this._encoding = e)),
              this._encoding !== e)
            )
              throw new Error("can't switch encodings");
            t = this._decoder.write(t);
            return r && (t += this._decoder.end()), t;
          }),
          (e.exports = o);
      },
      { inherits: 133, 'safe-buffer': 161, stream: 171, string_decoder: 186 },
    ],
    66: [
      function(t, a, e) {
        !function(o) {
          !function() {
            var e = t('elliptic'),
              r = t('bn.js');
            a.exports = function(t) {
              return new n(t);
            };
            var i = {
              secp256k1: { name: 'secp256k1', byteLength: 32 },
              secp224r1: { name: 'p224', byteLength: 28 },
              prime256v1: { name: 'p256', byteLength: 32 },
              prime192v1: { name: 'p192', byteLength: 24 },
              ed25519: { name: 'ed25519', byteLength: 32 },
              secp384r1: { name: 'p384', byteLength: 48 },
              secp521r1: { name: 'p521', byteLength: 66 },
            };
            function n(t) {
              (this.curveType = i[t]),
                this.curveType || (this.curveType = { name: t }),
                (this.curve = new e.ec(this.curveType.name)),
                (this.keys = void 0);
            }
            function s(t, e, r) {
              Array.isArray(t) || (t = t.toArray());
              t = new o(t);
              return (
                r &&
                  t.length < r &&
                  ((r = new o(r - t.length)).fill(0), (t = o.concat([r, t]))),
                e ? t.toString(e) : t
              );
            }
            (i.p224 = i.secp224r1),
              (i.p256 = i.secp256r1 = i.prime256v1),
              (i.p192 = i.secp192r1 = i.prime192v1),
              (i.p384 = i.secp384r1),
              (i.p521 = i.secp521r1),
              (n.prototype.generateKeys = function(t, e) {
                return (
                  (this.keys = this.curve.genKeyPair()), this.getPublicKey(t, e)
                );
              }),
              (n.prototype.computeSecret = function(t, e, r) {
                return (
                  (e = e || 'utf8'),
                  o.isBuffer(t) || (t = new o(t, e)),
                  s(
                    this.curve
                      .keyFromPublic(t)
                      .getPublic()
                      .mul(this.keys.getPrivate())
                      .getX(),
                    r,
                    this.curveType.byteLength
                  )
                );
              }),
              (n.prototype.getPublicKey = function(t, e) {
                var r = this.keys.getPublic('compressed' === e, !0);
                return (
                  'hybrid' === e &&
                    (r[r.length - 1] % 2 ? (r[0] = 7) : (r[0] = 6)),
                  s(r, t)
                );
              }),
              (n.prototype.getPrivateKey = function(t) {
                return s(this.keys.getPrivate(), t);
              }),
              (n.prototype.setPublicKey = function(t, e) {
                return (
                  (e = e || 'utf8'),
                  o.isBuffer(t) || (t = new o(t, e)),
                  this.keys._importPublic(t),
                  this
                );
              }),
              (n.prototype.setPrivateKey = function(t, e) {
                (e = e || 'utf8'), o.isBuffer(t) || (t = new o(t, e));
                t = (t = new r(t)).toString(16);
                return (
                  (this.keys = this.curve.genKeyPair()),
                  this.keys._importPrivate(t),
                  this
                );
              });
          }.call(this);
        }.call(this, t('buffer').Buffer);
      },
      { 'bn.js': 67, buffer: 64, elliptic: 84 },
    ],
    67: [
      function(t, e, r) {
        arguments[4][16][0].apply(r, arguments);
      },
      { buffer: 20, dup: 16 },
    ],
    68: [
      function(t, e, r) {
        'use strict';
        var i = t('inherits'),
          n = t('md5.js'),
          s = t('ripemd160'),
          o = t('sha.js'),
          a = t('cipher-base');
        function f(t) {
          a.call(this, 'digest'), (this._hash = t);
        }
        i(f, a),
          (f.prototype._update = function(t) {
            this._hash.update(t);
          }),
          (f.prototype._final = function() {
            return this._hash.digest();
          }),
          (e.exports = function(t) {
            return 'md5' === (t = t.toLowerCase())
              ? new n()
              : 'rmd160' === t || 'ripemd160' === t
              ? new s()
              : new f(o(t));
          });
      },
      {
        'cipher-base': 65,
        inherits: 133,
        'md5.js': 134,
        ripemd160: 160,
        'sha.js': 164,
      },
    ],
    69: [
      function(t, e, r) {
        var i = t('md5.js');
        e.exports = function(t) {
          return new i().update(t).digest();
        };
      },
      { 'md5.js': 134 },
    ],
    70: [
      function(t, e, r) {
        'use strict';
        var i = t('inherits'),
          n = t('./legacy'),
          o = t('cipher-base'),
          a = t('safe-buffer').Buffer,
          s = t('create-hash/md5'),
          f = t('ripemd160'),
          h = t('sha.js'),
          c = a.alloc(128);
        function u(t, e) {
          o.call(this, 'digest'), 'string' == typeof e && (e = a.from(e));
          var r = 'sha512' === t || 'sha384' === t ? 128 : 64;
          (this._alg = t),
            (this._key = e).length > r
              ? (e = ('rmd160' === t ? new f() : h(t)).update(e).digest())
              : e.length < r && (e = a.concat([e, c], r));
          for (
            var i = (this._ipad = a.allocUnsafe(r)),
              n = (this._opad = a.allocUnsafe(r)),
              s = 0;
            s < r;
            s++
          )
            (i[s] = 54 ^ e[s]), (n[s] = 92 ^ e[s]);
          (this._hash = 'rmd160' === t ? new f() : h(t)), this._hash.update(i);
        }
        i(u, o),
          (u.prototype._update = function(t) {
            this._hash.update(t);
          }),
          (u.prototype._final = function() {
            var t = this._hash.digest();
            return ('rmd160' === this._alg ? new f() : h(this._alg))
              .update(this._opad)
              .update(t)
              .digest();
          }),
          (e.exports = function(t, e) {
            return 'rmd160' === (t = t.toLowerCase()) || 'ripemd160' === t
              ? new u('rmd160', e)
              : 'md5' === t
              ? new n(s, e)
              : new u(t, e);
          });
      },
      {
        './legacy': 71,
        'cipher-base': 65,
        'create-hash/md5': 69,
        inherits: 133,
        ripemd160: 160,
        'safe-buffer': 161,
        'sha.js': 164,
      },
    ],
    71: [
      function(t, e, r) {
        'use strict';
        var i = t('inherits'),
          s = t('safe-buffer').Buffer,
          o = t('cipher-base'),
          a = s.alloc(128);
        function n(t, e) {
          o.call(this, 'digest'),
            'string' == typeof e && (e = s.from(e)),
            (this._alg = t),
            64 < (this._key = e).length
              ? (e = t(e))
              : e.length < 64 && (e = s.concat([e, a], 64));
          for (
            var r = (this._ipad = s.allocUnsafe(64)),
              i = (this._opad = s.allocUnsafe(64)),
              n = 0;
            n < 64;
            n++
          )
            (r[n] = 54 ^ e[n]), (i[n] = 92 ^ e[n]);
          this._hash = [r];
        }
        i(n, o),
          (n.prototype._update = function(t) {
            this._hash.push(t);
          }),
          (n.prototype._final = function() {
            var t = this._alg(s.concat(this._hash));
            return this._alg(s.concat([this._opad, t]));
          }),
          (e.exports = n);
      },
      { 'cipher-base': 65, inherits: 133, 'safe-buffer': 161 },
    ],
    72: [
      function(t, e, r) {
        'use strict';
        (r.randomBytes = r.rng = r.pseudoRandomBytes = r.prng = t(
          'randombytes'
        )),
          (r.createHash = r.Hash = t('create-hash')),
          (r.createHmac = r.Hmac = t('create-hmac'));
        var i = t('browserify-sign/algos'),
          i = Object.keys(i),
          n = [
            'sha1',
            'sha224',
            'sha256',
            'sha384',
            'sha512',
            'md5',
            'rmd160',
          ].concat(i);
        r.getHashes = function() {
          return n;
        };
        i = t('pbkdf2');
        (r.pbkdf2 = i.pbkdf2), (r.pbkdf2Sync = i.pbkdf2Sync);
        i = t('browserify-cipher');
        (r.Cipher = i.Cipher),
          (r.createCipher = i.createCipher),
          (r.Cipheriv = i.Cipheriv),
          (r.createCipheriv = i.createCipheriv),
          (r.Decipher = i.Decipher),
          (r.createDecipher = i.createDecipher),
          (r.Decipheriv = i.Decipheriv),
          (r.createDecipheriv = i.createDecipheriv),
          (r.getCiphers = i.getCiphers),
          (r.listCiphers = i.listCiphers);
        i = t('diffie-hellman');
        (r.DiffieHellmanGroup = i.DiffieHellmanGroup),
          (r.createDiffieHellmanGroup = i.createDiffieHellmanGroup),
          (r.getDiffieHellman = i.getDiffieHellman),
          (r.createDiffieHellman = i.createDiffieHellman),
          (r.DiffieHellman = i.DiffieHellman);
        i = t('browserify-sign');
        (r.createSign = i.createSign),
          (r.Sign = i.Sign),
          (r.createVerify = i.createVerify),
          (r.Verify = i.Verify),
          (r.createECDH = t('create-ecdh'));
        i = t('public-encrypt');
        (r.publicEncrypt = i.publicEncrypt),
          (r.privateEncrypt = i.privateEncrypt),
          (r.publicDecrypt = i.publicDecrypt),
          (r.privateDecrypt = i.privateDecrypt);
        t = t('randomfill');
        (r.randomFill = t.randomFill),
          (r.randomFillSync = t.randomFillSync),
          (r.createCredentials = function() {
            throw new Error(
              [
                'sorry, createCredentials is not implemented yet',
                'we accept pull requests',
                'https://github.com/crypto-browserify/crypto-browserify',
              ].join('\n')
            );
          }),
          (r.constants = {
            DH_CHECK_P_NOT_SAFE_PRIME: 2,
            DH_CHECK_P_NOT_PRIME: 1,
            DH_UNABLE_TO_CHECK_GENERATOR: 4,
            DH_NOT_SUITABLE_GENERATOR: 8,
            NPN_ENABLED: 1,
            ALPN_ENABLED: 1,
            RSA_PKCS1_PADDING: 1,
            RSA_SSLV23_PADDING: 2,
            RSA_NO_PADDING: 3,
            RSA_PKCS1_OAEP_PADDING: 4,
            RSA_X931_PADDING: 5,
            RSA_PKCS1_PSS_PADDING: 6,
            POINT_CONVERSION_COMPRESSED: 2,
            POINT_CONVERSION_UNCOMPRESSED: 4,
            POINT_CONVERSION_HYBRID: 6,
          });
      },
      {
        'browserify-cipher': 38,
        'browserify-sign': 45,
        'browserify-sign/algos': 42,
        'create-ecdh': 66,
        'create-hash': 68,
        'create-hmac': 70,
        'diffie-hellman': 79,
        pbkdf2: 144,
        'public-encrypt': 151,
        randombytes: 158,
        randomfill: 159,
      },
    ],
    73: [
      function(t, e, r) {
        'use strict';
        (r.utils = t('./des/utils')),
          (r.Cipher = t('./des/cipher')),
          (r.DES = t('./des/des')),
          (r.CBC = t('./des/cbc')),
          (r.EDE = t('./des/ede'));
      },
      {
        './des/cbc': 74,
        './des/cipher': 75,
        './des/des': 76,
        './des/ede': 77,
        './des/utils': 78,
      },
    ],
    74: [
      function(t, e, r) {
        'use strict';
        var i = t('minimalistic-assert'),
          s = t('inherits'),
          o = {};
        function n(t) {
          i.equal(t.length, 8, 'Invalid IV length'), (this.iv = new Array(8));
          for (var e = 0; e < this.iv.length; e++) this.iv[e] = t[e];
        }
        (r.instantiate = function(e) {
          function r(t) {
            e.call(this, t), this._cbcInit();
          }
          s(r, e);
          for (var t = Object.keys(o), i = 0; i < t.length; i++) {
            var n = t[i];
            r.prototype[n] = o[n];
          }
          return (
            (r.create = function(t) {
              return new r(t);
            }),
            r
          );
        }),
          (o._cbcInit = function() {
            var t = new n(this.options.iv);
            this._cbcState = t;
          }),
          (o._update = function(t, e, r, i) {
            var n = this._cbcState,
              s = this.constructor.super_.prototype,
              o = n.iv;
            if ('encrypt' === this.type) {
              for (var a = 0; a < this.blockSize; a++) o[a] ^= t[e + a];
              s._update.call(this, o, 0, r, i);
              for (a = 0; a < this.blockSize; a++) o[a] = r[i + a];
            } else {
              s._update.call(this, t, e, r, i);
              for (a = 0; a < this.blockSize; a++) r[i + a] ^= o[a];
              for (a = 0; a < this.blockSize; a++) o[a] = t[e + a];
            }
          });
      },
      { inherits: 133, 'minimalistic-assert': 137 },
    ],
    75: [
      function(t, e, r) {
        'use strict';
        var i = t('minimalistic-assert');
        function n(t) {
          (this.options = t),
            (this.type = this.options.type),
            (this.blockSize = 8),
            this._init(),
            (this.buffer = new Array(this.blockSize)),
            (this.bufferOff = 0);
        }
        ((e.exports = n).prototype._init = function() {}),
          (n.prototype.update = function(t) {
            return 0 === t.length
              ? []
              : 'decrypt' === this.type
              ? this._updateDecrypt(t)
              : this._updateEncrypt(t);
          }),
          (n.prototype._buffer = function(t, e) {
            for (
              var r = Math.min(
                  this.buffer.length - this.bufferOff,
                  t.length - e
                ),
                i = 0;
              i < r;
              i++
            )
              this.buffer[this.bufferOff + i] = t[e + i];
            return (this.bufferOff += r), r;
          }),
          (n.prototype._flushBuffer = function(t, e) {
            return (
              this._update(this.buffer, 0, t, e),
              (this.bufferOff = 0),
              this.blockSize
            );
          }),
          (n.prototype._updateEncrypt = function(t) {
            var e = 0,
              r = 0,
              i = ((this.bufferOff + t.length) / this.blockSize) | 0,
              n = new Array(i * this.blockSize);
            0 !== this.bufferOff &&
              ((e += this._buffer(t, e)),
              this.bufferOff === this.buffer.length &&
                (r += this._flushBuffer(n, r)));
            for (
              var s = t.length - ((t.length - e) % this.blockSize);
              e < s;
              e += this.blockSize
            )
              this._update(t, e, n, r), (r += this.blockSize);
            for (; e < t.length; e++, this.bufferOff++)
              this.buffer[this.bufferOff] = t[e];
            return n;
          }),
          (n.prototype._updateDecrypt = function(t) {
            for (
              var e = 0,
                r = 0,
                i = Math.ceil((this.bufferOff + t.length) / this.blockSize) - 1,
                n = new Array(i * this.blockSize);
              0 < i;
              i--
            )
              (e += this._buffer(t, e)), (r += this._flushBuffer(n, r));
            return (e += this._buffer(t, e)), n;
          }),
          (n.prototype.final = function(t) {
            var e;
            return (
              t && (e = this.update(t)),
              (t =
                'encrypt' === this.type
                  ? this._finalEncrypt()
                  : this._finalDecrypt()),
              e ? e.concat(t) : t
            );
          }),
          (n.prototype._pad = function(t, e) {
            if (0 === e) return !1;
            for (; e < t.length; ) t[e++] = 0;
            return !0;
          }),
          (n.prototype._finalEncrypt = function() {
            if (!this._pad(this.buffer, this.bufferOff)) return [];
            var t = new Array(this.blockSize);
            return this._update(this.buffer, 0, t, 0), t;
          }),
          (n.prototype._unpad = function(t) {
            return t;
          }),
          (n.prototype._finalDecrypt = function() {
            i.equal(
              this.bufferOff,
              this.blockSize,
              'Not enough data to decrypt'
            );
            var t = new Array(this.blockSize);
            return this._flushBuffer(t, 0), this._unpad(t);
          });
      },
      { 'minimalistic-assert': 137 },
    ],
    76: [
      function(t, e, r) {
        'use strict';
        var o = t('minimalistic-assert'),
          i = t('inherits'),
          c = t('./utils'),
          n = t('./cipher');
        function s() {
          (this.tmp = new Array(2)), (this.keys = null);
        }
        function a(t) {
          n.call(this, t);
          var e = new s();
          (this._desState = e), this.deriveKeys(e, t.key);
        }
        i(a, n),
          ((e.exports = a).create = function(t) {
            return new a(t);
          });
        var f = [1, 1, 2, 2, 2, 2, 2, 2, 1, 2, 2, 2, 2, 2, 2, 1];
        (a.prototype.deriveKeys = function(t, e) {
          (t.keys = new Array(32)),
            o.equal(e.length, this.blockSize, 'Invalid key length');
          var r = c.readUInt32BE(e, 0),
            i = c.readUInt32BE(e, 4);
          c.pc1(r, i, t.tmp, 0), (r = t.tmp[0]), (i = t.tmp[1]);
          for (var n = 0; n < t.keys.length; n += 2) {
            var s = f[n >>> 1],
              r = c.r28shl(r, s),
              i = c.r28shl(i, s);
            c.pc2(r, i, t.keys, n);
          }
        }),
          (a.prototype._update = function(t, e, r, i) {
            var n = this._desState,
              s = c.readUInt32BE(t, e),
              e = c.readUInt32BE(t, e + 4);
            c.ip(s, e, n.tmp, 0),
              (s = n.tmp[0]),
              (e = n.tmp[1]),
              'encrypt' === this.type
                ? this._encrypt(n, s, e, n.tmp, 0)
                : this._decrypt(n, s, e, n.tmp, 0),
              (s = n.tmp[0]),
              (e = n.tmp[1]),
              c.writeUInt32BE(r, s, i),
              c.writeUInt32BE(r, e, i + 4);
          }),
          (a.prototype._pad = function(t, e) {
            for (var r = t.length - e, i = e; i < t.length; i++) t[i] = r;
            return !0;
          }),
          (a.prototype._unpad = function(t) {
            for (var e = t[t.length - 1], r = t.length - e; r < t.length; r++)
              o.equal(t[r], e);
            return t.slice(0, t.length - e);
          }),
          (a.prototype._encrypt = function(t, e, r, i, n) {
            for (var s = e, o = r, a = 0; a < t.keys.length; a += 2) {
              var f = t.keys[a],
                h = t.keys[a + 1];
              c.expand(o, t.tmp, 0), (f ^= t.tmp[0]), (h ^= t.tmp[1]);
              (f = c.substitute(f, h)),
                (h = o),
                (o = (s ^ c.permute(f)) >>> 0),
                (s = h);
            }
            c.rip(o, s, i, n);
          }),
          (a.prototype._decrypt = function(t, e, r, i, n) {
            for (var s = r, o = e, a = t.keys.length - 2; 0 <= a; a -= 2) {
              var f = t.keys[a],
                h = t.keys[a + 1];
              c.expand(s, t.tmp, 0), (f ^= t.tmp[0]), (h ^= t.tmp[1]);
              (f = c.substitute(f, h)),
                (h = s),
                (s = (o ^ c.permute(f)) >>> 0),
                (o = h);
            }
            c.rip(s, o, i, n);
          });
      },
      {
        './cipher': 75,
        './utils': 78,
        inherits: 133,
        'minimalistic-assert': 137,
      },
    ],
    77: [
      function(t, e, r) {
        'use strict';
        var n = t('minimalistic-assert'),
          i = t('inherits'),
          s = t('./cipher'),
          o = t('./des');
        function a(t, e) {
          n.equal(e.length, 24, 'Invalid key length');
          var r = e.slice(0, 8),
            i = e.slice(8, 16),
            e = e.slice(16, 24);
          this.ciphers =
            'encrypt' === t
              ? [
                  o.create({ type: 'encrypt', key: r }),
                  o.create({ type: 'decrypt', key: i }),
                  o.create({ type: 'encrypt', key: e }),
                ]
              : [
                  o.create({ type: 'decrypt', key: e }),
                  o.create({ type: 'encrypt', key: i }),
                  o.create({ type: 'decrypt', key: r }),
                ];
        }
        function f(t) {
          s.call(this, t);
          t = new a(this.type, this.options.key);
          this._edeState = t;
        }
        i(f, s),
          ((e.exports = f).create = function(t) {
            return new f(t);
          }),
          (f.prototype._update = function(t, e, r, i) {
            var n = this._edeState;
            n.ciphers[0]._update(t, e, r, i),
              n.ciphers[1]._update(r, i, r, i),
              n.ciphers[2]._update(r, i, r, i);
          }),
          (f.prototype._pad = o.prototype._pad),
          (f.prototype._unpad = o.prototype._unpad);
      },
      {
        './cipher': 75,
        './des': 76,
        inherits: 133,
        'minimalistic-assert': 137,
      },
    ],
    78: [
      function(t, e, r) {
        'use strict';
        (r.readUInt32BE = function(t, e) {
          return (
            ((t[0 + e] << 24) |
              (t[1 + e] << 16) |
              (t[2 + e] << 8) |
              t[3 + e]) >>>
            0
          );
        }),
          (r.writeUInt32BE = function(t, e, r) {
            (t[0 + r] = e >>> 24),
              (t[1 + r] = (e >>> 16) & 255),
              (t[2 + r] = (e >>> 8) & 255),
              (t[3 + r] = 255 & e);
          }),
          (r.ip = function(t, e, r, i) {
            for (var n = 0, s = 0, o = 6; 0 <= o; o -= 2) {
              for (var a = 0; a <= 24; a += 8)
                (n <<= 1), (n |= (e >>> (a + o)) & 1);
              for (a = 0; a <= 24; a += 8)
                (n <<= 1), (n |= (t >>> (a + o)) & 1);
            }
            for (o = 6; 0 <= o; o -= 2) {
              for (a = 1; a <= 25; a += 8)
                (s <<= 1), (s |= (e >>> (a + o)) & 1);
              for (a = 1; a <= 25; a += 8)
                (s <<= 1), (s |= (t >>> (a + o)) & 1);
            }
            (r[i + 0] = n >>> 0), (r[i + 1] = s >>> 0);
          }),
          (r.rip = function(t, e, r, i) {
            for (var n = 0, s = 0, o = 0; o < 4; o++)
              for (var a = 24; 0 <= a; a -= 8)
                (n <<= 1),
                  (n |= (e >>> (a + o)) & 1),
                  (n <<= 1),
                  (n |= (t >>> (a + o)) & 1);
            for (o = 4; o < 8; o++)
              for (a = 24; 0 <= a; a -= 8)
                (s <<= 1),
                  (s |= (e >>> (a + o)) & 1),
                  (s <<= 1),
                  (s |= (t >>> (a + o)) & 1);
            (r[i + 0] = n >>> 0), (r[i + 1] = s >>> 0);
          }),
          (r.pc1 = function(t, e, r, i) {
            for (var n = 0, s = 0, o = 7; 5 <= o; o--) {
              for (var a = 0; a <= 24; a += 8)
                (n <<= 1), (n |= (e >> (a + o)) & 1);
              for (a = 0; a <= 24; a += 8) (n <<= 1), (n |= (t >> (a + o)) & 1);
            }
            for (a = 0; a <= 24; a += 8) (n <<= 1), (n |= (e >> (a + o)) & 1);
            for (o = 1; o <= 3; o++) {
              for (a = 0; a <= 24; a += 8) (s <<= 1), (s |= (e >> (a + o)) & 1);
              for (a = 0; a <= 24; a += 8) (s <<= 1), (s |= (t >> (a + o)) & 1);
            }
            for (a = 0; a <= 24; a += 8) (s <<= 1), (s |= (t >> (a + o)) & 1);
            (r[i + 0] = n >>> 0), (r[i + 1] = s >>> 0);
          }),
          (r.r28shl = function(t, e) {
            return ((t << e) & 268435455) | (t >>> (28 - e));
          });
        var f = [
          14,
          11,
          17,
          4,
          27,
          23,
          25,
          0,
          13,
          22,
          7,
          18,
          5,
          9,
          16,
          24,
          2,
          20,
          12,
          21,
          1,
          8,
          15,
          26,
          15,
          4,
          25,
          19,
          9,
          1,
          26,
          16,
          5,
          11,
          23,
          8,
          12,
          7,
          17,
          0,
          22,
          3,
          10,
          14,
          6,
          20,
          27,
          24,
        ];
        (r.pc2 = function(t, e, r, i) {
          for (var n = 0, s = 0, o = f.length >>> 1, a = 0; a < o; a++)
            (n <<= 1), (n |= (t >>> f[a]) & 1);
          for (a = o; a < f.length; a++) (s <<= 1), (s |= (e >>> f[a]) & 1);
          (r[i + 0] = n >>> 0), (r[i + 1] = s >>> 0);
        }),
          (r.expand = function(t, e, r) {
            for (
              var i = 0, n = 0, i = ((1 & t) << 5) | (t >>> 27), s = 23;
              15 <= s;
              s -= 4
            )
              (i <<= 6), (i |= (t >>> s) & 63);
            for (s = 11; 3 <= s; s -= 4) (n |= (t >>> s) & 63), (n <<= 6);
            (n |= ((31 & t) << 1) | (t >>> 31)),
              (e[r + 0] = i >>> 0),
              (e[r + 1] = n >>> 0);
          });
        var n = [
          14,
          0,
          4,
          15,
          13,
          7,
          1,
          4,
          2,
          14,
          15,
          2,
          11,
          13,
          8,
          1,
          3,
          10,
          10,
          6,
          6,
          12,
          12,
          11,
          5,
          9,
          9,
          5,
          0,
          3,
          7,
          8,
          4,
          15,
          1,
          12,
          14,
          8,
          8,
          2,
          13,
          4,
          6,
          9,
          2,
          1,
          11,
          7,
          15,
          5,
          12,
          11,
          9,
          3,
          7,
          14,
          3,
          10,
          10,
          0,
          5,
          6,
          0,
          13,
          15,
          3,
          1,
          13,
          8,
          4,
          14,
          7,
          6,
          15,
          11,
          2,
          3,
          8,
          4,
          14,
          9,
          12,
          7,
          0,
          2,
          1,
          13,
          10,
          12,
          6,
          0,
          9,
          5,
          11,
          10,
          5,
          0,
          13,
          14,
          8,
          7,
          10,
          11,
          1,
          10,
          3,
          4,
          15,
          13,
          4,
          1,
          2,
          5,
          11,
          8,
          6,
          12,
          7,
          6,
          12,
          9,
          0,
          3,
          5,
          2,
          14,
          15,
          9,
          10,
          13,
          0,
          7,
          9,
          0,
          14,
          9,
          6,
          3,
          3,
          4,
          15,
          6,
          5,
          10,
          1,
          2,
          13,
          8,
          12,
          5,
          7,
          14,
          11,
          12,
          4,
          11,
          2,
          15,
          8,
          1,
          13,
          1,
          6,
          10,
          4,
          13,
          9,
          0,
          8,
          6,
          15,
          9,
          3,
          8,
          0,
          7,
          11,
          4,
          1,
          15,
          2,
          14,
          12,
          3,
          5,
          11,
          10,
          5,
          14,
          2,
          7,
          12,
          7,
          13,
          13,
          8,
          14,
          11,
          3,
          5,
          0,
          6,
          6,
          15,
          9,
          0,
          10,
          3,
          1,
          4,
          2,
          7,
          8,
          2,
          5,
          12,
          11,
          1,
          12,
          10,
          4,
          14,
          15,
          9,
          10,
          3,
          6,
          15,
          9,
          0,
          0,
          6,
          12,
          10,
          11,
          1,
          7,
          13,
          13,
          8,
          15,
          9,
          1,
          4,
          3,
          5,
          14,
          11,
          5,
          12,
          2,
          7,
          8,
          2,
          4,
          14,
          2,
          14,
          12,
          11,
          4,
          2,
          1,
          12,
          7,
          4,
          10,
          7,
          11,
          13,
          6,
          1,
          8,
          5,
          5,
          0,
          3,
          15,
          15,
          10,
          13,
          3,
          0,
          9,
          14,
          8,
          9,
          6,
          4,
          11,
          2,
          8,
          1,
          12,
          11,
          7,
          10,
          1,
          13,
          14,
          7,
          2,
          8,
          13,
          15,
          6,
          9,
          15,
          12,
          0,
          5,
          9,
          6,
          10,
          3,
          4,
          0,
          5,
          14,
          3,
          12,
          10,
          1,
          15,
          10,
          4,
          15,
          2,
          9,
          7,
          2,
          12,
          6,
          9,
          8,
          5,
          0,
          6,
          13,
          1,
          3,
          13,
          4,
          14,
          14,
          0,
          7,
          11,
          5,
          3,
          11,
          8,
          9,
          4,
          14,
          3,
          15,
          2,
          5,
          12,
          2,
          9,
          8,
          5,
          12,
          15,
          3,
          10,
          7,
          11,
          0,
          14,
          4,
          1,
          10,
          7,
          1,
          6,
          13,
          0,
          11,
          8,
          6,
          13,
          4,
          13,
          11,
          0,
          2,
          11,
          14,
          7,
          15,
          4,
          0,
          9,
          8,
          1,
          13,
          10,
          3,
          14,
          12,
          3,
          9,
          5,
          7,
          12,
          5,
          2,
          10,
          15,
          6,
          8,
          1,
          6,
          1,
          6,
          4,
          11,
          11,
          13,
          13,
          8,
          12,
          1,
          3,
          4,
          7,
          10,
          14,
          7,
          10,
          9,
          15,
          5,
          6,
          0,
          8,
          15,
          0,
          14,
          5,
          2,
          9,
          3,
          2,
          12,
          13,
          1,
          2,
          15,
          8,
          13,
          4,
          8,
          6,
          10,
          15,
          3,
          11,
          7,
          1,
          4,
          10,
          12,
          9,
          5,
          3,
          6,
          14,
          11,
          5,
          0,
          0,
          14,
          12,
          9,
          7,
          2,
          7,
          2,
          11,
          1,
          4,
          14,
          1,
          7,
          9,
          4,
          12,
          10,
          14,
          8,
          2,
          13,
          0,
          15,
          6,
          12,
          10,
          9,
          13,
          0,
          15,
          3,
          3,
          5,
          5,
          6,
          8,
          11,
        ];
        r.substitute = function(t, e) {
          for (var r = 0, i = 0; i < 4; i++)
            (r <<= 4), (r |= n[64 * i + ((t >>> (18 - 6 * i)) & 63)]);
          for (i = 0; i < 4; i++)
            (r <<= 4), (r |= n[256 + 64 * i + ((e >>> (18 - 6 * i)) & 63)]);
          return r >>> 0;
        };
        var i = [
          16,
          25,
          12,
          11,
          3,
          20,
          4,
          15,
          31,
          17,
          9,
          6,
          27,
          14,
          1,
          22,
          30,
          24,
          8,
          18,
          0,
          5,
          29,
          23,
          13,
          19,
          2,
          26,
          10,
          21,
          28,
          7,
        ];
        (r.permute = function(t) {
          for (var e = 0, r = 0; r < i.length; r++)
            (e <<= 1), (e |= (t >>> i[r]) & 1);
          return e >>> 0;
        }),
          (r.padSplit = function(t, e, r) {
            for (var i = t.toString(2); i.length < e; ) i = '0' + i;
            for (var n = [], s = 0; s < e; s += r) n.push(i.slice(s, s + r));
            return n.join(' ');
          });
      },
      {},
    ],
    79: [
      function(t, e, i) {
        !function(f) {
          !function() {
            var s = t('./lib/generatePrime'),
              r = t('./lib/primes.json'),
              o = t('./lib/dh');
            var a = { binary: !0, hex: !0, base64: !0 };
            (i.DiffieHellmanGroup = i.createDiffieHellmanGroup = i.getDiffieHellman = function(
              t
            ) {
              var e = new f(r[t].prime, 'hex'),
                t = new f(r[t].gen, 'hex');
              return new o(e, t);
            }),
              (i.createDiffieHellman = i.DiffieHellman = function t(
                e,
                r,
                i,
                n
              ) {
                return f.isBuffer(r) || void 0 === a[r]
                  ? t(e, 'binary', r, i)
                  : ((r = r || 'binary'),
                    (n = n || 'binary'),
                    (i = i || new f([2])),
                    f.isBuffer(i) || (i = new f(i, n)),
                    'number' == typeof e
                      ? new o(s(e, i), i, !0)
                      : (f.isBuffer(e) || (e = new f(e, r)), new o(e, i, !0)));
              });
          }.call(this);
        }.call(this, t('buffer').Buffer);
      },
      {
        './lib/dh': 80,
        './lib/generatePrime': 81,
        './lib/primes.json': 82,
        buffer: 64,
      },
    ],
    80: [
      function(b, m, t) {
        !function(p) {
          !function() {
            var i = b('bn.js'),
              s = new (b('miller-rabin'))(),
              o = new i(24),
              a = new i(11),
              f = new i(10),
              h = new i(3),
              c = new i(7),
              u = b('./generatePrime'),
              t = b('randombytes');
            function n(t, e) {
              return (
                (e = e || 'utf8'),
                p.isBuffer(t) || (t = new p(t, e)),
                (this._pub = new i(t)),
                this
              );
            }
            function d(t, e) {
              return (
                (e = e || 'utf8'),
                p.isBuffer(t) || (t = new p(t, e)),
                (this._priv = new i(t)),
                this
              );
            }
            m.exports = e;
            var l = {};
            function e(t, e, r) {
              this.setGenerator(e),
                (this.__prime = new i(t)),
                (this._prime = i.mont(this.__prime)),
                (this._primeLen = t.length),
                (this._pub = void 0),
                (this._priv = void 0),
                (this._primeCode = void 0),
                r
                  ? ((this.setPublicKey = n), (this.setPrivateKey = d))
                  : (this._primeCode = 8);
            }
            function r(t, e) {
              t = new p(t.toArray());
              return e ? t.toString(e) : t;
            }
            Object.defineProperty(e.prototype, 'verifyError', {
              enumerable: !0,
              get: function() {
                return (
                  'number' != typeof this._primeCode &&
                    (this._primeCode = (function(t, e) {
                      var r = e.toString('hex');
                      if ((e = [r, t.toString(16)].join('_')) in l) return l[e];
                      var i,
                        n = 0;
                      if (
                        t.isEven() ||
                        !u.simpleSieve ||
                        !u.fermatTest(t) ||
                        !s.test(t)
                      )
                        return (
                          (n += 1),
                          (l[e] = n += '02' === r || '05' === r ? 8 : 4)
                        );
                      switch ((s.test(t.shrn(1)) || (n += 2), r)) {
                        case '02':
                          t.mod(o).cmp(a) && (n += 8);
                          break;
                        case '05':
                          (i = t.mod(f)).cmp(h) && i.cmp(c) && (n += 8);
                          break;
                        default:
                          n += 4;
                      }
                      return (l[e] = n);
                    })(this.__prime, this.__gen)),
                  this._primeCode
                );
              },
            }),
              (e.prototype.generateKeys = function() {
                return (
                  this._priv || (this._priv = new i(t(this._primeLen))),
                  (this._pub = this._gen
                    .toRed(this._prime)
                    .redPow(this._priv)
                    .fromRed()),
                  this.getPublicKey()
                );
              }),
              (e.prototype.computeSecret = function(t) {
                var e = (t = (t = new i(t)).toRed(this._prime))
                    .redPow(this._priv)
                    .fromRed(),
                  t = new p(e.toArray()),
                  e = this.getPrime();
                return (
                  t.length < e.length &&
                    ((e = new p(e.length - t.length)).fill(0),
                    (t = p.concat([e, t]))),
                  t
                );
              }),
              (e.prototype.getPublicKey = function(t) {
                return r(this._pub, t);
              }),
              (e.prototype.getPrivateKey = function(t) {
                return r(this._priv, t);
              }),
              (e.prototype.getPrime = function(t) {
                return r(this.__prime, t);
              }),
              (e.prototype.getGenerator = function(t) {
                return r(this._gen, t);
              }),
              (e.prototype.setGenerator = function(t, e) {
                return (
                  (e = e || 'utf8'),
                  p.isBuffer(t) || (t = new p(t, e)),
                  (this.__gen = t),
                  (this._gen = new i(t)),
                  this
                );
              });
          }.call(this);
        }.call(this, b('buffer').Buffer);
      },
      {
        './generatePrime': 81,
        'bn.js': 83,
        buffer: 64,
        'miller-rabin': 135,
        randombytes: 158,
      },
    ],
    81: [
      function(t, e, r) {
        var n = t('randombytes');
        ((e.exports = i).simpleSieve = m), (i.fermatTest = y);
        var s = t('bn.js'),
          o = new s(24),
          a = new (t('miller-rabin'))(),
          f = new s(1),
          h = new s(2),
          c = new s(5),
          u = (new s(16), new s(8), new s(10)),
          d = new s(3),
          l = (new s(7), new s(11)),
          p = new s(4),
          b = (new s(12), null);
        function m(t) {
          for (
            var e = (function() {
                if (null !== b) return b;
                var t = [];
                t[0] = 2;
                for (var e = 1, r = 3; r < 1048576; r += 2) {
                  for (
                    var i = Math.ceil(Math.sqrt(r)), n = 0;
                    n < e && t[n] <= i && r % t[n] != 0;
                    n++
                  );
                  (e !== n && t[n] <= i) || (t[e++] = r);
                }
                return (b = t);
              })(),
              r = 0;
            r < e.length;
            r++
          )
            if (0 === t.modn(e[r])) return 0 === t.cmpn(e[r]);
          return !0;
        }
        function y(t) {
          var e = s.mont(t);
          return (
            0 ===
            h
              .toRed(e)
              .redPow(t.subn(1))
              .fromRed()
              .cmpn(1)
          );
        }
        function i(t, e) {
          if (t < 16) return new s(2 === e || 5 === e ? [140, 123] : [140, 39]);
          var r, i;
          for (e = new s(e); ; ) {
            for (r = new s(n(Math.ceil(t / 8))); r.bitLength() > t; )
              r.ishrn(1);
            if ((r.isEven() && r.iadd(f), r.testn(1) || r.iadd(h), e.cmp(h))) {
              if (!e.cmp(c)) for (; r.mod(u).cmp(d); ) r.iadd(p);
            } else for (; r.mod(o).cmp(l); ) r.iadd(p);
            if (
              m((i = r.shrn(1))) &&
              m(r) &&
              y(i) &&
              y(r) &&
              a.test(i) &&
              a.test(r)
            )
              return r;
          }
        }
      },
      { 'bn.js': 83, 'miller-rabin': 135, randombytes: 158 },
    ],
    82: [
      function(t, e, r) {
        e.exports = {
          modp1: {
            gen: '02',
            prime:
              'ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff',
          },
          modp2: {
            gen: '02',
            prime:
              'ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff',
          },
          modp5: {
            gen: '02',
            prime:
              'ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff',
          },
          modp14: {
            gen: '02',
            prime:
              'ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff',
          },
          modp15: {
            gen: '02',
            prime:
              'ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff',
          },
          modp16: {
            gen: '02',
            prime:
              'ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff',
          },
          modp17: {
            gen: '02',
            prime:
              'ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff',
          },
          modp18: {
            gen: '02',
            prime:
              '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',
          },
        };
      },
      {},
    ],
    83: [
      function(t, e, r) {
        arguments[4][16][0].apply(r, arguments);
      },
      { buffer: 20, dup: 16 },
    ],
    84: [
      function(t, e, r) {
        'use strict';
        (r.version = t('../package.json').version),
          (r.utils = t('./elliptic/utils')),
          (r.rand = t('brorand')),
          (r.curve = t('./elliptic/curve')),
          (r.curves = t('./elliptic/curves')),
          (r.ec = t('./elliptic/ec')),
          (r.eddsa = t('./elliptic/eddsa'));
      },
      {
        '../package.json': 100,
        './elliptic/curve': 87,
        './elliptic/curves': 90,
        './elliptic/ec': 91,
        './elliptic/eddsa': 94,
        './elliptic/utils': 98,
        brorand: 19,
      },
    ],
    85: [
      function(t, e, r) {
        'use strict';
        var i = t('bn.js'),
          n = t('../utils'),
          k = n.getNAF,
          A = n.getJSF,
          u = n.assert;
        function s(t, e) {
          (this.type = t),
            (this.p = new i(e.p, 16)),
            (this.red = e.prime ? i.red(e.prime) : i.mont(this.p)),
            (this.zero = new i(0).toRed(this.red)),
            (this.one = new i(1).toRed(this.red)),
            (this.two = new i(2).toRed(this.red)),
            (this.n = e.n && new i(e.n, 16)),
            (this.g = e.g && this.pointFromJSON(e.g, e.gRed)),
            (this._wnafT1 = new Array(4)),
            (this._wnafT2 = new Array(4)),
            (this._wnafT3 = new Array(4)),
            (this._wnafT4 = new Array(4)),
            (this._bitLength = this.n ? this.n.bitLength() : 0);
          e = this.n && this.p.div(this.n);
          !e || 0 < e.cmpn(100)
            ? (this.redN = null)
            : ((this._maxwellTrick = !0), (this.redN = this.n.toRed(this.red)));
        }
        function o(t, e) {
          (this.curve = t), (this.type = e), (this.precomputed = null);
        }
        ((e.exports = s).prototype.point = function() {
          throw new Error('Not implemented');
        }),
          (s.prototype.validate = function() {
            throw new Error('Not implemented');
          }),
          (s.prototype._fixedNafMul = function(t, e) {
            u(t.precomputed);
            var r = t._getDoubles(),
              i = k(e, 1, this._bitLength),
              e = (1 << (r.step + 1)) - (r.step % 2 == 0 ? 2 : 1);
            e /= 3;
            for (var n = [], s = 0; s < i.length; s += r.step) {
              for (var o = 0, a = s + r.step - 1; s <= a; a--)
                o = (o << 1) + i[a];
              n.push(o);
            }
            for (
              var f = this.jpoint(null, null, null),
                h = this.jpoint(null, null, null),
                c = e;
              0 < c;
              c--
            ) {
              for (s = 0; s < n.length; s++)
                (o = n[s]) === c
                  ? (h = h.mixedAdd(r.points[s]))
                  : o === -c && (h = h.mixedAdd(r.points[s].neg()));
              f = f.add(h);
            }
            return f.toP();
          }),
          (s.prototype._wnafMul = function(t, e) {
            for (
              var r = t._getNAFPoints(4),
                i = r.wnd,
                n = r.points,
                s = k(e, i, this._bitLength),
                o = this.jpoint(null, null, null),
                a = s.length - 1;
              0 <= a;
              a--
            ) {
              for (var f = 0; 0 <= a && 0 === s[a]; a--) f++;
              if ((0 <= a && f++, (o = o.dblp(f)), a < 0)) break;
              var h = s[a];
              u(0 !== h),
                (o =
                  'affine' === t.type
                    ? 0 < h
                      ? o.mixedAdd(n[(h - 1) >> 1])
                      : o.mixedAdd(n[(-h - 1) >> 1].neg())
                    : 0 < h
                    ? o.add(n[(h - 1) >> 1])
                    : o.add(n[(-h - 1) >> 1].neg()));
            }
            return 'affine' === t.type ? o.toP() : o;
          }),
          (s.prototype._wnafMulAdd = function(t, e, r, i, n) {
            for (
              var s = this._wnafT1,
                o = this._wnafT2,
                a = this._wnafT3,
                f = 0,
                h = 0;
              h < i;
              h++
            ) {
              var c,
                u = (c = e[h])._getNAFPoints(t);
              (s[h] = u.wnd), (o[h] = u.points);
            }
            for (h = i - 1; 1 <= h; h -= 2) {
              var d = h - 1,
                l = h;
              if (1 === s[d] && 1 === s[l]) {
                var p = [e[d], null, null, e[l]];
                0 === e[d].y.cmp(e[l].y)
                  ? ((p[1] = e[d].add(e[l])),
                    (p[2] = e[d].toJ().mixedAdd(e[l].neg())))
                  : 0 === e[d].y.cmp(e[l].y.redNeg())
                  ? ((p[1] = e[d].toJ().mixedAdd(e[l])),
                    (p[2] = e[d].add(e[l].neg())))
                  : ((p[1] = e[d].toJ().mixedAdd(e[l])),
                    (p[2] = e[d].toJ().mixedAdd(e[l].neg())));
                var b = [-3, -1, -5, -7, 0, 7, 5, 1, 3],
                  m = A(r[d], r[l]),
                  f = Math.max(m[0].length, f);
                for (
                  a[d] = new Array(f), a[l] = new Array(f), S = 0;
                  S < f;
                  S++
                ) {
                  var y = 0 | m[0][S],
                    g = 0 | m[1][S];
                  (a[d][S] = b[3 * (1 + y) + (1 + g)]),
                    (a[l][S] = 0),
                    (o[d] = p);
                }
              } else
                (a[d] = k(r[d], s[d], this._bitLength)),
                  (a[l] = k(r[l], s[l], this._bitLength)),
                  (f = Math.max(a[d].length, f)),
                  (f = Math.max(a[l].length, f));
            }
            var v = this.jpoint(null, null, null),
              _ = this._wnafT4;
            for (h = f; 0 <= h; h--) {
              for (var w = 0; 0 <= h; ) {
                for (var M = !0, S = 0; S < i; S++)
                  (_[S] = 0 | a[S][h]), 0 !== _[S] && (M = !1);
                if (!M) break;
                w++, h--;
              }
              if ((0 <= h && w++, (v = v.dblp(w)), h < 0)) break;
              for (S = 0; S < i; S++) {
                var E = _[S];
                0 !== E &&
                  (0 < E
                    ? (c = o[S][(E - 1) >> 1])
                    : E < 0 && (c = o[S][(-E - 1) >> 1].neg()),
                  (v = 'affine' === c.type ? v.mixedAdd(c) : v.add(c)));
              }
            }
            for (h = 0; h < i; h++) o[h] = null;
            return n ? v : v.toP();
          }),
          ((s.BasePoint = o).prototype.eq = function() {
            throw new Error('Not implemented');
          }),
          (o.prototype.validate = function() {
            return this.curve.validate(this);
          }),
          (s.prototype.decodePoint = function(t, e) {
            t = n.toArray(t, e);
            e = this.p.byteLength();
            if (
              (4 === t[0] || 6 === t[0] || 7 === t[0]) &&
              t.length - 1 == 2 * e
            )
              return (
                6 === t[0]
                  ? u(t[t.length - 1] % 2 == 0)
                  : 7 === t[0] && u(t[t.length - 1] % 2 == 1),
                this.point(t.slice(1, 1 + e), t.slice(1 + e, 1 + 2 * e))
              );
            if ((2 === t[0] || 3 === t[0]) && t.length - 1 === e)
              return this.pointFromX(t.slice(1, 1 + e), 3 === t[0]);
            throw new Error('Unknown point format');
          }),
          (o.prototype.encodeCompressed = function(t) {
            return this.encode(t, !0);
          }),
          (o.prototype._encode = function(t) {
            var e = this.curve.p.byteLength(),
              r = this.getX().toArray('be', e);
            return t
              ? [this.getY().isEven() ? 2 : 3].concat(r)
              : [4].concat(r, this.getY().toArray('be', e));
          }),
          (o.prototype.encode = function(t, e) {
            return n.encode(this._encode(e), t);
          }),
          (o.prototype.precompute = function(t) {
            if (this.precomputed) return this;
            var e = { doubles: null, naf: null, beta: null };
            return (
              (e.naf = this._getNAFPoints(8)),
              (e.doubles = this._getDoubles(4, t)),
              (e.beta = this._getBeta()),
              (this.precomputed = e),
              this
            );
          }),
          (o.prototype._hasDoubles = function(t) {
            if (!this.precomputed) return !1;
            var e = this.precomputed.doubles;
            return (
              !!e && e.points.length >= Math.ceil((t.bitLength() + 1) / e.step)
            );
          }),
          (o.prototype._getDoubles = function(t, e) {
            if (this.precomputed && this.precomputed.doubles)
              return this.precomputed.doubles;
            for (var r = [this], i = this, n = 0; n < e; n += t) {
              for (var s = 0; s < t; s++) i = i.dbl();
              r.push(i);
            }
            return { step: t, points: r };
          }),
          (o.prototype._getNAFPoints = function(t) {
            if (this.precomputed && this.precomputed.naf)
              return this.precomputed.naf;
            for (
              var e = [this],
                r = (1 << t) - 1,
                i = 1 == r ? null : this.dbl(),
                n = 1;
              n < r;
              n++
            )
              e[n] = e[n - 1].add(i);
            return { wnd: t, points: e };
          }),
          (o.prototype._getBeta = function() {
            return null;
          }),
          (o.prototype.dblp = function(t) {
            for (var e = this, r = 0; r < t; r++) e = e.dbl();
            return e;
          });
      },
      { '../utils': 98, 'bn.js': 99 },
    ],
    86: [
      function(t, e, r) {
        'use strict';
        var i = t('../utils'),
          s = t('bn.js'),
          n = t('inherits'),
          o = t('./base'),
          a = i.assert;
        function f(t) {
          (this.twisted = 1 != (0 | t.a)),
            (this.mOneA = this.twisted && -1 == (0 | t.a)),
            (this.extended = this.mOneA),
            o.call(this, 'edwards', t),
            (this.a = new s(t.a, 16).umod(this.red.m)),
            (this.a = this.a.toRed(this.red)),
            (this.c = new s(t.c, 16).toRed(this.red)),
            (this.c2 = this.c.redSqr()),
            (this.d = new s(t.d, 16).toRed(this.red)),
            (this.dd = this.d.redAdd(this.d)),
            a(!this.twisted || 0 === this.c.fromRed().cmpn(1)),
            (this.oneC = 1 == (0 | t.c));
        }
        function h(t, e, r, i, n) {
          o.BasePoint.call(this, t, 'projective'),
            null === e && null === r && null === i
              ? ((this.x = this.curve.zero),
                (this.y = this.curve.one),
                (this.z = this.curve.one),
                (this.t = this.curve.zero),
                (this.zOne = !0))
              : ((this.x = new s(e, 16)),
                (this.y = new s(r, 16)),
                (this.z = i ? new s(i, 16) : this.curve.one),
                (this.t = n && new s(n, 16)),
                this.x.red || (this.x = this.x.toRed(this.curve.red)),
                this.y.red || (this.y = this.y.toRed(this.curve.red)),
                this.z.red || (this.z = this.z.toRed(this.curve.red)),
                this.t &&
                  !this.t.red &&
                  (this.t = this.t.toRed(this.curve.red)),
                (this.zOne = this.z === this.curve.one),
                this.curve.extended &&
                  !this.t &&
                  ((this.t = this.x.redMul(this.y)),
                  this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
        }
        n(f, o),
          ((e.exports = f).prototype._mulA = function(t) {
            return this.mOneA ? t.redNeg() : this.a.redMul(t);
          }),
          (f.prototype._mulC = function(t) {
            return this.oneC ? t : this.c.redMul(t);
          }),
          (f.prototype.jpoint = function(t, e, r, i) {
            return this.point(t, e, r, i);
          }),
          (f.prototype.pointFromX = function(t, e) {
            var r = (t = !(t = new s(t, 16)).red
                ? t.toRed(this.red)
                : t).redSqr(),
              i = this.c2.redSub(this.a.redMul(r)),
              r = this.one.redSub(this.c2.redMul(this.d).redMul(r)),
              i = i.redMul(r.redInvm()),
              r = i.redSqrt();
            if (
              0 !==
              r
                .redSqr()
                .redSub(i)
                .cmp(this.zero)
            )
              throw new Error('invalid point');
            i = r.fromRed().isOdd();
            return (
              ((e && !i) || (!e && i)) && (r = r.redNeg()), this.point(t, r)
            );
          }),
          (f.prototype.pointFromY = function(t, e) {
            var r = (t = !(t = new s(t, 16)).red
                ? t.toRed(this.red)
                : t).redSqr(),
              i = r.redSub(this.c2),
              r = r
                .redMul(this.d)
                .redMul(this.c2)
                .redSub(this.a),
              i = i.redMul(r.redInvm());
            if (0 === i.cmp(this.zero)) {
              if (e) throw new Error('invalid point');
              return this.point(this.zero, t);
            }
            r = i.redSqrt();
            if (
              0 !==
              r
                .redSqr()
                .redSub(i)
                .cmp(this.zero)
            )
              throw new Error('invalid point');
            return (
              r.fromRed().isOdd() !== e && (r = r.redNeg()), this.point(r, t)
            );
          }),
          (f.prototype.validate = function(t) {
            if (t.isInfinity()) return !0;
            t.normalize();
            var e = t.x.redSqr(),
              r = t.y.redSqr(),
              t = e.redMul(this.a).redAdd(r),
              r = this.c2.redMul(this.one.redAdd(this.d.redMul(e).redMul(r)));
            return 0 === t.cmp(r);
          }),
          n(h, o.BasePoint),
          (f.prototype.pointFromJSON = function(t) {
            return h.fromJSON(this, t);
          }),
          (f.prototype.point = function(t, e, r, i) {
            return new h(this, t, e, r, i);
          }),
          (h.fromJSON = function(t, e) {
            return new h(t, e[0], e[1], e[2]);
          }),
          (h.prototype.inspect = function() {
            return this.isInfinity()
              ? '<EC Point Infinity>'
              : '<EC Point x: ' +
                  this.x.fromRed().toString(16, 2) +
                  ' y: ' +
                  this.y.fromRed().toString(16, 2) +
                  ' z: ' +
                  this.z.fromRed().toString(16, 2) +
                  '>';
          }),
          (h.prototype.isInfinity = function() {
            return (
              0 === this.x.cmpn(0) &&
              (0 === this.y.cmp(this.z) ||
                (this.zOne && 0 === this.y.cmp(this.curve.c)))
            );
          }),
          (h.prototype._extDbl = function() {
            var t = this.x.redSqr(),
              e = this.y.redSqr(),
              r = (r = this.z.redSqr()).redIAdd(r),
              i = this.curve._mulA(t),
              n = this.x
                .redAdd(this.y)
                .redSqr()
                .redISub(t)
                .redISub(e),
              s = i.redAdd(e),
              t = s.redSub(r),
              r = i.redSub(e),
              i = n.redMul(t),
              e = s.redMul(r),
              r = n.redMul(r),
              s = t.redMul(s);
            return this.curve.point(i, e, s, r);
          }),
          (h.prototype._projDbl = function() {
            var t,
              e,
              r,
              i,
              n,
              s,
              o = this.x.redAdd(this.y).redSqr(),
              a = this.x.redSqr(),
              f = this.y.redSqr();
            return (
              (s = this.curve.twisted
                ? ((n = (i = this.curve._mulA(a)).redAdd(f)),
                  this.zOne
                    ? ((t = o
                        .redSub(a)
                        .redSub(f)
                        .redMul(n.redSub(this.curve.two))),
                      (e = n.redMul(i.redSub(f))),
                      n
                        .redSqr()
                        .redSub(n)
                        .redSub(n))
                    : ((r = this.z.redSqr()),
                      (s = n.redSub(r).redISub(r)),
                      (t = o
                        .redSub(a)
                        .redISub(f)
                        .redMul(s)),
                      (e = n.redMul(i.redSub(f))),
                      n.redMul(s)))
                : ((i = a.redAdd(f)),
                  (r = this.curve._mulC(this.z).redSqr()),
                  (s = i.redSub(r).redSub(r)),
                  (t = this.curve._mulC(o.redISub(i)).redMul(s)),
                  (e = this.curve._mulC(i).redMul(a.redISub(f))),
                  i.redMul(s))),
              this.curve.point(t, e, s)
            );
          }),
          (h.prototype.dbl = function() {
            return this.isInfinity()
              ? this
              : this.curve.extended
              ? this._extDbl()
              : this._projDbl();
          }),
          (h.prototype._extAdd = function(t) {
            var e = this.y.redSub(this.x).redMul(t.y.redSub(t.x)),
              r = this.y.redAdd(this.x).redMul(t.y.redAdd(t.x)),
              i = this.t.redMul(this.curve.dd).redMul(t.t),
              n = this.z.redMul(t.z.redAdd(t.z)),
              s = r.redSub(e),
              t = n.redSub(i),
              n = n.redAdd(i),
              i = r.redAdd(e),
              r = s.redMul(t),
              e = n.redMul(i),
              i = s.redMul(i),
              n = t.redMul(n);
            return this.curve.point(r, e, n, i);
          }),
          (h.prototype._projAdd = function(t) {
            var e,
              r = this.z.redMul(t.z),
              i = r.redSqr(),
              n = this.x.redMul(t.x),
              s = this.y.redMul(t.y),
              o = this.curve.d.redMul(n).redMul(s),
              a = i.redSub(o),
              o = i.redAdd(o),
              t = this.x
                .redAdd(this.y)
                .redMul(t.x.redAdd(t.y))
                .redISub(n)
                .redISub(s),
              t = r.redMul(a).redMul(t),
              o = this.curve.twisted
                ? ((e = r.redMul(o).redMul(s.redSub(this.curve._mulA(n)))),
                  a.redMul(o))
                : ((e = r.redMul(o).redMul(s.redSub(n))),
                  this.curve._mulC(a).redMul(o));
            return this.curve.point(t, e, o);
          }),
          (h.prototype.add = function(t) {
            return this.isInfinity()
              ? t
              : t.isInfinity()
              ? this
              : this.curve.extended
              ? this._extAdd(t)
              : this._projAdd(t);
          }),
          (h.prototype.mul = function(t) {
            return this._hasDoubles(t)
              ? this.curve._fixedNafMul(this, t)
              : this.curve._wnafMul(this, t);
          }),
          (h.prototype.mulAdd = function(t, e, r) {
            return this.curve._wnafMulAdd(1, [this, e], [t, r], 2, !1);
          }),
          (h.prototype.jmulAdd = function(t, e, r) {
            return this.curve._wnafMulAdd(1, [this, e], [t, r], 2, !0);
          }),
          (h.prototype.normalize = function() {
            if (this.zOne) return this;
            var t = this.z.redInvm();
            return (
              (this.x = this.x.redMul(t)),
              (this.y = this.y.redMul(t)),
              this.t && (this.t = this.t.redMul(t)),
              (this.z = this.curve.one),
              (this.zOne = !0),
              this
            );
          }),
          (h.prototype.neg = function() {
            return this.curve.point(
              this.x.redNeg(),
              this.y,
              this.z,
              this.t && this.t.redNeg()
            );
          }),
          (h.prototype.getX = function() {
            return this.normalize(), this.x.fromRed();
          }),
          (h.prototype.getY = function() {
            return this.normalize(), this.y.fromRed();
          }),
          (h.prototype.eq = function(t) {
            return (
              this === t ||
              (0 === this.getX().cmp(t.getX()) &&
                0 === this.getY().cmp(t.getY()))
            );
          }),
          (h.prototype.eqXToP = function(t) {
            var e = t.toRed(this.curve.red).redMul(this.z);
            if (0 === this.x.cmp(e)) return !0;
            for (var r = t.clone(), i = this.curve.redN.redMul(this.z); ; ) {
              if ((r.iadd(this.curve.n), 0 <= r.cmp(this.curve.p))) return !1;
              if ((e.redIAdd(i), 0 === this.x.cmp(e))) return !0;
            }
          }),
          (h.prototype.toP = h.prototype.normalize),
          (h.prototype.mixedAdd = h.prototype.add);
      },
      { '../utils': 98, './base': 85, 'bn.js': 99, inherits: 133 },
    ],
    87: [
      function(t, e, r) {
        'use strict';
        (r.base = t('./base')),
          (r.short = t('./short')),
          (r.mont = t('./mont')),
          (r.edwards = t('./edwards'));
      },
      { './base': 85, './edwards': 86, './mont': 88, './short': 89 },
    ],
    88: [
      function(t, e, r) {
        'use strict';
        var i = t('bn.js'),
          n = t('inherits'),
          s = t('./base'),
          o = t('../utils');
        function a(t) {
          s.call(this, 'mont', t),
            (this.a = new i(t.a, 16).toRed(this.red)),
            (this.b = new i(t.b, 16).toRed(this.red)),
            (this.i4 = new i(4).toRed(this.red).redInvm()),
            (this.two = new i(2).toRed(this.red)),
            (this.a24 = this.i4.redMul(this.a.redAdd(this.two)));
        }
        function f(t, e, r) {
          s.BasePoint.call(this, t, 'projective'),
            null === e && null === r
              ? ((this.x = this.curve.one), (this.z = this.curve.zero))
              : ((this.x = new i(e, 16)),
                (this.z = new i(r, 16)),
                this.x.red || (this.x = this.x.toRed(this.curve.red)),
                this.z.red || (this.z = this.z.toRed(this.curve.red)));
        }
        n(a, s),
          ((e.exports = a).prototype.validate = function(t) {
            var e = t.normalize().x,
              t = e.redSqr(),
              e = t
                .redMul(e)
                .redAdd(t.redMul(this.a))
                .redAdd(e);
            return (
              0 ===
              e
                .redSqrt()
                .redSqr()
                .cmp(e)
            );
          }),
          n(f, s.BasePoint),
          (a.prototype.decodePoint = function(t, e) {
            return this.point(o.toArray(t, e), 1);
          }),
          (a.prototype.point = function(t, e) {
            return new f(this, t, e);
          }),
          (a.prototype.pointFromJSON = function(t) {
            return f.fromJSON(this, t);
          }),
          (f.prototype.precompute = function() {}),
          (f.prototype._encode = function() {
            return this.getX().toArray('be', this.curve.p.byteLength());
          }),
          (f.fromJSON = function(t, e) {
            return new f(t, e[0], e[1] || t.one);
          }),
          (f.prototype.inspect = function() {
            return this.isInfinity()
              ? '<EC Point Infinity>'
              : '<EC Point x: ' +
                  this.x.fromRed().toString(16, 2) +
                  ' z: ' +
                  this.z.fromRed().toString(16, 2) +
                  '>';
          }),
          (f.prototype.isInfinity = function() {
            return 0 === this.z.cmpn(0);
          }),
          (f.prototype.dbl = function() {
            var t = this.x.redAdd(this.z).redSqr(),
              e = this.x.redSub(this.z).redSqr(),
              r = t.redSub(e),
              t = t.redMul(e),
              r = r.redMul(e.redAdd(this.curve.a24.redMul(r)));
            return this.curve.point(t, r);
          }),
          (f.prototype.add = function() {
            throw new Error('Not supported on Montgomery curve');
          }),
          (f.prototype.diffAdd = function(t, e) {
            var r = this.x.redAdd(this.z),
              i = this.x.redSub(this.z),
              n = t.x.redAdd(t.z),
              r = t.x.redSub(t.z).redMul(r),
              n = n.redMul(i),
              i = e.z.redMul(r.redAdd(n).redSqr()),
              n = e.x.redMul(r.redISub(n).redSqr());
            return this.curve.point(i, n);
          }),
          (f.prototype.mul = function(t) {
            for (
              var e = t.clone(),
                r = this,
                i = this.curve.point(null, null),
                n = [];
              0 !== e.cmpn(0);
              e.iushrn(1)
            )
              n.push(e.andln(1));
            for (var s = n.length - 1; 0 <= s; s--)
              0 === n[s]
                ? ((r = r.diffAdd(i, this)), (i = i.dbl()))
                : ((i = r.diffAdd(i, this)), (r = r.dbl()));
            return i;
          }),
          (f.prototype.mulAdd = function() {
            throw new Error('Not supported on Montgomery curve');
          }),
          (f.prototype.jumlAdd = function() {
            throw new Error('Not supported on Montgomery curve');
          }),
          (f.prototype.eq = function(t) {
            return 0 === this.getX().cmp(t.getX());
          }),
          (f.prototype.normalize = function() {
            return (
              (this.x = this.x.redMul(this.z.redInvm())),
              (this.z = this.curve.one),
              this
            );
          }),
          (f.prototype.getX = function() {
            return this.normalize(), this.x.fromRed();
          });
      },
      { '../utils': 98, './base': 85, 'bn.js': 99, inherits: 133 },
    ],
    89: [
      function(t, e, r) {
        'use strict';
        var i = t('../utils'),
          v = t('bn.js'),
          n = t('inherits'),
          s = t('./base'),
          o = i.assert;
        function a(t) {
          s.call(this, 'short', t),
            (this.a = new v(t.a, 16).toRed(this.red)),
            (this.b = new v(t.b, 16).toRed(this.red)),
            (this.tinv = this.two.redInvm()),
            (this.zeroA = 0 === this.a.fromRed().cmpn(0)),
            (this.threeA =
              0 ===
              this.a
                .fromRed()
                .sub(this.p)
                .cmpn(-3)),
            (this.endo = this._getEndomorphism(t)),
            (this._endoWnafT1 = new Array(4)),
            (this._endoWnafT2 = new Array(4));
        }
        function f(t, e, r, i) {
          s.BasePoint.call(this, t, 'affine'),
            null === e && null === r
              ? ((this.x = null), (this.y = null), (this.inf = !0))
              : ((this.x = new v(e, 16)),
                (this.y = new v(r, 16)),
                i &&
                  (this.x.forceRed(this.curve.red),
                  this.y.forceRed(this.curve.red)),
                this.x.red || (this.x = this.x.toRed(this.curve.red)),
                this.y.red || (this.y = this.y.toRed(this.curve.red)),
                (this.inf = !1));
        }
        function h(t, e, r, i) {
          s.BasePoint.call(this, t, 'jacobian'),
            null === e && null === r && null === i
              ? ((this.x = this.curve.one),
                (this.y = this.curve.one),
                (this.z = new v(0)))
              : ((this.x = new v(e, 16)),
                (this.y = new v(r, 16)),
                (this.z = new v(i, 16))),
            this.x.red || (this.x = this.x.toRed(this.curve.red)),
            this.y.red || (this.y = this.y.toRed(this.curve.red)),
            this.z.red || (this.z = this.z.toRed(this.curve.red)),
            (this.zOne = this.z === this.curve.one);
        }
        n(a, s),
          ((e.exports = a).prototype._getEndomorphism = function(t) {
            var e, r, i;
            if (this.zeroA && this.g && this.n && 1 === this.p.modn(3))
              return (
                (r = (t.beta
                  ? new v(t.beta, 16)
                  : (r =
                      (i = this._getEndoRoots(this.p))[0].cmp(i[1]) < 0
                        ? i[0]
                        : i[1])
                ).toRed(this.red)),
                t.lambda
                  ? (e = new v(t.lambda, 16))
                  : ((i = this._getEndoRoots(this.n)),
                    0 === this.g.mul(i[0]).x.cmp(this.g.x.redMul(r))
                      ? (e = i[0])
                      : ((e = i[1]),
                        o(0 === this.g.mul(e).x.cmp(this.g.x.redMul(r))))),
                {
                  beta: r,
                  lambda: e,
                  basis: t.basis
                    ? t.basis.map(function(t) {
                        return { a: new v(t.a, 16), b: new v(t.b, 16) };
                      })
                    : this._getEndoBasis(e),
                }
              );
          }),
          (a.prototype._getEndoRoots = function(t) {
            var e = t === this.p ? this.red : v.mont(t),
              r = new v(2).toRed(e).redInvm(),
              t = r.redNeg(),
              r = new v(3)
                .toRed(e)
                .redNeg()
                .redSqrt()
                .redMul(r);
            return [t.redAdd(r).fromRed(), t.redSub(r).fromRed()];
          }),
          (a.prototype._getEndoBasis = function(t) {
            for (
              var e,
                r,
                i,
                n,
                s,
                o = this.n.ushrn(Math.floor(this.n.bitLength() / 2)),
                a = t,
                f = this.n.clone(),
                h = new v(1),
                c = new v(0),
                u = new v(0),
                d = new v(1),
                l = 0;
              0 !== a.cmpn(0);

            ) {
              var p = f.div(a),
                b = f.sub(p.mul(a)),
                m = u.sub(p.mul(h)),
                p = d.sub(p.mul(c));
              if (!i && b.cmp(o) < 0)
                (e = s.neg()), (r = h), (i = b.neg()), (n = m);
              else if (i && 2 == ++l) break;
              (f = a), (a = s = b), (u = h), (h = m), (d = c), (c = p);
            }
            var y = b.neg(),
              g = m,
              t = i.sqr().add(n.sqr());
            return (
              0 <=
                y
                  .sqr()
                  .add(g.sqr())
                  .cmp(t) && ((y = e), (g = r)),
              i.negative && ((i = i.neg()), (n = n.neg())),
              y.negative && ((y = y.neg()), (g = g.neg())),
              [{ a: i, b: n }, { a: y, b: g }]
            );
          }),
          (a.prototype._endoSplit = function(t) {
            var e = this.endo.basis,
              r = e[0],
              i = e[1],
              n = i.b.mul(t).divRound(this.n),
              s = r.b
                .neg()
                .mul(t)
                .divRound(this.n),
              o = n.mul(r.a),
              e = s.mul(i.a),
              r = n.mul(r.b),
              i = s.mul(i.b);
            return { k1: t.sub(o).sub(e), k2: r.add(i).neg() };
          }),
          (a.prototype.pointFromX = function(t, e) {
            var r = (t = !(t = new v(t, 16)).red ? t.toRed(this.red) : t)
                .redSqr()
                .redMul(t)
                .redIAdd(t.redMul(this.a))
                .redIAdd(this.b),
              i = r.redSqrt();
            if (
              0 !==
              i
                .redSqr()
                .redSub(r)
                .cmp(this.zero)
            )
              throw new Error('invalid point');
            r = i.fromRed().isOdd();
            return (
              ((e && !r) || (!e && r)) && (i = i.redNeg()), this.point(t, i)
            );
          }),
          (a.prototype.validate = function(t) {
            if (t.inf) return !0;
            var e = t.x,
              r = t.y,
              t = this.a.redMul(e),
              t = e
                .redSqr()
                .redMul(e)
                .redIAdd(t)
                .redIAdd(this.b);
            return (
              0 ===
              r
                .redSqr()
                .redISub(t)
                .cmpn(0)
            );
          }),
          (a.prototype._endoWnafMulAdd = function(t, e, r) {
            for (
              var i = this._endoWnafT1, n = this._endoWnafT2, s = 0;
              s < t.length;
              s++
            ) {
              var o = this._endoSplit(e[s]),
                a = t[s],
                f = a._getBeta();
              o.k1.negative && (o.k1.ineg(), (a = a.neg(!0))),
                o.k2.negative && (o.k2.ineg(), (f = f.neg(!0))),
                (i[2 * s] = a),
                (i[2 * s + 1] = f),
                (n[2 * s] = o.k1),
                (n[2 * s + 1] = o.k2);
            }
            for (
              var r = this._wnafMulAdd(1, i, n, 2 * s, r), h = 0;
              h < 2 * s;
              h++
            )
              (i[h] = null), (n[h] = null);
            return r;
          }),
          n(f, s.BasePoint),
          (a.prototype.point = function(t, e, r) {
            return new f(this, t, e, r);
          }),
          (a.prototype.pointFromJSON = function(t, e) {
            return f.fromJSON(this, t, e);
          }),
          (f.prototype._getBeta = function() {
            if (this.curve.endo) {
              var t = this.precomputed;
              if (t && t.beta) return t.beta;
              var e,
                r,
                i = this.curve.point(
                  this.x.redMul(this.curve.endo.beta),
                  this.y
                );
              return (
                t &&
                  ((e = this.curve),
                  (r = function(t) {
                    return e.point(t.x.redMul(e.endo.beta), t.y);
                  }),
                  ((t.beta = i).precomputed = {
                    beta: null,
                    naf: t.naf && {
                      wnd: t.naf.wnd,
                      points: t.naf.points.map(r),
                    },
                    doubles: t.doubles && {
                      step: t.doubles.step,
                      points: t.doubles.points.map(r),
                    },
                  })),
                i
              );
            }
          }),
          (f.prototype.toJSON = function() {
            return this.precomputed
              ? [
                  this.x,
                  this.y,
                  this.precomputed && {
                    doubles: this.precomputed.doubles && {
                      step: this.precomputed.doubles.step,
                      points: this.precomputed.doubles.points.slice(1),
                    },
                    naf: this.precomputed.naf && {
                      wnd: this.precomputed.naf.wnd,
                      points: this.precomputed.naf.points.slice(1),
                    },
                  },
                ]
              : [this.x, this.y];
          }),
          (f.fromJSON = function(e, t, r) {
            'string' == typeof t && (t = JSON.parse(t));
            var i = e.point(t[0], t[1], r);
            if (!t[2]) return i;
            function n(t) {
              return e.point(t[0], t[1], r);
            }
            t = t[2];
            return (
              (i.precomputed = {
                beta: null,
                doubles: t.doubles && {
                  step: t.doubles.step,
                  points: [i].concat(t.doubles.points.map(n)),
                },
                naf: t.naf && {
                  wnd: t.naf.wnd,
                  points: [i].concat(t.naf.points.map(n)),
                },
              }),
              i
            );
          }),
          (f.prototype.inspect = function() {
            return this.isInfinity()
              ? '<EC Point Infinity>'
              : '<EC Point x: ' +
                  this.x.fromRed().toString(16, 2) +
                  ' y: ' +
                  this.y.fromRed().toString(16, 2) +
                  '>';
          }),
          (f.prototype.isInfinity = function() {
            return this.inf;
          }),
          (f.prototype.add = function(t) {
            if (this.inf) return t;
            if (t.inf) return this;
            if (this.eq(t)) return this.dbl();
            if (this.neg().eq(t)) return this.curve.point(null, null);
            if (0 === this.x.cmp(t.x)) return this.curve.point(null, null);
            var e = this.y.redSub(t.y),
              t = (e =
                0 !== e.cmpn(0) ? e.redMul(this.x.redSub(t.x).redInvm()) : e)
                .redSqr()
                .redISub(this.x)
                .redISub(t.x),
              e = e.redMul(this.x.redSub(t)).redISub(this.y);
            return this.curve.point(t, e);
          }),
          (f.prototype.dbl = function() {
            if (this.inf) return this;
            var t = this.y.redAdd(this.y);
            if (0 === t.cmpn(0)) return this.curve.point(null, null);
            var e = this.curve.a,
              r = this.x.redSqr(),
              t = t.redInvm(),
              e = r
                .redAdd(r)
                .redIAdd(r)
                .redIAdd(e)
                .redMul(t),
              t = e.redSqr().redISub(this.x.redAdd(this.x)),
              e = e.redMul(this.x.redSub(t)).redISub(this.y);
            return this.curve.point(t, e);
          }),
          (f.prototype.getX = function() {
            return this.x.fromRed();
          }),
          (f.prototype.getY = function() {
            return this.y.fromRed();
          }),
          (f.prototype.mul = function(t) {
            return (
              (t = new v(t, 16)),
              this.isInfinity()
                ? this
                : this._hasDoubles(t)
                ? this.curve._fixedNafMul(this, t)
                : this.curve.endo
                ? this.curve._endoWnafMulAdd([this], [t])
                : this.curve._wnafMul(this, t)
            );
          }),
          (f.prototype.mulAdd = function(t, e, r) {
            (e = [this, e]), (r = [t, r]);
            return this.curve.endo
              ? this.curve._endoWnafMulAdd(e, r)
              : this.curve._wnafMulAdd(1, e, r, 2);
          }),
          (f.prototype.jmulAdd = function(t, e, r) {
            (e = [this, e]), (r = [t, r]);
            return this.curve.endo
              ? this.curve._endoWnafMulAdd(e, r, !0)
              : this.curve._wnafMulAdd(1, e, r, 2, !0);
          }),
          (f.prototype.eq = function(t) {
            return (
              this === t ||
              (this.inf === t.inf &&
                (this.inf || (0 === this.x.cmp(t.x) && 0 === this.y.cmp(t.y))))
            );
          }),
          (f.prototype.neg = function(t) {
            if (this.inf) return this;
            var e,
              r = this.curve.point(this.x, this.y.redNeg());
            return (
              t &&
                this.precomputed &&
                ((e = this.precomputed),
                (t = function(t) {
                  return t.neg();
                }),
                (r.precomputed = {
                  naf: e.naf && { wnd: e.naf.wnd, points: e.naf.points.map(t) },
                  doubles: e.doubles && {
                    step: e.doubles.step,
                    points: e.doubles.points.map(t),
                  },
                })),
              r
            );
          }),
          (f.prototype.toJ = function() {
            return this.inf
              ? this.curve.jpoint(null, null, null)
              : this.curve.jpoint(this.x, this.y, this.curve.one);
          }),
          n(h, s.BasePoint),
          (a.prototype.jpoint = function(t, e, r) {
            return new h(this, t, e, r);
          }),
          (h.prototype.toP = function() {
            if (this.isInfinity()) return this.curve.point(null, null);
            var t = this.z.redInvm(),
              e = t.redSqr(),
              r = this.x.redMul(e),
              t = this.y.redMul(e).redMul(t);
            return this.curve.point(r, t);
          }),
          (h.prototype.neg = function() {
            return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
          }),
          (h.prototype.add = function(t) {
            if (this.isInfinity()) return t;
            if (t.isInfinity()) return this;
            var e = t.z.redSqr(),
              r = this.z.redSqr(),
              i = this.x.redMul(e),
              n = t.x.redMul(r),
              s = this.y.redMul(e.redMul(t.z)),
              o = t.y.redMul(r.redMul(this.z)),
              e = i.redSub(n),
              r = s.redSub(o);
            if (0 === e.cmpn(0))
              return 0 !== r.cmpn(0)
                ? this.curve.jpoint(null, null, null)
                : this.dbl();
            (n = e.redSqr()),
              (o = n.redMul(e)),
              (i = i.redMul(n)),
              (n = r
                .redSqr()
                .redIAdd(o)
                .redISub(i)
                .redISub(i)),
              (o = r.redMul(i.redISub(n)).redISub(s.redMul(o))),
              (e = this.z.redMul(t.z).redMul(e));
            return this.curve.jpoint(n, o, e);
          }),
          (h.prototype.mixedAdd = function(t) {
            if (this.isInfinity()) return t.toJ();
            if (t.isInfinity()) return this;
            var e = this.z.redSqr(),
              r = this.x,
              i = t.x.redMul(e),
              n = this.y,
              s = t.y.redMul(e).redMul(this.z),
              t = r.redSub(i),
              e = n.redSub(s);
            if (0 === t.cmpn(0))
              return 0 !== e.cmpn(0)
                ? this.curve.jpoint(null, null, null)
                : this.dbl();
            (i = t.redSqr()),
              (s = i.redMul(t)),
              (r = r.redMul(i)),
              (i = e
                .redSqr()
                .redIAdd(s)
                .redISub(r)
                .redISub(r)),
              (s = e.redMul(r.redISub(i)).redISub(n.redMul(s))),
              (t = this.z.redMul(t));
            return this.curve.jpoint(i, s, t);
          }),
          (h.prototype.dblp = function(t) {
            if (0 === t) return this;
            if (this.isInfinity()) return this;
            if (!t) return this.dbl();
            if (this.curve.zeroA || this.curve.threeA) {
              for (var e = this, r = 0; r < t; r++) e = e.dbl();
              return e;
            }
            var i = this.curve.a,
              n = this.curve.tinv,
              s = this.x,
              o = this.y,
              a = this.z,
              f = a.redSqr().redSqr(),
              h = o.redAdd(o);
            for (r = 0; r < t; r++) {
              var c = s.redSqr(),
                u = h.redSqr(),
                d = u.redSqr(),
                l = c
                  .redAdd(c)
                  .redIAdd(c)
                  .redIAdd(i.redMul(f)),
                c = s.redMul(u),
                u = l.redSqr().redISub(c.redAdd(c)),
                c = c.redISub(u),
                l = (l = l.redMul(c)).redIAdd(l).redISub(d),
                c = h.redMul(a);
              r + 1 < t && (f = f.redMul(d)), (s = u), (a = c), (h = l);
            }
            return this.curve.jpoint(s, h.redMul(n), a);
          }),
          (h.prototype.dbl = function() {
            return this.isInfinity()
              ? this
              : this.curve.zeroA
              ? this._zeroDbl()
              : this.curve.threeA
              ? this._threeDbl()
              : this._dbl();
          }),
          (h.prototype._zeroDbl = function() {
            var t,
              e,
              r,
              i,
              n,
              s = this.zOne
                ? ((r = this.x.redSqr()),
                  (t = (i = this.y.redSqr()).redSqr()),
                  (n = (n = this.x
                    .redAdd(i)
                    .redSqr()
                    .redISub(r)
                    .redISub(t)).redIAdd(n)),
                  (i = (e = r.redAdd(r).redIAdd(r))
                    .redSqr()
                    .redISub(n)
                    .redISub(n)),
                  (r = (r = (r = t.redIAdd(t)).redIAdd(r)).redIAdd(r)),
                  (e = e.redMul(n.redISub((t = i))).redISub(r)),
                  this.y.redAdd(this.y))
                : ((n = this.x.redSqr()),
                  (s = (i = this.y.redSqr()).redSqr()),
                  (r = (r = this.x
                    .redAdd(i)
                    .redSqr()
                    .redISub(n)
                    .redISub(s)).redIAdd(r)),
                  (n = (i = n.redAdd(n).redIAdd(n)).redSqr()),
                  (s = (s = (s = s.redIAdd(s)).redIAdd(s)).redIAdd(s)),
                  (t = n.redISub(r).redISub(r)),
                  (e = i.redMul(r.redISub(t)).redISub(s)),
                  (s = this.y.redMul(this.z)).redIAdd(s));
            return this.curve.jpoint(t, e, s);
          }),
          (h.prototype._threeDbl = function() {
            var t, e, r, i, n, s, o, a;
            return (
              this.zOne
                ? ((o = this.x.redSqr()),
                  (r = (t = this.y.redSqr()).redSqr()),
                  (s = (s = this.x
                    .redAdd(t)
                    .redSqr()
                    .redISub(o)
                    .redISub(r)).redIAdd(s)),
                  (e = i = (a = o
                    .redAdd(o)
                    .redIAdd(o)
                    .redIAdd(this.curve.a))
                    .redSqr()
                    .redISub(s)
                    .redISub(s)),
                  (n = (n = (n = r.redIAdd(r)).redIAdd(n)).redIAdd(n)),
                  (t = a.redMul(s.redISub(i)).redISub(n)),
                  (o = this.y.redAdd(this.y)))
                : ((r = this.z.redSqr()),
                  (a = this.y.redSqr()),
                  (s = this.x.redMul(a)),
                  (i = (i = this.x.redSub(r).redMul(this.x.redAdd(r)))
                    .redAdd(i)
                    .redIAdd(i)),
                  (s = (n = (n = s.redIAdd(s)).redIAdd(n)).redAdd(n)),
                  (e = i.redSqr().redISub(s)),
                  (o = this.y
                    .redAdd(this.z)
                    .redSqr()
                    .redISub(a)
                    .redISub(r)),
                  (a = (a = (a = (a = a.redSqr()).redIAdd(a)).redIAdd(
                    a
                  )).redIAdd(a)),
                  (t = i.redMul(n.redISub(e)).redISub(a))),
              this.curve.jpoint(e, t, o)
            );
          }),
          (h.prototype._dbl = function() {
            var t = this.curve.a,
              e = this.x,
              r = this.y,
              i = this.z,
              n = i.redSqr().redSqr(),
              s = e.redSqr(),
              o = r.redSqr(),
              t = s
                .redAdd(s)
                .redIAdd(s)
                .redIAdd(t.redMul(n)),
              n = e.redAdd(e),
              e = (n = n.redIAdd(n)).redMul(o),
              n = t.redSqr().redISub(e.redAdd(e)),
              e = e.redISub(n),
              o = o.redSqr();
            o = (o = (o = o.redIAdd(o)).redIAdd(o)).redIAdd(o);
            (o = t.redMul(e).redISub(o)), (i = r.redAdd(r).redMul(i));
            return this.curve.jpoint(n, o, i);
          }),
          (h.prototype.trpl = function() {
            if (!this.curve.zeroA) return this.dbl().add(this);
            var t = this.x.redSqr(),
              e = this.y.redSqr(),
              r = this.z.redSqr(),
              i = e.redSqr(),
              n = t.redAdd(t).redIAdd(t),
              s = n.redSqr(),
              o = this.x
                .redAdd(e)
                .redSqr()
                .redISub(t)
                .redISub(i),
              t = (o = (o = (o = o.redIAdd(o)).redAdd(o).redIAdd(o)).redISub(
                s
              )).redSqr(),
              i = i.redIAdd(i);
            i = (i = (i = i.redIAdd(i)).redIAdd(i)).redIAdd(i);
            (s = n
              .redIAdd(o)
              .redSqr()
              .redISub(s)
              .redISub(t)
              .redISub(i)),
              (e = e.redMul(s));
            e = (e = e.redIAdd(e)).redIAdd(e);
            e = this.x.redMul(t).redISub(e);
            e = (e = e.redIAdd(e)).redIAdd(e);
            s = this.y.redMul(s.redMul(i.redISub(s)).redISub(o.redMul(t)));
            s = (s = (s = s.redIAdd(s)).redIAdd(s)).redIAdd(s);
            t = this.z
              .redAdd(o)
              .redSqr()
              .redISub(r)
              .redISub(t);
            return this.curve.jpoint(e, s, t);
          }),
          (h.prototype.mul = function(t, e) {
            return (t = new v(t, e)), this.curve._wnafMul(this, t);
          }),
          (h.prototype.eq = function(t) {
            if ('affine' === t.type) return this.eq(t.toJ());
            if (this === t) return !0;
            var e = this.z.redSqr(),
              r = t.z.redSqr();
            if (
              0 !==
              this.x
                .redMul(r)
                .redISub(t.x.redMul(e))
                .cmpn(0)
            )
              return !1;
            (e = e.redMul(this.z)), (r = r.redMul(t.z));
            return (
              0 ===
              this.y
                .redMul(r)
                .redISub(t.y.redMul(e))
                .cmpn(0)
            );
          }),
          (h.prototype.eqXToP = function(t) {
            var e = this.z.redSqr(),
              r = t.toRed(this.curve.red).redMul(e);
            if (0 === this.x.cmp(r)) return !0;
            for (var i = t.clone(), n = this.curve.redN.redMul(e); ; ) {
              if ((i.iadd(this.curve.n), 0 <= i.cmp(this.curve.p))) return !1;
              if ((r.redIAdd(n), 0 === this.x.cmp(r))) return !0;
            }
          }),
          (h.prototype.inspect = function() {
            return this.isInfinity()
              ? '<EC JPoint Infinity>'
              : '<EC JPoint x: ' +
                  this.x.toString(16, 2) +
                  ' y: ' +
                  this.y.toString(16, 2) +
                  ' z: ' +
                  this.z.toString(16, 2) +
                  '>';
          }),
          (h.prototype.isInfinity = function() {
            return 0 === this.z.cmpn(0);
          });
      },
      { '../utils': 98, './base': 85, 'bn.js': 99, inherits: 133 },
    ],
    90: [
      function(t, e, r) {
        'use strict';
        var i,
          n = r,
          r = t('hash.js'),
          s = t('./curve'),
          o = t('./utils').assert;
        function a(t) {
          'short' === t.type
            ? (this.curve = new s.short(t))
            : 'edwards' === t.type
            ? (this.curve = new s.edwards(t))
            : (this.curve = new s.mont(t)),
            (this.g = this.curve.g),
            (this.n = this.curve.n),
            (this.hash = t.hash),
            o(this.g.validate(), 'Invalid curve'),
            o(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
        }
        function f(e, r) {
          Object.defineProperty(n, e, {
            configurable: !0,
            enumerable: !0,
            get: function() {
              var t = new a(r);
              return (
                Object.defineProperty(n, e, {
                  configurable: !0,
                  enumerable: !0,
                  value: t,
                }),
                t
              );
            },
          });
        }
        (n.PresetCurve = a),
          f('p192', {
            type: 'short',
            prime: 'p192',
            p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
            a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
            b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
            n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
            hash: r.sha256,
            gRed: !1,
            g: [
              '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
              '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811',
            ],
          }),
          f('p224', {
            type: 'short',
            prime: 'p224',
            p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
            a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
            b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
            n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
            hash: r.sha256,
            gRed: !1,
            g: [
              'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
              'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34',
            ],
          }),
          f('p256', {
            type: 'short',
            prime: null,
            p:
              'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
            a:
              'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
            b:
              '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
            n:
              'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
            hash: r.sha256,
            gRed: !1,
            g: [
              '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
              '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5',
            ],
          }),
          f('p384', {
            type: 'short',
            prime: null,
            p:
              'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff',
            a:
              'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc',
            b:
              'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
            n:
              'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
            hash: r.sha384,
            gRed: !1,
            g: [
              'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7',
              '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f',
            ],
          }),
          f('p521', {
            type: 'short',
            prime: null,
            p:
              '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff',
            a:
              '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc',
            b:
              '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
            n:
              '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
            hash: r.sha512,
            gRed: !1,
            g: [
              '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
              '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650',
            ],
          }),
          f('curve25519', {
            type: 'mont',
            prime: 'p25519',
            p:
              '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
            a: '76d06',
            b: '1',
            n:
              '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
            hash: r.sha256,
            gRed: !1,
            g: ['9'],
          }),
          f('ed25519', {
            type: 'edwards',
            prime: 'p25519',
            p:
              '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
            a: '-1',
            c: '1',
            d:
              '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
            n:
              '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
            hash: r.sha256,
            gRed: !1,
            g: [
              '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
              '6666666666666666666666666666666666666666666666666666666666666658',
            ],
          });
        try {
          i = t('./precomputed/secp256k1');
        } catch (t) {
          i = void 0;
        }
        f('secp256k1', {
          type: 'short',
          prime: 'k256',
          p:
            'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
          a: '0',
          b: '7',
          n:
            'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
          h: '1',
          hash: r.sha256,
          beta:
            '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
          lambda:
            '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
          basis: [
            {
              a: '3086d221a7d46bcde86c90e49284eb15',
              b: '-e4437ed6010e88286f547fa90abfe4c3',
            },
            {
              a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
              b: '3086d221a7d46bcde86c90e49284eb15',
            },
          ],
          gRed: !1,
          g: [
            '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
            '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
            i,
          ],
        });
      },
      {
        './curve': 87,
        './precomputed/secp256k1': 97,
        './utils': 98,
        'hash.js': 119,
      },
    ],
    91: [
      function(t, e, r) {
        'use strict';
        var d = t('bn.js'),
          l = t('hmac-drbg'),
          i = t('../utils'),
          n = t('../curves'),
          s = t('brorand'),
          a = i.assert,
          o = t('./key'),
          p = t('./signature');
        function f(t) {
          if (!(this instanceof f)) return new f(t);
          'string' == typeof t &&
            (a(
              Object.prototype.hasOwnProperty.call(n, t),
              'Unknown curve ' + t
            ),
            (t = n[t])),
            t instanceof n.PresetCurve && (t = { curve: t }),
            (this.curve = t.curve.curve),
            (this.n = this.curve.n),
            (this.nh = this.n.ushrn(1)),
            (this.g = this.curve.g),
            (this.g = t.curve.g),
            this.g.precompute(t.curve.n.bitLength() + 1),
            (this.hash = t.hash || t.curve.hash);
        }
        ((e.exports = f).prototype.keyPair = function(t) {
          return new o(this, t);
        }),
          (f.prototype.keyFromPrivate = function(t, e) {
            return o.fromPrivate(this, t, e);
          }),
          (f.prototype.keyFromPublic = function(t, e) {
            return o.fromPublic(this, t, e);
          }),
          (f.prototype.genKeyPair = function(t) {
            for (
              var e = new l({
                  hash: this.hash,
                  pers: (t = t || {}).pers,
                  persEnc: t.persEnc || 'utf8',
                  entropy: t.entropy || s(this.hash.hmacStrength),
                  entropyEnc: (t.entropy && t.entropyEnc) || 'utf8',
                  nonce: this.n.toArray(),
                }),
                r = this.n.byteLength(),
                i = this.n.sub(new d(2));
              ;

            ) {
              var n = new d(e.generate(r));
              if (!(0 < n.cmp(i))) return n.iaddn(1), this.keyFromPrivate(n);
            }
          }),
          (f.prototype._truncateToN = function(t, e) {
            var r = 8 * t.byteLength() - this.n.bitLength();
            return (
              0 < r && (t = t.ushrn(r)),
              !e && 0 <= t.cmp(this.n) ? t.sub(this.n) : t
            );
          }),
          (f.prototype.sign = function(t, e, r, i) {
            'object' == typeof r && ((i = r), (r = null)),
              (i = i || {}),
              (e = this.keyFromPrivate(e, r)),
              (t = this._truncateToN(new d(t, 16)));
            for (
              var n = this.n.byteLength(),
                r = e.getPrivate().toArray('be', n),
                n = t.toArray('be', n),
                s = new l({
                  hash: this.hash,
                  entropy: r,
                  nonce: n,
                  pers: i.pers,
                  persEnc: i.persEnc || 'utf8',
                }),
                o = this.n.sub(new d(1)),
                a = 0;
              ;
              a++
            ) {
              var f = i.k ? i.k(a) : new d(s.generate(this.n.byteLength()));
              if (
                !((f = this._truncateToN(f, !0)).cmpn(1) <= 0 || 0 <= f.cmp(o))
              ) {
                var h = this.g.mul(f);
                if (!h.isInfinity()) {
                  var c = h.getX(),
                    u = c.umod(this.n);
                  if (0 !== u.cmpn(0)) {
                    f = f.invm(this.n).mul(u.mul(e.getPrivate()).iadd(t));
                    if (0 !== (f = f.umod(this.n)).cmpn(0)) {
                      c = (h.getY().isOdd() ? 1 : 0) | (0 !== c.cmp(u) ? 2 : 0);
                      return (
                        i.canonical &&
                          0 < f.cmp(this.nh) &&
                          ((f = this.n.sub(f)), (c ^= 1)),
                        new p({ r: u, s: f, recoveryParam: c })
                      );
                    }
                  }
                }
              }
            }
          }),
          (f.prototype.verify = function(t, e, r, i) {
            (t = this._truncateToN(new d(t, 16))),
              (r = this.keyFromPublic(r, i));
            (i = (e = new p(e, 'hex')).r), (e = e.s);
            if (i.cmpn(1) < 0 || 0 <= i.cmp(this.n)) return !1;
            if (e.cmpn(1) < 0 || 0 <= e.cmp(this.n)) return !1;
            var n,
              e = e.invm(this.n),
              t = e.mul(t).umod(this.n),
              e = e.mul(i).umod(this.n);
            return this.curve._maxwellTrick
              ? !(n = this.g.jmulAdd(t, r.getPublic(), e)).isInfinity() &&
                  n.eqXToP(i)
              : !(n = this.g.mulAdd(t, r.getPublic(), e)).isInfinity() &&
                  0 ===
                    n
                      .getX()
                      .umod(this.n)
                      .cmp(i);
          }),
          (f.prototype.recoverPubKey = function(t, e, r, i) {
            a((3 & r) === r, 'The recovery param is more than two bits'),
              (e = new p(e, i));
            var n = this.n,
              s = new d(t),
              o = e.r,
              i = e.s,
              t = 1 & r,
              r = r >> 1;
            if (0 <= o.cmp(this.curve.p.umod(this.curve.n)) && r)
              throw new Error('Unable to find sencond key candinate');
            (o = r
              ? this.curve.pointFromX(o.add(this.curve.n), t)
              : this.curve.pointFromX(o, t)),
              (e = e.r.invm(n)),
              (s = n
                .sub(s)
                .mul(e)
                .umod(n)),
              (n = i.mul(e).umod(n));
            return this.g.mulAdd(s, o, n);
          }),
          (f.prototype.getKeyRecoveryParam = function(t, e, r, i) {
            if (null !== (e = new p(e, i)).recoveryParam)
              return e.recoveryParam;
            for (var n, s = 0; s < 4; s++) {
              try {
                n = this.recoverPubKey(t, e, s);
              } catch (t) {
                continue;
              }
              if (n.eq(r)) return s;
            }
            throw new Error('Unable to find valid recovery factor');
          });
      },
      {
        '../curves': 90,
        '../utils': 98,
        './key': 92,
        './signature': 93,
        'bn.js': 99,
        brorand: 19,
        'hmac-drbg': 131,
      },
    ],
    92: [
      function(t, e, r) {
        'use strict';
        var i = t('bn.js'),
          n = t('../utils').assert;
        function s(t, e) {
          (this.ec = t),
            (this.priv = null),
            (this.pub = null),
            e.priv && this._importPrivate(e.priv, e.privEnc),
            e.pub && this._importPublic(e.pub, e.pubEnc);
        }
        ((e.exports = s).fromPublic = function(t, e, r) {
          return e instanceof s ? e : new s(t, { pub: e, pubEnc: r });
        }),
          (s.fromPrivate = function(t, e, r) {
            return e instanceof s ? e : new s(t, { priv: e, privEnc: r });
          }),
          (s.prototype.validate = function() {
            var t = this.getPublic();
            return t.isInfinity()
              ? { result: !1, reason: 'Invalid public key' }
              : t.validate()
              ? t.mul(this.ec.curve.n).isInfinity()
                ? { result: !0, reason: null }
                : { result: !1, reason: 'Public key * N != O' }
              : { result: !1, reason: 'Public key is not a point' };
          }),
          (s.prototype.getPublic = function(t, e) {
            return (
              'string' == typeof t && ((e = t), (t = null)),
              this.pub || (this.pub = this.ec.g.mul(this.priv)),
              e ? this.pub.encode(e, t) : this.pub
            );
          }),
          (s.prototype.getPrivate = function(t) {
            return 'hex' === t ? this.priv.toString(16, 2) : this.priv;
          }),
          (s.prototype._importPrivate = function(t, e) {
            (this.priv = new i(t, e || 16)),
              (this.priv = this.priv.umod(this.ec.curve.n));
          }),
          (s.prototype._importPublic = function(t, e) {
            if (t.x || t.y)
              return (
                'mont' === this.ec.curve.type
                  ? n(t.x, 'Need x coordinate')
                  : ('short' !== this.ec.curve.type &&
                      'edwards' !== this.ec.curve.type) ||
                    n(t.x && t.y, 'Need both x and y coordinate'),
                void (this.pub = this.ec.curve.point(t.x, t.y))
              );
            this.pub = this.ec.curve.decodePoint(t, e);
          }),
          (s.prototype.derive = function(t) {
            return (
              t.validate() || n(t.validate(), 'public point not validated'),
              t.mul(this.priv).getX()
            );
          }),
          (s.prototype.sign = function(t, e, r) {
            return this.ec.sign(t, this, e, r);
          }),
          (s.prototype.verify = function(t, e) {
            return this.ec.verify(t, e, this);
          }),
          (s.prototype.inspect = function() {
            return (
              '<Key priv: ' +
              (this.priv && this.priv.toString(16, 2)) +
              ' pub: ' +
              (this.pub && this.pub.inspect()) +
              ' >'
            );
          });
      },
      { '../utils': 98, 'bn.js': 99 },
    ],
    93: [
      function(t, e, r) {
        'use strict';
        var n = t('bn.js'),
          s = t('../utils'),
          i = s.assert;
        function o(t, e) {
          if (t instanceof o) return t;
          this._importDER(t, e) ||
            (i(t.r && t.s, 'Signature without r or s'),
            (this.r = new n(t.r, 16)),
            (this.s = new n(t.s, 16)),
            void 0 === t.recoveryParam
              ? (this.recoveryParam = null)
              : (this.recoveryParam = t.recoveryParam));
        }
        function a() {
          this.place = 0;
        }
        function f(t, e) {
          var r = t[e.place++];
          if (!(128 & r)) return r;
          var i = 15 & r;
          if (0 == i || 4 < i) return !1;
          for (var n = 0, s = 0, o = e.place; s < i; s++, o++)
            (n <<= 8), (n |= t[o]), (n >>>= 0);
          return !(n <= 127) && ((e.place = o), n);
        }
        function h(t) {
          for (
            var e = 0, r = t.length - 1;
            !t[e] && !(128 & t[e + 1]) && e < r;

          )
            e++;
          return 0 === e ? t : t.slice(e);
        }
        function c(t, e) {
          if (e < 128) t.push(e);
          else {
            var r = 1 + ((Math.log(e) / Math.LN2) >>> 3);
            for (t.push(128 | r); --r; ) t.push((e >>> (r << 3)) & 255);
            t.push(e);
          }
        }
        ((e.exports = o).prototype._importDER = function(t, e) {
          t = s.toArray(t, e);
          var r = new a();
          if (48 !== t[r.place++]) return !1;
          var i = f(t, r);
          if (!1 === i) return !1;
          if (i + r.place !== t.length) return !1;
          if (2 !== t[r.place++]) return !1;
          e = f(t, r);
          if (!1 === e) return !1;
          i = t.slice(r.place, e + r.place);
          if (((r.place += e), 2 !== t[r.place++])) return !1;
          e = f(t, r);
          if (!1 === e) return !1;
          if (t.length !== e + r.place) return !1;
          r = t.slice(r.place, e + r.place);
          if (0 === i[0]) {
            if (!(128 & i[1])) return !1;
            i = i.slice(1);
          }
          if (0 === r[0]) {
            if (!(128 & r[1])) return !1;
            r = r.slice(1);
          }
          return (
            (this.r = new n(i)),
            (this.s = new n(r)),
            !(this.recoveryParam = null)
          );
        }),
          (o.prototype.toDER = function(t) {
            var e = this.r.toArray(),
              r = this.s.toArray();
            for (
              128 & e[0] && (e = [0].concat(e)),
                128 & r[0] && (r = [0].concat(r)),
                e = h(e),
                r = h(r);
              !(r[0] || 128 & r[1]);

            )
              r = r.slice(1);
            var i = [2];
            c(i, e.length), (i = i.concat(e)).push(2), c(i, r.length);
            (e = i.concat(r)), (i = [48]);
            return c(i, e.length), (i = i.concat(e)), s.encode(i, t);
          });
      },
      { '../utils': 98, 'bn.js': 99 },
    ],
    94: [
      function(t, e, r) {
        'use strict';
        var i = t('hash.js'),
          n = t('../curves'),
          s = t('../utils'),
          o = s.assert,
          a = s.parseBytes,
          f = t('./key'),
          h = t('./signature');
        function c(t) {
          if (
            (o('ed25519' === t, 'only tested with ed25519 so far'),
            !(this instanceof c))
          )
            return new c(t);
          (t = n[t].curve),
            (this.curve = t),
            (this.g = t.g),
            this.g.precompute(t.n.bitLength() + 1),
            (this.pointClass = t.point().constructor),
            (this.encodingLength = Math.ceil(t.n.bitLength() / 8)),
            (this.hash = i.sha512);
        }
        ((e.exports = c).prototype.sign = function(t, e) {
          t = a(t);
          var r = this.keyFromSecret(e),
            i = this.hashInt(r.messagePrefix(), t),
            n = this.g.mul(i),
            e = this.encodePoint(n),
            r = this.hashInt(e, r.pubBytes(), t).mul(r.priv()),
            r = i.add(r).umod(this.curve.n);
          return this.makeSignature({ R: n, S: r, Rencoded: e });
        }),
          (c.prototype.verify = function(t, e, r) {
            (t = a(t)), (e = this.makeSignature(e));
            var i = this.keyFromPublic(r),
              r = this.hashInt(e.Rencoded(), i.pubBytes(), t),
              t = this.g.mul(e.S());
            return e
              .R()
              .add(i.pub().mul(r))
              .eq(t);
          }),
          (c.prototype.hashInt = function() {
            for (var t = this.hash(), e = 0; e < arguments.length; e++)
              t.update(arguments[e]);
            return s.intFromLE(t.digest()).umod(this.curve.n);
          }),
          (c.prototype.keyFromPublic = function(t) {
            return f.fromPublic(this, t);
          }),
          (c.prototype.keyFromSecret = function(t) {
            return f.fromSecret(this, t);
          }),
          (c.prototype.makeSignature = function(t) {
            return t instanceof h ? t : new h(this, t);
          }),
          (c.prototype.encodePoint = function(t) {
            var e = t.getY().toArray('le', this.encodingLength);
            return (
              (e[this.encodingLength - 1] |= t.getX().isOdd() ? 128 : 0), e
            );
          }),
          (c.prototype.decodePoint = function(t) {
            var e = (t = s.parseBytes(t)).length - 1,
              r = t.slice(0, e).concat(-129 & t[e]),
              e = 0 != (128 & t[e]),
              r = s.intFromLE(r);
            return this.curve.pointFromY(r, e);
          }),
          (c.prototype.encodeInt = function(t) {
            return t.toArray('le', this.encodingLength);
          }),
          (c.prototype.decodeInt = function(t) {
            return s.intFromLE(t);
          }),
          (c.prototype.isPoint = function(t) {
            return t instanceof this.pointClass;
          });
      },
      {
        '../curves': 90,
        '../utils': 98,
        './key': 95,
        './signature': 96,
        'hash.js': 119,
      },
    ],
    95: [
      function(t, e, r) {
        'use strict';
        var i = t('../utils'),
          n = i.assert,
          s = i.parseBytes,
          t = i.cachedProperty;
        function o(t, e) {
          (this.eddsa = t),
            (this._secret = s(e.secret)),
            t.isPoint(e.pub)
              ? (this._pub = e.pub)
              : (this._pubBytes = s(e.pub));
        }
        (o.fromPublic = function(t, e) {
          return e instanceof o ? e : new o(t, { pub: e });
        }),
          (o.fromSecret = function(t, e) {
            return e instanceof o ? e : new o(t, { secret: e });
          }),
          (o.prototype.secret = function() {
            return this._secret;
          }),
          t(o, 'pubBytes', function() {
            return this.eddsa.encodePoint(this.pub());
          }),
          t(o, 'pub', function() {
            return this._pubBytes
              ? this.eddsa.decodePoint(this._pubBytes)
              : this.eddsa.g.mul(this.priv());
          }),
          t(o, 'privBytes', function() {
            var t = this.eddsa,
              e = this.hash(),
              r = t.encodingLength - 1,
              t = e.slice(0, t.encodingLength);
            return (t[0] &= 248), (t[r] &= 127), (t[r] |= 64), t;
          }),
          t(o, 'priv', function() {
            return this.eddsa.decodeInt(this.privBytes());
          }),
          t(o, 'hash', function() {
            return this.eddsa
              .hash()
              .update(this.secret())
              .digest();
          }),
          t(o, 'messagePrefix', function() {
            return this.hash().slice(this.eddsa.encodingLength);
          }),
          (o.prototype.sign = function(t) {
            return (
              n(this._secret, 'KeyPair can only verify'),
              this.eddsa.sign(t, this)
            );
          }),
          (o.prototype.verify = function(t, e) {
            return this.eddsa.verify(t, e, this);
          }),
          (o.prototype.getSecret = function(t) {
            return (
              n(this._secret, 'KeyPair is public only'),
              i.encode(this.secret(), t)
            );
          }),
          (o.prototype.getPublic = function(t) {
            return i.encode(this.pubBytes(), t);
          }),
          (e.exports = o);
      },
      { '../utils': 98 },
    ],
    96: [
      function(t, e, r) {
        'use strict';
        var i = t('bn.js'),
          n = t('../utils'),
          s = n.assert,
          t = n.cachedProperty,
          o = n.parseBytes;
        function a(t, e) {
          (this.eddsa = t),
            'object' != typeof e && (e = o(e)),
            Array.isArray(e) &&
              (e = {
                R: e.slice(0, t.encodingLength),
                S: e.slice(t.encodingLength),
              }),
            s(e.R && e.S, 'Signature without R or S'),
            t.isPoint(e.R) && (this._R = e.R),
            e.S instanceof i && (this._S = e.S),
            (this._Rencoded = Array.isArray(e.R) ? e.R : e.Rencoded),
            (this._Sencoded = Array.isArray(e.S) ? e.S : e.Sencoded);
        }
        t(a, 'S', function() {
          return this.eddsa.decodeInt(this.Sencoded());
        }),
          t(a, 'R', function() {
            return this.eddsa.decodePoint(this.Rencoded());
          }),
          t(a, 'Rencoded', function() {
            return this.eddsa.encodePoint(this.R());
          }),
          t(a, 'Sencoded', function() {
            return this.eddsa.encodeInt(this.S());
          }),
          (a.prototype.toBytes = function() {
            return this.Rencoded().concat(this.Sencoded());
          }),
          (a.prototype.toHex = function() {
            return n.encode(this.toBytes(), 'hex').toUpperCase();
          }),
          (e.exports = a);
      },
      { '../utils': 98, 'bn.js': 99 },
    ],
    97: [
      function(t, e, r) {
        e.exports = {
          doubles: {
            step: 4,
            points: [
              [
                'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821',
              ],
              [
                '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf',
              ],
              [
                '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695',
              ],
              [
                '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9',
              ],
              [
                '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36',
              ],
              [
                '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f',
              ],
              [
                'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999',
              ],
              [
                '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09',
              ],
              [
                'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d',
              ],
              [
                'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088',
              ],
              [
                'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d',
              ],
              [
                '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8',
              ],
              [
                '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a',
              ],
              [
                '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453',
              ],
              [
                '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160',
              ],
              [
                '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0',
              ],
              [
                '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6',
              ],
              [
                '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589',
              ],
              [
                '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17',
              ],
              [
                'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda',
              ],
              [
                'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd',
              ],
              [
                '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2',
              ],
              [
                '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6',
              ],
              [
                'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f',
              ],
              [
                '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01',
              ],
              [
                'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3',
              ],
              [
                'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f',
              ],
              [
                'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7',
              ],
              [
                'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78',
              ],
              [
                'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1',
              ],
              [
                '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150',
              ],
              [
                '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82',
              ],
              [
                'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc',
              ],
              [
                '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b',
              ],
              [
                'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51',
              ],
              [
                'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45',
              ],
              [
                'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120',
              ],
              [
                '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84',
              ],
              [
                '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d',
              ],
              [
                '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d',
              ],
              [
                '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8',
              ],
              [
                'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8',
              ],
              [
                '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac',
              ],
              [
                '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f',
              ],
              [
                '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962',
              ],
              [
                'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907',
              ],
              [
                '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec',
              ],
              [
                'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d',
              ],
              [
                'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414',
              ],
              [
                '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd',
              ],
              [
                '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0',
              ],
              [
                'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811',
              ],
              [
                'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1',
              ],
              [
                'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c',
              ],
              [
                '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73',
              ],
              [
                '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd',
              ],
              [
                'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405',
              ],
              [
                '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589',
              ],
              [
                '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e',
              ],
              [
                '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27',
              ],
              [
                'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1',
              ],
              [
                '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482',
              ],
              [
                '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945',
              ],
              [
                'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573',
              ],
              [
                'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82',
              ],
            ],
          },
          naf: {
            wnd: 7,
            points: [
              [
                'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672',
              ],
              [
                '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6',
              ],
              [
                '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da',
              ],
              [
                'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37',
              ],
              [
                '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b',
              ],
              [
                'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81',
              ],
              [
                'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58',
              ],
              [
                'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77',
              ],
              [
                '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a',
              ],
              [
                '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c',
              ],
              [
                '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67',
              ],
              [
                '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402',
              ],
              [
                'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55',
              ],
              [
                'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482',
              ],
              [
                '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82',
              ],
              [
                '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396',
              ],
              [
                '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49',
              ],
              [
                '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf',
              ],
              [
                '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a',
              ],
              [
                '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7',
              ],
              [
                'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933',
              ],
              [
                '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a',
              ],
              [
                '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6',
              ],
              [
                'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37',
              ],
              [
                '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e',
              ],
              [
                'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6',
              ],
              [
                'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476',
              ],
              [
                '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40',
              ],
              [
                '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61',
              ],
              [
                '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683',
              ],
              [
                'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5',
              ],
              [
                '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b',
              ],
              [
                'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417',
              ],
              [
                '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868',
              ],
              [
                '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a',
              ],
              [
                'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6',
              ],
              [
                '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996',
              ],
              [
                '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e',
              ],
              [
                'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d',
              ],
              [
                '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2',
              ],
              [
                '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e',
              ],
              [
                '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437',
              ],
              [
                '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311',
              ],
              [
                'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4',
              ],
              [
                '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575',
              ],
              [
                '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d',
              ],
              [
                '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d',
              ],
              [
                'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629',
              ],
              [
                'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06',
              ],
              [
                '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374',
              ],
              [
                '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee',
              ],
              [
                'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1',
              ],
              [
                'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b',
              ],
              [
                '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661',
              ],
              [
                '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6',
              ],
              [
                'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e',
              ],
              [
                '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d',
              ],
              [
                'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc',
              ],
              [
                '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4',
              ],
              [
                '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c',
              ],
              [
                'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b',
              ],
              [
                'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913',
              ],
              [
                '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154',
              ],
              [
                '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865',
              ],
              [
                '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc',
              ],
              [
                '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224',
              ],
              [
                '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e',
              ],
              [
                '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6',
              ],
              [
                '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511',
              ],
              [
                '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b',
              ],
              [
                'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2',
              ],
              [
                '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c',
              ],
              [
                'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3',
              ],
              [
                'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d',
              ],
              [
                'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700',
              ],
              [
                'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4',
              ],
              [
                '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196',
              ],
              [
                '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4',
              ],
              [
                '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257',
              ],
              [
                'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13',
              ],
              [
                'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096',
              ],
              [
                'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38',
              ],
              [
                'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f',
              ],
              [
                '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448',
              ],
              [
                'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a',
              ],
              [
                'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4',
              ],
              [
                '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437',
              ],
              [
                '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7',
              ],
              [
                'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d',
              ],
              [
                'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a',
              ],
              [
                'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54',
              ],
              [
                '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77',
              ],
              [
                'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517',
              ],
              [
                '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10',
              ],
              [
                'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125',
              ],
              [
                'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e',
              ],
              [
                '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1',
              ],
              [
                'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2',
              ],
              [
                'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423',
              ],
              [
                'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8',
              ],
              [
                '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758',
              ],
              [
                '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375',
              ],
              [
                'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d',
              ],
              [
                '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec',
              ],
              [
                '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0',
              ],
              [
                '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c',
              ],
              [
                'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4',
              ],
              [
                '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f',
              ],
              [
                '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649',
              ],
              [
                '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826',
              ],
              [
                '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5',
              ],
              [
                'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87',
              ],
              [
                '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b',
              ],
              [
                'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc',
              ],
              [
                '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c',
              ],
              [
                'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f',
              ],
              [
                'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a',
              ],
              [
                'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46',
              ],
              [
                '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f',
              ],
              [
                '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03',
              ],
              [
                '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08',
              ],
              [
                '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8',
              ],
              [
                '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373',
              ],
              [
                '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3',
              ],
              [
                '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8',
              ],
              [
                '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1',
              ],
              [
                '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9',
              ],
            ],
          },
        };
      },
      {},
    ],
    98: [
      function(t, e, r) {
        'use strict';
        var i = r,
          n = t('bn.js'),
          r = t('minimalistic-assert'),
          t = t('minimalistic-crypto-utils');
        (i.assert = r),
          (i.toArray = t.toArray),
          (i.zero2 = t.zero2),
          (i.toHex = t.toHex),
          (i.encode = t.encode),
          (i.getNAF = function(t, e, r) {
            var i = new Array(Math.max(t.bitLength(), r) + 1);
            i.fill(0);
            for (
              var n = 1 << (e + 1), s = t.clone(), o = 0;
              o < i.length;
              o++
            ) {
              var a,
                f = s.andln(n - 1);
              s.isOdd()
                ? s.isubn((a = (n >> 1) - 1 < f ? (n >> 1) - f : f))
                : (a = 0),
                (i[o] = a),
                s.iushrn(1);
            }
            return i;
          }),
          (i.getJSF = function(t, e) {
            var r = [[], []];
            (t = t.clone()), (e = e.clone());
            for (var i, n = 0, s = 0; 0 < t.cmpn(-n) || 0 < e.cmpn(-s); ) {
              var o,
                a = (t.andln(3) + n) & 3,
                f = (e.andln(3) + s) & 3;
              3 === f && (f = -1),
                (o =
                  0 == (1 & (a = 3 === a ? -1 : a))
                    ? 0
                    : (3 !== (i = (t.andln(7) + n) & 7) && 5 !== i) || 2 !== f
                    ? a
                    : -a),
                r[0].push(o),
                (f =
                  0 == (1 & f)
                    ? 0
                    : (3 !== (i = (e.andln(7) + s) & 7) && 5 !== i) || 2 !== a
                    ? f
                    : -f),
                r[1].push(f),
                2 * n === o + 1 && (n = 1 - n),
                2 * s === f + 1 && (s = 1 - s),
                t.iushrn(1),
                e.iushrn(1);
            }
            return r;
          }),
          (i.cachedProperty = function(t, e, r) {
            var i = '_' + e;
            t.prototype[e] = function() {
              return void 0 !== this[i] ? this[i] : (this[i] = r.call(this));
            };
          }),
          (i.parseBytes = function(t) {
            return 'string' == typeof t ? i.toArray(t, 'hex') : t;
          }),
          (i.intFromLE = function(t) {
            return new n(t, 'hex', 'le');
          });
      },
      {
        'bn.js': 99,
        'minimalistic-assert': 137,
        'minimalistic-crypto-utils': 138,
      },
    ],
    99: [
      function(t, e, r) {
        arguments[4][16][0].apply(r, arguments);
      },
      { buffer: 20, dup: 16 },
    ],
    100: [
      function(t, e, r) {
        e.exports = {
          name: 'elliptic',
          version: '6.5.4',
          description: 'EC cryptography',
          main: 'lib/elliptic.js',
          files: ['lib'],
          scripts: {
            lint: 'eslint lib test',
            'lint:fix': 'npm run lint -- --fix',
            unit: 'istanbul test _mocha --reporter=spec test/index.js',
            test: 'npm run lint && npm run unit',
            version: 'grunt dist && git add dist/',
          },
          repository: { type: 'git', url: 'git@github.com:indutny/elliptic' },
          keywords: ['EC', 'Elliptic', 'curve', 'Cryptography'],
          author: 'Fedor Indutny <fedor@indutny.com>',
          license: 'MIT',
          bugs: { url: 'https://github.com/indutny/elliptic/issues' },
          homepage: 'https://github.com/indutny/elliptic',
          devDependencies: {
            brfs: '^2.0.2',
            coveralls: '^3.1.0',
            eslint: '^7.6.0',
            grunt: '^1.2.1',
            'grunt-browserify': '^5.3.0',
            'grunt-cli': '^1.3.2',
            'grunt-contrib-connect': '^3.0.0',
            'grunt-contrib-copy': '^1.0.0',
            'grunt-contrib-uglify': '^5.0.0',
            'grunt-mocha-istanbul': '^5.0.2',
            'grunt-saucelabs': '^9.0.1',
            istanbul: '^0.4.5',
            mocha: '^8.0.1',
          },
          dependencies: {
            'bn.js': '^4.11.9',
            brorand: '^1.1.0',
            'hash.js': '^1.0.0',
            'hmac-drbg': '^1.0.1',
            inherits: '^2.0.4',
            'minimalistic-assert': '^1.0.1',
            'minimalistic-crypto-utils': '^1.0.1',
          },
        };
      },
      {},
    ],
    101: [
      function(t, e, r) {
        'use strict';
        var i = 'object' == typeof Reflect ? Reflect : null,
          f =
            i && 'function' == typeof i.apply
              ? i.apply
              : function(t, e, r) {
                  return Function.prototype.apply.call(t, e, r);
                };
        var n =
            i && 'function' == typeof i.ownKeys
              ? i.ownKeys
              : Object.getOwnPropertySymbols
              ? function(t) {
                  return Object.getOwnPropertyNames(t).concat(
                    Object.getOwnPropertySymbols(t)
                  );
                }
              : function(t) {
                  return Object.getOwnPropertyNames(t);
                },
          s =
            Number.isNaN ||
            function(t) {
              return t != t;
            };
        function o() {
          o.init.call(this);
        }
        (e.exports = o),
          (e.exports.once = function(a, f) {
            return new Promise(function(t, e) {
              function r(t) {
                a.removeListener(f, i), e(t);
              }
              function i() {
                'function' == typeof a.removeListener &&
                  a.removeListener('error', r),
                  t([].slice.call(arguments));
              }
              var n, s, o;
              m(a, f, i, { once: !0 }),
                'error' !== f &&
                  ((s = r),
                  (o = { once: !0 }),
                  'function' == typeof (n = a).on && m(n, 'error', s, o));
            });
          }),
          ((o.EventEmitter = o).prototype._events = void 0),
          (o.prototype._eventsCount = 0),
          (o.prototype._maxListeners = void 0);
        var a = 10;
        function h(t) {
          if ('function' != typeof t)
            throw new TypeError(
              'The "listener" argument must be of type Function. Received type ' +
                typeof t
            );
        }
        function c(t) {
          return void 0 === t._maxListeners
            ? o.defaultMaxListeners
            : t._maxListeners;
        }
        function u(t, e, r, i) {
          var n, s;
          return (
            h(r),
            void 0 === (n = t._events)
              ? ((n = t._events = Object.create(null)), (t._eventsCount = 0))
              : (void 0 !== n.newListener &&
                  (t.emit('newListener', e, r.listener || r), (n = t._events)),
                (s = n[e])),
            void 0 === s
              ? ((s = n[e] = r), ++t._eventsCount)
              : ('function' == typeof s
                  ? (s = n[e] = i ? [r, s] : [s, r])
                  : i
                  ? s.unshift(r)
                  : s.push(r),
                0 < (r = c(t)) &&
                  s.length > r &&
                  !s.warned &&
                  ((s.warned = !0),
                  ((r = new Error(
                    'Possible EventEmitter memory leak detected. ' +
                      s.length +
                      ' ' +
                      String(e) +
                      ' listeners added. Use emitter.setMaxListeners() to increase limit'
                  )).name = 'MaxListenersExceededWarning'),
                  (r.emitter = t),
                  (r.type = e),
                  (r.count = s.length),
                  (r = r),
                  console && console.warn && console.warn(r))),
            t
          );
        }
        function d(t, e, r) {
          (t = { fired: !1, wrapFn: void 0, target: t, type: e, listener: r }),
            (e = function() {
              if (!this.fired)
                return (
                  this.target.removeListener(this.type, this.wrapFn),
                  (this.fired = !0),
                  0 === arguments.length
                    ? this.listener.call(this.target)
                    : this.listener.apply(this.target, arguments)
                );
            }.bind(t));
          return (e.listener = r), (t.wrapFn = e);
        }
        function l(t, e, r) {
          t = t._events;
          if (void 0 === t) return [];
          e = t[e];
          return void 0 === e
            ? []
            : 'function' == typeof e
            ? r
              ? [e.listener || e]
              : [e]
            : r
            ? (function(t) {
                for (var e = new Array(t.length), r = 0; r < e.length; ++r)
                  e[r] = t[r].listener || t[r];
                return e;
              })(e)
            : b(e, e.length);
        }
        function p(t) {
          var e = this._events;
          if (void 0 !== e) {
            t = e[t];
            if ('function' == typeof t) return 1;
            if (void 0 !== t) return t.length;
          }
          return 0;
        }
        function b(t, e) {
          for (var r = new Array(e), i = 0; i < e; ++i) r[i] = t[i];
          return r;
        }
        function m(r, i, n, s) {
          if ('function' == typeof r.on) s.once ? r.once(i, n) : r.on(i, n);
          else {
            if ('function' != typeof r.addEventListener)
              throw new TypeError(
                'The "emitter" argument must be of type EventEmitter. Received type ' +
                  typeof r
              );
            r.addEventListener(i, function t(e) {
              s.once && r.removeEventListener(i, t), n(e);
            });
          }
        }
        Object.defineProperty(o, 'defaultMaxListeners', {
          enumerable: !0,
          get: function() {
            return a;
          },
          set: function(t) {
            if ('number' != typeof t || t < 0 || s(t))
              throw new RangeError(
                'The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' +
                  t +
                  '.'
              );
            a = t;
          },
        }),
          (o.init = function() {
            (void 0 !== this._events &&
              this._events !== Object.getPrototypeOf(this)._events) ||
              ((this._events = Object.create(null)), (this._eventsCount = 0)),
              (this._maxListeners = this._maxListeners || void 0);
          }),
          (o.prototype.setMaxListeners = function(t) {
            if ('number' != typeof t || t < 0 || s(t))
              throw new RangeError(
                'The value of "n" is out of range. It must be a non-negative number. Received ' +
                  t +
                  '.'
              );
            return (this._maxListeners = t), this;
          }),
          (o.prototype.getMaxListeners = function() {
            return c(this);
          }),
          (o.prototype.emit = function(t) {
            for (var e = [], r = 1; r < arguments.length; r++)
              e.push(arguments[r]);
            var i,
              n = 'error' === t,
              s = this._events;
            if (void 0 !== s) n = n && void 0 === s.error;
            else if (!n) return !1;
            if (n) {
              if ((i = 0 < e.length ? e[0] : i) instanceof Error) throw i;
              n = new Error(
                'Unhandled error.' + (i ? ' (' + i.message + ')' : '')
              );
              throw ((n.context = i), n);
            }
            t = s[t];
            if (void 0 === t) return !1;
            if ('function' == typeof t) f(t, this, e);
            else
              for (var o = t.length, a = b(t, o), r = 0; r < o; ++r)
                f(a[r], this, e);
            return !0;
          }),
          (o.prototype.on = o.prototype.addListener = function(t, e) {
            return u(this, t, e, !1);
          }),
          (o.prototype.prependListener = function(t, e) {
            return u(this, t, e, !0);
          }),
          (o.prototype.once = function(t, e) {
            return h(e), this.on(t, d(this, t, e)), this;
          }),
          (o.prototype.prependOnceListener = function(t, e) {
            return h(e), this.prependListener(t, d(this, t, e)), this;
          }),
          (o.prototype.removeListener = function(t, e) {
            var r, i, n, s, o;
            if ((h(e), void 0 === (i = this._events))) return this;
            if (void 0 === (r = i[t])) return this;
            if (r === e || r.listener === e)
              0 == --this._eventsCount
                ? (this._events = Object.create(null))
                : (delete i[t],
                  i.removeListener &&
                    this.emit('removeListener', t, r.listener || e));
            else if ('function' != typeof r) {
              for (n = -1, s = r.length - 1; 0 <= s; s--)
                if (r[s] === e || r[s].listener === e) {
                  (o = r[s].listener), (n = s);
                  break;
                }
              if (n < 0) return this;
              0 === n
                ? r.shift()
                : (function(t, e) {
                    for (; e + 1 < t.length; e++) t[e] = t[e + 1];
                    t.pop();
                  })(r, n),
                1 === r.length && (i[t] = r[0]),
                void 0 !== i.removeListener &&
                  this.emit('removeListener', t, o || e);
            }
            return this;
          }),
          (o.prototype.off = o.prototype.removeListener),
          (o.prototype.removeAllListeners = function(t) {
            var e,
              r = this._events;
            if (void 0 === r) return this;
            if (void 0 === r.removeListener)
              return (
                0 === arguments.length
                  ? ((this._events = Object.create(null)),
                    (this._eventsCount = 0))
                  : void 0 !== r[t] &&
                    (0 == --this._eventsCount
                      ? (this._events = Object.create(null))
                      : delete r[t]),
                this
              );
            if (0 === arguments.length) {
              for (var i, n = Object.keys(r), s = 0; s < n.length; ++s)
                'removeListener' !== (i = n[s]) && this.removeAllListeners(i);
              return (
                this.removeAllListeners('removeListener'),
                (this._events = Object.create(null)),
                (this._eventsCount = 0),
                this
              );
            }
            if ('function' == typeof (e = r[t])) this.removeListener(t, e);
            else if (void 0 !== e)
              for (s = e.length - 1; 0 <= s; s--) this.removeListener(t, e[s]);
            return this;
          }),
          (o.prototype.listeners = function(t) {
            return l(this, t, !0);
          }),
          (o.prototype.rawListeners = function(t) {
            return l(this, t, !1);
          }),
          (o.listenerCount = function(t, e) {
            return 'function' == typeof t.listenerCount
              ? t.listenerCount(e)
              : p.call(t, e);
          }),
          (o.prototype.listenerCount = p),
          (o.prototype.eventNames = function() {
            return 0 < this._eventsCount ? n(this._events) : [];
          });
      },
      {},
    ],
    102: [
      function(t, e, r) {
        var u = t('safe-buffer').Buffer,
          d = t('md5.js');
        e.exports = function(t, e, r, i) {
          if (
            (u.isBuffer(t) || (t = u.from(t, 'binary')),
            e && 8 !== (e = !u.isBuffer(e) ? u.from(e, 'binary') : e).length)
          )
            throw new RangeError('salt should be Buffer with 8 byte length');
          for (
            var n = r / 8, s = u.alloc(n), o = u.alloc(i || 0), a = u.alloc(0);
            0 < n || 0 < i;

          ) {
            var f = new d();
            f.update(a), f.update(t), e && f.update(e);
            var h,
              a = f.digest(),
              c = 0;
            0 < n &&
              ((h = s.length - n),
              (c = Math.min(n, a.length)),
              a.copy(s, h, 0, c),
              (n -= c)),
              c < a.length &&
                0 < i &&
                ((f = o.length - i),
                (h = Math.min(i, a.length - c)),
                a.copy(o, f, c, c + h),
                (i -= h));
          }
          return a.fill(0), { key: s, iv: o };
        };
      },
      { 'md5.js': 134, 'safe-buffer': 161 },
    ],
    103: [
      function(t, e, r) {
        'use strict';
        var a = t('safe-buffer').Buffer,
          i = t('readable-stream').Transform;
        function n(t) {
          i.call(this),
            (this._block = a.allocUnsafe(t)),
            (this._blockSize = t),
            (this._blockOffset = 0),
            (this._length = [0, 0, 0, 0]),
            (this._finalized = !1);
        }
        t('inherits')(n, i),
          (n.prototype._transform = function(t, e, r) {
            var i = null;
            try {
              this.update(t, e);
            } catch (t) {
              i = t;
            }
            r(i);
          }),
          (n.prototype._flush = function(t) {
            var e = null;
            try {
              this.push(this.digest());
            } catch (t) {
              e = t;
            }
            t(e);
          }),
          (n.prototype.update = function(t, e) {
            if (
              (!(function(t, e) {
                if (!a.isBuffer(t) && 'string' != typeof t)
                  throw new TypeError(e + ' must be a string or a buffer');
              })(t, 'Data'),
              this._finalized)
            )
              throw new Error('Digest already called');
            a.isBuffer(t) || (t = a.from(t, e));
            for (
              var r = this._block, i = 0;
              this._blockOffset + t.length - i >= this._blockSize;

            ) {
              for (var n = this._blockOffset; n < this._blockSize; )
                r[n++] = t[i++];
              this._update(), (this._blockOffset = 0);
            }
            for (; i < t.length; ) r[this._blockOffset++] = t[i++];
            for (var s = 0, o = 8 * t.length; 0 < o; ++s)
              (this._length[s] += o),
                0 < (o = (this._length[s] / 4294967296) | 0) &&
                  (this._length[s] -= 4294967296 * o);
            return this;
          }),
          (n.prototype._update = function() {
            throw new Error('_update is not implemented');
          }),
          (n.prototype.digest = function(t) {
            if (this._finalized) throw new Error('Digest already called');
            this._finalized = !0;
            var e = this._digest();
            void 0 !== t && (e = e.toString(t)), this._block.fill(0);
            for (var r = (this._blockOffset = 0); r < 4; ++r)
              this._length[r] = 0;
            return e;
          }),
          (n.prototype._digest = function() {
            throw new Error('_digest is not implemented');
          }),
          (e.exports = n);
      },
      { inherits: 133, 'readable-stream': 118, 'safe-buffer': 161 },
    ],
    104: [
      function(t, e, r) {
        arguments[4][48][0].apply(r, arguments);
      },
      { dup: 48 },
    ],
    105: [
      function(t, e, r) {
        arguments[4][49][0].apply(r, arguments);
      },
      {
        './_stream_readable': 107,
        './_stream_writable': 109,
        _process: 150,
        dup: 49,
        inherits: 133,
      },
    ],
    106: [
      function(t, e, r) {
        arguments[4][50][0].apply(r, arguments);
      },
      { './_stream_transform': 108, dup: 50, inherits: 133 },
    ],
    107: [
      function(t, e, r) {
        arguments[4][51][0].apply(r, arguments);
      },
      {
        '../errors': 104,
        './_stream_duplex': 105,
        './internal/streams/async_iterator': 110,
        './internal/streams/buffer_list': 111,
        './internal/streams/destroy': 112,
        './internal/streams/from': 114,
        './internal/streams/state': 116,
        './internal/streams/stream': 117,
        _process: 150,
        buffer: 64,
        dup: 51,
        events: 101,
        inherits: 133,
        'string_decoder/': 186,
        util: 20,
      },
    ],
    108: [
      function(t, e, r) {
        arguments[4][52][0].apply(r, arguments);
      },
      { '../errors': 104, './_stream_duplex': 105, dup: 52, inherits: 133 },
    ],
    109: [
      function(t, e, r) {
        arguments[4][53][0].apply(r, arguments);
      },
      {
        '../errors': 104,
        './_stream_duplex': 105,
        './internal/streams/destroy': 112,
        './internal/streams/state': 116,
        './internal/streams/stream': 117,
        _process: 150,
        buffer: 64,
        dup: 53,
        inherits: 133,
        'util-deprecate': 187,
      },
    ],
    110: [
      function(t, e, r) {
        arguments[4][54][0].apply(r, arguments);
      },
      { './end-of-stream': 113, _process: 150, dup: 54 },
    ],
    111: [
      function(t, e, r) {
        arguments[4][55][0].apply(r, arguments);
      },
      { buffer: 64, dup: 55, util: 20 },
    ],
    112: [
      function(t, e, r) {
        arguments[4][56][0].apply(r, arguments);
      },
      { _process: 150, dup: 56 },
    ],
    113: [
      function(t, e, r) {
        arguments[4][57][0].apply(r, arguments);
      },
      { '../../../errors': 104, dup: 57 },
    ],
    114: [
      function(t, e, r) {
        arguments[4][58][0].apply(r, arguments);
      },
      { dup: 58 },
    ],
    115: [
      function(t, e, r) {
        arguments[4][59][0].apply(r, arguments);
      },
      { '../../../errors': 104, './end-of-stream': 113, dup: 59 },
    ],
    116: [
      function(t, e, r) {
        arguments[4][60][0].apply(r, arguments);
      },
      { '../../../errors': 104, dup: 60 },
    ],
    117: [
      function(t, e, r) {
        arguments[4][61][0].apply(r, arguments);
      },
      { dup: 61, events: 101 },
    ],
    118: [
      function(t, e, r) {
        arguments[4][62][0].apply(r, arguments);
      },
      {
        './lib/_stream_duplex.js': 105,
        './lib/_stream_passthrough.js': 106,
        './lib/_stream_readable.js': 107,
        './lib/_stream_transform.js': 108,
        './lib/_stream_writable.js': 109,
        './lib/internal/streams/end-of-stream.js': 113,
        './lib/internal/streams/pipeline.js': 115,
        dup: 62,
      },
    ],
    119: [
      function(t, e, r) {
        (r.utils = t('./hash/utils')),
          (r.common = t('./hash/common')),
          (r.sha = t('./hash/sha')),
          (r.ripemd = t('./hash/ripemd')),
          (r.hmac = t('./hash/hmac')),
          (r.sha1 = r.sha.sha1),
          (r.sha256 = r.sha.sha256),
          (r.sha224 = r.sha.sha224),
          (r.sha384 = r.sha.sha384),
          (r.sha512 = r.sha.sha512),
          (r.ripemd160 = r.ripemd.ripemd160);
      },
      {
        './hash/common': 120,
        './hash/hmac': 121,
        './hash/ripemd': 122,
        './hash/sha': 123,
        './hash/utils': 130,
      },
    ],
    120: [
      function(t, e, r) {
        'use strict';
        var i = t('./utils'),
          n = t('minimalistic-assert');
        function s() {
          (this.pending = null),
            (this.pendingTotal = 0),
            (this.blockSize = this.constructor.blockSize),
            (this.outSize = this.constructor.outSize),
            (this.hmacStrength = this.constructor.hmacStrength),
            (this.padLength = this.constructor.padLength / 8),
            (this.endian = 'big'),
            (this._delta8 = this.blockSize / 8),
            (this._delta32 = this.blockSize / 32);
        }
        ((r.BlockHash = s).prototype.update = function(t, e) {
          if (
            ((t = i.toArray(t, e)),
            this.pending
              ? (this.pending = this.pending.concat(t))
              : (this.pending = t),
            (this.pendingTotal += t.length),
            this.pending.length >= this._delta8)
          ) {
            e = (t = this.pending).length % this._delta8;
            (this.pending = t.slice(t.length - e, t.length)),
              0 === this.pending.length && (this.pending = null),
              (t = i.join32(t, 0, t.length - e, this.endian));
            for (var r = 0; r < t.length; r += this._delta32)
              this._update(t, r, r + this._delta32);
          }
          return this;
        }),
          (s.prototype.digest = function(t) {
            return (
              this.update(this._pad()),
              n(null === this.pending),
              this._digest(t)
            );
          }),
          (s.prototype._pad = function() {
            var t = this.pendingTotal,
              e = this._delta8,
              r = e - ((t + this.padLength) % e),
              i = new Array(r + this.padLength);
            i[0] = 128;
            for (var n = 1; n < r; n++) i[n] = 0;
            if (((t <<= 3), 'big' === this.endian)) {
              for (var s = 8; s < this.padLength; s++) i[n++] = 0;
              (i[n++] = 0),
                (i[n++] = 0),
                (i[n++] = 0),
                (i[n++] = 0),
                (i[n++] = (t >>> 24) & 255),
                (i[n++] = (t >>> 16) & 255),
                (i[n++] = (t >>> 8) & 255),
                (i[n++] = 255 & t);
            } else
              for (
                i[n++] = 255 & t,
                  i[n++] = (t >>> 8) & 255,
                  i[n++] = (t >>> 16) & 255,
                  i[n++] = (t >>> 24) & 255,
                  i[n++] = 0,
                  i[n++] = 0,
                  i[n++] = 0,
                  i[n++] = 0,
                  s = 8;
                s < this.padLength;
                s++
              )
                i[n++] = 0;
            return i;
          });
      },
      { './utils': 130, 'minimalistic-assert': 137 },
    ],
    121: [
      function(t, e, r) {
        'use strict';
        var i = t('./utils'),
          n = t('minimalistic-assert');
        function s(t, e, r) {
          if (!(this instanceof s)) return new s(t, e, r);
          (this.Hash = t),
            (this.blockSize = t.blockSize / 8),
            (this.outSize = t.outSize / 8),
            (this.inner = null),
            (this.outer = null),
            this._init(i.toArray(e, r));
        }
        ((e.exports = s).prototype._init = function(t) {
          t.length > this.blockSize && (t = new this.Hash().update(t).digest()),
            n(t.length <= this.blockSize);
          for (var e = t.length; e < this.blockSize; e++) t.push(0);
          for (e = 0; e < t.length; e++) t[e] ^= 54;
          for (this.inner = new this.Hash().update(t), e = 0; e < t.length; e++)
            t[e] ^= 106;
          this.outer = new this.Hash().update(t);
        }),
          (s.prototype.update = function(t, e) {
            return this.inner.update(t, e), this;
          }),
          (s.prototype.digest = function(t) {
            return this.outer.update(this.inner.digest()), this.outer.digest(t);
          });
      },
      { './utils': 130, 'minimalistic-assert': 137 },
    ],
    122: [
      function(t, e, r) {
        'use strict';
        var i = t('./utils'),
          t = t('./common'),
          b = i.rotl32,
          m = i.sum32,
          y = i.sum32_3,
          g = i.sum32_4,
          n = t.BlockHash;
        function s() {
          if (!(this instanceof s)) return new s();
          n.call(this),
            (this.h = [
              1732584193,
              4023233417,
              2562383102,
              271733878,
              3285377520,
            ]),
            (this.endian = 'little');
        }
        function v(t, e, r, i) {
          return t <= 15
            ? e ^ r ^ i
            : t <= 31
            ? (e & r) | (~e & i)
            : t <= 47
            ? (e | ~r) ^ i
            : t <= 63
            ? (e & i) | (r & ~i)
            : e ^ (r | ~i);
        }
        i.inherits(s, n),
          ((r.ripemd160 = s).blockSize = 512),
          (s.outSize = 160),
          (s.hmacStrength = 192),
          (s.padLength = 64),
          (s.prototype._update = function(t, e) {
            for (
              var r,
                i = (c = this.h[0]),
                n = (p = this.h[1]),
                s = (l = this.h[2]),
                o = (d = this.h[3]),
                a = (u = this.h[4]),
                f = 0;
              f < 80;
              f++
            )
              var h = m(
                  b(
                    g(
                      c,
                      v(f, p, l, d),
                      t[_[f] + e],
                      (r = f) <= 15
                        ? 0
                        : r <= 31
                        ? 1518500249
                        : r <= 47
                        ? 1859775393
                        : r <= 63
                        ? 2400959708
                        : 2840853838
                    ),
                    M[f]
                  ),
                  u
                ),
                c = u,
                u = d,
                d = b(l, 10),
                l = p,
                p = h,
                h = m(
                  b(
                    g(
                      i,
                      v(79 - f, n, s, o),
                      t[w[f] + e],
                      (r = f) <= 15
                        ? 1352829926
                        : r <= 31
                        ? 1548603684
                        : r <= 47
                        ? 1836072691
                        : r <= 63
                        ? 2053994217
                        : 0
                    ),
                    S[f]
                  ),
                  a
                ),
                i = a,
                a = o,
                o = b(s, 10),
                s = n,
                n = h;
            (h = y(this.h[1], l, o)),
              (this.h[1] = y(this.h[2], d, a)),
              (this.h[2] = y(this.h[3], u, i)),
              (this.h[3] = y(this.h[4], c, n)),
              (this.h[4] = y(this.h[0], p, s)),
              (this.h[0] = h);
          }),
          (s.prototype._digest = function(t) {
            return 'hex' === t
              ? i.toHex32(this.h, 'little')
              : i.split32(this.h, 'little');
          });
        var _ = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            7,
            4,
            13,
            1,
            10,
            6,
            15,
            3,
            12,
            0,
            9,
            5,
            2,
            14,
            11,
            8,
            3,
            10,
            14,
            4,
            9,
            15,
            8,
            1,
            2,
            7,
            0,
            6,
            13,
            11,
            5,
            12,
            1,
            9,
            11,
            10,
            0,
            8,
            12,
            4,
            13,
            3,
            7,
            15,
            14,
            5,
            6,
            2,
            4,
            0,
            5,
            9,
            7,
            12,
            2,
            10,
            14,
            1,
            3,
            8,
            11,
            6,
            15,
            13,
          ],
          w = [
            5,
            14,
            7,
            0,
            9,
            2,
            11,
            4,
            13,
            6,
            15,
            8,
            1,
            10,
            3,
            12,
            6,
            11,
            3,
            7,
            0,
            13,
            5,
            10,
            14,
            15,
            8,
            12,
            4,
            9,
            1,
            2,
            15,
            5,
            1,
            3,
            7,
            14,
            6,
            9,
            11,
            8,
            12,
            2,
            10,
            0,
            4,
            13,
            8,
            6,
            4,
            1,
            3,
            11,
            15,
            0,
            5,
            12,
            2,
            13,
            9,
            7,
            10,
            14,
            12,
            15,
            10,
            4,
            1,
            5,
            8,
            7,
            6,
            2,
            13,
            14,
            0,
            3,
            9,
            11,
          ],
          M = [
            11,
            14,
            15,
            12,
            5,
            8,
            7,
            9,
            11,
            13,
            14,
            15,
            6,
            7,
            9,
            8,
            7,
            6,
            8,
            13,
            11,
            9,
            7,
            15,
            7,
            12,
            15,
            9,
            11,
            7,
            13,
            12,
            11,
            13,
            6,
            7,
            14,
            9,
            13,
            15,
            14,
            8,
            13,
            6,
            5,
            12,
            7,
            5,
            11,
            12,
            14,
            15,
            14,
            15,
            9,
            8,
            9,
            14,
            5,
            6,
            8,
            6,
            5,
            12,
            9,
            15,
            5,
            11,
            6,
            8,
            13,
            12,
            5,
            12,
            13,
            14,
            11,
            8,
            5,
            6,
          ],
          S = [
            8,
            9,
            9,
            11,
            13,
            15,
            15,
            5,
            7,
            7,
            8,
            11,
            14,
            14,
            12,
            6,
            9,
            13,
            15,
            7,
            12,
            8,
            9,
            11,
            7,
            7,
            12,
            7,
            6,
            15,
            13,
            11,
            9,
            7,
            15,
            11,
            8,
            6,
            6,
            14,
            12,
            13,
            5,
            14,
            13,
            13,
            7,
            5,
            15,
            5,
            8,
            11,
            14,
            14,
            6,
            14,
            6,
            9,
            12,
            9,
            12,
            5,
            15,
            8,
            8,
            5,
            12,
            9,
            12,
            5,
            14,
            6,
            8,
            13,
            6,
            5,
            15,
            13,
            11,
            11,
          ];
      },
      { './common': 120, './utils': 130 },
    ],
    123: [
      function(t, e, r) {
        'use strict';
        (r.sha1 = t('./sha/1')),
          (r.sha224 = t('./sha/224')),
          (r.sha256 = t('./sha/256')),
          (r.sha384 = t('./sha/384')),
          (r.sha512 = t('./sha/512'));
      },
      {
        './sha/1': 124,
        './sha/224': 125,
        './sha/256': 126,
        './sha/384': 127,
        './sha/512': 128,
      },
    ],
    124: [
      function(t, e, r) {
        'use strict';
        var i = t('../utils'),
          n = t('../common'),
          t = t('./common'),
          c = i.rotl32,
          u = i.sum32,
          d = i.sum32_5,
          l = t.ft_1,
          s = n.BlockHash,
          p = [1518500249, 1859775393, 2400959708, 3395469782];
        function o() {
          if (!(this instanceof o)) return new o();
          s.call(this),
            (this.h = [
              1732584193,
              4023233417,
              2562383102,
              271733878,
              3285377520,
            ]),
            (this.W = new Array(80));
        }
        i.inherits(o, s),
          ((e.exports = o).blockSize = 512),
          (o.outSize = 160),
          (o.hmacStrength = 80),
          (o.padLength = 64),
          (o.prototype._update = function(t, e) {
            for (var r = this.W, i = 0; i < 16; i++) r[i] = t[e + i];
            for (; i < r.length; i++)
              r[i] = c(r[i - 3] ^ r[i - 8] ^ r[i - 14] ^ r[i - 16], 1);
            for (
              var n = this.h[0],
                s = this.h[1],
                o = this.h[2],
                a = this.h[3],
                f = this.h[4],
                i = 0;
              i < r.length;
              i++
            )
              var h = ~~(i / 20),
                h = d(c(n, 5), l(h, s, o, a), f, r[i], p[h]),
                f = a,
                a = o,
                o = c(s, 30),
                s = n,
                n = h;
            (this.h[0] = u(this.h[0], n)),
              (this.h[1] = u(this.h[1], s)),
              (this.h[2] = u(this.h[2], o)),
              (this.h[3] = u(this.h[3], a)),
              (this.h[4] = u(this.h[4], f));
          }),
          (o.prototype._digest = function(t) {
            return 'hex' === t
              ? i.toHex32(this.h, 'big')
              : i.split32(this.h, 'big');
          });
      },
      { '../common': 120, '../utils': 130, './common': 129 },
    ],
    125: [
      function(t, e, r) {
        'use strict';
        var i = t('../utils'),
          n = t('./256');
        function s() {
          if (!(this instanceof s)) return new s();
          n.call(this),
            (this.h = [
              3238371032,
              914150663,
              812702999,
              4144912697,
              4290775857,
              1750603025,
              1694076839,
              3204075428,
            ]);
        }
        i.inherits(s, n),
          ((e.exports = s).blockSize = 512),
          (s.outSize = 224),
          (s.hmacStrength = 192),
          (s.padLength = 64),
          (s.prototype._digest = function(t) {
            return 'hex' === t
              ? i.toHex32(this.h.slice(0, 7), 'big')
              : i.split32(this.h.slice(0, 7), 'big');
          });
      },
      { '../utils': 130, './256': 126 },
    ],
    126: [
      function(t, e, r) {
        'use strict';
        var i = t('../utils'),
          n = t('../common'),
          s = t('./common'),
          p = t('minimalistic-assert'),
          b = i.sum32,
          m = i.sum32_4,
          y = i.sum32_5,
          g = s.ch32,
          v = s.maj32,
          _ = s.s0_256,
          w = s.s1_256,
          M = s.g0_256,
          S = s.g1_256,
          o = n.BlockHash,
          a = [
            1116352408,
            1899447441,
            3049323471,
            3921009573,
            961987163,
            1508970993,
            2453635748,
            2870763221,
            3624381080,
            310598401,
            607225278,
            1426881987,
            1925078388,
            2162078206,
            2614888103,
            3248222580,
            3835390401,
            4022224774,
            264347078,
            604807628,
            770255983,
            1249150122,
            1555081692,
            1996064986,
            2554220882,
            2821834349,
            2952996808,
            3210313671,
            3336571891,
            3584528711,
            113926993,
            338241895,
            666307205,
            773529912,
            1294757372,
            1396182291,
            1695183700,
            1986661051,
            2177026350,
            2456956037,
            2730485921,
            2820302411,
            3259730800,
            3345764771,
            3516065817,
            3600352804,
            4094571909,
            275423344,
            430227734,
            506948616,
            659060556,
            883997877,
            958139571,
            1322822218,
            1537002063,
            1747873779,
            1955562222,
            2024104815,
            2227730452,
            2361852424,
            2428436474,
            2756734187,
            3204031479,
            3329325298,
          ];
        function f() {
          if (!(this instanceof f)) return new f();
          o.call(this),
            (this.h = [
              1779033703,
              3144134277,
              1013904242,
              2773480762,
              1359893119,
              2600822924,
              528734635,
              1541459225,
            ]),
            (this.k = a),
            (this.W = new Array(64));
        }
        i.inherits(f, o),
          ((e.exports = f).blockSize = 512),
          (f.outSize = 256),
          (f.hmacStrength = 192),
          (f.padLength = 64),
          (f.prototype._update = function(t, e) {
            for (var r = this.W, i = 0; i < 16; i++) r[i] = t[e + i];
            for (; i < r.length; i++)
              r[i] = m(S(r[i - 2]), r[i - 7], M(r[i - 15]), r[i - 16]);
            var n = this.h[0],
              s = this.h[1],
              o = this.h[2],
              a = this.h[3],
              f = this.h[4],
              h = this.h[5],
              c = this.h[6],
              u = this.h[7];
            for (p(this.k.length === r.length), i = 0; i < r.length; i++)
              var d = y(u, w(f), g(f, h, c), this.k[i], r[i]),
                l = b(_(n), v(n, s, o)),
                u = c,
                c = h,
                h = f,
                f = b(a, d),
                a = o,
                o = s,
                s = n,
                n = b(d, l);
            (this.h[0] = b(this.h[0], n)),
              (this.h[1] = b(this.h[1], s)),
              (this.h[2] = b(this.h[2], o)),
              (this.h[3] = b(this.h[3], a)),
              (this.h[4] = b(this.h[4], f)),
              (this.h[5] = b(this.h[5], h)),
              (this.h[6] = b(this.h[6], c)),
              (this.h[7] = b(this.h[7], u));
          }),
          (f.prototype._digest = function(t) {
            return 'hex' === t
              ? i.toHex32(this.h, 'big')
              : i.split32(this.h, 'big');
          });
      },
      {
        '../common': 120,
        '../utils': 130,
        './common': 129,
        'minimalistic-assert': 137,
      },
    ],
    127: [
      function(t, e, r) {
        'use strict';
        var i = t('../utils'),
          n = t('./512');
        function s() {
          if (!(this instanceof s)) return new s();
          n.call(this),
            (this.h = [
              3418070365,
              3238371032,
              1654270250,
              914150663,
              2438529370,
              812702999,
              355462360,
              4144912697,
              1731405415,
              4290775857,
              2394180231,
              1750603025,
              3675008525,
              1694076839,
              1203062813,
              3204075428,
            ]);
        }
        i.inherits(s, n),
          ((e.exports = s).blockSize = 1024),
          (s.outSize = 384),
          (s.hmacStrength = 192),
          (s.padLength = 128),
          (s.prototype._digest = function(t) {
            return 'hex' === t
              ? i.toHex32(this.h.slice(0, 12), 'big')
              : i.split32(this.h.slice(0, 12), 'big');
          });
      },
      { '../utils': 130, './512': 128 },
    ],
    128: [
      function(t, e, r) {
        'use strict';
        var i = t('../utils'),
          n = t('../common'),
          j = t('minimalistic-assert'),
          T = i.rotr64_hi,
          C = i.rotr64_lo,
          d = i.shr64_hi,
          l = i.shr64_lo,
          L = i.sum64,
          P = i.sum64_hi,
          O = i.sum64_lo,
          p = i.sum64_4_hi,
          b = i.sum64_4_lo,
          D = i.sum64_5_hi,
          N = i.sum64_5_lo,
          s = n.BlockHash,
          o = [
            1116352408,
            3609767458,
            1899447441,
            602891725,
            3049323471,
            3964484399,
            3921009573,
            2173295548,
            961987163,
            4081628472,
            1508970993,
            3053834265,
            2453635748,
            2937671579,
            2870763221,
            3664609560,
            3624381080,
            2734883394,
            310598401,
            1164996542,
            607225278,
            1323610764,
            1426881987,
            3590304994,
            1925078388,
            4068182383,
            2162078206,
            991336113,
            2614888103,
            633803317,
            3248222580,
            3479774868,
            3835390401,
            2666613458,
            4022224774,
            944711139,
            264347078,
            2341262773,
            604807628,
            2007800933,
            770255983,
            1495990901,
            1249150122,
            1856431235,
            1555081692,
            3175218132,
            1996064986,
            2198950837,
            2554220882,
            3999719339,
            2821834349,
            766784016,
            2952996808,
            2566594879,
            3210313671,
            3203337956,
            3336571891,
            1034457026,
            3584528711,
            2466948901,
            113926993,
            3758326383,
            338241895,
            168717936,
            666307205,
            1188179964,
            773529912,
            1546045734,
            1294757372,
            1522805485,
            1396182291,
            2643833823,
            1695183700,
            2343527390,
            1986661051,
            1014477480,
            2177026350,
            1206759142,
            2456956037,
            344077627,
            2730485921,
            1290863460,
            2820302411,
            3158454273,
            3259730800,
            3505952657,
            3345764771,
            106217008,
            3516065817,
            3606008344,
            3600352804,
            1432725776,
            4094571909,
            1467031594,
            275423344,
            851169720,
            430227734,
            3100823752,
            506948616,
            1363258195,
            659060556,
            3750685593,
            883997877,
            3785050280,
            958139571,
            3318307427,
            1322822218,
            3812723403,
            1537002063,
            2003034995,
            1747873779,
            3602036899,
            1955562222,
            1575990012,
            2024104815,
            1125592928,
            2227730452,
            2716904306,
            2361852424,
            442776044,
            2428436474,
            593698344,
            2756734187,
            3733110249,
            3204031479,
            2999351573,
            3329325298,
            3815920427,
            3391569614,
            3928383900,
            3515267271,
            566280711,
            3940187606,
            3454069534,
            4118630271,
            4000239992,
            116418474,
            1914138554,
            174292421,
            2731055270,
            289380356,
            3203993006,
            460393269,
            320620315,
            685471733,
            587496836,
            852142971,
            1086792851,
            1017036298,
            365543100,
            1126000580,
            2618297676,
            1288033470,
            3409855158,
            1501505948,
            4234509866,
            1607167915,
            987167468,
            1816402316,
            1246189591,
          ];
        function a() {
          if (!(this instanceof a)) return new a();
          s.call(this),
            (this.h = [
              1779033703,
              4089235720,
              3144134277,
              2227873595,
              1013904242,
              4271175723,
              2773480762,
              1595750129,
              1359893119,
              2917565137,
              2600822924,
              725511199,
              528734635,
              4215389547,
              1541459225,
              327033209,
            ]),
            (this.k = o),
            (this.W = new Array(160));
        }
        i.inherits(a, s),
          ((e.exports = a).blockSize = 1024),
          (a.outSize = 512),
          (a.hmacStrength = 192),
          (a.padLength = 128),
          (a.prototype._prepareBlock = function(t, e) {
            for (var r = this.W, i = 0; i < 32; i++) r[i] = t[e + i];
            for (; i < r.length; i += 2) {
              var n = (function(t, e) {
                  var r = T(t, e, 19),
                    i = T(e, t, 29),
                    e = d(t, e, 6),
                    e = r ^ i ^ e;
                  e < 0 && (e += 4294967296);
                  return e;
                })(r[i - 4], r[i - 3]),
                s = (function(t, e) {
                  var r = C(t, e, 19),
                    i = C(e, t, 29),
                    e = l(t, e, 6),
                    e = r ^ i ^ e;
                  e < 0 && (e += 4294967296);
                  return e;
                })(r[i - 4], r[i - 3]),
                o = r[i - 14],
                a = r[i - 13],
                f = (function(t, e) {
                  var r = T(t, e, 1),
                    i = T(t, e, 8),
                    e = d(t, e, 7),
                    e = r ^ i ^ e;
                  e < 0 && (e += 4294967296);
                  return e;
                })(r[i - 30], r[i - 29]),
                h = (function(t, e) {
                  var r = C(t, e, 1),
                    i = C(t, e, 8),
                    e = l(t, e, 7),
                    e = r ^ i ^ e;
                  e < 0 && (e += 4294967296);
                  return e;
                })(r[i - 30], r[i - 29]),
                c = r[i - 32],
                u = r[i - 31];
              (r[i] = p(n, s, o, a, f, h, c, u)),
                (r[i + 1] = b(n, s, o, a, f, h, c, u));
            }
          }),
          (a.prototype._update = function(t, e) {
            this._prepareBlock(t, e);
            var r = this.W,
              i = this.h[0],
              n = this.h[1],
              s = this.h[2],
              o = this.h[3],
              a = this.h[4],
              f = this.h[5],
              h = this.h[6],
              c = this.h[7],
              u = this.h[8],
              d = this.h[9],
              l = this.h[10],
              p = this.h[11],
              b = this.h[12],
              m = this.h[13],
              y = this.h[14],
              g = this.h[15];
            j(this.k.length === r.length);
            for (var v = 0; v < r.length; v += 2)
              var _ = y,
                w = g,
                M = (function(t, e) {
                  var r = T(t, e, 14),
                    i = T(t, e, 18),
                    t = T(e, t, 9),
                    t = r ^ i ^ t;
                  t < 0 && (t += 4294967296);
                  return t;
                })(u, d),
                S = (function(t, e) {
                  var r = C(t, e, 14),
                    i = C(t, e, 18),
                    t = C(e, t, 9),
                    t = r ^ i ^ t;
                  t < 0 && (t += 4294967296);
                  return t;
                })(u, d),
                E = (function(t, e, r) {
                  r = (t & e) ^ (~t & r);
                  r < 0 && (r += 4294967296);
                  return r;
                })(u, l, b),
                k = (function(t, e, r) {
                  r = (t & e) ^ (~t & r);
                  r < 0 && (r += 4294967296);
                  return r;
                })(d, p, m),
                A = this.k[v],
                x = this.k[v + 1],
                B = r[v],
                I = r[v + 1],
                R = D(_, w, M, S, E, k, A, x, B, I),
                B = N(_, w, M, S, E, k, A, x, B, I),
                _ = (function(t, e) {
                  var r = T(t, e, 28),
                    i = T(e, t, 2),
                    t = T(e, t, 7),
                    t = r ^ i ^ t;
                  t < 0 && (t += 4294967296);
                  return t;
                })(i, n),
                w = (function(t, e) {
                  var r = C(t, e, 28),
                    i = C(e, t, 2),
                    t = C(e, t, 7),
                    t = r ^ i ^ t;
                  t < 0 && (t += 4294967296);
                  return t;
                })(i, n),
                M = (function(t, e, r) {
                  r = (t & e) ^ (t & r) ^ (e & r);
                  r < 0 && (r += 4294967296);
                  return r;
                })(i, s, a),
                S = (function(t, e, r) {
                  r = (t & e) ^ (t & r) ^ (e & r);
                  r < 0 && (r += 4294967296);
                  return r;
                })(n, o, f),
                I = P(_, w, M, S),
                S = O(_, w, M, S),
                y = b,
                g = m,
                b = l,
                m = p,
                l = u,
                p = d,
                u = P(h, c, R, B),
                d = O(c, c, R, B),
                h = a,
                c = f,
                a = s,
                f = o,
                s = i,
                o = n,
                i = P(R, B, I, S),
                n = O(R, B, I, S);
            L(this.h, 0, i, n),
              L(this.h, 2, s, o),
              L(this.h, 4, a, f),
              L(this.h, 6, h, c),
              L(this.h, 8, u, d),
              L(this.h, 10, l, p),
              L(this.h, 12, b, m),
              L(this.h, 14, y, g);
          }),
          (a.prototype._digest = function(t) {
            return 'hex' === t
              ? i.toHex32(this.h, 'big')
              : i.split32(this.h, 'big');
          });
      },
      { '../common': 120, '../utils': 130, 'minimalistic-assert': 137 },
    ],
    129: [
      function(t, e, r) {
        'use strict';
        var i = t('../utils').rotr32;
        function n(t, e, r) {
          return (t & e) ^ (~t & r);
        }
        function s(t, e, r) {
          return (t & e) ^ (t & r) ^ (e & r);
        }
        function o(t, e, r) {
          return t ^ e ^ r;
        }
        (r.ft_1 = function(t, e, r, i) {
          return 0 === t
            ? n(e, r, i)
            : 1 === t || 3 === t
            ? e ^ r ^ i
            : 2 === t
            ? s(e, r, i)
            : void 0;
        }),
          (r.ch32 = n),
          (r.maj32 = s),
          (r.p32 = o),
          (r.s0_256 = function(t) {
            return i(t, 2) ^ i(t, 13) ^ i(t, 22);
          }),
          (r.s1_256 = function(t) {
            return i(t, 6) ^ i(t, 11) ^ i(t, 25);
          }),
          (r.g0_256 = function(t) {
            return i(t, 7) ^ i(t, 18) ^ (t >>> 3);
          }),
          (r.g1_256 = function(t) {
            return i(t, 17) ^ i(t, 19) ^ (t >>> 10);
          });
      },
      { '../utils': 130 },
    ],
    130: [
      function(t, e, r) {
        'use strict';
        var f = t('minimalistic-assert'),
          t = t('inherits');
        function s(t) {
          return (
            ((t >>> 24) |
              ((t >>> 8) & 65280) |
              ((t << 8) & 16711680) |
              ((255 & t) << 24)) >>>
            0
          );
        }
        function i(t) {
          return 1 === t.length ? '0' + t : t;
        }
        function o(t) {
          return 7 === t.length
            ? '0' + t
            : 6 === t.length
            ? '00' + t
            : 5 === t.length
            ? '000' + t
            : 4 === t.length
            ? '0000' + t
            : 3 === t.length
            ? '00000' + t
            : 2 === t.length
            ? '000000' + t
            : 1 === t.length
            ? '0000000' + t
            : t;
        }
        (r.inherits = t),
          (r.toArray = function(t, e) {
            if (Array.isArray(t)) return t.slice();
            if (!t) return [];
            var r,
              i,
              n = [];
            if ('string' == typeof t)
              if (e) {
                if ('hex' === e)
                  for (
                    (t = t.replace(/[^a-z0-9]+/gi, '')).length % 2 != 0 &&
                      (t = '0' + t),
                      o = 0;
                    o < t.length;
                    o += 2
                  )
                    n.push(parseInt(t[o] + t[o + 1], 16));
              } else
                for (var s = 0, o = 0; o < t.length; o++) {
                  var a = t.charCodeAt(o);
                  a < 128
                    ? (n[s++] = a)
                    : a < 2048
                    ? ((n[s++] = (a >> 6) | 192), (n[s++] = (63 & a) | 128))
                    : ((i = o),
                      55296 != (64512 & (r = t).charCodeAt(i)) ||
                      i < 0 ||
                      i + 1 >= r.length ||
                      56320 != (64512 & r.charCodeAt(i + 1))
                        ? (n[s++] = (a >> 12) | 224)
                        : ((a =
                            65536 +
                            ((1023 & a) << 10) +
                            (1023 & t.charCodeAt(++o))),
                          (n[s++] = (a >> 18) | 240),
                          (n[s++] = ((a >> 12) & 63) | 128)),
                      (n[s++] = ((a >> 6) & 63) | 128),
                      (n[s++] = (63 & a) | 128));
                }
            else for (o = 0; o < t.length; o++) n[o] = 0 | t[o];
            return n;
          }),
          (r.toHex = function(t) {
            for (var e = '', r = 0; r < t.length; r++)
              e += i(t[r].toString(16));
            return e;
          }),
          (r.htonl = s),
          (r.toHex32 = function(t, e) {
            for (var r = '', i = 0; i < t.length; i++) {
              var n = t[i];
              r += o((n = 'little' === e ? s(n) : n).toString(16));
            }
            return r;
          }),
          (r.zero2 = i),
          (r.zero8 = o),
          (r.join32 = function(t, e, r, i) {
            f((r -= e) % 4 == 0);
            for (
              var n = new Array(r / 4), s = 0, o = e;
              s < n.length;
              s++, o += 4
            ) {
              var a =
                'big' === i
                  ? (t[o] << 24) | (t[o + 1] << 16) | (t[o + 2] << 8) | t[o + 3]
                  : (t[o + 3] << 24) |
                    (t[o + 2] << 16) |
                    (t[o + 1] << 8) |
                    t[o];
              n[s] = a >>> 0;
            }
            return n;
          }),
          (r.split32 = function(t, e) {
            for (
              var r = new Array(4 * t.length), i = 0, n = 0;
              i < t.length;
              i++, n += 4
            ) {
              var s = t[i];
              'big' === e
                ? ((r[n] = s >>> 24),
                  (r[n + 1] = (s >>> 16) & 255),
                  (r[n + 2] = (s >>> 8) & 255),
                  (r[n + 3] = 255 & s))
                : ((r[n + 3] = s >>> 24),
                  (r[n + 2] = (s >>> 16) & 255),
                  (r[n + 1] = (s >>> 8) & 255),
                  (r[n] = 255 & s));
            }
            return r;
          }),
          (r.rotr32 = function(t, e) {
            return (t >>> e) | (t << (32 - e));
          }),
          (r.rotl32 = function(t, e) {
            return (t << e) | (t >>> (32 - e));
          }),
          (r.sum32 = function(t, e) {
            return (t + e) >>> 0;
          }),
          (r.sum32_3 = function(t, e, r) {
            return (t + e + r) >>> 0;
          }),
          (r.sum32_4 = function(t, e, r, i) {
            return (t + e + r + i) >>> 0;
          }),
          (r.sum32_5 = function(t, e, r, i, n) {
            return (t + e + r + i + n) >>> 0;
          }),
          (r.sum64 = function(t, e, r, i) {
            var n = t[e],
              s = (i + t[e + 1]) >>> 0;
            (t[e] = ((s < i ? 1 : 0) + r + n) >>> 0), (t[e + 1] = s);
          }),
          (r.sum64_hi = function(t, e, r, i) {
            return (((e + i) >>> 0 < e ? 1 : 0) + t + r) >>> 0;
          }),
          (r.sum64_lo = function(t, e, r, i) {
            return (e + i) >>> 0;
          }),
          (r.sum64_4_hi = function(t, e, r, i, n, s, o, a) {
            var f = 0,
              h = e;
            return (
              (f += (h = (e + i) >>> 0) < e ? 1 : 0),
              (f += (h = (h + s) >>> 0) < s ? 1 : 0),
              (t + r + n + o + (f += (h = (h + a) >>> 0) < a ? 1 : 0)) >>> 0
            );
          }),
          (r.sum64_4_lo = function(t, e, r, i, n, s, o, a) {
            return (e + i + s + a) >>> 0;
          }),
          (r.sum64_5_hi = function(t, e, r, i, n, s, o, a, f, h) {
            var c = 0,
              u = e;
            return (
              (c += (u = (e + i) >>> 0) < e ? 1 : 0),
              (c += (u = (u + s) >>> 0) < s ? 1 : 0),
              (c += (u = (u + a) >>> 0) < a ? 1 : 0),
              (t + r + n + o + f + (c += (u = (u + h) >>> 0) < h ? 1 : 0)) >>> 0
            );
          }),
          (r.sum64_5_lo = function(t, e, r, i, n, s, o, a, f, h) {
            return (e + i + s + a + h) >>> 0;
          }),
          (r.rotr64_hi = function(t, e, r) {
            return ((e << (32 - r)) | (t >>> r)) >>> 0;
          }),
          (r.rotr64_lo = function(t, e, r) {
            return ((t << (32 - r)) | (e >>> r)) >>> 0;
          }),
          (r.shr64_hi = function(t, e, r) {
            return t >>> r;
          }),
          (r.shr64_lo = function(t, e, r) {
            return ((t << (32 - r)) | (e >>> r)) >>> 0;
          });
      },
      { inherits: 133, 'minimalistic-assert': 137 },
    ],
    131: [
      function(t, e, r) {
        'use strict';
        var i = t('hash.js'),
          s = t('minimalistic-crypto-utils'),
          n = t('minimalistic-assert');
        function o(t) {
          if (!(this instanceof o)) return new o(t);
          (this.hash = t.hash),
            (this.predResist = !!t.predResist),
            (this.outLen = this.hash.outSize),
            (this.minEntropy = t.minEntropy || this.hash.hmacStrength),
            (this._reseed = null),
            (this.reseedInterval = null),
            (this.K = null),
            (this.V = null);
          var e = s.toArray(t.entropy, t.entropyEnc || 'hex'),
            r = s.toArray(t.nonce, t.nonceEnc || 'hex'),
            t = s.toArray(t.pers, t.persEnc || 'hex');
          n(
            e.length >= this.minEntropy / 8,
            'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits'
          ),
            this._init(e, r, t);
        }
        ((e.exports = o).prototype._init = function(t, e, r) {
          r = t.concat(e).concat(r);
          (this.K = new Array(this.outLen / 8)),
            (this.V = new Array(this.outLen / 8));
          for (var i = 0; i < this.V.length; i++)
            (this.K[i] = 0), (this.V[i] = 1);
          this._update(r),
            (this._reseed = 1),
            (this.reseedInterval = 281474976710656);
        }),
          (o.prototype._hmac = function() {
            return new i.hmac(this.hash, this.K);
          }),
          (o.prototype._update = function(t) {
            var e = this._hmac()
              .update(this.V)
              .update([0]);
            t && (e = e.update(t)),
              (this.K = e.digest()),
              (this.V = this._hmac()
                .update(this.V)
                .digest()),
              t &&
                ((this.K = this._hmac()
                  .update(this.V)
                  .update([1])
                  .update(t)
                  .digest()),
                (this.V = this._hmac()
                  .update(this.V)
                  .digest()));
          }),
          (o.prototype.reseed = function(t, e, r, i) {
            'string' != typeof e && ((i = r), (r = e), (e = null)),
              (t = s.toArray(t, e)),
              (r = s.toArray(r, i)),
              n(
                t.length >= this.minEntropy / 8,
                'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits'
              ),
              this._update(t.concat(r || [])),
              (this._reseed = 1);
          }),
          (o.prototype.generate = function(t, e, r, i) {
            if (this._reseed > this.reseedInterval)
              throw new Error('Reseed is reqqqd');
            'string' != typeof e && ((i = r), (r = e), (e = null)),
              r && ((r = s.toArray(r, i || 'hex')), this._update(r));
            for (var n = []; n.length < t; )
              (this.V = this._hmac()
                .update(this.V)
                .digest()),
                (n = n.concat(this.V));
            i = n.slice(0, t);
            return this._update(r), this._reseed++, s.encode(i, e);
          });
      },
      {
        'hash.js': 119,
        'minimalistic-assert': 137,
        'minimalistic-crypto-utils': 138,
      },
    ],
    132: [
      function(t, e, r) {
        (r.read = function(t, e, r, i, n) {
          var s,
            o,
            a = 8 * n - i - 1,
            f = (1 << a) - 1,
            h = f >> 1,
            c = -7,
            u = r ? n - 1 : 0,
            d = r ? -1 : 1,
            r = t[e + u];
          for (
            u += d, s = r & ((1 << -c) - 1), r >>= -c, c += a;
            0 < c;
            s = 256 * s + t[e + u], u += d, c -= 8
          );
          for (
            o = s & ((1 << -c) - 1), s >>= -c, c += i;
            0 < c;
            o = 256 * o + t[e + u], u += d, c -= 8
          );
          if (0 === s) s = 1 - h;
          else {
            if (s === f) return o ? NaN : (1 / 0) * (r ? -1 : 1);
            (o += Math.pow(2, i)), (s -= h);
          }
          return (r ? -1 : 1) * o * Math.pow(2, s - i);
        }),
          (r.write = function(t, e, r, i, n, s) {
            var o,
              a,
              f = 8 * s - n - 1,
              h = (1 << f) - 1,
              c = h >> 1,
              u = 23 === n ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
              d = i ? 0 : s - 1,
              l = i ? 1 : -1,
              s = e < 0 || (0 === e && 1 / e < 0) ? 1 : 0;
            for (
              e = Math.abs(e),
                isNaN(e) || e === 1 / 0
                  ? ((a = isNaN(e) ? 1 : 0), (o = h))
                  : ((o = Math.floor(Math.log(e) / Math.LN2)),
                    e * (i = Math.pow(2, -o)) < 1 && (o--, (i *= 2)),
                    2 <=
                      (e += 1 <= o + c ? u / i : u * Math.pow(2, 1 - c)) * i &&
                      (o++, (i /= 2)),
                    h <= o + c
                      ? ((a = 0), (o = h))
                      : 1 <= o + c
                      ? ((a = (e * i - 1) * Math.pow(2, n)), (o += c))
                      : ((a = e * Math.pow(2, c - 1) * Math.pow(2, n)),
                        (o = 0)));
              8 <= n;
              t[r + d] = 255 & a, d += l, a /= 256, n -= 8
            );
            for (
              o = (o << n) | a, f += n;
              0 < f;
              t[r + d] = 255 & o, d += l, o /= 256, f -= 8
            );
            t[r + d - l] |= 128 * s;
          });
      },
      {},
    ],
    133: [
      function(t, e, r) {
        'function' == typeof Object.create
          ? (e.exports = function(t, e) {
              e &&
                ((t.super_ = e),
                (t.prototype = Object.create(e.prototype, {
                  constructor: {
                    value: t,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0,
                  },
                })));
            })
          : (e.exports = function(t, e) {
              var r;
              e &&
                ((t.super_ = e),
                ((r = function() {}).prototype = e.prototype),
                (t.prototype = new r()),
                (t.prototype.constructor = t));
            });
      },
      {},
    ],
    134: [
      function(t, e, r) {
        'use strict';
        var i = t('inherits'),
          n = t('hash-base'),
          s = t('safe-buffer').Buffer,
          o = new Array(16);
        function a() {
          n.call(this, 64),
            (this._a = 1732584193),
            (this._b = 4023233417),
            (this._c = 2562383102),
            (this._d = 271733878);
        }
        function f(t, e) {
          return (t << e) | (t >>> (32 - e));
        }
        function h(t, e, r, i, n, s, o) {
          return (f((t + ((e & r) | (~e & i)) + n + s) | 0, o) + e) | 0;
        }
        function c(t, e, r, i, n, s, o) {
          return (f((t + ((e & i) | (r & ~i)) + n + s) | 0, o) + e) | 0;
        }
        function u(t, e, r, i, n, s, o) {
          return (f((t + (e ^ r ^ i) + n + s) | 0, o) + e) | 0;
        }
        function d(t, e, r, i, n, s, o) {
          return (f((t + (r ^ (e | ~i)) + n + s) | 0, o) + e) | 0;
        }
        i(a, n),
          (a.prototype._update = function() {
            for (var t = o, e = 0; e < 16; ++e)
              t[e] = this._block.readInt32LE(4 * e);
            var r = h(
                (r = this._a),
                (s = this._b),
                (n = this._c),
                (i = this._d),
                t[0],
                3614090360,
                7
              ),
              i = h(i, r, s, n, t[1], 3905402710, 12),
              n = h(n, i, r, s, t[2], 606105819, 17),
              s = h(s, n, i, r, t[3], 3250441966, 22);
            (r = h(r, s, n, i, t[4], 4118548399, 7)),
              (i = h(i, r, s, n, t[5], 1200080426, 12)),
              (n = h(n, i, r, s, t[6], 2821735955, 17)),
              (s = h(s, n, i, r, t[7], 4249261313, 22)),
              (r = h(r, s, n, i, t[8], 1770035416, 7)),
              (i = h(i, r, s, n, t[9], 2336552879, 12)),
              (n = h(n, i, r, s, t[10], 4294925233, 17)),
              (s = h(s, n, i, r, t[11], 2304563134, 22)),
              (r = h(r, s, n, i, t[12], 1804603682, 7)),
              (i = h(i, r, s, n, t[13], 4254626195, 12)),
              (n = h(n, i, r, s, t[14], 2792965006, 17)),
              (r = c(
                r,
                (s = h(s, n, i, r, t[15], 1236535329, 22)),
                n,
                i,
                t[1],
                4129170786,
                5
              )),
              (i = c(i, r, s, n, t[6], 3225465664, 9)),
              (n = c(n, i, r, s, t[11], 643717713, 14)),
              (s = c(s, n, i, r, t[0], 3921069994, 20)),
              (r = c(r, s, n, i, t[5], 3593408605, 5)),
              (i = c(i, r, s, n, t[10], 38016083, 9)),
              (n = c(n, i, r, s, t[15], 3634488961, 14)),
              (s = c(s, n, i, r, t[4], 3889429448, 20)),
              (r = c(r, s, n, i, t[9], 568446438, 5)),
              (i = c(i, r, s, n, t[14], 3275163606, 9)),
              (n = c(n, i, r, s, t[3], 4107603335, 14)),
              (s = c(s, n, i, r, t[8], 1163531501, 20)),
              (r = c(r, s, n, i, t[13], 2850285829, 5)),
              (i = c(i, r, s, n, t[2], 4243563512, 9)),
              (n = c(n, i, r, s, t[7], 1735328473, 14)),
              (r = u(
                r,
                (s = c(s, n, i, r, t[12], 2368359562, 20)),
                n,
                i,
                t[5],
                4294588738,
                4
              )),
              (i = u(i, r, s, n, t[8], 2272392833, 11)),
              (n = u(n, i, r, s, t[11], 1839030562, 16)),
              (s = u(s, n, i, r, t[14], 4259657740, 23)),
              (r = u(r, s, n, i, t[1], 2763975236, 4)),
              (i = u(i, r, s, n, t[4], 1272893353, 11)),
              (n = u(n, i, r, s, t[7], 4139469664, 16)),
              (s = u(s, n, i, r, t[10], 3200236656, 23)),
              (r = u(r, s, n, i, t[13], 681279174, 4)),
              (i = u(i, r, s, n, t[0], 3936430074, 11)),
              (n = u(n, i, r, s, t[3], 3572445317, 16)),
              (s = u(s, n, i, r, t[6], 76029189, 23)),
              (r = u(r, s, n, i, t[9], 3654602809, 4)),
              (i = u(i, r, s, n, t[12], 3873151461, 11)),
              (n = u(n, i, r, s, t[15], 530742520, 16)),
              (r = d(
                r,
                (s = u(s, n, i, r, t[2], 3299628645, 23)),
                n,
                i,
                t[0],
                4096336452,
                6
              )),
              (i = d(i, r, s, n, t[7], 1126891415, 10)),
              (n = d(n, i, r, s, t[14], 2878612391, 15)),
              (s = d(s, n, i, r, t[5], 4237533241, 21)),
              (r = d(r, s, n, i, t[12], 1700485571, 6)),
              (i = d(i, r, s, n, t[3], 2399980690, 10)),
              (n = d(n, i, r, s, t[10], 4293915773, 15)),
              (s = d(s, n, i, r, t[1], 2240044497, 21)),
              (r = d(r, s, n, i, t[8], 1873313359, 6)),
              (i = d(i, r, s, n, t[15], 4264355552, 10)),
              (n = d(n, i, r, s, t[6], 2734768916, 15)),
              (s = d(s, n, i, r, t[13], 1309151649, 21)),
              (r = d(r, s, n, i, t[4], 4149444226, 6)),
              (i = d(i, r, s, n, t[11], 3174756917, 10)),
              (n = d(n, i, r, s, t[2], 718787259, 15)),
              (s = d(s, n, i, r, t[9], 3951481745, 21)),
              (this._a = (this._a + r) | 0),
              (this._b = (this._b + s) | 0),
              (this._c = (this._c + n) | 0),
              (this._d = (this._d + i) | 0);
          }),
          (a.prototype._digest = function() {
            (this._block[this._blockOffset++] = 128),
              56 < this._blockOffset &&
                (this._block.fill(0, this._blockOffset, 64),
                this._update(),
                (this._blockOffset = 0)),
              this._block.fill(0, this._blockOffset, 56),
              this._block.writeUInt32LE(this._length[0], 56),
              this._block.writeUInt32LE(this._length[1], 60),
              this._update();
            var t = s.allocUnsafe(16);
            return (
              t.writeInt32LE(this._a, 0),
              t.writeInt32LE(this._b, 4),
              t.writeInt32LE(this._c, 8),
              t.writeInt32LE(this._d, 12),
              t
            );
          }),
          (e.exports = a);
      },
      { 'hash-base': 103, inherits: 133, 'safe-buffer': 161 },
    ],
    135: [
      function(t, e, r) {
        var l = t('bn.js'),
          i = t('brorand');
        function n(t) {
          this.rand = t || new i.Rand();
        }
        ((e.exports = n).create = function(t) {
          return new n(t);
        }),
          (n.prototype._randbelow = function(t) {
            var e = t.bitLength(),
              r = Math.ceil(e / 8);
            do {
              var i = new l(this.rand.generate(r));
            } while (0 <= i.cmp(t));
            return i;
          }),
          (n.prototype._randrange = function(t, e) {
            e = e.sub(t);
            return t.add(this._randbelow(e));
          }),
          (n.prototype.test = function(t, e, r) {
            var i = t.bitLength(),
              n = l.mont(t),
              s = new l(1).toRed(n);
            e = e || Math.max(1, (i / 48) | 0);
            for (var o = t.subn(1), a = 0; !o.testn(a); a++);
            for (var f = t.shrn(a), h = o.toRed(n); 0 < e; e--) {
              var c = this._randrange(new l(2), o);
              r && r(c);
              var u = c.toRed(n).redPow(f);
              if (0 !== u.cmp(s) && 0 !== u.cmp(h)) {
                for (var d = 1; d < a; d++) {
                  if (0 === (u = u.redSqr()).cmp(s)) return !1;
                  if (0 === u.cmp(h)) break;
                }
                if (d === a) return !1;
              }
            }
            return !0;
          }),
          (n.prototype.getDivisor = function(t, e) {
            var r = t.bitLength(),
              i = l.mont(t),
              n = new l(1).toRed(i);
            e = e || Math.max(1, (r / 48) | 0);
            for (var s = t.subn(1), o = 0; !s.testn(o); o++);
            for (var a = t.shrn(o), f = s.toRed(i); 0 < e; e--) {
              var h = this._randrange(new l(2), s),
                c = t.gcd(h);
              if (0 !== c.cmpn(1)) return c;
              var u = h.toRed(i).redPow(a);
              if (0 !== u.cmp(n) && 0 !== u.cmp(f)) {
                for (var d = 1; d < o; d++) {
                  if (0 === (u = u.redSqr()).cmp(n))
                    return u
                      .fromRed()
                      .subn(1)
                      .gcd(t);
                  if (0 === u.cmp(f)) break;
                }
                if (d === o)
                  return (u = u.redSqr())
                    .fromRed()
                    .subn(1)
                    .gcd(t);
              }
            }
            return !1;
          });
      },
      { 'bn.js': 136, brorand: 19 },
    ],
    136: [
      function(t, e, r) {
        arguments[4][16][0].apply(r, arguments);
      },
      { buffer: 20, dup: 16 },
    ],
    137: [
      function(t, e, r) {
        function i(t, e) {
          if (!t) throw new Error(e || 'Assertion failed');
        }
        (e.exports = i).equal = function(t, e, r) {
          if (t != e)
            throw new Error(r || 'Assertion failed: ' + t + ' != ' + e);
        };
      },
      {},
    ],
    138: [
      function(t, e, r) {
        'use strict';
        function i(t) {
          return 1 === t.length ? '0' + t : t;
        }
        function n(t) {
          for (var e = '', r = 0; r < t.length; r++) e += i(t[r].toString(16));
          return e;
        }
        (r.toArray = function(t, e) {
          if (Array.isArray(t)) return t.slice();
          if (!t) return [];
          var r = [];
          if ('string' != typeof t) {
            for (var i = 0; i < t.length; i++) r[i] = 0 | t[i];
            return r;
          }
          if ('hex' === e) {
            (t = t.replace(/[^a-z0-9]+/gi, '')).length % 2 != 0 &&
              (t = '0' + t);
            for (i = 0; i < t.length; i += 2)
              r.push(parseInt(t[i] + t[i + 1], 16));
          } else
            for (i = 0; i < t.length; i++) {
              var n = t.charCodeAt(i),
                s = n >> 8,
                n = 255 & n;
              s ? r.push(s, n) : r.push(n);
            }
          return r;
        }),
          (r.zero2 = i),
          (r.toHex = n),
          (r.encode = function(t, e) {
            return 'hex' === e ? n(t) : t;
          });
      },
      {},
    ],
    139: [
      function(t, e, r) {
        e.exports = {
          '2.16.840.1.101.3.4.1.1': 'aes-128-ecb',
          '2.16.840.1.101.3.4.1.2': 'aes-128-cbc',
          '2.16.840.1.101.3.4.1.3': 'aes-128-ofb',
          '2.16.840.1.101.3.4.1.4': 'aes-128-cfb',
          '2.16.840.1.101.3.4.1.21': 'aes-192-ecb',
          '2.16.840.1.101.3.4.1.22': 'aes-192-cbc',
          '2.16.840.1.101.3.4.1.23': 'aes-192-ofb',
          '2.16.840.1.101.3.4.1.24': 'aes-192-cfb',
          '2.16.840.1.101.3.4.1.41': 'aes-256-ecb',
          '2.16.840.1.101.3.4.1.42': 'aes-256-cbc',
          '2.16.840.1.101.3.4.1.43': 'aes-256-ofb',
          '2.16.840.1.101.3.4.1.44': 'aes-256-cfb',
        };
      },
      {},
    ],
    140: [
      function(t, e, r) {
        'use strict';
        var i = t('asn1.js');
        r.certificate = t('./certificate');
        t = i.define('RSAPrivateKey', function() {
          this.seq().obj(
            this.key('version').int(),
            this.key('modulus').int(),
            this.key('publicExponent').int(),
            this.key('privateExponent').int(),
            this.key('prime1').int(),
            this.key('prime2').int(),
            this.key('exponent1').int(),
            this.key('exponent2').int(),
            this.key('coefficient').int()
          );
        });
        r.RSAPrivateKey = t;
        t = i.define('RSAPublicKey', function() {
          this.seq().obj(
            this.key('modulus').int(),
            this.key('publicExponent').int()
          );
        });
        r.RSAPublicKey = t;
        t = i.define('SubjectPublicKeyInfo', function() {
          this.seq().obj(
            this.key('algorithm').use(n),
            this.key('subjectPublicKey').bitstr()
          );
        });
        r.PublicKey = t;
        var n = i.define('AlgorithmIdentifier', function() {
            this.seq().obj(
              this.key('algorithm').objid(),
              this.key('none')
                .null_()
                .optional(),
              this.key('curve')
                .objid()
                .optional(),
              this.key('params')
                .seq()
                .obj(
                  this.key('p').int(),
                  this.key('q').int(),
                  this.key('g').int()
                )
                .optional()
            );
          }),
          t = i.define('PrivateKeyInfo', function() {
            this.seq().obj(
              this.key('version').int(),
              this.key('algorithm').use(n),
              this.key('subjectPrivateKey').octstr()
            );
          });
        r.PrivateKey = t;
        t = i.define('EncryptedPrivateKeyInfo', function() {
          this.seq().obj(
            this.key('algorithm')
              .seq()
              .obj(
                this.key('id').objid(),
                this.key('decrypt')
                  .seq()
                  .obj(
                    this.key('kde')
                      .seq()
                      .obj(
                        this.key('id').objid(),
                        this.key('kdeparams')
                          .seq()
                          .obj(
                            this.key('salt').octstr(),
                            this.key('iters').int()
                          )
                      ),
                    this.key('cipher')
                      .seq()
                      .obj(this.key('algo').objid(), this.key('iv').octstr())
                  )
              ),
            this.key('subjectPrivateKey').octstr()
          );
        });
        r.EncryptedPrivateKey = t;
        t = i.define('DSAPrivateKey', function() {
          this.seq().obj(
            this.key('version').int(),
            this.key('p').int(),
            this.key('q').int(),
            this.key('g').int(),
            this.key('pub_key').int(),
            this.key('priv_key').int()
          );
        });
        (r.DSAPrivateKey = t),
          (r.DSAparam = i.define('DSAparam', function() {
            this.int();
          }));
        t = i.define('ECPrivateKey', function() {
          this.seq().obj(
            this.key('version').int(),
            this.key('privateKey').octstr(),
            this.key('parameters')
              .optional()
              .explicit(0)
              .use(s),
            this.key('publicKey')
              .optional()
              .explicit(1)
              .bitstr()
          );
        });
        r.ECPrivateKey = t;
        var s = i.define('ECParameters', function() {
          this.choice({ namedCurve: this.objid() });
        });
        r.signature = i.define('signature', function() {
          this.seq().obj(this.key('r').int(), this.key('s').int());
        });
      },
      { './certificate': 141, 'asn1.js': 2 },
    ],
    141: [
      function(t, e, r) {
        'use strict';
        var t = t('asn1.js'),
          i = t.define('Time', function() {
            this.choice({
              utcTime: this.utctime(),
              generalTime: this.gentime(),
            });
          }),
          n = t.define('AttributeTypeValue', function() {
            this.seq().obj(this.key('type').objid(), this.key('value').any());
          }),
          s = t.define('AlgorithmIdentifier', function() {
            this.seq().obj(
              this.key('algorithm').objid(),
              this.key('parameters').optional(),
              this.key('curve')
                .objid()
                .optional()
            );
          }),
          o = t.define('SubjectPublicKeyInfo', function() {
            this.seq().obj(
              this.key('algorithm').use(s),
              this.key('subjectPublicKey').bitstr()
            );
          }),
          a = t.define('RelativeDistinguishedName', function() {
            this.setof(n);
          }),
          f = t.define('RDNSequence', function() {
            this.seqof(a);
          }),
          h = t.define('Name', function() {
            this.choice({ rdnSequence: this.use(f) });
          }),
          c = t.define('Validity', function() {
            this.seq().obj(
              this.key('notBefore').use(i),
              this.key('notAfter').use(i)
            );
          }),
          u = t.define('Extension', function() {
            this.seq().obj(
              this.key('extnID').objid(),
              this.key('critical')
                .bool()
                .def(!1),
              this.key('extnValue').octstr()
            );
          }),
          d = t.define('TBSCertificate', function() {
            this.seq().obj(
              this.key('version')
                .explicit(0)
                .int()
                .optional(),
              this.key('serialNumber').int(),
              this.key('signature').use(s),
              this.key('issuer').use(h),
              this.key('validity').use(c),
              this.key('subject').use(h),
              this.key('subjectPublicKeyInfo').use(o),
              this.key('issuerUniqueID')
                .implicit(1)
                .bitstr()
                .optional(),
              this.key('subjectUniqueID')
                .implicit(2)
                .bitstr()
                .optional(),
              this.key('extensions')
                .explicit(3)
                .seqof(u)
                .optional()
            );
          }),
          t = t.define('X509Certificate', function() {
            this.seq().obj(
              this.key('tbsCertificate').use(d),
              this.key('signatureAlgorithm').use(s),
              this.key('signatureValue').bitstr()
            );
          });
        e.exports = t;
      },
      { 'asn1.js': 2 },
    ],
    142: [
      function(t, e, r) {
        var a = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m,
          f = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m,
          h = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m,
          c = t('evp_bytestokey'),
          u = t('browserify-aes'),
          d = t('safe-buffer').Buffer;
        e.exports = function(t, e) {
          var r,
            i,
            n,
            s = t.toString(),
            o = s.match(a);
          return (
            (n = o
              ? ((r = 'aes' + o[1]),
                (i = d.from(o[2], 'hex')),
                (t = d.from(o[3].replace(/[\r\n]/g, ''), 'base64')),
                (e = c(e, i.slice(0, 8), parseInt(o[1], 10)).key),
                (o = []),
                (i = u.createDecipheriv(r, e, i)),
                o.push(i.update(t)),
                o.push(i.final()),
                d.concat(o))
              : ((n = s.match(h)),
                d.from(n[2].replace(/[\r\n]/g, ''), 'base64'))),
            { tag: s.match(f)[1], data: n }
          );
        };
      },
      { 'browserify-aes': 23, evp_bytestokey: 102, 'safe-buffer': 161 },
    ],
    143: [
      function(t, e, r) {
        var l = t('./asn1'),
          p = t('./aesid.json'),
          b = t('./fixProc'),
          m = t('browserify-aes'),
          y = t('pbkdf2'),
          g = t('safe-buffer').Buffer;
        function i(t) {
          var e;
          'object' != typeof t ||
            g.isBuffer(t) ||
            ((e = t.passphrase), (t = t.key)),
            'string' == typeof t && (t = g.from(t));
          var r,
            i,
            n,
            s,
            o,
            a,
            f,
            h,
            c,
            t = b(t, e),
            u = t.tag,
            d = t.data;
          switch (u) {
            case 'CERTIFICATE':
              i = l.certificate.decode(d, 'der').tbsCertificate
                .subjectPublicKeyInfo;
            case 'PUBLIC KEY':
              switch (
                (r = (i =
                  i || l.PublicKey.decode(d, 'der')).algorithm.algorithm.join(
                  '.'
                ))
              ) {
                case '1.2.840.113549.1.1.1':
                  return l.RSAPublicKey.decode(i.subjectPublicKey.data, 'der');
                case '1.2.840.10045.2.1':
                  return (
                    (i.subjectPrivateKey = i.subjectPublicKey),
                    { type: 'ec', data: i }
                  );
                case '1.2.840.10040.4.1':
                  return (
                    (i.algorithm.params.pub_key = l.DSAparam.decode(
                      i.subjectPublicKey.data,
                      'der'
                    )),
                    { type: 'dsa', data: i.algorithm.params }
                  );
                default:
                  throw new Error('unknown key id ' + r);
              }
            case 'ENCRYPTED PRIVATE KEY':
              (d = l.EncryptedPrivateKey.decode(d, 'der')),
                (s = e),
                (o = (n = d).algorithm.decrypt.kde.kdeparams.salt),
                (a = parseInt(
                  n.algorithm.decrypt.kde.kdeparams.iters.toString(),
                  10
                )),
                (f = p[n.algorithm.decrypt.cipher.algo.join('.')]),
                (h = n.algorithm.decrypt.cipher.iv),
                (c = n.subjectPrivateKey),
                (n = parseInt(f.split('-')[1], 10) / 8),
                (n = y.pbkdf2Sync(s, o, a, n, 'sha1')),
                (n = m.createDecipheriv(f, n, h)),
                (h = []).push(n.update(c)),
                h.push(n.final()),
                (d = g.concat(h));
            case 'PRIVATE KEY':
              switch (
                (r = (i = l.PrivateKey.decode(
                  d,
                  'der'
                )).algorithm.algorithm.join('.'))
              ) {
                case '1.2.840.113549.1.1.1':
                  return l.RSAPrivateKey.decode(i.subjectPrivateKey, 'der');
                case '1.2.840.10045.2.1':
                  return {
                    curve: i.algorithm.curve,
                    privateKey: l.ECPrivateKey.decode(
                      i.subjectPrivateKey,
                      'der'
                    ).privateKey,
                  };
                case '1.2.840.10040.4.1':
                  return (
                    (i.algorithm.params.priv_key = l.DSAparam.decode(
                      i.subjectPrivateKey,
                      'der'
                    )),
                    { type: 'dsa', params: i.algorithm.params }
                  );
                default:
                  throw new Error('unknown key id ' + r);
              }
            case 'RSA PUBLIC KEY':
              return l.RSAPublicKey.decode(d, 'der');
            case 'RSA PRIVATE KEY':
              return l.RSAPrivateKey.decode(d, 'der');
            case 'DSA PRIVATE KEY':
              return { type: 'dsa', params: l.DSAPrivateKey.decode(d, 'der') };
            case 'EC PRIVATE KEY':
              return {
                curve: (d = l.ECPrivateKey.decode(d, 'der')).parameters.value,
                privateKey: d.privateKey,
              };
            default:
              throw new Error('unknown key type ' + u);
          }
        }
        (e.exports = i).signature = l.signature;
      },
      {
        './aesid.json': 139,
        './asn1': 140,
        './fixProc': 142,
        'browserify-aes': 23,
        pbkdf2: 144,
        'safe-buffer': 161,
      },
    ],
    144: [
      function(t, e, r) {
        (r.pbkdf2 = t('./lib/async')), (r.pbkdf2Sync = t('./lib/sync'));
      },
      { './lib/async': 145, './lib/sync': 148 },
    ],
    145: [
      function(e, r, t) {
        !function(_) {
          !function() {
            var h,
              t,
              c = e('safe-buffer').Buffer,
              u = e('./precondition'),
              d = e('./default-encoding'),
              l = e('./sync'),
              p = e('./to-buffer'),
              b = _.crypto && _.crypto.subtle,
              m = {
                sha: 'SHA-1',
                'sha-1': 'SHA-1',
                sha1: 'SHA-1',
                sha256: 'SHA-256',
                'sha-256': 'SHA-256',
                sha384: 'SHA-384',
                'sha-384': 'SHA-384',
                'sha-512': 'SHA-512',
                sha512: 'SHA-512',
              },
              y = [];
            function g() {
              return (t =
                t ||
                (_.process && _.process.nextTick
                  ? _.process.nextTick
                  : _.queueMicrotask || _.setImmediate || _.setTimeout));
            }
            function v(t, e, r, i, n) {
              return b
                .importKey('raw', t, { name: 'PBKDF2' }, !1, ['deriveBits'])
                .then(function(t) {
                  return b.deriveBits(
                    {
                      name: 'PBKDF2',
                      salt: e,
                      iterations: r,
                      hash: { name: n },
                    },
                    t,
                    i << 3
                  );
                })
                .then(function(t) {
                  return c.from(t);
                });
            }
            r.exports = function(e, r, i, n, s, o) {
              'function' == typeof s && ((o = s), (s = void 0));
              var t,
                a,
                f = m[(s = s || 'sha1').toLowerCase()];
              if (f && 'function' == typeof _.Promise) {
                if (
                  (u(i, n),
                  (e = p(e, d, 'Password')),
                  (r = p(r, d, 'Salt')),
                  'function' != typeof o)
                )
                  throw new Error('No callback provided to pbkdf2');
                (t = (function(t) {
                  if (_.process && !_.process.browser)
                    return Promise.resolve(!1);
                  if (!b || !b.importKey || !b.deriveBits)
                    return Promise.resolve(!1);
                  if (void 0 !== y[t]) return y[t];
                  var e = v((h = h || c.alloc(8)), h, 10, 128, t)
                    .then(function() {
                      return !0;
                    })
                    .catch(function() {
                      return !1;
                    });
                  return (y[t] = e);
                })(f).then(function(t) {
                  return t ? v(e, r, i, n, f) : l(e, r, i, n, s);
                })),
                  (a = o),
                  t.then(
                    function(t) {
                      g()(function() {
                        a(null, t);
                      });
                    },
                    function(t) {
                      g()(function() {
                        a(t);
                      });
                    }
                  );
              } else
                g()(function() {
                  var t;
                  try {
                    t = l(e, r, i, n, s);
                  } catch (t) {
                    return o(t);
                  }
                  o(null, t);
                });
            };
          }.call(this);
        }.call(
          this,
          'undefined' != typeof global
            ? global
            : 'undefined' != typeof self
            ? self
            : 'undefined' != typeof window
            ? window
            : {}
        );
      },
      {
        './default-encoding': 146,
        './precondition': 147,
        './sync': 148,
        './to-buffer': 149,
        'safe-buffer': 161,
      },
    ],
    146: [
      function(t, i, e) {
        !function(e, r) {
          !function() {
            var t;
            (t =
              (r.process && r.process.browser) ||
              !r.process ||
              !r.process.version ||
              6 <= parseInt(e.version.split('.')[0].slice(1), 10)
                ? 'utf-8'
                : 'binary'),
              (i.exports = t);
          }.call(this);
        }.call(
          this,
          t('_process'),
          'undefined' != typeof global
            ? global
            : 'undefined' != typeof self
            ? self
            : 'undefined' != typeof window
            ? window
            : {}
        );
      },
      { _process: 150 },
    ],
    147: [
      function(t, e, r) {
        var i = Math.pow(2, 30) - 1;
        e.exports = function(t, e) {
          if ('number' != typeof t)
            throw new TypeError('Iterations not a number');
          if (t < 0) throw new TypeError('Bad iterations');
          if ('number' != typeof e)
            throw new TypeError('Key length not a number');
          if (e < 0 || i < e || e != e) throw new TypeError('Bad key length');
        };
      },
      {},
    ],
    148: [
      function(t, e, r) {
        var h = t('create-hash/md5'),
          c = t('ripemd160'),
          u = t('sha.js'),
          m = t('safe-buffer').Buffer,
          y = t('./precondition'),
          g = t('./default-encoding'),
          v = t('./to-buffer'),
          d = m.alloc(128),
          _ = {
            md5: 16,
            sha1: 20,
            sha224: 28,
            sha256: 32,
            sha384: 48,
            sha512: 64,
            rmd160: 20,
            ripemd160: 20,
          };
        function w(t, e, r) {
          var i,
            n =
              'rmd160' === (i = t) || 'ripemd160' === i
                ? function(t) {
                    return new c().update(t).digest();
                  }
                : 'md5' === i
                ? h
                : function(t) {
                    return u(i)
                      .update(t)
                      .digest();
                  },
            s = 'sha512' === t || 'sha384' === t ? 128 : 64;
          e.length > s ? (e = n(e)) : e.length < s && (e = m.concat([e, d], s));
          for (
            var o = m.allocUnsafe(s + _[t]), a = m.allocUnsafe(s + _[t]), f = 0;
            f < s;
            f++
          )
            (o[f] = 54 ^ e[f]), (a[f] = 92 ^ e[f]);
          r = m.allocUnsafe(s + r + 4);
          o.copy(r, 0, 0, s),
            (this.ipad1 = r),
            (this.ipad2 = o),
            (this.opad = a),
            (this.alg = t),
            (this.blocksize = s),
            (this.hash = n),
            (this.size = _[t]);
        }
        (w.prototype.run = function(t, e) {
          return (
            t.copy(e, this.blocksize),
            this.hash(e).copy(this.opad, this.blocksize),
            this.hash(this.opad)
          );
        }),
          (e.exports = function(t, e, r, i, n) {
            y(r, i);
            var s = new w(
                (n = n || 'sha1'),
                (t = v(t, g, 'Password')),
                (e = v(e, g, 'Salt')).length
              ),
              o = m.allocUnsafe(i),
              a = m.allocUnsafe(e.length + 4);
            e.copy(a, 0, 0, e.length);
            for (
              var f = 0, h = _[n], c = Math.ceil(i / h), u = 1;
              u <= c;
              u++
            ) {
              a.writeUInt32BE(u, e.length);
              for (var d = s.run(a, s.ipad1), l = d, p = 1; p < r; p++)
                for (var l = s.run(l, s.ipad2), b = 0; b < h; b++) d[b] ^= l[b];
              d.copy(o, f), (f += h);
            }
            return o;
          });
      },
      {
        './default-encoding': 146,
        './precondition': 147,
        './to-buffer': 149,
        'create-hash/md5': 69,
        ripemd160: 160,
        'safe-buffer': 161,
        'sha.js': 164,
      },
    ],
    149: [
      function(t, e, r) {
        var i = t('safe-buffer').Buffer;
        e.exports = function(t, e, r) {
          if (i.isBuffer(t)) return t;
          if ('string' == typeof t) return i.from(t, e);
          if (ArrayBuffer.isView(t)) return i.from(t.buffer);
          throw new TypeError(
            r + ' must be a string, a Buffer, a typed array or a DataView'
          );
        };
      },
      { 'safe-buffer': 161 },
    ],
    150: [
      function(t, e, r) {
        var i,
          n,
          e = (e.exports = {});
        function s() {
          throw new Error('setTimeout has not been defined');
        }
        function o() {
          throw new Error('clearTimeout has not been defined');
        }
        function a(e) {
          if (i === setTimeout) return setTimeout(e, 0);
          if ((i === s || !i) && setTimeout)
            return (i = setTimeout), setTimeout(e, 0);
          try {
            return i(e, 0);
          } catch (t) {
            try {
              return i.call(null, e, 0);
            } catch (t) {
              return i.call(this, e, 0);
            }
          }
        }
        !(function() {
          try {
            i = 'function' == typeof setTimeout ? setTimeout : s;
          } catch (t) {
            i = s;
          }
          try {
            n = 'function' == typeof clearTimeout ? clearTimeout : o;
          } catch (t) {
            n = o;
          }
        })();
        var f,
          h = [],
          c = !1,
          u = -1;
        function d() {
          c &&
            f &&
            ((c = !1),
            f.length ? (h = f.concat(h)) : (u = -1),
            h.length && l());
        }
        function l() {
          if (!c) {
            var t = a(d);
            c = !0;
            for (var e = h.length; e; ) {
              for (f = h, h = []; ++u < e; ) f && f[u].run();
              (u = -1), (e = h.length);
            }
            (f = null),
              (c = !1),
              (function(e) {
                if (n === clearTimeout) return clearTimeout(e);
                if ((n === o || !n) && clearTimeout)
                  return (n = clearTimeout), clearTimeout(e);
                try {
                  n(e);
                } catch (t) {
                  try {
                    return n.call(null, e);
                  } catch (t) {
                    return n.call(this, e);
                  }
                }
              })(t);
          }
        }
        function p(t, e) {
          (this.fun = t), (this.array = e);
        }
        function b() {}
        (e.nextTick = function(t) {
          var e = new Array(arguments.length - 1);
          if (1 < arguments.length)
            for (var r = 1; r < arguments.length; r++) e[r - 1] = arguments[r];
          h.push(new p(t, e)), 1 !== h.length || c || a(l);
        }),
          (p.prototype.run = function() {
            this.fun.apply(null, this.array);
          }),
          (e.title = 'browser'),
          (e.browser = !0),
          (e.env = {}),
          (e.argv = []),
          (e.version = ''),
          (e.versions = {}),
          (e.on = b),
          (e.addListener = b),
          (e.once = b),
          (e.off = b),
          (e.removeListener = b),
          (e.removeAllListeners = b),
          (e.emit = b),
          (e.prependListener = b),
          (e.prependOnceListener = b),
          (e.listeners = function(t) {
            return [];
          }),
          (e.binding = function(t) {
            throw new Error('process.binding is not supported');
          }),
          (e.cwd = function() {
            return '/';
          }),
          (e.chdir = function(t) {
            throw new Error('process.chdir is not supported');
          }),
          (e.umask = function() {
            return 0;
          });
      },
      {},
    ],
    151: [
      function(t, e, r) {
        (r.publicEncrypt = t('./publicEncrypt')),
          (r.privateDecrypt = t('./privateDecrypt')),
          (r.privateEncrypt = function(t, e) {
            return r.publicEncrypt(t, e, !0);
          }),
          (r.publicDecrypt = function(t, e) {
            return r.privateDecrypt(t, e, !0);
          });
      },
      { './privateDecrypt': 154, './publicEncrypt': 155 },
    ],
    152: [
      function(t, e, r) {
        var o = t('create-hash'),
          a = t('safe-buffer').Buffer;
        e.exports = function(t, e) {
          for (var r, i, n = a.alloc(0), s = 0; n.length < e; )
            (r = s++),
              (i = void 0),
              (i = a.allocUnsafe(4)).writeUInt32BE(r, 0),
              (i = i),
              (n = a.concat([
                n,
                o('sha1')
                  .update(t)
                  .update(i)
                  .digest(),
              ]));
          return n.slice(0, e);
        };
      },
      { 'create-hash': 68, 'safe-buffer': 161 },
    ],
    153: [
      function(t, e, r) {
        arguments[4][16][0].apply(r, arguments);
      },
      { buffer: 20, dup: 16 },
    ],
    154: [
      function(t, e, r) {
        var o = t('parse-asn1'),
          a = t('./mgf'),
          f = t('./xor'),
          h = t('bn.js'),
          c = t('browserify-rsa'),
          u = t('create-hash'),
          d = t('./withPublic'),
          l = t('safe-buffer').Buffer;
        e.exports = function(t, e, r) {
          var i = t.padding || (r ? 1 : 4),
            n = o(t),
            s = n.modulus.byteLength();
          if (e.length > s || 0 <= new h(e).cmp(n.modulus))
            throw new Error('decryption error');
          (t = r ? d(new h(e), n) : c(e, n)), (e = l.alloc(s - t.length));
          if (((t = l.concat([e, t], s)), 4 === i))
            return (function(t, e) {
              var r = t.modulus.byteLength(),
                i = u('sha1')
                  .update(l.alloc(0))
                  .digest(),
                n = i.length;
              if (0 !== e[0]) throw new Error('decryption error');
              var t = e.slice(1, n + 1),
                e = e.slice(n + 1),
                t = f(t, a(e, n)),
                s = f(e, a(t, r - n - 1));
              if (
                (function(t, e) {
                  (t = l.from(t)), (e = l.from(e));
                  var r = 0,
                    i = t.length;
                  t.length !== e.length &&
                    (r++, (i = Math.min(t.length, e.length)));
                  var n = -1;
                  for (; ++n < i; ) r += t[n] ^ e[n];
                  return r;
                })(i, s.slice(0, n))
              )
                throw new Error('decryption error');
              var o = n;
              for (; 0 === s[o]; ) o++;
              if (1 === s[o++]) return s.slice(o);
              throw new Error('decryption error');
            })(n, t);
          if (1 === i)
            return (function(t, e) {
              var r = t.slice(0, 2),
                i = 2,
                n = 0;
              for (; 0 !== t[i++]; )
                if (i >= t.length) {
                  n++;
                  break;
                }
              var s = t.slice(2, i - 1);
              (('0002' !== r.toString('hex') && !e) ||
                ('0001' !== r.toString('hex') && e)) &&
                n++;
              s.length < 8 && n++;
              if (n) throw new Error('decryption error');
              return t.slice(i);
            })(t, r);
          if (3 === i) return t;
          throw new Error('unknown padding');
        };
      },
      {
        './mgf': 152,
        './withPublic': 156,
        './xor': 157,
        'bn.js': 153,
        'browserify-rsa': 41,
        'create-hash': 68,
        'parse-asn1': 143,
        'safe-buffer': 161,
      },
    ],
    155: [
      function(t, e, r) {
        var s = t('parse-asn1'),
          a = t('randombytes'),
          f = t('create-hash'),
          h = t('./mgf'),
          c = t('./xor'),
          u = t('bn.js'),
          o = t('./withPublic'),
          d = t('browserify-rsa'),
          l = t('safe-buffer').Buffer;
        e.exports = function(t, e, r) {
          var i,
            n = t.padding || (r ? 1 : 4),
            t = s(t);
          if (4 === n)
            i = (function(t, e) {
              var r = t.modulus.byteLength(),
                i = e.length,
                n = f('sha1')
                  .update(l.alloc(0))
                  .digest(),
                s = n.length,
                o = 2 * s;
              if (r - o - 2 < i) throw new Error('message too long');
              (t = l.alloc(r - i - o - 2)),
                (i = r - s - 1),
                (o = a(s)),
                (i = c(l.concat([n, t, l.alloc(1, 1), e], i), h(o, i))),
                (s = c(o, h(i, s)));
              return new u(l.concat([l.alloc(1), s, i], r));
            })(t, e);
          else if (1 === n)
            i = (function(t, e, r) {
              var i = e.length,
                t = t.modulus.byteLength();
              if (t - 11 < i) throw new Error('message too long');
              i = r
                ? l.alloc(t - i - 3, 255)
                : (function(t) {
                    var e,
                      r = l.allocUnsafe(t),
                      i = 0,
                      n = a(2 * t),
                      s = 0;
                    for (; i < t; )
                      s === n.length && ((n = a(2 * t)), (s = 0)),
                        (e = n[s++]) && (r[i++] = e);
                    return r;
                  })(t - i - 3);
              return new u(
                l.concat([l.from([0, r ? 1 : 2]), i, l.alloc(1), e], t)
              );
            })(t, e, r);
          else {
            if (3 !== n) throw new Error('unknown padding');
            if (0 <= (i = new u(e)).cmp(t.modulus))
              throw new Error('data too long for modulus');
          }
          return (r ? d : o)(i, t);
        };
      },
      {
        './mgf': 152,
        './withPublic': 156,
        './xor': 157,
        'bn.js': 153,
        'browserify-rsa': 41,
        'create-hash': 68,
        'parse-asn1': 143,
        randombytes: 158,
        'safe-buffer': 161,
      },
    ],
    156: [
      function(t, e, r) {
        var i = t('bn.js'),
          n = t('safe-buffer').Buffer;
        e.exports = function(t, e) {
          return n.from(
            t
              .toRed(i.mont(e.modulus))
              .redPow(new i(e.publicExponent))
              .fromRed()
              .toArray()
          );
        };
      },
      { 'bn.js': 153, 'safe-buffer': 161 },
    ],
    157: [
      function(t, e, r) {
        e.exports = function(t, e) {
          for (var r = t.length, i = -1; ++i < r; ) t[i] ^= e[i];
          return t;
        };
      },
      {},
    ],
    158: [
      function(e, r, t) {
        !function(o, t) {
          !function() {
            'use strict';
            var n = e('safe-buffer').Buffer,
              s = t.crypto || t.msCrypto;
            s && s.getRandomValues
              ? (r.exports = function(t, e) {
                  if (4294967295 < t)
                    throw new RangeError('requested too many random bytes');
                  var r = n.allocUnsafe(t);
                  if (0 < t)
                    if (65536 < t)
                      for (var i = 0; i < t; i += 65536)
                        s.getRandomValues(r.slice(i, i + 65536));
                    else s.getRandomValues(r);
                  return 'function' != typeof e
                    ? r
                    : o.nextTick(function() {
                        e(null, r);
                      });
                })
              : (r.exports = function() {
                  throw new Error(
                    'Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11'
                  );
                });
          }.call(this);
        }.call(
          this,
          e('_process'),
          'undefined' != typeof global
            ? global
            : 'undefined' != typeof self
            ? self
            : 'undefined' != typeof window
            ? window
            : {}
        );
      },
      { _process: 150, 'safe-buffer': 161 },
    ],
    159: [
      function(r, t, l) {
        !function(u, d) {
          !function() {
            'use strict';
            function t() {
              throw new Error(
                'secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11'
              );
            }
            var e = r('safe-buffer'),
              s = r('randombytes'),
              n = e.Buffer,
              i = e.kMaxLength,
              o = d.crypto || d.msCrypto,
              a = Math.pow(2, 32) - 1;
            function f(t, e) {
              if ('number' != typeof t || t != t)
                throw new TypeError('offset must be a number');
              if (a < t || t < 0)
                throw new TypeError('offset must be a uint32');
              if (i < t || e < t) throw new RangeError('offset out of range');
            }
            function h(t, e, r) {
              if ('number' != typeof t || t != t)
                throw new TypeError('size must be a number');
              if (a < t || t < 0) throw new TypeError('size must be a uint32');
              if (r < t + e || i < t) throw new RangeError('buffer too small');
            }
            function c(r, i, t, n) {
              if (u.browser) {
                var e = r.buffer,
                  e = new Uint8Array(e, i, t);
                return (
                  o.getRandomValues(e),
                  n
                    ? void u.nextTick(function() {
                        n(null, r);
                      })
                    : r
                );
              }
              if (!n) return s(t).copy(r, i), r;
              s(t, function(t, e) {
                return t ? n(t) : (e.copy(r, i), void n(null, r));
              });
            }
            (o && o.getRandomValues) || !u.browser
              ? ((l.randomFill = function(t, e, r, i) {
                  if (!(n.isBuffer(t) || t instanceof d.Uint8Array))
                    throw new TypeError(
                      '"buf" argument must be a Buffer or Uint8Array'
                    );
                  if ('function' == typeof e) (i = e), (e = 0), (r = t.length);
                  else if ('function' == typeof r) (i = r), (r = t.length - e);
                  else if ('function' != typeof i)
                    throw new TypeError('"cb" argument must be a function');
                  return f(e, t.length), h(r, e, t.length), c(t, e, r, i);
                }),
                (l.randomFillSync = function(t, e, r) {
                  void 0 === e && (e = 0);
                  if (!(n.isBuffer(t) || t instanceof d.Uint8Array))
                    throw new TypeError(
                      '"buf" argument must be a Buffer or Uint8Array'
                    );
                  f(e, t.length), void 0 === r && (r = t.length - e);
                  return h(r, e, t.length), c(t, e, r);
                }))
              : ((l.randomFill = t), (l.randomFillSync = t));
          }.call(this);
        }.call(
          this,
          r('_process'),
          'undefined' != typeof global
            ? global
            : 'undefined' != typeof self
            ? self
            : 'undefined' != typeof window
            ? window
            : {}
        );
      },
      { _process: 150, randombytes: 158, 'safe-buffer': 161 },
    ],
    160: [
      function(t, e, r) {
        'use strict';
        var i = t('buffer').Buffer,
          n = t('inherits'),
          s = t('hash-base'),
          m = new Array(16),
          y = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            7,
            4,
            13,
            1,
            10,
            6,
            15,
            3,
            12,
            0,
            9,
            5,
            2,
            14,
            11,
            8,
            3,
            10,
            14,
            4,
            9,
            15,
            8,
            1,
            2,
            7,
            0,
            6,
            13,
            11,
            5,
            12,
            1,
            9,
            11,
            10,
            0,
            8,
            12,
            4,
            13,
            3,
            7,
            15,
            14,
            5,
            6,
            2,
            4,
            0,
            5,
            9,
            7,
            12,
            2,
            10,
            14,
            1,
            3,
            8,
            11,
            6,
            15,
            13,
          ],
          g = [
            5,
            14,
            7,
            0,
            9,
            2,
            11,
            4,
            13,
            6,
            15,
            8,
            1,
            10,
            3,
            12,
            6,
            11,
            3,
            7,
            0,
            13,
            5,
            10,
            14,
            15,
            8,
            12,
            4,
            9,
            1,
            2,
            15,
            5,
            1,
            3,
            7,
            14,
            6,
            9,
            11,
            8,
            12,
            2,
            10,
            0,
            4,
            13,
            8,
            6,
            4,
            1,
            3,
            11,
            15,
            0,
            5,
            12,
            2,
            13,
            9,
            7,
            10,
            14,
            12,
            15,
            10,
            4,
            1,
            5,
            8,
            7,
            6,
            2,
            13,
            14,
            0,
            3,
            9,
            11,
          ],
          v = [
            11,
            14,
            15,
            12,
            5,
            8,
            7,
            9,
            11,
            13,
            14,
            15,
            6,
            7,
            9,
            8,
            7,
            6,
            8,
            13,
            11,
            9,
            7,
            15,
            7,
            12,
            15,
            9,
            11,
            7,
            13,
            12,
            11,
            13,
            6,
            7,
            14,
            9,
            13,
            15,
            14,
            8,
            13,
            6,
            5,
            12,
            7,
            5,
            11,
            12,
            14,
            15,
            14,
            15,
            9,
            8,
            9,
            14,
            5,
            6,
            8,
            6,
            5,
            12,
            9,
            15,
            5,
            11,
            6,
            8,
            13,
            12,
            5,
            12,
            13,
            14,
            11,
            8,
            5,
            6,
          ],
          _ = [
            8,
            9,
            9,
            11,
            13,
            15,
            15,
            5,
            7,
            7,
            8,
            11,
            14,
            14,
            12,
            6,
            9,
            13,
            15,
            7,
            12,
            8,
            9,
            11,
            7,
            7,
            12,
            7,
            6,
            15,
            13,
            11,
            9,
            7,
            15,
            11,
            8,
            6,
            6,
            14,
            12,
            13,
            5,
            14,
            13,
            13,
            7,
            5,
            15,
            5,
            8,
            11,
            14,
            14,
            6,
            14,
            6,
            9,
            12,
            9,
            12,
            5,
            15,
            8,
            8,
            5,
            12,
            9,
            12,
            5,
            14,
            6,
            8,
            13,
            6,
            5,
            15,
            13,
            11,
            11,
          ],
          w = [0, 1518500249, 1859775393, 2400959708, 2840853838],
          M = [1352829926, 1548603684, 1836072691, 2053994217, 0];
        function o() {
          s.call(this, 64),
            (this._a = 1732584193),
            (this._b = 4023233417),
            (this._c = 2562383102),
            (this._d = 271733878),
            (this._e = 3285377520);
        }
        function S(t, e) {
          return (t << e) | (t >>> (32 - e));
        }
        function E(t, e, r, i, n, s, o, a) {
          return (S((t + (e ^ r ^ i) + s + o) | 0, a) + n) | 0;
        }
        function k(t, e, r, i, n, s, o, a) {
          return (S((t + ((e & r) | (~e & i)) + s + o) | 0, a) + n) | 0;
        }
        function A(t, e, r, i, n, s, o, a) {
          return (S((t + ((e | ~r) ^ i) + s + o) | 0, a) + n) | 0;
        }
        function x(t, e, r, i, n, s, o, a) {
          return (S((t + ((e & i) | (r & ~i)) + s + o) | 0, a) + n) | 0;
        }
        function B(t, e, r, i, n, s, o, a) {
          return (S((t + (e ^ (r | ~i)) + s + o) | 0, a) + n) | 0;
        }
        n(o, s),
          (o.prototype._update = function() {
            for (var t = m, e = 0; e < 16; ++e)
              t[e] = this._block.readInt32LE(4 * e);
            for (
              var r = 0 | this._a,
                i = 0 | this._b,
                n = 0 | this._c,
                s = 0 | this._d,
                o = 0 | this._e,
                a = 0 | this._a,
                f = 0 | this._b,
                h = 0 | this._c,
                c = 0 | this._d,
                u = 0 | this._e,
                d = 0;
              d < 80;
              d += 1
            )
              var l,
                p =
                  d < 16
                    ? ((l = E(r, i, n, s, o, t[y[d]], w[0], v[d])),
                      B(a, f, h, c, u, t[g[d]], M[0], _[d]))
                    : d < 32
                    ? ((l = k(r, i, n, s, o, t[y[d]], w[1], v[d])),
                      x(a, f, h, c, u, t[g[d]], M[1], _[d]))
                    : d < 48
                    ? ((l = A(r, i, n, s, o, t[y[d]], w[2], v[d])),
                      A(a, f, h, c, u, t[g[d]], M[2], _[d]))
                    : d < 64
                    ? ((l = x(r, i, n, s, o, t[y[d]], w[3], v[d])),
                      k(a, f, h, c, u, t[g[d]], M[3], _[d]))
                    : ((l = B(r, i, n, s, o, t[y[d]], w[4], v[d])),
                      E(a, f, h, c, u, t[g[d]], M[4], _[d])),
                r = o,
                o = s,
                s = S(n, 10),
                n = i,
                i = l,
                a = u,
                u = c,
                c = S(h, 10),
                h = f,
                f = p;
            var b = (this._b + n + c) | 0;
            (this._b = (this._c + s + u) | 0),
              (this._c = (this._d + o + a) | 0),
              (this._d = (this._e + r + f) | 0),
              (this._e = (this._a + i + h) | 0),
              (this._a = b);
          }),
          (o.prototype._digest = function() {
            (this._block[this._blockOffset++] = 128),
              56 < this._blockOffset &&
                (this._block.fill(0, this._blockOffset, 64),
                this._update(),
                (this._blockOffset = 0)),
              this._block.fill(0, this._blockOffset, 56),
              this._block.writeUInt32LE(this._length[0], 56),
              this._block.writeUInt32LE(this._length[1], 60),
              this._update();
            var t = i.alloc ? i.alloc(20) : new i(20);
            return (
              t.writeInt32LE(this._a, 0),
              t.writeInt32LE(this._b, 4),
              t.writeInt32LE(this._c, 8),
              t.writeInt32LE(this._d, 12),
              t.writeInt32LE(this._e, 16),
              t
            );
          }),
          (e.exports = o);
      },
      { buffer: 64, 'hash-base': 103, inherits: 133 },
    ],
    161: [
      function(t, e, r) {
        var i = t('buffer'),
          n = i.Buffer;
        function s(t, e) {
          for (var r in t) e[r] = t[r];
        }
        function o(t, e, r) {
          return n(t, e, r);
        }
        n.from && n.alloc && n.allocUnsafe && n.allocUnsafeSlow
          ? (e.exports = i)
          : (s(i, r), (r.Buffer = o)),
          (o.prototype = Object.create(n.prototype)),
          s(n, o),
          (o.from = function(t, e, r) {
            if ('number' == typeof t)
              throw new TypeError('Argument must not be a number');
            return n(t, e, r);
          }),
          (o.alloc = function(t, e, r) {
            if ('number' != typeof t)
              throw new TypeError('Argument must be a number');
            t = n(t);
            return (
              void 0 !== e
                ? 'string' == typeof r
                  ? t.fill(e, r)
                  : t.fill(e)
                : t.fill(0),
              t
            );
          }),
          (o.allocUnsafe = function(t) {
            if ('number' != typeof t)
              throw new TypeError('Argument must be a number');
            return n(t);
          }),
          (o.allocUnsafeSlow = function(t) {
            if ('number' != typeof t)
              throw new TypeError('Argument must be a number');
            return i.SlowBuffer(t);
          });
      },
      { buffer: 64 },
    ],
    162: [
      function(o, a, t) {
        !function(s) {
          !function() {
            'use strict';
            var t,
              e = o('buffer'),
              i = e.Buffer,
              r = {};
            for (t in e)
              e.hasOwnProperty(t) &&
                'SlowBuffer' !== t &&
                'Buffer' !== t &&
                (r[t] = e[t]);
            var n = (r.Buffer = {});
            for (t in i)
              i.hasOwnProperty(t) &&
                'allocUnsafe' !== t &&
                'allocUnsafeSlow' !== t &&
                (n[t] = i[t]);
            if (
              ((r.Buffer.prototype = i.prototype),
              (n.from && n.from !== Uint8Array.from) ||
                (n.from = function(t, e, r) {
                  if ('number' == typeof t)
                    throw new TypeError(
                      'The "value" argument must not be of type number. Received type ' +
                        typeof t
                    );
                  if (t && void 0 === t.length)
                    throw new TypeError(
                      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type ' +
                        typeof t
                    );
                  return i(t, e, r);
                }),
              n.alloc ||
                (n.alloc = function(t, e, r) {
                  if ('number' != typeof t)
                    throw new TypeError(
                      'The "size" argument must be of type number. Received type ' +
                        typeof t
                    );
                  if (t < 0 || 2 * (1 << 30) <= t)
                    throw new RangeError(
                      'The value "' + t + '" is invalid for option "size"'
                    );
                  t = i(t);
                  return (
                    e && 0 !== e.length
                      ? 'string' == typeof r
                        ? t.fill(e, r)
                        : t.fill(e)
                      : t.fill(0),
                    t
                  );
                }),
              !r.kStringMaxLength)
            )
              try {
                r.kStringMaxLength = s.binding('buffer').kStringMaxLength;
              } catch (t) {}
            r.constants ||
              ((r.constants = { MAX_LENGTH: r.kMaxLength }),
              r.kStringMaxLength &&
                (r.constants.MAX_STRING_LENGTH = r.kStringMaxLength)),
              (a.exports = r);
          }.call(this);
        }.call(this, o('_process'));
      },
      { _process: 150, buffer: 64 },
    ],
    163: [
      function(t, e, r) {
        var c = t('safe-buffer').Buffer;
        function i(t, e) {
          (this._block = c.alloc(t)),
            (this._finalSize = e),
            (this._blockSize = t),
            (this._len = 0);
        }
        (i.prototype.update = function(t, e) {
          'string' == typeof t && (t = c.from(t, (e = e || 'utf8')));
          for (
            var r = this._block,
              i = this._blockSize,
              n = t.length,
              s = this._len,
              o = 0;
            o < n;

          ) {
            for (var a = s % i, f = Math.min(n - o, i - a), h = 0; h < f; h++)
              r[a + h] = t[o + h];
            (o += f), (s += f) % i == 0 && this._update(r);
          }
          return (this._len += n), this;
        }),
          (i.prototype.digest = function(t) {
            var e = this._len % this._blockSize;
            (this._block[e] = 128),
              this._block.fill(0, 1 + e),
              e >= this._finalSize &&
                (this._update(this._block), this._block.fill(0));
            e = 8 * this._len;
            e <= 4294967295
              ? this._block.writeUInt32BE(e, this._blockSize - 4)
              : (this._block.writeUInt32BE(
                  (e - (r = (4294967295 & e) >>> 0)) / 4294967296,
                  this._blockSize - 8
                ),
                this._block.writeUInt32BE(r, this._blockSize - 4)),
              this._update(this._block);
            var r = this._hash();
            return t ? r.toString(t) : r;
          }),
          (i.prototype._update = function() {
            throw new Error('_update must be implemented by subclass');
          }),
          (e.exports = i);
      },
      { 'safe-buffer': 161 },
    ],
    164: [
      function(t, e, r) {
        ((r = e.exports = function(t) {
          t = t.toLowerCase();
          var e = r[t];
          if (!e)
            throw new Error(t + ' is not supported (we accept pull requests)');
          return new e();
        }).sha = t('./sha')),
          (r.sha1 = t('./sha1')),
          (r.sha224 = t('./sha224')),
          (r.sha256 = t('./sha256')),
          (r.sha384 = t('./sha384')),
          (r.sha512 = t('./sha512'));
      },
      {
        './sha': 165,
        './sha1': 166,
        './sha224': 167,
        './sha256': 168,
        './sha384': 169,
        './sha512': 170,
      },
    ],
    165: [
      function(t, e, r) {
        var i = t('inherits'),
          n = t('./hash'),
          s = t('safe-buffer').Buffer,
          p = [1518500249, 1859775393, -1894007588, -899497514],
          o = new Array(80);
        function a() {
          this.init(), (this._w = o), n.call(this, 64, 56);
        }
        i(a, n),
          (a.prototype.init = function() {
            return (
              (this._a = 1732584193),
              (this._b = 4023233417),
              (this._c = 2562383102),
              (this._d = 271733878),
              (this._e = 3285377520),
              this
            );
          }),
          (a.prototype._update = function(t) {
            for (
              var e = this._w,
                r = 0 | this._a,
                i = 0 | this._b,
                n = 0 | this._c,
                s = 0 | this._d,
                o = 0 | this._e,
                a = 0;
              a < 16;
              ++a
            )
              e[a] = t.readInt32BE(4 * a);
            for (; a < 80; ++a)
              e[a] = e[a - 3] ^ e[a - 8] ^ e[a - 14] ^ e[a - 16];
            for (var f, h, c, u, d = 0; d < 80; ++d)
              var l = ~~(d / 20),
                l =
                  0 |
                  (((r << 5) | (r >>> 27)) +
                    ((h = i),
                    (c = n),
                    (u = s),
                    0 === (f = l)
                      ? (h & c) | (~h & u)
                      : 2 === f
                      ? (h & c) | (h & u) | (c & u)
                      : h ^ c ^ u) +
                    o +
                    e[d] +
                    p[l]),
                o = s,
                s = n,
                n = (i << 30) | (i >>> 2),
                i = r,
                r = l;
            (this._a = (r + this._a) | 0),
              (this._b = (i + this._b) | 0),
              (this._c = (n + this._c) | 0),
              (this._d = (s + this._d) | 0),
              (this._e = (o + this._e) | 0);
          }),
          (a.prototype._hash = function() {
            var t = s.allocUnsafe(20);
            return (
              t.writeInt32BE(0 | this._a, 0),
              t.writeInt32BE(0 | this._b, 4),
              t.writeInt32BE(0 | this._c, 8),
              t.writeInt32BE(0 | this._d, 12),
              t.writeInt32BE(0 | this._e, 16),
              t
            );
          }),
          (e.exports = a);
      },
      { './hash': 163, inherits: 133, 'safe-buffer': 161 },
    ],
    166: [
      function(t, e, r) {
        var i = t('inherits'),
          n = t('./hash'),
          s = t('safe-buffer').Buffer,
          b = [1518500249, 1859775393, -1894007588, -899497514],
          o = new Array(80);
        function a() {
          this.init(), (this._w = o), n.call(this, 64, 56);
        }
        i(a, n),
          (a.prototype.init = function() {
            return (
              (this._a = 1732584193),
              (this._b = 4023233417),
              (this._c = 2562383102),
              (this._d = 271733878),
              (this._e = 3285377520),
              this
            );
          }),
          (a.prototype._update = function(t) {
            for (
              var e,
                r = this._w,
                i = 0 | this._a,
                n = 0 | this._b,
                s = 0 | this._c,
                o = 0 | this._d,
                a = 0 | this._e,
                f = 0;
              f < 16;
              ++f
            )
              r[f] = t.readInt32BE(4 * f);
            for (; f < 80; ++f)
              r[f] =
                ((e = r[f - 3] ^ r[f - 8] ^ r[f - 14] ^ r[f - 16]) << 1) |
                (e >>> 31);
            for (var h, c, u, d, l = 0; l < 80; ++l)
              var p = ~~(l / 20),
                p =
                  0 |
                  (((i << 5) | (i >>> 27)) +
                    ((c = n),
                    (u = s),
                    (d = o),
                    0 === (h = p)
                      ? (c & u) | (~c & d)
                      : 2 === h
                      ? (c & u) | (c & d) | (u & d)
                      : c ^ u ^ d) +
                    a +
                    r[l] +
                    b[p]),
                a = o,
                o = s,
                s = (n << 30) | (n >>> 2),
                n = i,
                i = p;
            (this._a = (i + this._a) | 0),
              (this._b = (n + this._b) | 0),
              (this._c = (s + this._c) | 0),
              (this._d = (o + this._d) | 0),
              (this._e = (a + this._e) | 0);
          }),
          (a.prototype._hash = function() {
            var t = s.allocUnsafe(20);
            return (
              t.writeInt32BE(0 | this._a, 0),
              t.writeInt32BE(0 | this._b, 4),
              t.writeInt32BE(0 | this._c, 8),
              t.writeInt32BE(0 | this._d, 12),
              t.writeInt32BE(0 | this._e, 16),
              t
            );
          }),
          (e.exports = a);
      },
      { './hash': 163, inherits: 133, 'safe-buffer': 161 },
    ],
    167: [
      function(t, e, r) {
        var i = t('inherits'),
          n = t('./sha256'),
          s = t('./hash'),
          o = t('safe-buffer').Buffer,
          a = new Array(64);
        function f() {
          this.init(), (this._w = a), s.call(this, 64, 56);
        }
        i(f, n),
          (f.prototype.init = function() {
            return (
              (this._a = 3238371032),
              (this._b = 914150663),
              (this._c = 812702999),
              (this._d = 4144912697),
              (this._e = 4290775857),
              (this._f = 1750603025),
              (this._g = 1694076839),
              (this._h = 3204075428),
              this
            );
          }),
          (f.prototype._hash = function() {
            var t = o.allocUnsafe(28);
            return (
              t.writeInt32BE(this._a, 0),
              t.writeInt32BE(this._b, 4),
              t.writeInt32BE(this._c, 8),
              t.writeInt32BE(this._d, 12),
              t.writeInt32BE(this._e, 16),
              t.writeInt32BE(this._f, 20),
              t.writeInt32BE(this._g, 24),
              t
            );
          }),
          (e.exports = f);
      },
      { './hash': 163, './sha256': 168, inherits: 133, 'safe-buffer': 161 },
    ],
    168: [
      function(t, e, r) {
        var i = t('inherits'),
          n = t('./hash'),
          s = t('safe-buffer').Buffer,
          b = [
            1116352408,
            1899447441,
            3049323471,
            3921009573,
            961987163,
            1508970993,
            2453635748,
            2870763221,
            3624381080,
            310598401,
            607225278,
            1426881987,
            1925078388,
            2162078206,
            2614888103,
            3248222580,
            3835390401,
            4022224774,
            264347078,
            604807628,
            770255983,
            1249150122,
            1555081692,
            1996064986,
            2554220882,
            2821834349,
            2952996808,
            3210313671,
            3336571891,
            3584528711,
            113926993,
            338241895,
            666307205,
            773529912,
            1294757372,
            1396182291,
            1695183700,
            1986661051,
            2177026350,
            2456956037,
            2730485921,
            2820302411,
            3259730800,
            3345764771,
            3516065817,
            3600352804,
            4094571909,
            275423344,
            430227734,
            506948616,
            659060556,
            883997877,
            958139571,
            1322822218,
            1537002063,
            1747873779,
            1955562222,
            2024104815,
            2227730452,
            2361852424,
            2428436474,
            2756734187,
            3204031479,
            3329325298,
          ],
          o = new Array(64);
        function a() {
          this.init(), (this._w = o), n.call(this, 64, 56);
        }
        i(a, n),
          (a.prototype.init = function() {
            return (
              (this._a = 1779033703),
              (this._b = 3144134277),
              (this._c = 1013904242),
              (this._d = 2773480762),
              (this._e = 1359893119),
              (this._f = 2600822924),
              (this._g = 528734635),
              (this._h = 1541459225),
              this
            );
          }),
          (a.prototype._update = function(t) {
            for (
              var e,
                r = this._w,
                i = 0 | this._a,
                n = 0 | this._b,
                s = 0 | this._c,
                o = 0 | this._d,
                a = 0 | this._e,
                f = 0 | this._f,
                h = 0 | this._g,
                c = 0 | this._h,
                u = 0;
              u < 16;
              ++u
            )
              r[u] = t.readInt32BE(4 * u);
            for (; u < 64; ++u)
              r[u] =
                0 |
                (((((e = r[u - 2]) >>> 17) | (e << 15)) ^
                  ((e >>> 19) | (e << 13)) ^
                  (e >>> 10)) +
                  r[u - 7] +
                  ((((e = r[u - 15]) >>> 7) | (e << 25)) ^
                    ((e >>> 18) | (e << 14)) ^
                    (e >>> 3)) +
                  r[u - 16]);
            for (var d = 0; d < 64; ++d)
              var l =
                  (c +
                    (((a >>> 6) | (a << 26)) ^
                      ((a >>> 11) | (a << 21)) ^
                      ((a >>> 25) | (a << 7))) +
                    (h ^ (a & (f ^ h))) +
                    b[d] +
                    r[d]) |
                  0,
                p =
                  0 |
                  ((((i >>> 2) | (i << 30)) ^
                    ((i >>> 13) | (i << 19)) ^
                    ((i >>> 22) | (i << 10))) +
                    ((i & n) | (s & (i | n)))),
                c = h,
                h = f,
                f = a,
                a = (o + l) | 0,
                o = s,
                s = n,
                n = i,
                i = (l + p) | 0;
            (this._a = (i + this._a) | 0),
              (this._b = (n + this._b) | 0),
              (this._c = (s + this._c) | 0),
              (this._d = (o + this._d) | 0),
              (this._e = (a + this._e) | 0),
              (this._f = (f + this._f) | 0),
              (this._g = (h + this._g) | 0),
              (this._h = (c + this._h) | 0);
          }),
          (a.prototype._hash = function() {
            var t = s.allocUnsafe(32);
            return (
              t.writeInt32BE(this._a, 0),
              t.writeInt32BE(this._b, 4),
              t.writeInt32BE(this._c, 8),
              t.writeInt32BE(this._d, 12),
              t.writeInt32BE(this._e, 16),
              t.writeInt32BE(this._f, 20),
              t.writeInt32BE(this._g, 24),
              t.writeInt32BE(this._h, 28),
              t
            );
          }),
          (e.exports = a);
      },
      { './hash': 163, inherits: 133, 'safe-buffer': 161 },
    ],
    169: [
      function(t, e, r) {
        var i = t('inherits'),
          n = t('./sha512'),
          s = t('./hash'),
          o = t('safe-buffer').Buffer,
          a = new Array(160);
        function f() {
          this.init(), (this._w = a), s.call(this, 128, 112);
        }
        i(f, n),
          (f.prototype.init = function() {
            return (
              (this._ah = 3418070365),
              (this._bh = 1654270250),
              (this._ch = 2438529370),
              (this._dh = 355462360),
              (this._eh = 1731405415),
              (this._fh = 2394180231),
              (this._gh = 3675008525),
              (this._hh = 1203062813),
              (this._al = 3238371032),
              (this._bl = 914150663),
              (this._cl = 812702999),
              (this._dl = 4144912697),
              (this._el = 4290775857),
              (this._fl = 1750603025),
              (this._gl = 1694076839),
              (this._hl = 3204075428),
              this
            );
          }),
          (f.prototype._hash = function() {
            var i = o.allocUnsafe(48);
            function t(t, e, r) {
              i.writeInt32BE(t, r), i.writeInt32BE(e, r + 4);
            }
            return (
              t(this._ah, this._al, 0),
              t(this._bh, this._bl, 8),
              t(this._ch, this._cl, 16),
              t(this._dh, this._dl, 24),
              t(this._eh, this._el, 32),
              t(this._fh, this._fl, 40),
              i
            );
          }),
          (e.exports = f);
      },
      { './hash': 163, './sha512': 170, inherits: 133, 'safe-buffer': 161 },
    ],
    170: [
      function(t, e, r) {
        var i = t('inherits'),
          n = t('./hash'),
          s = t('safe-buffer').Buffer,
          U = [
            1116352408,
            3609767458,
            1899447441,
            602891725,
            3049323471,
            3964484399,
            3921009573,
            2173295548,
            961987163,
            4081628472,
            1508970993,
            3053834265,
            2453635748,
            2937671579,
            2870763221,
            3664609560,
            3624381080,
            2734883394,
            310598401,
            1164996542,
            607225278,
            1323610764,
            1426881987,
            3590304994,
            1925078388,
            4068182383,
            2162078206,
            991336113,
            2614888103,
            633803317,
            3248222580,
            3479774868,
            3835390401,
            2666613458,
            4022224774,
            944711139,
            264347078,
            2341262773,
            604807628,
            2007800933,
            770255983,
            1495990901,
            1249150122,
            1856431235,
            1555081692,
            3175218132,
            1996064986,
            2198950837,
            2554220882,
            3999719339,
            2821834349,
            766784016,
            2952996808,
            2566594879,
            3210313671,
            3203337956,
            3336571891,
            1034457026,
            3584528711,
            2466948901,
            113926993,
            3758326383,
            338241895,
            168717936,
            666307205,
            1188179964,
            773529912,
            1546045734,
            1294757372,
            1522805485,
            1396182291,
            2643833823,
            1695183700,
            2343527390,
            1986661051,
            1014477480,
            2177026350,
            1206759142,
            2456956037,
            344077627,
            2730485921,
            1290863460,
            2820302411,
            3158454273,
            3259730800,
            3505952657,
            3345764771,
            106217008,
            3516065817,
            3606008344,
            3600352804,
            1432725776,
            4094571909,
            1467031594,
            275423344,
            851169720,
            430227734,
            3100823752,
            506948616,
            1363258195,
            659060556,
            3750685593,
            883997877,
            3785050280,
            958139571,
            3318307427,
            1322822218,
            3812723403,
            1537002063,
            2003034995,
            1747873779,
            3602036899,
            1955562222,
            1575990012,
            2024104815,
            1125592928,
            2227730452,
            2716904306,
            2361852424,
            442776044,
            2428436474,
            593698344,
            2756734187,
            3733110249,
            3204031479,
            2999351573,
            3329325298,
            3815920427,
            3391569614,
            3928383900,
            3515267271,
            566280711,
            3940187606,
            3454069534,
            4118630271,
            4000239992,
            116418474,
            1914138554,
            174292421,
            2731055270,
            289380356,
            3203993006,
            460393269,
            320620315,
            685471733,
            587496836,
            852142971,
            1086792851,
            1017036298,
            365543100,
            1126000580,
            2618297676,
            1288033470,
            3409855158,
            1501505948,
            4234509866,
            1607167915,
            987167468,
            1816402316,
            1246189591,
          ],
          o = new Array(160);
        function a() {
          this.init(), (this._w = o), n.call(this, 128, 112);
        }
        function z(t, e, r) {
          return r ^ (t & (e ^ r));
        }
        function K(t, e, r) {
          return (t & e) | (r & (t | e));
        }
        function F(t, e) {
          return (
            ((t >>> 28) | (e << 4)) ^
            ((e >>> 2) | (t << 30)) ^
            ((e >>> 7) | (t << 25))
          );
        }
        function H(t, e) {
          return (
            ((t >>> 14) | (e << 18)) ^
            ((t >>> 18) | (e << 14)) ^
            ((e >>> 9) | (t << 23))
          );
        }
        function W(t, e) {
          return t >>> 0 < e >>> 0 ? 1 : 0;
        }
        i(a, n),
          (a.prototype.init = function() {
            return (
              (this._ah = 1779033703),
              (this._bh = 3144134277),
              (this._ch = 1013904242),
              (this._dh = 2773480762),
              (this._eh = 1359893119),
              (this._fh = 2600822924),
              (this._gh = 528734635),
              (this._hh = 1541459225),
              (this._al = 4089235720),
              (this._bl = 2227873595),
              (this._cl = 4271175723),
              (this._dl = 1595750129),
              (this._el = 2917565137),
              (this._fl = 725511199),
              (this._gl = 4215389547),
              (this._hl = 327033209),
              this
            );
          }),
          (a.prototype._update = function(t) {
            for (
              var e = this._w,
                r = 0 | this._ah,
                i = 0 | this._bh,
                n = 0 | this._ch,
                s = 0 | this._dh,
                o = 0 | this._eh,
                a = 0 | this._fh,
                f = 0 | this._gh,
                h = 0 | this._hh,
                c = 0 | this._al,
                u = 0 | this._bl,
                d = 0 | this._cl,
                l = 0 | this._dl,
                p = 0 | this._el,
                b = 0 | this._fl,
                m = 0 | this._gl,
                y = 0 | this._hl,
                g = 0;
              g < 32;
              g += 2
            )
              (e[g] = t.readInt32BE(4 * g)),
                (e[g + 1] = t.readInt32BE(4 * g + 4));
            for (; g < 160; g += 2) {
              var v = e[g - 30],
                _ = e[g - 30 + 1],
                w =
                  ((v >>> 1) | (_ << 31)) ^ ((v >>> 8) | (_ << 24)) ^ (v >>> 7),
                M =
                  ((_ >>> 1) | (v << 31)) ^
                  ((_ >>> 8) | (v << 24)) ^
                  ((_ >>> 7) | (v << 25)),
                v = e[g - 4],
                S =
                  (((_ = e[g - 4 + 1]) >>> 19) | (v << 13)) ^
                  ((v >>> 29) | (_ << 3)) ^
                  ((_ >>> 6) | (v << 26)),
                E = e[g - 14],
                k = e[g - 14 + 1],
                A = e[g - 32],
                x = e[g - 32 + 1],
                B = (M + k) | 0,
                I = (w + E + W(B, M)) | 0;
              (I =
                ((I =
                  (I +
                    (((v >>> 19) | (_ << 13)) ^
                      ((_ >>> 29) | (v << 3)) ^
                      (v >>> 6)) +
                    W((B = (B + S) | 0), S)) |
                  0) +
                  A +
                  W((B = (B + x) | 0), x)) |
                0),
                (e[g] = I),
                (e[g + 1] = B);
            }
            for (var R = 0; R < 160; R += 2) {
              (I = e[R]), (B = e[R + 1]);
              var j = K(r, i, n),
                T = K(c, u, d),
                C = F(r, c),
                L = F(c, r),
                P = H(o, p),
                O = H(p, o),
                D = U[R + 1],
                N = z(o, a, f),
                q = z(p, b, m),
                O = (y + O) | 0;
              P =
                ((P =
                  ((P =
                    ((P = (h + P + W(O, y)) | 0) +
                      N +
                      W((O = (O + q) | 0), q)) |
                    0) +
                    U[R] +
                    W((O = (O + D) | 0), D)) |
                  0) +
                  I +
                  W((O = (O + B) | 0), B)) |
                0;
              (T = (L + T) | 0),
                (L = (C + j + W(T, L)) | 0),
                (h = f),
                (y = m),
                (f = a),
                (m = b),
                (a = o),
                (b = p),
                (o = (s + P + W((p = (l + O) | 0), l)) | 0),
                (s = n),
                (l = d),
                (n = i),
                (d = u),
                (i = r),
                (u = c),
                (r = (P + L + W((c = (O + T) | 0), O)) | 0);
            }
            (this._al = (this._al + c) | 0),
              (this._bl = (this._bl + u) | 0),
              (this._cl = (this._cl + d) | 0),
              (this._dl = (this._dl + l) | 0),
              (this._el = (this._el + p) | 0),
              (this._fl = (this._fl + b) | 0),
              (this._gl = (this._gl + m) | 0),
              (this._hl = (this._hl + y) | 0),
              (this._ah = (this._ah + r + W(this._al, c)) | 0),
              (this._bh = (this._bh + i + W(this._bl, u)) | 0),
              (this._ch = (this._ch + n + W(this._cl, d)) | 0),
              (this._dh = (this._dh + s + W(this._dl, l)) | 0),
              (this._eh = (this._eh + o + W(this._el, p)) | 0),
              (this._fh = (this._fh + a + W(this._fl, b)) | 0),
              (this._gh = (this._gh + f + W(this._gl, m)) | 0),
              (this._hh = (this._hh + h + W(this._hl, y)) | 0);
          }),
          (a.prototype._hash = function() {
            var i = s.allocUnsafe(64);
            function t(t, e, r) {
              i.writeInt32BE(t, r), i.writeInt32BE(e, r + 4);
            }
            return (
              t(this._ah, this._al, 0),
              t(this._bh, this._bl, 8),
              t(this._ch, this._cl, 16),
              t(this._dh, this._dl, 24),
              t(this._eh, this._el, 32),
              t(this._fh, this._fl, 40),
              t(this._gh, this._gl, 48),
              t(this._hh, this._hl, 56),
              i
            );
          }),
          (e.exports = a);
      },
      { './hash': 163, inherits: 133, 'safe-buffer': 161 },
    ],
    171: [
      function(t, e, r) {
        e.exports = i;
        var c = t('events').EventEmitter;
        function i() {
          c.call(this);
        }
        t('inherits')(i, c),
          (i.Readable = t('readable-stream/lib/_stream_readable.js')),
          (i.Writable = t('readable-stream/lib/_stream_writable.js')),
          (i.Duplex = t('readable-stream/lib/_stream_duplex.js')),
          (i.Transform = t('readable-stream/lib/_stream_transform.js')),
          (i.PassThrough = t('readable-stream/lib/_stream_passthrough.js')),
          (i.finished = t(
            'readable-stream/lib/internal/streams/end-of-stream.js'
          )),
          (i.pipeline = t('readable-stream/lib/internal/streams/pipeline.js')),
          ((i.Stream = i).prototype.pipe = function(e, t) {
            var r = this;
            function i(t) {
              e.writable && !1 === e.write(t) && r.pause && r.pause();
            }
            function n() {
              r.readable && r.resume && r.resume();
            }
            r.on('data', i),
              e.on('drain', n),
              e._isStdio ||
                (t && !1 === t.end) ||
                (r.on('end', o), r.on('close', a));
            var s = !1;
            function o() {
              s || ((s = !0), e.end());
            }
            function a() {
              s || ((s = !0), 'function' == typeof e.destroy && e.destroy());
            }
            function f(t) {
              if ((h(), 0 === c.listenerCount(this, 'error'))) throw t;
            }
            function h() {
              r.removeListener('data', i),
                e.removeListener('drain', n),
                r.removeListener('end', o),
                r.removeListener('close', a),
                r.removeListener('error', f),
                e.removeListener('error', f),
                r.removeListener('end', h),
                r.removeListener('close', h),
                e.removeListener('close', h);
            }
            return (
              r.on('error', f),
              e.on('error', f),
              r.on('end', h),
              r.on('close', h),
              e.on('close', h),
              e.emit('pipe', r),
              e
            );
          });
      },
      {
        events: 101,
        inherits: 133,
        'readable-stream/lib/_stream_duplex.js': 173,
        'readable-stream/lib/_stream_passthrough.js': 174,
        'readable-stream/lib/_stream_readable.js': 175,
        'readable-stream/lib/_stream_transform.js': 176,
        'readable-stream/lib/_stream_writable.js': 177,
        'readable-stream/lib/internal/streams/end-of-stream.js': 181,
        'readable-stream/lib/internal/streams/pipeline.js': 183,
      },
    ],
    172: [
      function(t, e, r) {
        arguments[4][48][0].apply(r, arguments);
      },
      { dup: 48 },
    ],
    173: [
      function(t, e, r) {
        arguments[4][49][0].apply(r, arguments);
      },
      {
        './_stream_readable': 175,
        './_stream_writable': 177,
        _process: 150,
        dup: 49,
        inherits: 133,
      },
    ],
    174: [
      function(t, e, r) {
        arguments[4][50][0].apply(r, arguments);
      },
      { './_stream_transform': 176, dup: 50, inherits: 133 },
    ],
    175: [
      function(t, e, r) {
        arguments[4][51][0].apply(r, arguments);
      },
      {
        '../errors': 172,
        './_stream_duplex': 173,
        './internal/streams/async_iterator': 178,
        './internal/streams/buffer_list': 179,
        './internal/streams/destroy': 180,
        './internal/streams/from': 182,
        './internal/streams/state': 184,
        './internal/streams/stream': 185,
        _process: 150,
        buffer: 64,
        dup: 51,
        events: 101,
        inherits: 133,
        'string_decoder/': 186,
        util: 20,
      },
    ],
    176: [
      function(t, e, r) {
        arguments[4][52][0].apply(r, arguments);
      },
      { '../errors': 172, './_stream_duplex': 173, dup: 52, inherits: 133 },
    ],
    177: [
      function(t, e, r) {
        arguments[4][53][0].apply(r, arguments);
      },
      {
        '../errors': 172,
        './_stream_duplex': 173,
        './internal/streams/destroy': 180,
        './internal/streams/state': 184,
        './internal/streams/stream': 185,
        _process: 150,
        buffer: 64,
        dup: 53,
        inherits: 133,
        'util-deprecate': 187,
      },
    ],
    178: [
      function(t, e, r) {
        arguments[4][54][0].apply(r, arguments);
      },
      { './end-of-stream': 181, _process: 150, dup: 54 },
    ],
    179: [
      function(t, e, r) {
        arguments[4][55][0].apply(r, arguments);
      },
      { buffer: 64, dup: 55, util: 20 },
    ],
    180: [
      function(t, e, r) {
        arguments[4][56][0].apply(r, arguments);
      },
      { _process: 150, dup: 56 },
    ],
    181: [
      function(t, e, r) {
        arguments[4][57][0].apply(r, arguments);
      },
      { '../../../errors': 172, dup: 57 },
    ],
    182: [
      function(t, e, r) {
        arguments[4][58][0].apply(r, arguments);
      },
      { dup: 58 },
    ],
    183: [
      function(t, e, r) {
        arguments[4][59][0].apply(r, arguments);
      },
      { '../../../errors': 172, './end-of-stream': 181, dup: 59 },
    ],
    184: [
      function(t, e, r) {
        arguments[4][60][0].apply(r, arguments);
      },
      { '../../../errors': 172, dup: 60 },
    ],
    185: [
      function(t, e, r) {
        arguments[4][61][0].apply(r, arguments);
      },
      { dup: 61, events: 101 },
    ],
    186: [
      function(t, e, r) {
        'use strict';
        var i = t('safe-buffer').Buffer,
          n =
            i.isEncoding ||
            function(t) {
              switch ((t = '' + t) && t.toLowerCase()) {
                case 'hex':
                case 'utf8':
                case 'utf-8':
                case 'ascii':
                case 'binary':
                case 'base64':
                case 'ucs2':
                case 'ucs-2':
                case 'utf16le':
                case 'utf-16le':
                case 'raw':
                  return !0;
                default:
                  return !1;
              }
            };
        function s(t) {
          var e = (function(t) {
            if (!t) return 'utf8';
            for (var e; ; )
              switch (t) {
                case 'utf8':
                case 'utf-8':
                  return 'utf8';
                case 'ucs2':
                case 'ucs-2':
                case 'utf16le':
                case 'utf-16le':
                  return 'utf16le';
                case 'latin1':
                case 'binary':
                  return 'latin1';
                case 'base64':
                case 'ascii':
                case 'hex':
                  return t;
                default:
                  if (e) return;
                  (t = ('' + t).toLowerCase()), (e = !0);
              }
          })(t);
          if ('string' != typeof e && (i.isEncoding === n || !n(t)))
            throw new Error('Unknown encoding: ' + t);
          return e || t;
        }
        function o(t) {
          var e;
          switch (((this.encoding = s(t)), this.encoding)) {
            case 'utf16le':
              (this.text = h), (this.end = c), (e = 4);
              break;
            case 'utf8':
              (this.fillLast = f), (e = 4);
              break;
            case 'base64':
              (this.text = u), (this.end = d), (e = 3);
              break;
            default:
              return (this.write = l), void (this.end = p);
          }
          (this.lastNeed = 0),
            (this.lastTotal = 0),
            (this.lastChar = i.allocUnsafe(e));
        }
        function a(t) {
          return t <= 127
            ? 0
            : t >> 5 == 6
            ? 2
            : t >> 4 == 14
            ? 3
            : t >> 3 == 30
            ? 4
            : t >> 6 == 2
            ? -1
            : -2;
        }
        function f(t) {
          var e,
            r,
            i = this.lastTotal - this.lastNeed,
            e =
              ((e = this),
              128 != (192 & (r = t)[0])
                ? ((e.lastNeed = 0), '�')
                : 1 < e.lastNeed && 1 < r.length
                ? 128 != (192 & r[1])
                  ? ((e.lastNeed = 1), '�')
                  : 2 < e.lastNeed && 2 < r.length && 128 != (192 & r[2])
                  ? ((e.lastNeed = 2), '�')
                  : void 0
                : void 0);
          return void 0 !== e
            ? e
            : this.lastNeed <= t.length
            ? (t.copy(this.lastChar, i, 0, this.lastNeed),
              this.lastChar.toString(this.encoding, 0, this.lastTotal))
            : (t.copy(this.lastChar, i, 0, t.length),
              void (this.lastNeed -= t.length));
        }
        function h(t, e) {
          if ((t.length - e) % 2 != 0)
            return (
              (this.lastNeed = 1),
              (this.lastTotal = 2),
              (this.lastChar[0] = t[t.length - 1]),
              t.toString('utf16le', e, t.length - 1)
            );
          var r = t.toString('utf16le', e);
          if (r) {
            e = r.charCodeAt(r.length - 1);
            if (55296 <= e && e <= 56319)
              return (
                (this.lastNeed = 2),
                (this.lastTotal = 4),
                (this.lastChar[0] = t[t.length - 2]),
                (this.lastChar[1] = t[t.length - 1]),
                r.slice(0, -1)
              );
          }
          return r;
        }
        function c(t) {
          var e = t && t.length ? this.write(t) : '';
          if (this.lastNeed) {
            t = this.lastTotal - this.lastNeed;
            return e + this.lastChar.toString('utf16le', 0, t);
          }
          return e;
        }
        function u(t, e) {
          var r = (t.length - e) % 3;
          return 0 == r
            ? t.toString('base64', e)
            : ((this.lastNeed = 3 - r),
              (this.lastTotal = 3),
              1 == r
                ? (this.lastChar[0] = t[t.length - 1])
                : ((this.lastChar[0] = t[t.length - 2]),
                  (this.lastChar[1] = t[t.length - 1])),
              t.toString('base64', e, t.length - r));
        }
        function d(t) {
          t = t && t.length ? this.write(t) : '';
          return this.lastNeed
            ? t + this.lastChar.toString('base64', 0, 3 - this.lastNeed)
            : t;
        }
        function l(t) {
          return t.toString(this.encoding);
        }
        function p(t) {
          return t && t.length ? this.write(t) : '';
        }
        ((r.StringDecoder = o).prototype.write = function(t) {
          if (0 === t.length) return '';
          var e, r;
          if (this.lastNeed) {
            if (void 0 === (e = this.fillLast(t))) return '';
            (r = this.lastNeed), (this.lastNeed = 0);
          } else r = 0;
          return r < t.length
            ? e
              ? e + this.text(t, r)
              : this.text(t, r)
            : e || '';
        }),
          (o.prototype.end = function(t) {
            t = t && t.length ? this.write(t) : '';
            return this.lastNeed ? t + '�' : t;
          }),
          (o.prototype.text = function(t, e) {
            var r = (function(t, e, r) {
              var i = e.length - 1;
              if (i < r) return 0;
              var n = a(e[i]);
              if (0 <= n) return 0 < n && (t.lastNeed = n - 1), n;
              if (--i < r || -2 === n) return 0;
              if (0 <= (n = a(e[i]))) return 0 < n && (t.lastNeed = n - 2), n;
              if (--i < r || -2 === n) return 0;
              if (0 <= (n = a(e[i])))
                return 0 < n && (2 === n ? (n = 0) : (t.lastNeed = n - 3)), n;
              return 0;
            })(this, t, e);
            if (!this.lastNeed) return t.toString('utf8', e);
            this.lastTotal = r;
            r = t.length - (r - this.lastNeed);
            return t.copy(this.lastChar, 0, r), t.toString('utf8', e, r);
          }),
          (o.prototype.fillLast = function(t) {
            if (this.lastNeed <= t.length)
              return (
                t.copy(
                  this.lastChar,
                  this.lastTotal - this.lastNeed,
                  0,
                  this.lastNeed
                ),
                this.lastChar.toString(this.encoding, 0, this.lastTotal)
              );
            t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, t.length),
              (this.lastNeed -= t.length);
          });
      },
      { 'safe-buffer': 161 },
    ],
    187: [
      function(t, r, e) {
        !function(e) {
          !function() {
            function i(t) {
              try {
                if (!e.localStorage) return;
              } catch (t) {
                return;
              }
              t = e.localStorage[t];
              return null != t && 'true' === String(t).toLowerCase();
            }
            r.exports = function(t, e) {
              if (i('noDeprecation')) return t;
              var r = !1;
              return function() {
                if (!r) {
                  if (i('throwDeprecation')) throw new Error(e);
                  i('traceDeprecation') ? console.trace(e) : console.warn(e),
                    (r = !0);
                }
                return t.apply(this, arguments);
              };
            };
          }.call(this);
        }.call(
          this,
          'undefined' != typeof global
            ? global
            : 'undefined' != typeof self
            ? self
            : 'undefined' != typeof window
            ? window
            : {}
        );
      },
      {},
    ],
  },
  {},
  [1]
),
  (module.exports = crypto);
